webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/V3YESr/%3F1737121728562&title=Charles%20Dickens%20Collection%20Volume%20Two&summary=Three%20classic%20novels%20of%20wealth%2C%20poverty%2C%20murder%2C%20and%20ambition%20from%20the%20greatest%20storyteller%20of%20the%20Victorian%20era.%20Filled%20with%20drama%2C%20emotion%2C%20and%20suspense%2C%20these%20three%20novels%20have%20compelled%20and%20delighted%20readers%20for%20well%20over%20a%20century.&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/V3YESr/%3F1737121728562",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Three%20classic%20novels%20of%20wealth%2C%20poverty%2C%20murder%2C%20and%20ambition%20from%20the%20greatest%20storyteller%20of%20the%20Victorian%20era.%20Filled%20with%0Dhttps://textcafe.co/books/V3YESr/%3F1737121728562&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/V3YESr/%3F1737121728562&posttype=link&caption=Three%20classic%20novels%20of%20wealth%2C%20poverty%2C%20murder%2C%20and%20ambition%20from%20the%20greatest%20storyteller%20of%20the%20Victorian%20era.%20Filled%20with%20drama%2C%20emotion%2C%20and%20suspense%2C%20these%20three%20novels%20have%20compelled%20and%20delighted%20readers%20for%20well%20over%20a%20century.",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/V3YESr/%3F1737121728562&description=Three%20classic%20novels%20of%20wealth%2C%20poverty%2C%20murder%2C%20and%20ambition%20from%20the%20greatest%20storyteller%20of%20the%20Victorian%20era.%20Filled%20with%20drama%2C%20emotion%2C%20and%20suspense%2C%20these%20three%20novels%20have%20compelled%20and%20delighted%20readers%20for%20well%20over%20a%20century.&media=https://textcafe.co/books/V3YESr/tc-custom/9781504065146.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504065146&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=uuMKEAAAQBAJ&amp;rdid=book-uuMKEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504065146').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/V3YESr/tc-custom/9781504065146.jpg?1737121728562',
        alt: 'Charles Dickens Collection Volume Two'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "bundle_content", "Book1/xhtml/00_Cover", "Book1/xhtml/01a_Title", "Book1/xhtml/03_Preface", "Book1/xhtml/04_Postscript", "Book1/xhtml/05_Chapter01", "Book1/xhtml/06_Chapter02", "Book1/xhtml/07_Chapter03", "Book1/xhtml/08_Chapter04", "Book1/xhtml/09_Chapter05", "Book1/xhtml/10_Chapter06", "Book1/xhtml/11_Chapter07", "Book1/xhtml/12_Chapter08", "Book1/xhtml/13_Chapter09", "Book1/xhtml/14_Chapter10", "Book1/xhtml/15_Chapter11", "Book1/xhtml/16_Chapter12", "Book1/xhtml/17_Chapter13", "Book1/xhtml/18_Chapter14", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/V3YESr/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_bundle_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_bundle_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ebb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ebb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bundle_title__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_bundle_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_bundle_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_content__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_bundle_content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_bundle_content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Book1_xhtml_00_Cover__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Book1_xhtml_00_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Book1_xhtml_00_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_01a_Title__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_01a_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_01a_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_03_Preface__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_03_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_03_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_04_Postscript__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_04_Postscript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_04_Postscript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_05_Chapter01__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_05_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_05_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_06_Chapter02__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_06_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_06_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_07_Chapter03__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_07_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_07_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_08_Chapter04__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_08_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_08_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_09_Chapter05__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_09_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_09_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_10_Chapter06__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_10_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_10_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_11_Chapter07__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_11_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_11_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_12_Chapter08__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_12_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_12_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_13_Chapter09__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_13_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_13_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_14_Chapter10__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_14_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_14_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_15_Chapter11__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_15_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_15_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_16_Chapter12__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_16_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_16_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_17_Chapter13__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_17_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_17_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_18_Chapter14__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_18_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_18_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_19_Chapter15__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_19_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Book1_xhtml_19_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_20_Chapter16__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_20_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Book1_xhtml_20_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_21_Chapter17__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_21_Chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_Book1_xhtml_21_Chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_22_Chapter18__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_22_Chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Book1_xhtml_22_Chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_23_Chapter19__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_23_Chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Book1_xhtml_23_Chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_24_Chapter20__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_24_Chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_Book1_xhtml_24_Chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_25_Chapter21__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_25_Chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_Book1_xhtml_25_Chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_26_Chapter22__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_26_Chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_Book1_xhtml_26_Chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_27_Chapter23__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_27_Chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_Book1_xhtml_27_Chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_28_Chapter24__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_28_Chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_Book1_xhtml_28_Chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_29_Chapter25__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_29_Chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_Book1_xhtml_29_Chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_30_Chapter26__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_30_Chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_Book1_xhtml_30_Chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_31_Chapter27__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_31_Chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_Book1_xhtml_31_Chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_32_Chapter28__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_32_Chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_Book1_xhtml_32_Chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_33_Chapter29__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_33_Chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_Book1_xhtml_33_Chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_34_Chapter30__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_34_Chapter30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_Book1_xhtml_34_Chapter30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_35_Chapter31__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_35_Chapter31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_Book1_xhtml_35_Chapter31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_36_Chapter32__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_36_Chapter32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_Book1_xhtml_36_Chapter32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_37_Chapter33__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_37_Chapter33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_Book1_xhtml_37_Chapter33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_38_Chapter34__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_38_Chapter34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_Book1_xhtml_38_Chapter34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_39_Chapter35__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_39_Chapter35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_Book1_xhtml_39_Chapter35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_40_Chapter36__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_40_Chapter36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_Book1_xhtml_40_Chapter36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_41_Chapter37__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_41_Chapter37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_Book1_xhtml_41_Chapter37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_42_Chapter38__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_42_Chapter38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_Book1_xhtml_42_Chapter38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_43_Chapter39__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_43_Chapter39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_Book1_xhtml_43_Chapter39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_44_Chapter40__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_44_Chapter40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_Book1_xhtml_44_Chapter40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_45_Chapter41__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_45_Chapter41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_Book1_xhtml_45_Chapter41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book1_xhtml_46_Chapter42__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_Book1_xhtml_46_Chapter42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_Book1_xhtml_46_Chapter42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book1_xhtml_47_Chapter43__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_Book1_xhtml_47_Chapter43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_Book1_xhtml_47_Chapter43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book1_xhtml_48_Chapter44__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_Book1_xhtml_48_Chapter44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_Book1_xhtml_48_Chapter44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book1_xhtml_49_Chapter45__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_Book1_xhtml_49_Chapter45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_Book1_xhtml_49_Chapter45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book1_xhtml_50_Chapter46__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_Book1_xhtml_50_Chapter46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_Book1_xhtml_50_Chapter46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book1_xhtml_51_Chapter47__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_Book1_xhtml_51_Chapter47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_Book1_xhtml_51_Chapter47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book1_xhtml_52_Chapter48__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_Book1_xhtml_52_Chapter48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_Book1_xhtml_52_Chapter48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book1_xhtml_53_Chapter49__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_Book1_xhtml_53_Chapter49___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_Book1_xhtml_53_Chapter49__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book1_xhtml_54_Chapter50__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_Book1_xhtml_54_Chapter50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_Book1_xhtml_54_Chapter50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book1_xhtml_55_Chapter51__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_Book1_xhtml_55_Chapter51___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_Book1_xhtml_55_Chapter51__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book1_xhtml_56_Chapter52__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_Book1_xhtml_56_Chapter52___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_Book1_xhtml_56_Chapter52__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book1_xhtml_57_Chapter53__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_Book1_xhtml_57_Chapter53___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_Book1_xhtml_57_Chapter53__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book1_xhtml_58_Chapter54__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_Book1_xhtml_58_Chapter54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_Book1_xhtml_58_Chapter54__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_00_Cover__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_00_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_Book2_xhtml_00_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_01_Title__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_01_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_Book2_xhtml_01_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_03_Authors_Preface__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_03_Authors_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_Book2_xhtml_03_Authors_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_04_Chapter01__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_04_Chapter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_Book2_xhtml_04_Chapter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_05_Chapter02__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_05_Chapter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_Book2_xhtml_05_Chapter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_06_Chapter03__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_06_Chapter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_Book2_xhtml_06_Chapter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_07_Chapter04__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_07_Chapter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_Book2_xhtml_07_Chapter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_08_Chapter05__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_08_Chapter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_Book2_xhtml_08_Chapter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_09_Chapter06__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_09_Chapter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_Book2_xhtml_09_Chapter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_10_Chapter07__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_10_Chapter07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_Book2_xhtml_10_Chapter07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_11_Chapter08__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_11_Chapter08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_Book2_xhtml_11_Chapter08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_12_Chapter09__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_12_Chapter09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_Book2_xhtml_12_Chapter09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_13_Chapter10__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_13_Chapter10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_Book2_xhtml_13_Chapter10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_14_Chapter11__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_14_Chapter11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_Book2_xhtml_14_Chapter11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_15_Chapter12__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_15_Chapter12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_Book2_xhtml_15_Chapter12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_16_Chapter13__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_16_Chapter13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_Book2_xhtml_16_Chapter13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_17_Chapter14__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_17_Chapter14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_Book2_xhtml_17_Chapter14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_18_Chapter15__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_18_Chapter15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__components_Book2_xhtml_18_Chapter15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_19_Chapter16__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_19_Chapter16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__components_Book2_xhtml_19_Chapter16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_20_Chapter17__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_20_Chapter17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__components_Book2_xhtml_20_Chapter17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_21_Chapter18__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_21_Chapter18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__components_Book2_xhtml_21_Chapter18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_22_Chapter19__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_22_Chapter19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__components_Book2_xhtml_22_Chapter19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_23_Chapter20__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_23_Chapter20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__components_Book2_xhtml_23_Chapter20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_24_Chapter21__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_24_Chapter21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__components_Book2_xhtml_24_Chapter21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_25_Chapter22__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_25_Chapter22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__components_Book2_xhtml_25_Chapter22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_26_Chapter23__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_26_Chapter23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__components_Book2_xhtml_26_Chapter23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_27_Chapter24__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_27_Chapter24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__components_Book2_xhtml_27_Chapter24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_28_Chapter25__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_28_Chapter25___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__components_Book2_xhtml_28_Chapter25__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book2_xhtml_29_Chapter26__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_Book2_xhtml_29_Chapter26___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__components_Book2_xhtml_29_Chapter26__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book2_xhtml_30_Chapter27__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_Book2_xhtml_30_Chapter27___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__components_Book2_xhtml_30_Chapter27__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book2_xhtml_31_Chapter28__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_Book2_xhtml_31_Chapter28___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__components_Book2_xhtml_31_Chapter28__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book2_xhtml_32_Chapter29__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_Book2_xhtml_32_Chapter29___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__components_Book2_xhtml_32_Chapter29__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book2_xhtml_33_Chapter30__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_Book2_xhtml_33_Chapter30___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__components_Book2_xhtml_33_Chapter30__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book2_xhtml_34_Chapter31__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_Book2_xhtml_34_Chapter31___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__components_Book2_xhtml_34_Chapter31__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book2_xhtml_35_Chapter32__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_Book2_xhtml_35_Chapter32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__components_Book2_xhtml_35_Chapter32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book2_xhtml_36_Chapter33__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_Book2_xhtml_36_Chapter33___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__components_Book2_xhtml_36_Chapter33__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book2_xhtml_37_Chapter34__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_Book2_xhtml_37_Chapter34___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__components_Book2_xhtml_37_Chapter34__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book2_xhtml_38_Chapter35__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__components_Book2_xhtml_38_Chapter35___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__components_Book2_xhtml_38_Chapter35__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book2_xhtml_39_Chapter36__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__components_Book2_xhtml_39_Chapter36___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__components_Book2_xhtml_39_Chapter36__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book2_xhtml_40_Chapter37__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__components_Book2_xhtml_40_Chapter37___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__components_Book2_xhtml_40_Chapter37__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book2_xhtml_41_Chapter38__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__components_Book2_xhtml_41_Chapter38___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__components_Book2_xhtml_41_Chapter38__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book2_xhtml_42_Chapter39__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__components_Book2_xhtml_42_Chapter39___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__components_Book2_xhtml_42_Chapter39__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book2_xhtml_43_Chapter40__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__components_Book2_xhtml_43_Chapter40___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__components_Book2_xhtml_43_Chapter40__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book2_xhtml_44_Chapter41__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__components_Book2_xhtml_44_Chapter41___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__components_Book2_xhtml_44_Chapter41__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book2_xhtml_45_Chapter42__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__components_Book2_xhtml_45_Chapter42___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__components_Book2_xhtml_45_Chapter42__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book2_xhtml_46_Chapter43__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__components_Book2_xhtml_46_Chapter43___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__components_Book2_xhtml_46_Chapter43__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book2_xhtml_47_Chapter44__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__components_Book2_xhtml_47_Chapter44___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__components_Book2_xhtml_47_Chapter44__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book2_xhtml_48_Chapter45__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__components_Book2_xhtml_48_Chapter45___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__components_Book2_xhtml_48_Chapter45__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book2_xhtml_49_Chapter46__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__components_Book2_xhtml_49_Chapter46___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__components_Book2_xhtml_49_Chapter46__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book2_xhtml_50_Chapter47__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__components_Book2_xhtml_50_Chapter47___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__components_Book2_xhtml_50_Chapter47__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book2_xhtml_51_Chapter48__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__components_Book2_xhtml_51_Chapter48___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__components_Book2_xhtml_51_Chapter48__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book2_xhtml_52_Chapter49__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__components_Book2_xhtml_52_Chapter49___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__components_Book2_xhtml_52_Chapter49__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book2_xhtml_53_Chapter50__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__components_Book2_xhtml_53_Chapter50___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__components_Book2_xhtml_53_Chapter50__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book2_xhtml_54_Chapter51__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__components_Book2_xhtml_54_Chapter51___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__components_Book2_xhtml_54_Chapter51__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book2_xhtml_55_Chapter52__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__components_Book2_xhtml_55_Chapter52___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__components_Book2_xhtml_55_Chapter52__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book2_xhtml_56_Chapter53__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__components_Book2_xhtml_56_Chapter53___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__components_Book2_xhtml_56_Chapter53__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book2_xhtml_57_Chapter54__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__components_Book2_xhtml_57_Chapter54___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__components_Book2_xhtml_57_Chapter54__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book2_xhtml_58_Chapter55__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__components_Book2_xhtml_58_Chapter55___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__components_Book2_xhtml_58_Chapter55__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book2_xhtml_59_Chapter56__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__components_Book2_xhtml_59_Chapter56___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__components_Book2_xhtml_59_Chapter56__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book2_xhtml_60_Chapter57__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__components_Book2_xhtml_60_Chapter57___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__components_Book2_xhtml_60_Chapter57__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book2_xhtml_61_Chapter58__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__components_Book2_xhtml_61_Chapter58___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__components_Book2_xhtml_61_Chapter58__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book2_xhtml_62_Chapter59__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__components_Book2_xhtml_62_Chapter59___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__components_Book2_xhtml_62_Chapter59__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book2_xhtml_63_Chapter60__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__components_Book2_xhtml_63_Chapter60___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__components_Book2_xhtml_63_Chapter60__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book2_xhtml_64_Chapter61__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__components_Book2_xhtml_64_Chapter61___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__components_Book2_xhtml_64_Chapter61__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book2_xhtml_65_Chapter62__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__components_Book2_xhtml_65_Chapter62___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__components_Book2_xhtml_65_Chapter62__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book2_xhtml_66_Chapter63__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__components_Book2_xhtml_66_Chapter63___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__components_Book2_xhtml_66_Chapter63__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book2_xhtml_67_Chapter64__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__components_Book2_xhtml_67_Chapter64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__components_Book2_xhtml_67_Chapter64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book2_xhtml_68_Chapter65__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__components_Book2_xhtml_68_Chapter65___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__components_Book2_xhtml_68_Chapter65__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_00_Cover__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_00_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__components_Book3_xhtml_00_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_01_Title__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_01_Title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__components_Book3_xhtml_01_Title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_03_Part_01__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_03_Part_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__components_Book3_xhtml_03_Part_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book3_xhtml_04_P01_Ch_01__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__components_Book3_xhtml_04_P01_Ch_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__components_Book3_xhtml_04_P01_Ch_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book3_xhtml_05_P01_Ch_02__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__components_Book3_xhtml_05_P01_Ch_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__components_Book3_xhtml_05_P01_Ch_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book3_xhtml_06_P01_Ch_03__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__components_Book3_xhtml_06_P01_Ch_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__components_Book3_xhtml_06_P01_Ch_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book3_xhtml_07_P01_Ch_04__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__components_Book3_xhtml_07_P01_Ch_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__components_Book3_xhtml_07_P01_Ch_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book3_xhtml_08_P01_Ch_05__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__components_Book3_xhtml_08_P01_Ch_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__components_Book3_xhtml_08_P01_Ch_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book3_xhtml_09_P01_Ch_06__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__components_Book3_xhtml_09_P01_Ch_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__components_Book3_xhtml_09_P01_Ch_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book3_xhtml_10_P01_Ch_07__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__components_Book3_xhtml_10_P01_Ch_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__components_Book3_xhtml_10_P01_Ch_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book3_xhtml_11_P01_Ch_08__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__components_Book3_xhtml_11_P01_Ch_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__components_Book3_xhtml_11_P01_Ch_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book3_xhtml_12_P01_Ch_09__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__components_Book3_xhtml_12_P01_Ch_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__components_Book3_xhtml_12_P01_Ch_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book3_xhtml_13_P01_Ch_10__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__components_Book3_xhtml_13_P01_Ch_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__components_Book3_xhtml_13_P01_Ch_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book3_xhtml_14_P01_Ch_11__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__components_Book3_xhtml_14_P01_Ch_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__components_Book3_xhtml_14_P01_Ch_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book3_xhtml_15_P01_Ch_12__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__components_Book3_xhtml_15_P01_Ch_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__components_Book3_xhtml_15_P01_Ch_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book3_xhtml_16_P01_Ch_13__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__components_Book3_xhtml_16_P01_Ch_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__components_Book3_xhtml_16_P01_Ch_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book3_xhtml_17_P01_Ch_14__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__components_Book3_xhtml_17_P01_Ch_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__components_Book3_xhtml_17_P01_Ch_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book3_xhtml_18_P01_Ch_15__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__components_Book3_xhtml_18_P01_Ch_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__components_Book3_xhtml_18_P01_Ch_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book3_xhtml_19_P01_Ch_16__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__components_Book3_xhtml_19_P01_Ch_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__components_Book3_xhtml_19_P01_Ch_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book3_xhtml_20_P01_Ch_17__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__components_Book3_xhtml_20_P01_Ch_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__components_Book3_xhtml_20_P01_Ch_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book3_xhtml_21_Part_02__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__components_Book3_xhtml_21_Part_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__components_Book3_xhtml_21_Part_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_Book3_xhtml_22_P02_Ch_01__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__components_Book3_xhtml_22_P02_Ch_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__components_Book3_xhtml_22_P02_Ch_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book3_xhtml_23_P02_Ch_02__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__components_Book3_xhtml_23_P02_Ch_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__components_Book3_xhtml_23_P02_Ch_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_Book3_xhtml_24_P02_Ch_03__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__components_Book3_xhtml_24_P02_Ch_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__components_Book3_xhtml_24_P02_Ch_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book3_xhtml_25_P02_Ch_04__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__components_Book3_xhtml_25_P02_Ch_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__components_Book3_xhtml_25_P02_Ch_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book3_xhtml_26_P02_Ch_05__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__components_Book3_xhtml_26_P02_Ch_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__components_Book3_xhtml_26_P02_Ch_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_Book3_xhtml_27_P02_Ch_06__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__components_Book3_xhtml_27_P02_Ch_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__components_Book3_xhtml_27_P02_Ch_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_Book3_xhtml_28_P02_Ch_07__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__components_Book3_xhtml_28_P02_Ch_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__components_Book3_xhtml_28_P02_Ch_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_Book3_xhtml_29_P02_Ch_08__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__components_Book3_xhtml_29_P02_Ch_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__components_Book3_xhtml_29_P02_Ch_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_Book3_xhtml_30_P02_Ch_09__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__components_Book3_xhtml_30_P02_Ch_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__components_Book3_xhtml_30_P02_Ch_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_Book3_xhtml_31_P02_Ch_10__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__components_Book3_xhtml_31_P02_Ch_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__components_Book3_xhtml_31_P02_Ch_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_Book3_xhtml_32_P02_Ch_11__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__components_Book3_xhtml_32_P02_Ch_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__components_Book3_xhtml_32_P02_Ch_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_Book3_xhtml_33_P02_Ch_12__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__components_Book3_xhtml_33_P02_Ch_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__components_Book3_xhtml_33_P02_Ch_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_Book3_xhtml_34_P02_Ch_13__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__components_Book3_xhtml_34_P02_Ch_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__components_Book3_xhtml_34_P02_Ch_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_Book3_xhtml_35_P02_Ch_14__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__components_Book3_xhtml_35_P02_Ch_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__components_Book3_xhtml_35_P02_Ch_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_Book3_xhtml_36_P02_Ch_15__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__components_Book3_xhtml_36_P02_Ch_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__components_Book3_xhtml_36_P02_Ch_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_Book3_xhtml_37_P02_Ch_16__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__components_Book3_xhtml_37_P02_Ch_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__components_Book3_xhtml_37_P02_Ch_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_Book3_xhtml_38_Part_03__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__components_Book3_xhtml_38_Part_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__components_Book3_xhtml_38_Part_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_Book3_xhtml_39_P03_Ch_01__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__components_Book3_xhtml_39_P03_Ch_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__components_Book3_xhtml_39_P03_Ch_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_Book3_xhtml_40_P03_Ch_02__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__components_Book3_xhtml_40_P03_Ch_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__components_Book3_xhtml_40_P03_Ch_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_Book3_xhtml_41_P03_Ch_03__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__components_Book3_xhtml_41_P03_Ch_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__components_Book3_xhtml_41_P03_Ch_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_Book3_xhtml_42_P03_Ch_04__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__components_Book3_xhtml_42_P03_Ch_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__components_Book3_xhtml_42_P03_Ch_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_Book3_xhtml_43_P03_Ch_05__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__components_Book3_xhtml_43_P03_Ch_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__components_Book3_xhtml_43_P03_Ch_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_Book3_xhtml_44_P03_Ch_06__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__components_Book3_xhtml_44_P03_Ch_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__components_Book3_xhtml_44_P03_Ch_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_Book3_xhtml_45_P03_Ch_07__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__components_Book3_xhtml_45_P03_Ch_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__components_Book3_xhtml_45_P03_Ch_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_Book3_xhtml_46_P03_Ch_08__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__components_Book3_xhtml_46_P03_Ch_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__components_Book3_xhtml_46_P03_Ch_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_Book3_xhtml_47_P03_Ch_09__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__components_Book3_xhtml_47_P03_Ch_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__components_Book3_xhtml_47_P03_Ch_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_Book3_xhtml_48_P03_Ch_10__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__components_Book3_xhtml_48_P03_Ch_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__components_Book3_xhtml_48_P03_Ch_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_Book3_xhtml_49_P03_Ch_11__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__components_Book3_xhtml_49_P03_Ch_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__components_Book3_xhtml_49_P03_Ch_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_Book3_xhtml_50_P03_Ch_12__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__components_Book3_xhtml_50_P03_Ch_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__components_Book3_xhtml_50_P03_Ch_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_Book3_xhtml_51_P03_Ch_13__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__components_Book3_xhtml_51_P03_Ch_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__components_Book3_xhtml_51_P03_Ch_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_Book3_xhtml_52_P03_Ch_14__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__components_Book3_xhtml_52_P03_Ch_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__components_Book3_xhtml_52_P03_Ch_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_Book3_xhtml_53_P03_Ch_15__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__components_Book3_xhtml_53_P03_Ch_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__components_Book3_xhtml_53_P03_Ch_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_Book3_xhtml_54_P03_Ch_16__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__components_Book3_xhtml_54_P03_Ch_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__components_Book3_xhtml_54_P03_Ch_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_Book3_xhtml_55_P03_Ch_17__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__components_Book3_xhtml_55_P03_Ch_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__components_Book3_xhtml_55_P03_Ch_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_Book3_xhtml_56_Part_04__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__components_Book3_xhtml_56_Part_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__components_Book3_xhtml_56_Part_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_Book3_xhtml_57_P04_Ch_01__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__components_Book3_xhtml_57_P04_Ch_01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__components_Book3_xhtml_57_P04_Ch_01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_Book3_xhtml_58_P04_Ch_02__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__components_Book3_xhtml_58_P04_Ch_02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__components_Book3_xhtml_58_P04_Ch_02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_Book3_xhtml_59_P04_Ch_03__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__components_Book3_xhtml_59_P04_Ch_03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__components_Book3_xhtml_59_P04_Ch_03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_Book3_xhtml_60_P04_Ch_04__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__components_Book3_xhtml_60_P04_Ch_04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__components_Book3_xhtml_60_P04_Ch_04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_Book3_xhtml_61_P04_Ch_05__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__components_Book3_xhtml_61_P04_Ch_05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__components_Book3_xhtml_61_P04_Ch_05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_Book3_xhtml_62_P04_Ch_06__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__components_Book3_xhtml_62_P04_Ch_06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__components_Book3_xhtml_62_P04_Ch_06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_Book3_xhtml_63_P04_Ch_07__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__components_Book3_xhtml_63_P04_Ch_07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__components_Book3_xhtml_63_P04_Ch_07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_Book3_xhtml_64_P04_Ch_08__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__components_Book3_xhtml_64_P04_Ch_08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__components_Book3_xhtml_64_P04_Ch_08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_Book3_xhtml_65_P04_Ch_09__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__components_Book3_xhtml_65_P04_Ch_09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__components_Book3_xhtml_65_P04_Ch_09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_Book3_xhtml_66_P04_Ch_10__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__components_Book3_xhtml_66_P04_Ch_10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__components_Book3_xhtml_66_P04_Ch_10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_Book3_xhtml_67_P04_Ch_11__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__components_Book3_xhtml_67_P04_Ch_11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__components_Book3_xhtml_67_P04_Ch_11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_Book3_xhtml_68_P04_Ch_12__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__components_Book3_xhtml_68_P04_Ch_12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__components_Book3_xhtml_68_P04_Ch_12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_Book3_xhtml_69_P04_Ch_13__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__components_Book3_xhtml_69_P04_Ch_13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__components_Book3_xhtml_69_P04_Ch_13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_Book3_xhtml_70_P04_Ch_14__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__components_Book3_xhtml_70_P04_Ch_14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__components_Book3_xhtml_70_P04_Ch_14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_Book3_xhtml_71_P04_Ch_15__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__components_Book3_xhtml_71_P04_Ch_15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__components_Book3_xhtml_71_P04_Ch_15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_Book3_xhtml_72_P04_Ch_16__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__components_Book3_xhtml_72_P04_Ch_16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__components_Book3_xhtml_72_P04_Ch_16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_Book3_xhtml_73_P04_Ch_17__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__components_Book3_xhtml_73_P04_Ch_17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__components_Book3_xhtml_73_P04_Ch_17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_Book3_xhtml_74_Postscript__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__components_Book3_xhtml_74_Postscript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__components_Book3_xhtml_74_Postscript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_love_2__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__components_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__components_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_Comon_copyright__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__components_Comon_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__components_Comon_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_Book3_xhtml_auba__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__components_Book3_xhtml_auba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__components_Book3_xhtml_auba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__components_ORIMad__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__components_ORIMad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__components_ORIMad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__components_last__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__components_last__);
/*jshint esversion: 6 */
























































































































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/bundle_content",
    "name": "bundle_content",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_bundle_content___default.a
  }, {
    "path": "/Book1/xhtml/00_Cover",
    "name": "Book1/xhtml/00_Cover",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_Book1_xhtml_00_Cover___default.a
  }, {
    "path": "/Book1/xhtml/01a_Title",
    "name": "Book1/xhtml/01a_Title",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_Book1_xhtml_01a_Title___default.a
  }, {
    "path": "/Book1/xhtml/03_Preface",
    "name": "Book1/xhtml/03_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_Book1_xhtml_03_Preface___default.a
  }, {
    "path": "/Book1/xhtml/04_Postscript",
    "name": "Book1/xhtml/04_Postscript",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_Book1_xhtml_04_Postscript___default.a
  }, {
    "path": "/Book1/xhtml/05_Chapter01",
    "name": "Book1/xhtml/05_Chapter01",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_Book1_xhtml_05_Chapter01___default.a
  }, {
    "path": "/Book1/xhtml/06_Chapter02",
    "name": "Book1/xhtml/06_Chapter02",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_Book1_xhtml_06_Chapter02___default.a
  }, {
    "path": "/Book1/xhtml/07_Chapter03",
    "name": "Book1/xhtml/07_Chapter03",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_Book1_xhtml_07_Chapter03___default.a
  }, {
    "path": "/Book1/xhtml/08_Chapter04",
    "name": "Book1/xhtml/08_Chapter04",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_Book1_xhtml_08_Chapter04___default.a
  }, {
    "path": "/Book1/xhtml/09_Chapter05",
    "name": "Book1/xhtml/09_Chapter05",
    "component": __WEBPACK_IMPORTED_MODULE_17__components_Book1_xhtml_09_Chapter05___default.a
  }, {
    "path": "/Book1/xhtml/10_Chapter06",
    "name": "Book1/xhtml/10_Chapter06",
    "component": __WEBPACK_IMPORTED_MODULE_18__components_Book1_xhtml_10_Chapter06___default.a
  }, {
    "path": "/Book1/xhtml/11_Chapter07",
    "name": "Book1/xhtml/11_Chapter07",
    "component": __WEBPACK_IMPORTED_MODULE_19__components_Book1_xhtml_11_Chapter07___default.a
  }, {
    "path": "/Book1/xhtml/12_Chapter08",
    "name": "Book1/xhtml/12_Chapter08",
    "component": __WEBPACK_IMPORTED_MODULE_20__components_Book1_xhtml_12_Chapter08___default.a
  }, {
    "path": "/Book1/xhtml/13_Chapter09",
    "name": "Book1/xhtml/13_Chapter09",
    "component": __WEBPACK_IMPORTED_MODULE_21__components_Book1_xhtml_13_Chapter09___default.a
  }, {
    "path": "/Book1/xhtml/14_Chapter10",
    "name": "Book1/xhtml/14_Chapter10",
    "component": __WEBPACK_IMPORTED_MODULE_22__components_Book1_xhtml_14_Chapter10___default.a
  }, {
    "path": "/Book1/xhtml/15_Chapter11",
    "name": "Book1/xhtml/15_Chapter11",
    "component": __WEBPACK_IMPORTED_MODULE_23__components_Book1_xhtml_15_Chapter11___default.a
  }, {
    "path": "/Book1/xhtml/16_Chapter12",
    "name": "Book1/xhtml/16_Chapter12",
    "component": __WEBPACK_IMPORTED_MODULE_24__components_Book1_xhtml_16_Chapter12___default.a
  }, {
    "path": "/Book1/xhtml/17_Chapter13",
    "name": "Book1/xhtml/17_Chapter13",
    "component": __WEBPACK_IMPORTED_MODULE_25__components_Book1_xhtml_17_Chapter13___default.a
  }, {
    "path": "/Book1/xhtml/18_Chapter14",
    "name": "Book1/xhtml/18_Chapter14",
    "component": __WEBPACK_IMPORTED_MODULE_26__components_Book1_xhtml_18_Chapter14___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_213__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charles Dickens\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An international celebrity during his lifetime, Charles Dickens (1812­–1870) is widely regarded as the greatest novelist of the Victorian era. His classic works include "), _c('I', [_vm._v("A Christmas Carol")]), _vm._v(", "), _c('I', [_vm._v("Oliver Twist")]), _vm._v(", "), _c('I', [_vm._v("David Copperfield")]), _vm._v(", "), _c('I', [_vm._v("Great Expectations")]), _vm._v(", and "), _c('I', [_vm._v("A Tale of Two Cities")]), _vm._v(", one of the bestselling novels of all time. When Dickens was twelve years old, his father was sent to debtors’ prison, and the boy was forced to work in a boot-blacking factory to support his family. The experience greatly shaped both his fiction and his tireless advocacy for children’s rights and social reform.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/V3YESr/tc-custom/9781504065146.jpg?1737121728562",
      "alt": "This image is the cover for the book Charles Dickens Collection Volume Two"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Charles Dickens Collection Volume Two\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three classic novels of wealth, poverty, murder, and ambition from the greatest storyteller of the Victorian era.")]), _c('br'), _c('br'), _vm._v(" Filled with drama, emotion, and suspense, these three novels have compelled and delighted readers for well over a century."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Martin Chuzzlewit")]), _vm._v(": After losing his inheritance, a young man strives to make his own fortune, in this witty, wide-ranging saga."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Nicholas Nickleby")]), _vm._v(": A young man fights to save his mother, his sister, and a group of abused schoolboys in this novel of hardship and heroism."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Our Mutual Friend")]), _vm._v(": When a corpse is found in the River Thames, it will alter the course of several lives."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “In addition to its realistic police procedures and incisive criminal psychology, "), _c('i', [_vm._v("Our Mutual Friend")]), _vm._v(" is steeped in the gloomy atmosphere and foreboding imagery that one associates with the modern suspense thriller.” —"), _c('i', [_vm._v("The New York Times")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc2"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/00_Cover"
    }
  }, [_vm._v("Martin Chuzzlewit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/01a_Title"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/03_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/04_Postscript"
    }
  }, [_vm._v("Postscript")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/05_Chapter01"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/06_Chapter02"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/07_Chapter03"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/08_Chapter04"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/09_Chapter05"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/10_Chapter06"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/11_Chapter07"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/12_Chapter08"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/13_Chapter09"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/14_Chapter10"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/15_Chapter11"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/16_Chapter12"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/17_Chapter13"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/18_Chapter14"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/19_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/20_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/21_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/22_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/23_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/24_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/25_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/26_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/27_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/28_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/29_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/30_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/31_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/32_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/33_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/34_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/35_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/36_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/37_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/38_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/39_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/40_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/41_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/42_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/43_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/44_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/45_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/46_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/47_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/48_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/49_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/50_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/51_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/52_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/53_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/54_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/55_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/56_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/57_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/58_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Four")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicholas Nickleby")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/01_Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/03_Authors_Preface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/04_Chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/05_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/06_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/07_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/08_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/09_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/10_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/11_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/12_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/13_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/14_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/15_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/16_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/17_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/18_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/19_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/20_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/21_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/22_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/23_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/24_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/25_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/26_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/27_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/28_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/29_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/30_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/31_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/32_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/33_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/34_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/35_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/36_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/37_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/38_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/39_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/40_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/41_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/42_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/43_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/44_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 41")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/45_Chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 42")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/46_Chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 43")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/47_Chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 44")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/48_Chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 45")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/49_Chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 46")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/50_Chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 47")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/51_Chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 48")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/52_Chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 49")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/53_Chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 50")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/54_Chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 51")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/55_Chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 52")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/56_Chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 53")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/57_Chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 54")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/58_Chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/59_Chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 56")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/60_Chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 57")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/61_Chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 58")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/62_Chapter59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 59")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/63_Chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 60")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/64_Chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 61")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/65_Chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 62")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/66_Chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 63")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/67_Chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 64")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/68_Chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 65")])]), _vm._v(" "), _c('div', {
    staticClass: "toc1"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/00_Cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Mutual Friend")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/01_Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/03_Part_01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BOOK THE FIRST—THE CUP AND THE LIP")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/04_P01_Ch_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/05_P01_Ch_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/06_P01_Ch_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/07_P01_Ch_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/08_P01_Ch_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/09_P01_Ch_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/10_P01_Ch_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/11_P01_Ch_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/12_P01_Ch_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/13_P01_Ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/14_P01_Ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/15_P01_Ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/16_P01_Ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/17_P01_Ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/18_P01_Ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/19_P01_Ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/20_P01_Ch_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/21_Part_02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BOOK THE SECOND—BIRDS OF A FEATHER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/22_P02_Ch_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/23_P02_Ch_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/24_P02_Ch_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/25_P02_Ch_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/26_P02_Ch_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/27_P02_Ch_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/28_P02_Ch_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/29_P02_Ch_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/30_P02_Ch_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/31_P02_Ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/32_P02_Ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/33_P02_Ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/34_P02_Ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/35_P02_Ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/36_P02_Ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/37_P02_Ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/38_Part_03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BOOK THE THIRD—A LONG LANE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/39_P03_Ch_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/40_P03_Ch_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/41_P03_Ch_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/42_P03_Ch_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/43_P03_Ch_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/44_P03_Ch_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/45_P03_Ch_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/46_P03_Ch_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/47_P03_Ch_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/48_P03_Ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/49_P03_Ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/50_P03_Ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/51_P03_Ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/52_P03_Ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/53_P03_Ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/54_P03_Ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/55_P03_Ch_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/56_Part_04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BOOK THE FOURTH—A TURNING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/57_P04_Ch_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/58_P04_Ch_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/59_P04_Ch_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/60_P04_Ch_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/61_P04_Ch_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/62_P04_Ch_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/63_P04_Ch_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/64_P04_Ch_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/65_P04_Ch_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/66_P04_Ch_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/67_P04_Ch_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/68_P04_Ch_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/69_P04_Ch_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/70_P04_Ch_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/71_P04_Ch_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/72_P04_Ch_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/73_P04_Ch_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/74_Postscript",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postscript")])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_C"
    }
  }, [_c('img', {
    staticClass: "svg_cover",
    attrs: {
      "alt": "image",
      "src": "Book1/images/cover.jpg"
    }
  })])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Martin Chuzzlewit")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "author"
  }, [_vm._v("Charles Dickens")]), _vm._v(" "), _c('div', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/logo.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("What is exaggeration to one class of minds and perceptions, is plain truth to another. That which is commonly called a long-sight, perceives in a prospect innumerable features and bearings non-existent to a short-sighted person. I sometimes ask myself whether there may occasionally be a difference of this kind between some writers and some readers; whether it is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always")]), _vm._v(" the writer who colours highly, or whether it is now and then the reader whose eye for colour is a little dull?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On this head of exaggeration I have a positive experience, more curious than the speculation I have just set down. It is this: I have never touched a character precisely from the life, but some counterpart of that character has incredulously asked me: “Now really, did I ever really, see one like it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the Pecksniff family upon earth are quite agreed, I believe, that Mr Pecksniff is an exaggeration, and that no such character ever existed. I will not offer any plea on his behalf to so powerful and genteel a body, but will make a remark on the character of Jonas Chuzzlewit.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I conceive that the sordid coarseness and brutality of Jonas would be unnatural, if there had been nothing in his early education, and in the precept and example always before him, to engender and develop the vices that make him odious. But, so born and so bred, admired for that which made him hateful, and justified from his cradle in cunning, treachery, and avarice; I claim him as the legitimate issue of the father upon whom those vices are seen to recoil. And I submit that their ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("recoil upon that old man, in his unhonoured age, is not a mere piece of poetical justice, but is the extreme exposition of a direct truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I make this comment, and solicit the reader’s attention to it in his or her consideration of this tale, because nothing is more common in real life than a want of profitable reflection on the causes of many vices and crimes that awaken the general horror. What is substantially true of families in this respect, is true of a whole commonwealth. As we sow, we reap. Let the reader go into the children’s side of any prison in England, or, I grieve to add, of many workhouses, and judge whether those are monsters who disgrace our streets, people our hulks and penitentiaries, and overcrowd our penal colonies, or are creatures whom we have deliberately suffered to be bred for misery and ruin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The American portion of this story is in no other respect a caricature than as it is an exhibition, for the most part (Mr Bevan expected), of a ludicrous side, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only")]), _vm._v(", of the American character—of that side which was, four-and-twenty years ago, from its nature, the most obtrusive, and the most likely to be seen by such travellers as Young Martin and Mark Tapley. As I had never, in writing fiction, had any disposition to soften what is ridiculous or wrong at home, so I then hoped that the good-humored people of the United States would not be generally disposed to quarrel with me for carrying the same usage abroad. I am happy to believe that my confidence in that great nation was not misplaced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When this book was first published, I was given to understand, by some authorities, that the Watertoast Association and eloquence were beyond all bounds of belief. Therefore I record the fact that all that portion of Martin Chuzzlewit’s experiences is a literal paraphrase of some reports of public "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("proceedings in the United States (especially of the proceedings of a certain Brandywine Association), which were printed in the Times Newspaper in June and July, 1843—at about the time when I was engaged in writing those parts of the book; and which remain on the file of the Times Newspaper, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In all my writings, I hope I have taken every available opportunity of showing the want of sanitary improvements in the neglected dwellings of the poor. Mrs Sarah Gamp was, four-and-twenty years ago, a fair representation of the hired attendant on the poor in sickness. The hospitals of London were, in many respects, noble Institutions; in others, very defective. I think it not the least among the instances of their mismanagement, that Mrs Betsey Prig was a fair specimen of a Hospital Nurse; and that the Hospitals, with their means and funds, should have left it to private humanity and enterprise, to enter on an attempt to improve that class of persons—since, greatly improved through the agency of good women.")])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("Postscript")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("At a Public Dinner given to me on Saturday the 18th of April, 1868, in the city of New York, by two hundred representatives of the Press of the United States of America, I made the following observations, among others:—")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“So much of my voice has lately been heard in the land, that I might have been contented with troubling you no further from my present standing-point, were it not a duty with which I henceforth charge myself, not only here but on every suitable occasion, whatsoever and wheresoever, to express my high and grateful sense of my second reception in America, and to bear my honest testimony to the national generosity and magnanimity. Also, to declare how astounded I have been by the amazing changes I have seen around me on every side—changes moral, changes physical, changes in the amount of land subdued and peopled, changes in the rise of vast new cities, changes in the growth of older cities almost out of recognition, changes in the graces and amenities of life, changes in the Press, without whose advancement no advancement can take place anywhere. Nor am I, believe me, so arrogant as to suppose that in five-and-twenty years there have been no changes in me, and that I had nothing to learn and no extreme impressions to correct when I was here first. And this brings me to a point on which I have, ever since I landed in the United States last November, observed a strict silence, though sometimes tempted to break it, but in reference to which I will, with your good leave, take you into my ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("confidence now. Even the Press, being human, may be sometimes mistaken or misinformed, and I rather think that I have in one or two rare instances observed its information to be not strictly accurate with reference to myself. Indeed, I have, now and again, been more surprised by printed news that I have read of myself, than by any printed news that I have ever read in my present state of existence. Thus, the vigour and perseverance with which I have for some months past been collecting materials for, and hammering away at, a new book on America has much astonished me; seeing that all that time my declaration has been perfectly well known to my publishers on both sides of the Atlantic, that no consideration on earth would induce me to write one. But what I have intended, what I have resolved upon (and this is the confidence I seek to place in you), is, on my return to England, in my own person, in my own Journal, to bear, for the behoof of my countrymen, such testimony to the gigantic changes in this country as I have hinted at to-night. Also, to record that wherever I have been, in the smallest places equally with the largest, I have been received with unsurpassable politeness, delicacy, sweet temper, hospitality, consideration, and with unsurpassable respect for the privacy daily enforced upon me by the nature of my avocation here and the state of my health. This testimony, so long as I live, and so long as my descendants have any legal right in my books, I shall cause to be republished, as an appendix to every copy of those two books of mine in which I have referred to America. And this I will do and cause to be done, not in mere love and thankfulness, but because I regard it as an act of plain justice and honour.”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("I said these words with the greatest earnestness that I could lay upon them, and I repeat them in print here with equal earnestness. So long as this book shall last, I hope that ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("they will form a part of it, and will be fairly read as inseparable from my experiences and impressions of America.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "att"
  }, [_vm._v("CHARLES DICKENS.")]), _vm._v(" "), _c('p', {
    staticClass: "atta"
  }, [_vm._v("May, 1868.")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Introductory, Concerning the Pedigree of the Chuzzlewit Family")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As no lady or gentleman, with any claims to polite breeding, can possibly sympathize with the Chuzzlewit Family without being first assured of the extreme antiquity of the race, it is a great satisfaction to know that it undoubtedly descended in a direct line from Adam and Eve; and was, in the very earliest times, closely connected with the agricultural interest. If it should ever be urged by grudging and malicious persons, that a Chuzzlewit, in any period of the family history, displayed an overweening amount of family pride, surely the weakness will be considered not only pardonable but laudable, when the immense superiority of the house to the rest of mankind, in respect of this its ancient origin, is taken into account.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("It is remarkable that as there was, in the oldest family of which we have any record, a murderer and a vagabond, so we never fail to meet, in the records of all old families, with innumerable repetitions of the same phase of character. Indeed, it may be laid down as a general principle, that the more extended the ancestry, the greater the amount of violence and vagabondism; for in ancient days those two amusements, combining a wholesome excitement with a promising means of repairing shattered fortunes, were at once the ennobling ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("pursuit and the healthful recreation of the Quality of this land.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Consequently, it is a source of inexpressible comfort and happiness to find, that in various periods of our history, the Chuzzlewits were actively connected with divers slaughterous conspiracies and bloody frays. It is further recorded of them, that being clad from head to heel in steel of proof, they did on many occasions lead their leather-jerkined soldiers to the death with invincible courage, and afterwards return home gracefully to their relations and friends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There can be no doubt that at least one Chuzzlewit came over with William the Conqueror. It does not appear that this illustrious ancestor ‘came over’ that monarch, to employ the vulgar phrase, at any subsequent period; inasmuch as the Family do not seem to have been ever greatly distinguished by the possession of landed estate. And it is well known that for the bestowal of that kind of property upon his favourites, the liberality and gratitude of the Norman were as remarkable as those virtues are usually found to be in great men when they give away what belongs to other people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps in this place the history may pause to congratulate itself upon the enormous amount of bravery, wisdom, eloquence, virtue, gentle birth, and true nobility, that appears to have come into England with the Norman Invasion: an amount which the genealogy of every ancient family lends its aid to swell, and which would beyond all question have been found to be just as great, and to the full as prolific in giving birth to long lines of chivalrous descendants, boastful of their origin, even though William the Conqueror had been William the Conquered; a change of circumstances which, it is quite certain, would have made no manner of difference in this respect.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("There was unquestionably a Chuzzlewit in the Gunpowder ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Plot, if indeed the arch-traitor, Fawkes himself, were not a scion of this remarkable stock; as he might easily have been, supposing another Chuzzlewit to have emigrated to Spain in the previous generation, and there intermarried with a Spanish lady, by whom he had issue, one olive-complexioned son. This probable conjecture is strengthened, if not absolutely confirmed, by a fact which cannot fail to be interesting to those who are curious in tracing the progress of hereditary tastes through the lives of their unconscious inheritors. It is a notable circumstance that in these later times, many Chuzzlewits, being unsuccessful in other pursuits, have, without the smallest rational hope of enriching themselves, or any conceivable reason, set up as coal-merchants; and have, month after month, continued gloomily to watch a small stock of coals, without in any one instance negotiating with a purchaser. The remarkable similarity between this course of proceeding and that adopted by their Great Ancestor beneath the vaults of the Parliament House at Westminster, is too obvious and too full of interest, to stand in need of comment.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It is also clearly proved by the oral traditions of the Family, that there existed, at some one period of its history which is not distinctly stated, a matron of such destructive principles, and so familiarized to the use and composition of inflammatory and combustible engines, that she was called ‘The Match Maker;’ by which nickname and byword she is recognized in the Family legends to this day. Surely there can be no reasonable doubt that this was the Spanish lady, the mother of Chuzzlewit Fawkes.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("But there is one other piece of evidence, bearing immediate reference to their close connection with this memorable event in English History, which must carry conviction, even to a mind (if such a mind there be) remaining unconvinced by ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("these presumptive proofs.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("There was, within a few years, in the possession of a highly respectable and in every way credible and unimpeachable member of the Chuzzlewit Family (for his bitterest enemy never dared to hint at his being otherwise than a wealthy man), a dark lantern of undoubted antiquity; rendered still more interesting by being, in shape and pattern, extremely like such as are in use at the present day. Now this gentleman, since deceased, was at all times ready to make oath, and did again and again set forth upon his solemn asseveration, that he had frequently heard his grandmother say, when contemplating this venerable relic, ‘Aye, aye! This was carried by my fourth son on the fifth of November, when he was a Guy Fawkes.’ These remarkable words wrought (as well they might) a strong impression on his mind, and he was in the habit of repeating them very often. The just interpretation which they bear, and the conclusion to which they lead, are triumphant and irresistible. The old lady, naturally strong-minded, was nevertheless frail and fading; she was notoriously subject to that confusion of ideas, or, to say the least, of speech, to which age and garrulity are liable. The slight, the very slight, confusion apparent in these expressions is manifest, and is ludicrously easy of correction. ‘Aye, aye,’ quoth she, and it will be observed that no emendation whatever is necessary to be made in these two initiative remarks, ‘Aye, aye! This lantern was carried by my forefather’—not fourth son, which is preposterous—‘on the fifth of November. And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" was Guy Fawkes.’ Here we have a remark at once consistent, clear, natural, and in strict accordance with the character of the speaker. Indeed the anecdote is so plainly susceptible of this meaning and no other, that it would be hardly worth recording in its original state, were it not a proof of what may be (and very ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("often is) affected not only in historical prose but in imaginative poetry, by the exercise of a little ingenious labour on the part of a commentator.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It has been said that there is no instance, in modern times, of a Chuzzlewit having been found on terms of intimacy with the Great. But here again the sneering detractors who weave such miserable figments from their malicious brains, are stricken dumb by evidence. For letters are yet in the possession of various branches of the family, from which it distinctly appears, being stated in so many words, that one Diggory Chuzzlewit was in the habit of perpetually dining with Duke Humphrey. So constantly was he a guest at that nobleman’s table, indeed; and so unceasingly were His Grace’s hospitality and companionship forced, as it were, upon him; that we find him uneasy, and full of constraint and reluctance; writing his friends to the effect that if they fail to do so and so by bearer, he will have no choice but to dine again with Duke Humphrey; and expressing himself in a very marked and extraordinary manner as one surfeited of High Life and Gracious Company.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("It has been rumoured, and it is needless to say the rumour originated in the same base quarters, that a certain male Chuzzlewit, whose birth must be admitted to be involved in some obscurity, was of very mean and low descent. How stands the proof? When the son of that individual, to whom the secret of his father’s birth was supposed to have been communicated by his father in his lifetime, lay upon his deathbed, this question was put to him in a distinct, solemn, and formal way: ‘Toby Chuzzlewit, who was your grandfather?’ To which he, with his last breath, no less distinctly, solemnly, and formally replied: and his words were taken down at the time, and signed by six witnesses, each with his name and address in full: ‘The Lord No Zoo.’ It may be said—")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" been said, for human wickedness has no limits—that there is no Lord of that name, and that among the titles which have become extinct, none at all resembling this, in sound even, is to be discovered. But what is the irresistible inference? Rejecting a theory broached by some well-meaning but mistaken persons, that this Mr Toby Chuzzlewit’s grandfather, to judge from his name, must surely have been a Mandarin (which is wholly insupportable, for there is no pretence of his grandmother ever having been out of this country, or of any Mandarin having been in it within some years of his father’s birth; except those in the tea-shops, which cannot for a moment be regarded as having any bearing on the question, one way or other), rejecting this hypothesis, is it not manifest that Mr Toby Chuzzlewit had either received the name imperfectly from his father, or that he had forgotten it, or that he had mispronounced it? and that even at the recent period in question, the Chuzzlewits were connected by a bend sinister, or kind of heraldic over-the-left, with some unknown noble and illustrious House?")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("From documentary evidence, yet preserved in the family, the fact is clearly established that in the comparatively modern days of the Diggory Chuzzlewit before mentioned, one of its members had attained to very great wealth and influence. Throughout such fragments of his correspondence as have escaped the ravages of the moths (who, in right of their extensive absorption of the contents of deeds and papers, may be called the general registers of the Insect World), we find him making constant reference to an uncle, in respect of whom he would seem to have entertained great expectations, as he was in the habit of seeking to propitiate his favour by presents of plate, jewels, books, watches, and other valuable articles. Thus, he writes on one occasion to his brother in reference to ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("a gravy-spoon, the brother’s property, which he (Diggory) would appear to have borrowed or otherwise possessed himself of: ‘Do not be angry, I have parted with it—to my uncle.’ On another occasion he expresses himself in a similar manner with regard to a child’s mug which had been entrusted to him to get repaired. On another occasion he says, ‘I have bestowed upon that irresistible uncle of mine everything I ever possessed.’ And that he was in the habit of paying long and constant visits to this gentleman at his mansion, if, indeed, he did not wholly reside there, is manifest from the following sentence: ‘With the exception of the suit of clothes I carry about with me, the whole of my wearing apparel is at present at my uncle’s.’ This gentleman’s patronage and influence must have been very extensive, for his nephew writes, ‘His interest is too high’—’It is too much’—’It is tremendous’—and the like. Still it does not appear (which is strange) to have procured for him any lucrative post at court or elsewhere, or to have conferred upon him any other distinction than that which was necessarily included in the countenance of so great a man, and the being invited by him to certain entertainment’s, so splendid and costly in their nature, that he calls them ‘Golden Balls.’")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("It is needless to multiply instances of the high and lofty station, and the vast importance of the Chuzzlewits, at different periods. If it came within the scope of reasonable probability that further proofs were required, they might be heaped upon each other until they formed an Alps of testimony, beneath which the boldest scepticism should be crushed and beaten flat. As a goodly tumulus is already collected, and decently battened up above the Family grave, the present chapter is content to leave it as it is: merely adding, by way of a final spadeful, that many Chuzzlewits, both male and female, are proved to demonstration, on the faith of letters written by ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("their own mothers, to have had chiselled noses, undeniable chins, forms that might have served the sculptor for a model, exquisitely-turned limbs and polished foreheads of so transparent a texture that the blue veins might be seen branching off in various directions, like so many roads on an ethereal map. This fact in itself, though it had been a solitary one, would have utterly settled and clenched the business in hand; for it is well known, on the authority of all the books which treat of such matters, that every one of these phenomena, but especially that of the chiselling, are invariably peculiar to, and only make themselves apparent in, persons of the very best condition.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("This history having, to its own perfect satisfaction, (and, consequently, to the full contentment of all its readers,) proved the Chuzzlewits to have had an origin, and to have been at one time or other of an importance which cannot fail to render them highly improving and acceptable acquaintance to all right-minded individuals, may now proceed in earnest with its task. And having shown that they must have had, by reason of their ancient birth, a pretty large share in the foundation and increase of the human family, it will one day become its province to submit, that such of its members as shall be introduced in these pages, have still many counterparts and prototypes in the Great World about us. At present it contents itself with remarking, in a general way, on this head: Firstly, that it may be safely asserted, and yet without implying any direct participation in the Manboddo doctrine touching the probability of the human race having once been monkeys, that men do play very strange and extraordinary tricks. Secondly, and yet without trenching on the Blumenbach theory as to the descendants of Adam having a vast number of qualities which belong more particularly to swine than to any ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("other class of animals in the creation, that some men certainly are remarkable for taking uncommon good care of themselves.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  })])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Chapter Two")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Wherin Certain Persons are Presented to the Reader, with whom He May, if He Please, Become Better Acqainted")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was pretty late in the autumn of the year, when the declining sun struggling through the mist which had obscured it all day, looked brightly down upon a little Wiltshire village, within an easy journey of the fair old town of Salisbury.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Like a sudden flash of memory or spirit kindling up the mind of an old man, it shed a glory upon the scene, in which its departed youth and freshness seemed to live again. The wet grass sparkled in the light; the scanty patches of verdure in the hedges—where a few green twigs yet stood together bravely, resisting to the last the tyranny of nipping winds and early frosts—took heart and brightened up; the stream which had been dull and sullen all day long, broke out into a cheerful smile; the birds began to chirp and twitter on the naked boughs, as though the hopeful creatures half believed that winter had gone by, and spring had come already. The vane upon the tapering spire of the old church glistened from its lofty station in sympathy with the general gladness; and from the ivy-shaded windows such gleams of light shone back upon ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("the glowing sky, that it seemed as if the quiet buildings were the hoarding-place of twenty summers, and all their ruddiness and warmth were stored within.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Even those tokens of the season which emphatically whispered of the coming winter, graced the landscape, and, for the moment, tinged its livelier features with no oppressive air of sadness. The fallen leaves, with which the ground was strewn, gave forth a pleasant fragrance, and subduing all harsh sounds of distant feet and wheels created a repose in gentle unison with the light scattering of seed hither and thither by the distant husbandman, and with the noiseless passage of the plough as it turned up the rich brown earth, and wrought a graceful pattern in the stubbled fields. On the motionless branches of some trees, autumn berries hung like clusters of coral beads, as in those fabled orchards where the fruits were jewels; others stripped of all their garniture, stood, each the centre of its little heap of bright red leaves, watching their slow decay; others again, still wearing theirs, had them all crunched and crackled up, as though they had been burnt; about the stems of some were piled, in ruddy mounds, the apples they had borne that year; while others (hardy evergreens this class) showed somewhat stern and gloomy in their vigour, as charged by nature with the admonition that it is not to her more sensitive and joyous favourites she grants the longest term of life. Still athwart their darker boughs, the sunbeams struck out paths of deeper gold; and the red light, mantling in among their swarthy branches, used them as foils to set its brightness off, and aid the lustre of the dying day.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("A moment, and its glory was no more. The sun went down beneath the long dark lines of hill and cloud which piled up in the west an airy city, wall heaped on wall, and battlement on battlement; the light was all withdrawn; the shining church ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("turned cold and dark; the stream forgot to smile; the birds were silent; and the gloom of winter dwelt on everything.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("An evening wind uprose too, and the slighter branches cracked and rattled as they moved, in skeleton dances, to its moaning music. The withering leaves no longer quiet, hurried to and fro in search of shelter from its chill pursuit; the labourer unyoked his horses, and with head bent down, trudged briskly home beside them; and from the cottage windows lights began to glance and wink upon the darkening fields.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then the village forge came out in all its bright importance. The lusty bellows roared Ha ha! to the clear fire, which roared in turn, and bade the shining sparks dance gayly to the merry clinking of the hammers on the anvil. The gleaming iron, in its emulation, sparkled too, and shed its red-hot gems around profusely. The strong smith and his men dealt such strokes upon their work, as made even the melancholy night rejoice, and brought a glow into its dark face as it hovered about the door and windows, peeping curiously in above the shoulders of a dozen loungers. As to this idle company, there they stood, spellbound by the place, and, casting now and then a glance upon the darkness in their rear, settled their lazy elbows more at ease upon the sill, and leaned a little further in: no more disposed to tear themselves away than if they had been born to cluster round the blazing hearth like so many crickets.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Out upon the angry wind! how from sighing, it began to bluster round the merry forge, banging at the wicket, and grumbling in the chimney, as if it bullied the jolly bellows for doing anything to order. And what an impotent swaggerer it was too, for all its noise; for if it had any influence on that hoarse companion, it was but to make him roar his cheerful song the louder, and by consequence to make the fire burn the brighter, and the sparks to dance more gayly yet; at length, ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("they whizzed so madly round and round, that it was too much for such a surly wind to bear; so off it flew with a howl giving the old sign before the ale-house door such a cuff as it went, that the Blue Dragon was more rampant than usual ever afterwards, and indeed, before Christmas, reared clean out of its crazy frame.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was small tyranny for a respectable wind to go wreaking its vengeance on such poor creatures as the fallen leaves, but this wind happening to come up with a great heap of them just after venting its humour on the insulted Dragon, did so disperse and scatter them that they fled away, pell-mell, some here, some there, rolling over each other, whirling round and round upon their thin edges, taking frantic flights into the air, and playing all manner of extraordinary gambols in the extremity of their distress. Nor was this enough for its malicious fury; for not content with driving them abroad, it charged small parties of them and hunted them into the wheel wright’s saw-pit, and below the planks and timbers in the yard, and, scattering the sawdust in the air, it looked for them underneath, and when it did meet with any, whew! how it drove them on and followed at their heels!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The scared leaves only flew the faster for all this, and a giddy chase it was; for they got into unfrequented places, where there was no outlet, and where their pursuer kept them eddying round and round at his pleasure; and they crept under the eaves of houses, and clung tightly to the sides of hay-ricks, like bats; and tore in at open chamber windows, and cowered close to hedges; and, in short, went anywhere for safety. But the oddest feat they achieved was, to take advantage of the sudden opening of Mr Pecksniff’s front-door, to dash wildly into his passage; whither the wind following close upon them, and finding the back-door open, incontinently ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("blew out the lighted candle held by Miss Pecksniff, and slammed the front-door against Mr Pecksniff who was at that moment entering, with such violence, that in the twinkling of an eye he lay on his back at the bottom of the steps. Being by this time weary of such trifling performances, the boisterous rover hurried away rejoicing, roaring over moor and meadow, hill and flat, until it got out to sea, where it met with other winds similarly disposed, and made a night of it.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime Mr Pecksniff, having received from a sharp angle in the bottom step but one, that sort of knock on the head which lights up, for the patient’s entertainment, an imaginary general illumination of very bright short-sixes, lay placidly staring at his own street door. And it would seem to have been more suggestive in its aspect than street doors usually are; for he continued to lie there, rather a lengthy and unreasonable time, without so much as wondering whether he was hurt or no; neither, when Miss Pecksniff inquired through the key-hole in a shrill voice, which might have belonged to a wind in its teens, ‘Who’s there’ did he make any reply; nor, when Miss Pecksniff opened the door again, and shading the candle with her hand, peered out, and looked provokingly round him, and about him, and over him, and everywhere but at him, did he offer any remark, or indicate in any manner the least hint of a desire to be picked up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I see you,’ cried Miss Pecksniff, to the ideal inflicter of a runaway knock. ‘You’ll catch it, sir!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still Mr Pecksniff, perhaps from having caught it already, said nothing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("‘You’re round the corner now,’ cried Miss Pecksniff. She said it at a venture, but there was appropriate matter in it too; for Mr Pecksniff, being in the act of extinguishing the candles before mentioned pretty rapidly, and of reducing the number ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("of brass knobs on his street door from four or five hundred (which had previously been juggling of their own accord before his eyes in a very novel manner) to a dozen or so, might in one sense have been said to be coming round the corner, and just turning it.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With a sharply delivered warning relative to the cage and the constable, and the stocks and the gallows, Miss Pecksniff was about to close the door again, when Mr Pecksniff (being still at the bottom of the steps) raised himself on one elbow, and sneezed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That voice!’ cried Miss Pecksniff. ‘My parent!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this exclamation, another Miss Pecksniff bounced out of the parlour; and the two Miss Pecksniffs, with many incoherent expressions, dragged Mr Pecksniff into an upright posture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pa!’ they cried in concert. ‘Pa! Speak, Pa! Do not look so wild my dearest Pa!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But as a gentleman’s looks, in such a case of all others, are by no means under his own control, Mr Pecksniff continued to keep his mouth and his eyes very wide open, and to drop his lower jaw, somewhat after the manner of a toy nut-cracker; and as his hat had fallen off, and his face was pale, and his hair erect, and his coat muddy, the spectacle he presented was so very doleful, that neither of the Miss Pecksniffs could repress an involuntary screech.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’ll do,’ said Mr Pecksniff. ‘I’m better.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s come to himself!’ cried the youngest Miss Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He speaks again!’ exclaimed the eldest.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("With these joyful words they kissed Mr Pecksniff on either cheek; and bore him into the house. Presently, the youngest Miss Pecksniff ran out again to pick up his hat, his brown paper parcel, his umbrella, his gloves, and other small articles; and that done, and the door closed, both young ladies applied ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("themselves to tending Mr Pecksniff’s wounds in the back parlour.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were not very serious in their nature; being limited to abrasions on what the eldest Miss Pecksniff called ‘the knobby parts’ of her parent’s anatomy, such as his knees and elbows, and to the development of an entirely new organ, unknown to phrenologists, on the back of his head. These injuries having been comforted externally, with patches of pickled brown paper, and Mr Pecksniff having been comforted internally, with some stiff brandy-and-water, the eldest Miss Pecksniff sat down to make the tea, which was all ready. In the meantime the youngest Miss Pecksniff brought from the kitchen a smoking dish of ham and eggs, and, setting the same before her father, took up her station on a low stool at his feet; thereby bringing her eyes on a level with the teaboard.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("It must not be inferred from this position of humility, that the youngest Miss Pecksniff was so young as to be, as one may say, forced to sit upon a stool, by reason of the shortness of her legs. Miss Pecksniff sat upon a stool because of her simplicity and innocence, which were very great, very great. Miss Pecksniff sat upon a stool because she was all girlishness, and playfulness, and wildness, and kittenish buoyancy. She was the most arch and at the same time the most artless creature, was the youngest Miss Pecksniff, that you can possibly imagine. It was her great charm. She was too fresh and guileless, and too full of child-like vivacity, was the youngest Miss Pecksniff, to wear combs in her hair, or to turn it up, or to frizzle it, or braid it. She wore it in a crop, a loosely flowing crop, which had so many rows of curls in it, that the top row was only one curl. Moderately buxom was her shape, and quite womanly too; but sometimes—yes, sometimes—she even wore a pinafore; and how charming "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" was! Oh! she was indeed ‘a gushing ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("thing’ (as a young gentleman had observed in verse, in the Poet’s Corner of a provincial newspaper), was the youngest Miss Pecksniff!")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff was a moral man—a grave man, a man of noble sentiments and speech—and he had had her christened Mercy. Mercy! oh, what a charming name for such a pure-souled Being as the youngest Miss Pecksniff! Her sister’s name was Charity. There was a good thing! Mercy and Charity! And Charity, with her fine strong sense and her mild, yet not reproachful gravity, was so well named, and did so well set off and illustrate her sister! What a pleasant sight was that the contrast they presented; to see each loved and loving one sympathizing with, and devoted to, and leaning on, and yet correcting and counter-checking, and, as it were, antidoting, the other! To behold each damsel in her very admiration of her sister, setting up in business for herself on an entirely different principle, and announcing no connection with over-the-way, and if the quality of goods at that establishment don’t please you, you are respectfully invited to favour "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" with a call! And the crowning circumstance of the whole delightful catalogue was, that both the fair creatures were so utterly unconscious of all this! They had no idea of it. They no more thought or dreamed of it than Mr Pecksniff did. Nature played them off against each other; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they")]), _vm._v(" had no hand in it, the two Miss Pecksniffs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("It has been remarked that Mr Pecksniff was a moral man. So he was. Perhaps there never was a more moral man than Mr Pecksniff, especially in his conversation and correspondence. It was once said of him by a homely admirer, that he had a Fortunatus’s purse of good sentiments in his inside. In this particular he was like the girl in the fairy tale, except that if they were not actual diamonds which fell from his lips, they ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("were the very brightest paste, and shone prodigiously. He was a most exemplary man; fuller of virtuous precept than a copy book. Some people likened him to a direction-post, which is always telling the way to a place, and never goes there; but these were his enemies, the shadows cast by his brightness; that was all. His very throat was moral. You saw a good deal of it. You looked over a very low fence of white cravat (whereof no man had ever beheld the tie for he fastened it behind), and there it lay, a valley between two jutting heights of collar, serene and whiskerless before you. It seemed to say, on the part of Mr Pecksniff, ‘There is no deception, ladies and gentlemen, all is peace, a holy calm pervades me.’ So did his hair, just grizzled with an iron-grey which was all brushed off his forehead, and stood bolt upright, or slightly drooped in kindred action with his heavy eyelids. So did his person, which was sleek though free from corpulency. So did his manner, which was soft and oily. In a word, even his plain black suit, and state of widower and dangling double eye-glass, all tended to the same purpose, and cried aloud, ‘Behold the moral Pecksniff!’")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The brazen plate upon the door (which being Mr Pecksniff’s, could not lie) bore this inscription, ‘PECKSNIFF, ARCHITECT,’ to which Mr Pecksniff, on his cards of business, added, AND LAND SURVEYOR.’ In one sense, and only one, he may be said to have been a Land Surveyor on a pretty large scale, as an extensive prospect lay stretched out before the windows of his house. Of his architectural doings, nothing was clearly known, except that he had never designed or built anything; but it was generally understood that his knowledge of the science was almost awful in its profundity.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Mr Pecksniff’s professional engagements, indeed, were almost, if not entirely, confined to the reception of pupils; for the collection of rents, with which pursuit he occasionally varied ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("and relieved his graver toils, can hardly be said to be a strictly architectural employment. His genius lay in ensnaring parents and guardians, and pocketing premiums. A young gentleman’s premium being paid, and the young gentleman come to Mr Pecksniff’s house, Mr Pecksniff borrowed his case of mathematical instruments (if silver-mounted or otherwise valuable); entreated him, from that moment, to consider himself one of the family; complimented him highly on his parents or guardians, as the case might be; and turned him loose in a spacious room on the two-pair front; where, in the company of certain drawing-boards, parallel rulers, very stiff-legged compasses, and two, or perhaps three, other young gentlemen, he improved himself, for three or five years, according to his articles, in making elevations of Salisbury Cathedral from every possible point of sight; and in constructing in the air a vast quantity of Castles, Houses of Parliament, and other Public Buildings. Perhaps in no place in the world were so many gorgeous edifices of this class erected as under Mr Pecksniff’s auspices; and if but one-twentieth part of the churches which were built in that front room, with one or other of the Miss Pecksniffs at the altar in the act of marrying the architect, could only be made available by the parliamentary commissioners, no more churches would be wanted for at least five centuries.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Even the worldly goods of which we have just disposed,’ said Mr Pecksniff, glancing round the table when he had finished, ‘even cream, sugar, tea, toast, ham—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And eggs,’ suggested Charity in a low voice.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("‘And eggs,’ said Mr Pecksniff, ‘even they have their moral. See how they come and go! Every pleasure is transitory. We can’t even eat, long. If we indulge in harmless fluids, we get the dropsy; if in exciting liquids, we get drunk. What a soothing ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("reflection is that!’")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t say "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("we")]), _vm._v(" get drunk, Pa,’ urged the eldest Miss Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When I say we, my dear,’ returned her father, ‘I mean mankind in general; the human race, considered as a body, and not as individuals. There is nothing personal in morality, my love. Even such a thing as this,’ said Mr Pecksniff, laying the fore-finger of his left hand upon the brown paper patch on the top of his head, ‘slight casual baldness though it be, reminds us that we are but’—he was going to say ‘worms,’ but recollecting that worms were not remarkable for heads of hair, he substituted ‘flesh and blood.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Which,’ cried Mr Pecksniff after a pause, during which he seemed to have been casting about for a new moral, and not quite successfully, ‘which is also very soothing. Mercy, my dear, stir the fire and throw up the cinders.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young lady obeyed, and having done so, resumed her stool, reposed one arm upon her father’s knee, and laid her blooming cheek upon it. Miss Charity drew her chair nearer the fire, as one prepared for conversation, and looked towards her father.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Mr Pecksniff, after a short pause, during which he had been silently smiling, and shaking his head at the fire—’I have again been fortunate in the attainment of my object. A new inmate will very shortly come among us.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A youth, papa?’ asked Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ye-es, a youth,’ said Mr Pecksniff. ‘He will avail himself of the eligible opportunity which now offers, for uniting the advantages of the best practical architectural education with the comforts of a home, and the constant association with some who (however humble their sphere, and limited their capacity) are not unmindful of their moral responsibilities.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("‘Oh Pa!’ cried Mercy, holding up her finger archly. ‘See advertisement!’")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Playful—playful warbler,’ said Mr Pecksniff. It may be observed in connection with his calling his daughter a ‘warbler,’ that she was not at all vocal, but that Mr Pecksniff was in the frequent habit of using any word that occurred to him as having a good sound, and rounding a sentence well without much care for its meaning. And he did this so boldly, and in such an imposing manner, that he would sometimes stagger the wisest people with his eloquence, and make them gasp again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His enemies asserted, by the way, that a strong trustfulness in sounds and forms was the master-key to Mr Pecksniff’s character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is he handsome, Pa?’ inquired the younger daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Silly Merry!’ said the eldest: Merry being fond for Mercy. ‘What is the premium, Pa? tell us that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, good gracious, Cherry!’ cried Miss Mercy, holding up her hands with the most winning giggle in the world, ‘what a mercenary girl you are! oh you naughty, thoughtful, prudent thing!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was perfectly charming, and worthy of the Pastoral age, to see how the two Miss Pecksniffs slapped each other after this, and then subsided into an embrace expressive of their different dispositions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is well looking,’ said Mr Pecksniff, slowly and distinctly; ‘well looking enough. I do not positively expect any immediate premium with him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Notwithstanding their different natures, both Charity and Mercy concurred in opening their eyes uncommonly wide at this announcement, and in looking for the moment as blank as if their thoughts had actually had a direct bearing on the main chance.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("‘But what of that!’ said Mr Pecksniff, still smiling at the fire. ‘There is disinterestedness in the world, I hope? We are not all arrayed in two opposite ranks; the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("of")]), _vm._v("fensive and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de")]), _vm._v("fensive. Some few there are who walk between; who help the needy as they go; and take no part with either side. Umph!’")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was something in these morsels of philanthropy which reassured the sisters. They exchanged glances, and brightened very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! let us not be for ever calculating, devising, and plotting for the future,’ said Mr Pecksniff, smiling more and more, and looking at the fire as a man might, who was cracking a joke with it: ‘I am weary of such arts. If our inclinations are but good and open-hearted, let us gratify them boldly, though they bring upon us Loss instead of Profit. Eh, Charity?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Glancing towards his daughters for the first time since he had begun these reflections, and seeing that they both smiled, Mr Pecksniff eyed them for an instant so jocosely (though still with a kind of saintly waggishness) that the younger one was moved to sit upon his knee forthwith, put her fair arms round his neck, and kiss him twenty times. During the whole of this affectionate display she laughed to a most immoderate extent: in which hilarious indulgence even the prudent Cherry joined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tut, tut,’ said Mr Pecksniff, pushing his latest-born away and running his fingers through his hair, as he resumed his tranquil face. ‘What folly is this! Let us take heed how we laugh without reason lest we cry with it. What is the domestic news since yesterday? John Westlock is gone, I hope?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed, no,’ said Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And why not?’ returned her father. ‘His term expired yesterday. And his box was packed, I know; for I saw it, in the morning, standing in the hall.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("‘He slept last night at the Dragon,’ returned the young lady, ‘and had Mr Pinch to dine with him. They spent the evening together, and Mr Pinch was not home till very late.’")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And when I saw him on the stairs this morning, Pa,’ said Mercy with her usual sprightliness, ‘he looked, oh goodness, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("such")]), _vm._v(" a monster! with his face all manner of colours, and his eyes as dull as if they had been boiled, and his head aching dreadfully, I am sure from the look of it, and his clothes smelling, oh it’s impossible to say how strong, oh’—here the young lady shuddered—‘of smoke and punch.’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20059m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now I think,’ said Mr Pecksniff with his accustomed gentleness, though still with the air of one who suffered under injury without complaint, ‘I think Mr Pinch might have done better than choose for his companion one who, at the close of a long intercourse, had endeavoured, as he knew, to wound my feelings. I am not quite sure that this was delicate in Mr Pinch. I am not quite sure that this was kind in Mr Pinch. I will go further and say, I am not quite sure that this was even ordinarily grateful in Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But what can anyone expect from Mr Pinch!’ cried Charity, with as strong and scornful an emphasis on the name as if it would have given her unspeakable pleasure to express it, in an acted charade, on the calf of that gentleman’s leg.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("‘Aye, aye,’ returned her father, raising his hand mildly: ‘it is very well to say what can we expect from Mr Pinch, but Mr Pinch is a fellow-creature, my dear; Mr Pinch is an item in the vast total of humanity, my love; and we have a right, it is our duty, to expect in Mr Pinch some development of those better qualities, the possession of which in our own persons inspires our humble self-respect. No,’ continued Mr Pecksniff. ‘No! Heaven forbid that I should say, nothing can be expected from Mr Pinch; or that I should say, nothing can be expected from ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("any man alive (even the most degraded, which Mr Pinch is not, no, really); but Mr Pinch has disappointed me; he has hurt me; I think a little the worse of him on this account, but not if human nature. Oh, no, no!’")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hark!’ said Miss Charity, holding up her finger, as a gentle rap was heard at the street door. ‘There is the creature! Now mark my words, he has come back with John Westlock for his box, and is going to help him to take it to the mail. Only mark my words, if that isn’t his intention!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even as she spoke, the box appeared to be in progress of conveyance from the house, but after a brief murmuring of question and answer, it was put down again, and somebody knocked at the parlour door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come in!’ cried Mr Pecksniff—not severely; only virtuously. ‘Come in!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ungainly, awkward-looking man, extremely short-sighted, and prematurely bald, availed himself of this permission; and seeing that Mr Pecksniff sat with his back towards him, gazing at the fire, stood hesitating, with the door in his hand. He was far from handsome certainly; and was drest in a snuff-coloured suit, of an uncouth make at the best, which, being shrunk with long wear, was twisted and tortured into all kinds of odd shapes; but notwithstanding his attire, and his clumsy figure, which a great stoop in his shoulders, and a ludicrous habit he had of thrusting his head forward, by no means redeemed, one would not have been disposed (unless Mr Pecksniff said so) to consider him a bad fellow by any means. He was perhaps about thirty, but he might have been almost any age between sixteen and sixty; being one of those strange creatures who never decline into an ancient appearance, but look their oldest when they are very young, and get it over at once.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Keeping his hand upon the lock of the door, he glanced from Mr Pecksniff to Mercy, from Mercy to Charity, and from Charity to Mr Pecksniff again, several times; but the young ladies being as intent upon the fire as their father was, and neither of the three taking any notice of him, he was fain to say, at last,")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! I beg your pardon, Mr Pecksniff: I beg your pardon for intruding; but—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No intrusion, Mr Pinch,’ said that gentleman very sweetly, but without looking round. ‘Pray be seated, Mr Pinch. Have the goodness to shut the door, Mr Pinch, if you please.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Certainly, sir,’ said Pinch; not doing so, however, but holding it rather wider open than before, and beckoning nervously to somebody without: ‘Mr Westlock, sir, hearing that you were come home—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Pinch, Mr Pinch!’ said Pecksniff, wheeling his chair about, and looking at him with an aspect of the deepest melancholy, ‘I did not expect this from you. I have not deserved this from you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, but upon my word, sir—’ urged Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The less you say, Mr Pinch,’ interposed the other, ‘the better. I utter no complaint. Make no defence.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, but do have the goodness, sir,’ cried Pinch, with great earnestness, ‘if you please. Mr Westlock, sir, going away for good and all, wishes to leave none but friends behind him. Mr Westlock and you, sir, had a little difference the other day; you have had many little differences.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Little differences!’ cried Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Little differences!’ echoed Mercy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("‘My loves!’ said Mr Pecksniff, with the same serene upraising of his hand; ‘My dears!’ After a solemn pause he meekly bowed to Mr Pinch, as who should say, ‘Proceed;’ but Mr Pinch ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("was so very much at a loss how to resume, and looked so helplessly at the two Miss Pecksniffs, that the conversation would most probably have terminated there, if a good-looking youth, newly arrived at man’s estate, had not stepped forward from the doorway and taken up the thread of the discourse.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come, Mr Pecksniff,’ he said, with a smile, ‘don’t let there be any ill-blood between us, pray. I am sorry we have ever differed, and extremely sorry I have ever given you offence. Bear me no ill-will at parting, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I bear,’ answered Mr Pecksniff, mildly, ‘no ill-will to any man on earth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told you he didn’t,’ said Pinch, in an undertone; ‘I knew he didn’t! He always says he don’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then you will shake hands, sir?’ cried Westlock, advancing a step or two, and bespeaking Mr Pinch’s close attention by a glance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Umph!’ said Mr Pecksniff, in his most winning tone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You will shake hands, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, John,’ said Mr Pecksniff, with a calmness quite ethereal; ‘no, I will not shake hands, John. I have forgiven you. I had already forgiven you, even before you ceased to reproach and taunt me. I have embraced you in the spirit, John, which is better than shaking hands.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pinch,’ said the youth, turning towards him, with a hearty disgust of his late master, ‘what did I tell you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Pinch looked down uneasily at Mr Pecksniff, whose eye was fixed upon him as it had been from the first; and looking up at the ceiling again, made no reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As to your forgiveness, Mr Pecksniff,’ said the youth, ‘I’ll not have it upon such terms. I won’t be forgiven.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("‘Won’t you, John?’ retorted Mr Pecksniff, with a smile. ‘You must. You can’t help it. Forgiveness is a high quality; an exalted ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("virtue; far above "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" control or influence, John. I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" forgive you. You cannot move me to remember any wrong you have ever done me, John.’")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wrong!’ cried the other, with all the heat and impetuosity of his age. ‘Here’s a pretty fellow! Wrong! Wrong I have done him! He’ll not even remember the five hundred pounds he had with me under false pretences; or the seventy pounds a year for board and lodging that would have been dear at seventeen! Here’s a martyr!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Money, John,’ said Mr Pecksniff, ‘is the root of all evil. I grieve to see that it is already bearing evil fruit in you. But I will not remember its existence. I will not even remember the conduct of that misguided person’—and here, although he spoke like one at peace with all the world, he used an emphasis that plainly said “I have my eye upon the rascal now”—‘that misguided person who has brought you here to-night, seeking to disturb (it is a happiness to say, in vain) the heart’s repose and peace of one who would have shed his dearest blood to serve him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The voice of Mr Pecksniff trembled as he spoke, and sobs were heard from his daughters. Sounds floated on the air, moreover, as if two spirit voices had exclaimed: one, ‘Beast!’ the other, ‘Savage!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("‘Forgiveness,’ said Mr Pecksniff, ‘entire and pure forgiveness is not incompatible with a wounded heart; perchance when the heart is wounded, it becomes a greater virtue. With my breast still wrung and grieved to its inmost core by the ingratitude of that person, I am proud and glad to say that I forgive him. Nay! I beg,’ cried Mr Pecksniff, raising his voice, as Pinch appeared about to speak, ‘I beg that individual not to offer a remark; he will truly oblige me by not uttering one word, just now. I am not sure that I am equal to the trial. In a ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("very short space of time, I shall have sufficient fortitude, I trust to converse with him as if these events had never happened. But not,’ said Mr Pecksniff, turning round again towards the fire, and waving his hand in the direction of the door, ‘not now.’")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bah!’ cried John Westlock, with the utmost disgust and disdain the monosyllable is capable of expressing. ‘Ladies, good evening. Come, Pinch, it’s not worth thinking of. I was right and you were wrong. That’s small matter; you’ll be wiser another time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So saying, he clapped that dejected companion on the shoulder, turned upon his heel, and walked out into the passage, whither poor Mr Pinch, after lingering irresolutely in the parlour for a few seconds, expressing in his countenance the deepest mental misery and gloom followed him. Then they took up the box between them, and sallied out to meet the mail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That fleet conveyance passed, every night, the corner of a lane at some distance; towards which point they bent their steps. For some minutes they walked along in silence, until at length young Westlock burst into a loud laugh, and at intervals into another, and another. Still there was no response from his companion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll tell you what, Pinch!’ he said abruptly, after another lengthened silence—‘You haven’t half enough of the devil in you. Half enough! You haven’t any.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well!’ said Pinch with a sigh, ‘I don’t know, I’m sure. It’s compliment to say so. If I haven’t, I suppose, I’m all the better for it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All the better!’ repeated his companion tartly: ‘All the worse, you mean to say.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("‘And yet,’ said Pinch, pursuing his own thoughts and not ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("this last remark on the part of his friend, ‘I must have a good deal of what you call the devil in me, too, or how could I make Pecksniff so uncomfortable? I wouldn’t have occasioned him so much distress—don’t laugh, please—for a mine of money; and Heaven knows I could find good use for it too, John. How grieved he was!’")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" grieved!’ returned the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why didn’t you observe that the tears were almost starting out of his eyes!’ cried Pinch. ‘Bless my soul, John, is it nothing to see a man moved to that extent and know one’s self to be the cause! And did you hear him say that he could have shed his blood for me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("want")]), _vm._v(" any blood shed for you?’ returned his friend, with considerable irritation. ‘Does he shed anything for you that you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" want? Does he shed employment for you, instruction for you, pocket money for you? Does he shed even legs of mutton for you in any decent proportion to potatoes and garden stuff?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid,’ said Pinch, sighing again, ‘that I am a great eater; I can’t disguise from myself that I’m a great eater. Now, you know that, John.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You a great eater!’ retorted his companion, with no less indignation than before. ‘How do you know you are?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There appeared to be forcible matter in this inquiry, for Mr Pinch only repeated in an undertone that he had a strong misgiving on the subject, and that he greatly feared he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Besides, whether I am or no,’ he added, ‘that has little or nothing to do with his thinking me ungrateful. John, there is scarcely a sin in the world that is in my eyes such a crying one as ingratitude; and when he taxes me with that, and believes me to be guilty of it, he makes me miserable and wretched.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("‘Do you think he don’t know that?’ returned the other ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("scornfully. ‘But come, Pinch, before I say anything more to you, just run over the reasons you have for being grateful to him at all, will you? Change hands first, for the box is heavy. That’ll do. Now, go on.’")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the first place,’ said Pinch, ‘he took me as his pupil for much less than he asked.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well,’ rejoined his friend, perfectly unmoved by this instance of generosity. ‘What in the second place?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What in the second place?’ cried Pinch, in a sort of desperation, ‘why, everything in the second place. My poor old grandmother died happy to think that she had put me with such an excellent man. I have grown up in his house, I am in his confidence, I am his assistant, he allows me a salary; when his business improves, my prospects are to improve too. All this, and a great deal more, is in the second place. And in the very prologue and preface to the first place, John, you must consider this, which nobody knows better than I: that I was born for much plainer and poorer things, that I am not a good hand for his kind of business, and have no talent for it, or indeed for anything else but odds and ends that are of no use or service to anybody.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He said this with so much earnestness, and in a tone so full of feeling, that his companion instinctively changed his manner as he sat down on the box (they had by this time reached the finger-post at the end of the lane); motioned him to sit down beside him; and laid his hand upon his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I believe you are one of the best fellows in the world,’ he said, ‘Tom Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all,’ rejoined Tom. ‘If you only knew Pecksniff as well as I do, you might say it of him, indeed, and say it truly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll say anything of him, you like,’ returned the other, ‘and not another word to his disparagement.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("‘It’s for my sake, then; not his, I am afraid,’ said Pinch, shaking his head gravely.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For whose you please, Tom, so that it does please you. Oh! He’s a famous fellow! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" never scraped and clawed into his pouch all your poor grandmother’s hard savings—she was a housekeeper, wasn’t she, Tom?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Mr Pinch, nursing one of his large knees, and nodding his head; ‘a gentleman’s housekeeper.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" never scraped and clawed into his pouch all her hard savings; dazzling her with prospects of your happiness and advancement, which he knew (and no man better) never would be realised! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" never speculated and traded on her pride in you, and her having educated you, and on her desire that you at least should live to be a gentleman. Not he, Tom!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Tom, looking into his friend’s face, as if he were a little doubtful of his meaning. ‘Of course not.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So I say,’ returned the youth, ‘of course he never did. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" didn’t take less than he had asked, because that less was all she had, and more than he expected; not he, Tom! He doesn’t keep you as his assistant because you are of any use to him; because your wonderful faith in his pretensions is of inestimable service in all his mean disputes; because your honesty reflects honesty on him; because your wandering about this little place all your spare hours, reading in ancient books and foreign tongues, gets noised abroad, even as far as Salisbury, making of him, Pecksniff the master, a man of learning and of vast importance. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" gets no credit from you, Tom, not he.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, of course he don’t,’ said Pinch, gazing at his friend with a more troubled aspect than before. ‘Pecksniff get credit from me! Well!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("‘Don’t I say that it’s ridiculous,’ rejoined the other, ‘even to ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("think of such a thing?’")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, it’s madness,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Madness!’ returned young Westlock. ‘Certainly it’s madness. Who but a madman would suppose he cares to hear it said on Sundays, that the volunteer who plays the organ in the church, and practises on summer evenings in the dark, is Mr Pecksniff’s young man, eh, Tom? Who but a madman would suppose it is the game of such a man as he, to have his name in everybody’s mouth, connected with the thousand useless odds and ends you do (and which, of course, he taught you), eh, Tom? Who but a madman would suppose you advertised him hereabouts, much cheaper and much better than a chalker on the walls could, eh, Tom? As well might one suppose that he doesn’t on all occasions pour out his whole heart and soul to you; that he doesn’t make you a very liberal and indeed rather an extravagant allowance; or, to be more wild and monstrous still, if that be possible, as well might one suppose,’ and here, at every word, he struck him lightly on the breast, ‘that Pecksniff traded in your nature, and that your nature was to be timid and distrustful of yourself, and trustful of all other men, but most of all, of him who least deserves it. There would be madness, Tom!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Mr Pinch had listened to all this with looks of bewilderment, which seemed to be in part occasioned by the matter of his companion’s speech, and in part by his rapid and vehement manner. Now that he had come to a close, he drew a very long breath; and gazing wistfully in his face as if he were unable to settle in his own mind what expression it wore, and were desirous to draw from it as good a clue to his real meaning as it was possible to obtain in the dark, was about to answer, when the sound of the mail guard’s horn came cheerily upon their ears, putting an immediate end to the conference; ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("greatly as it seemed to the satisfaction of the younger man, who jumped up briskly, and gave his hand to his companion.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Both hands, Tom. I shall write to you from London, mind!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Pinch. ‘Yes. Do, please. Good-bye. Good-bye. I can hardly believe you’re going. It seems, now, but yesterday that you came. Good-bye! my dear old fellow!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Westlock returned his parting words with no less heartiness of manner, and sprung up to his seat upon the roof. Off went the mail at a canter down the dark road; the lamps gleaming brightly, and the horn awakening all the echoes, far and wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go your ways,’ said Pinch, apostrophizing the coach; ‘I can hardly persuade myself but you’re alive, and are some great monster who visits this place at certain intervals, to bear my friends away into the world. You’re more exulting and rampant than usual tonight, I think; and you may well crow over your prize; for he is a fine lad, an ingenuous lad, and has but one fault that I know of; he don’t mean it, but he is most cruelly unjust to Pecksniff!’")])])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("Chapter Three")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("In which Certain other Persons are Introduced; On the Same Terms as in the Last Chapter")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mention has been already made more than once, of a certain Dragon who swung and creaked complainingly before the village alehouse door. A faded, and an ancient dragon he was; and many a wintry storm of rain, snow, sleet, and hail, had changed his colour from a gaudy blue to a faint lack-lustre shade of grey. But there he hung; rearing, in a state of monstrous imbecility, on his hind legs; waxing, with every month that passed, so much more dim and shapeless, that as you gazed at him on one side of the sign-board it seemed as if he must be gradually melting through it, and coming out upon the other.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("He was a courteous and considerate dragon, too; or had been in his distincter days; for in the midst of his rampant feebleness, he kept one of his forepaws near his nose, as though he would say, ‘Don’t mind me—it’s only my fun;’ while he held out the other in polite and hospitable entreaty. Indeed it must be conceded to the whole brood of dragons of modern times, that they have made a great advance in civilisation and refinement. They no longer demand a beautiful virgin for breakfast every morning, with as much regularity as any tame ")]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("single gentleman expects his hot roll, but rest content with the society of idle bachelors and roving married men; and they are now remarkable rather for holding aloof from the softer sex and discouraging their visits (especially on Saturday nights), than for rudely insisting on their company without any reference to their inclinations, as they are known to have done in days of yore.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nor is this tribute to the reclaimed animals in question so wide a digression into the realms of Natural History as it may, at first sight, appear to be; for the present business of these pages in with the dragon who had his retreat in Mr Pecksniff’s neighbourhood, and that courteous animal being already on the carpet, there is nothing in the way of its immediate transaction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For many years, then, he had swung and creaked, and flapped himself about, before the two windows of the best bedroom of that house of entertainment to which he lent his name; but never in all his swinging, creaking, and flapping, had there been such a stir within its dingy precincts, as on the evening next after that upon which the incidents, detailed in the last chapter occurred; when there was such a hurrying up and down stairs of feet, such a glancing of lights, such a whispering of voices, such a smoking and sputtering of wood newly lighted in a damp chimney, such an airing of linen, such a scorching smell of hot warming-pans, such a domestic bustle and to-do, in short, as never dragon, griffin, unicorn, or other animal of that species presided over, since they first began to interest themselves in household affairs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("An old gentleman and a young lady, travelling, unattended, in a rusty old chariot with post-horses; coming nobody knew whence and going nobody knew whither; had turned out of the high road, and driven unexpectedly to the Blue Dragon; ")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("and here was the old gentleman, who had taken this step by reason of his sudden illness in the carriage, suffering the most horrible cramps and spasms, yet protesting and vowing in the very midst of his pain, that he wouldn’t have a doctor sent for, and wouldn’t take any remedies but those which the young lady administered from a small medicine-chest, and wouldn’t, in a word, do anything but terrify the landlady out of her five wits, and obstinately refuse compliance with every suggestion that was made to him.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Of all the five hundred proposals for his relief which the good woman poured out in less than half an hour, he would entertain but one. That was that he should go to bed. And it was in the preparation of his bed and the arrangement of his chamber, that all the stir was made in the room behind the Dragon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was, beyond all question, very ill, and suffered exceedingly; not the less, perhaps, because he was a strong and vigorous old man, with a will of iron, and a voice of brass. But neither the apprehensions which he plainly entertained, at times, for his life, nor the great pain he underwent, influenced his resolution in the least degree. He would have no person sent for. The worse he grew, the more rigid and inflexible he became in his determination. If they sent for any person to attend him, man, woman, or child, he would leave the house directly (so he told them), though he quitted it on foot, and died upon the threshold of the door.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Now, there being no medical practitioner actually resident in the village, but a poor apothecary who was also a grocer and general dealer, the landlady had, upon her own responsibility, sent for him, in the very first burst and outset of the disaster. Of course it followed, as a necessary result of his being wanted, that he was not at home. He had gone some miles ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("away, and was not expected home until late at night; so the landlady, being by this time pretty well beside herself, dispatched the same messenger in all haste for Mr Pecksniff, as a learned man who could bear a deal of responsibility, and a moral man who could administer a world of comfort to a troubled mind. That her guest had need of some efficient services under the latter head was obvious enough from the restless expressions, importing, however, rather a worldly than a spiritual anxiety, to which he gave frequent utterance.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("From this last-mentioned secret errand, the messenger returned with no better news than from the first; Mr Pecksniff was not at home. However, they got the patient into bed without him; and in the course of two hours, he gradually became so far better that there were much longer intervals than at first between his terms of suffering. By degrees, he ceased to suffer at all; though his exhaustion was occasionally so great that it suggested hardly less alarm than his actual endurance had done.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was in one of his intervals of repose, when, looking round with great caution, and reaching uneasily out of his nest of pillows, he endeavoured, with a strange air of secrecy and distrust, to make use of the writing materials which he had ordered to be placed on a table beside him, that the young lady and the mistress of the Blue Dragon found themselves sitting side by side before the fire in the sick chamber.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("The mistress of the Blue Dragon was in outward appearance just what a landlady should be: broad, buxom, comfortable, and good looking, with a face of clear red and white, which, by its jovial aspect, at once bore testimony to her hearty participation in the good things of the larder and cellar, and to their thriving and healthful influences. She was a widow, but years ago had passed through her state of weeds, and ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("burst into flower again; and in full bloom she had continued ever since; and in full bloom she was now; with roses on her ample skirts, and roses on her bodice, roses in her cap, roses in her cheeks,—aye, and roses, worth the gathering too, on her lips, for that matter. She had still a bright black eye, and jet black hair; was comely, dimpled, plump, and tight as a gooseberry; and though she was not exactly what the world calls young, you may make an affidavit, on trust, before any mayor or magistrate in Christendom, that there are a great many young ladies in the world (blessings on them one and all!) whom you wouldn’t like half as well, or admire half as much, as the beaming hostess of the Blue Dragon.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("As this fair matron sat beside the fire, she glanced occasionally with all the pride of ownership, about the room; which was a large apartment, such as one may see in country places, with a low roof and a sunken flooring, all downhill from the door, and a descent of two steps on the inside so exquisitely unexpected, that strangers, despite the most elaborate cautioning, usually dived in head first, as into a plunging-bath. It was none of your frivolous and preposterously bright bedrooms, where nobody can close an eye with any kind of propriety or decent regard to the association of ideas; but it was a good, dull, leaden, drowsy place, where every article of furniture reminded you that you came there to sleep, and that you were expected to go to sleep. There was no wakeful reflection of the fire there, as in your modern chambers, which upon the darkest nights have a watchful consciousness of French polish; the old Spanish mahogany winked at it now and then, as a dozing cat or dog might, nothing more. The very size and shape, and hopeless immovability of the bedstead, and wardrobe, and in a minor degree of even the chairs and tables, provoked sleep; they were plainly apoplectic and disposed ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("to snore. There were no staring portraits to remonstrate with you for being lazy; no round-eyed birds upon the curtains, disgustingly wide awake, and insufferably prying. The thick neutral hangings, and the dark blinds, and the heavy heap of bed-clothes, were all designed to hold in sleep, and act as nonconductors to the day and getting up. Even the old stuffed fox upon the top of the wardrobe was devoid of any spark of vigilance, for his glass eye had fallen out, and he slumbered as he stood.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The wandering attention of the mistress of the Blue Dragon roved to these things but twice or thrice, and then for but an instant at a time. It soon deserted them, and even the distant bed with its strange burden, for the young creature immediately before her, who, with her downcast eyes intently fixed upon the fire, sat wrapped in silent meditation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was very young; apparently no more than seventeen; timid and shrinking in her manner, and yet with a greater share of self possession and control over her emotions than usually belongs to a far more advanced period of female life. This she had abundantly shown, but now, in her tending of the sick gentleman. She was short in stature; and her figure was slight, as became her years; but all the charms of youth and maidenhood set it off, and clustered on her gentle brow. Her face was very pale, in part no doubt from recent agitation. Her dark brown hair, disordered from the same cause, had fallen negligently from its bonds, and hung upon her neck; for which instance of its waywardness no male observer would have had the heart to blame it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("Her attire was that of a lady, but extremely plain; and in her manner, even when she sat as still as she did then, there was an indefinable something which appeared to be in kindred with her scrupulously unpretending dress. She had sat, ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("at first looking anxiously towards the bed; but seeing that the patient remained quiet, and was busy with his writing, she had softly moved her chair into its present place; partly, as it seemed, from an instinctive consciousness that he desired to avoid observation; and partly that she might, unseen by him, give some vent to the natural feelings she had hitherto suppressed.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Of all this, and much more, the rosy landlady of the Blue Dragon took as accurate note and observation as only woman can take of woman. And at length she said, in a voice too low, she knew, to reach the bed:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have seen the gentleman in this way before, miss? Is he used to these attacks?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have seen him very ill before, but not so ill as he has been tonight.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What a Providence!’ said the landlady of the Dragon, ‘that you had the prescriptions and the medicines with you, miss!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘They are intended for such an emergency. We never travel without them.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ thought the hostess, ‘then we are in the habit of travelling, and of travelling together.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was so conscious of expressing this in her face, that meeting the young lady’s eyes immediately afterwards, and being a very honest hostess, she was rather confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The gentleman—your grandpapa’—she resumed, after a short pause, ‘being so bent on having no assistance, must terrify you very much, miss?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have been very much alarmed to-night. He—he is not my grandfather.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Father, I should have said,’ returned the hostess, sensible of having made an awkward mistake.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("‘Nor my father’ said the young lady. ‘Nor,’ she added, ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("slightly smiling with a quick perception of what the landlady was going to add, ‘Nor my uncle. We are not related.’")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh dear me!’ returned the landlady, still more embarrassed than before; ‘how could I be so very much mistaken; knowing, as anybody in their proper senses might that when a gentleman is ill, he looks so much older than he really is? That I should have called you “Miss,” too, ma’am!’ But when she had proceeded thus far, she glanced involuntarily at the third finger of the young lady’s left hand, and faltered again; for there was no ring upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When I told you we were not related,’ said the other mildly, but not without confusion on her own part, ‘I meant not in any way. Not even by marriage. Did you call me, Martin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Call you?’ cried the old man, looking quickly up, and hurriedly drawing beneath the coverlet the paper on which he had been writing. ‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She had moved a pace or two towards the bed, but stopped immediately, and went no farther.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ he repeated, with a petulant emphasis. ‘Why do you ask me? If I had called you, what need for such a question?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was the creaking of the sign outside, sir, I dare say,’ observed the landlady; a suggestion by the way (as she felt a moment after she had made it), not at all complimentary to the voice of the old gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No matter what, ma’am,’ he rejoined: ‘it wasn’t I. Why how you stand there, Mary, as if I had the plague! But they’re all afraid of me,’ he added, leaning helplessly backward on his pillow; ‘even she! There is a curse upon me. What else have I to look for?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh dear, no. Oh no, I’m sure,’ said the good-tempered landlady, rising, and going towards him. ‘Be of better cheer, sir. These are only sick fancies.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("‘What are only sick fancies?’ he retorted. ‘What do you know about fancies? Who told you about fancies? The old story! Fancies!’")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/0023m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Only see again there, how you take one up!’ said the mistress of the Blue Dragon, with unimpaired good humour. ‘Dear heart alive, there is no harm in the word, sir, if it is an old one. Folks in good health have their fancies, too, and strange ones, every day.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harmless as this speech appeared to be, it acted on the traveller’s distrust, like oil on fire. He raised his head up in the bed, and, fixing on her two dark eyes whose brightness was exaggerated by the paleness of his hollow cheeks, as they in turn, together with his straggling locks of long grey hair, were rendered whiter by the tight black velvet skullcap which he wore, he searched her face intently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah! you begin too soon,’ he said, in so low a voice that he seemed to be thinking it, rather than addressing her. ‘But you lose no time. You do your errand, and you earn your fee. Now, who may be your client?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The landlady looked in great astonishment at her whom he called Mary, and finding no rejoinder in the drooping face, looked back again at him. At first she had recoiled involuntarily, supposing him disordered in his mind; but the slow composure of his manner, and the settled purpose announced in his strong features, and gathering, most of all, about his puckered mouth, forbade the supposition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come,’ he said, ‘tell me who is it? Being here, it is not very hard for me to guess, you may suppose.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Martin,’ interposed the young lady, laying her hand upon his arm; ‘reflect how short a time we have been in this house, and that even your name is unknown here.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("‘Unless,’ he said, ‘you—’ He was evidently tempted to express ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("a suspicion of her having broken his confidence in favour of the landlady, but either remembering her tender nursing, or being moved in some sort by her face, he checked himself, and changing his uneasy posture in the bed, was silent.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There!’ said Mrs Lupin; for in that name the Blue Dragon was licensed to furnish entertainment, both to man and beast. ‘Now, you will be well again, sir. You forgot, for the moment, that there were none but friends here.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ cried the old man, moaning impatiently, as he tossed one restless arm upon the coverlet; ‘why do you talk to me of friends! Can you or anybody teach me to know who are my friends, and who my enemies?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At least,’ urged Mrs Lupin, gently, ‘this young lady is your friend, I am sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She has no temptation to be otherwise,’ cried the old man, like one whose hope and confidence were utterly exhausted. ‘I suppose she is. Heaven knows. There, let me try to sleep. Leave the candle where it is.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As they retired from the bed, he drew forth the writing which had occupied him so long, and holding it in the flame of the taper burnt it to ashes. That done, he extinguished the light, and turning his face away with a heavy sigh, drew the coverlet about his head, and lay quite still.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This destruction of the paper, both as being strangely inconsistent with the labour he had devoted to it, and as involving considerable danger of fire to the Dragon, occasioned Mrs Lupin not a little consternation. But the young lady evincing no surprise, curiosity, or alarm, whispered her, with many thanks for her solicitude and company, that she would remain there some time longer; and that she begged her not to share her watch, as she was well used to being alone, and would pass the time in reading.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("Mrs Lupin had her full share and dividend of that large capital of curiosity which is inherited by her sex, and at another time it might have been difficult so to impress this hint upon her as to induce her to take it. But now, in sheer wonder and amazement at these mysteries, she withdrew at once, and repairing straightway to her own little parlour below stairs, sat down in her easy-chair with unnatural composure. At this very crisis, a step was heard in the entry, and Mr Pecksniff, looking sweetly over the half-door of the bar, and into the vista of snug privacy beyond, murmured:")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good evening, Mrs Lupin!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh dear me, sir!’ she cried, advancing to receive him, ‘I am so very glad you have come.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And I am very glad I have come,’ said Mr Pecksniff, ‘if I can be of service. I am very glad I have come. What is the matter, Mrs Lupin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A gentleman taken ill upon the road, has been so very bad upstairs, sir,’ said the tearful hostess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A gentleman taken ill upon the road, has been so very bad upstairs, has he?’ repeated Mr Pecksniff. ‘Well, well!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now there was nothing that one may call decidedly original in this remark, nor can it be exactly said to have contained any wise precept theretofore unknown to mankind, or to have opened any hidden source of consolation; but Mr Pecksniff’s manner was so bland, and he nodded his head so soothingly, and showed in everything such an affable sense of his own excellence, that anybody would have been, as Mrs Lupin was, comforted by the mere voice and presence of such a man; and, though he had merely said ‘a verb must agree with its nominative case in number and person, my good friend,’ or ‘eight times eight are sixty-four, my worthy soul,’ must have felt deeply grateful to him for his humanity and wisdom.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("‘And how,’ asked Mr Pecksniff, drawing off his gloves and warming his hands before the fire, as benevolently as if they were somebody else’s, not his; ‘and how is he now?’")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is better, and quite tranquil,’ answered Mrs Lupin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is better, and quite tranquil,’ said Mr Pecksniff. ‘Very well! Ve-ry well!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here again, though the statement was Mrs Lupin’s and not Mr Pecksniff’s, Mr Pecksniff made it his own and consoled her with it. It was not much when Mrs Lupin said it, but it was a whole book when Mr Pecksniff said it. ‘I observe,’ he seemed to say, ‘and through me, morality in general remarks, that he is better and quite tranquil.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There must be weighty matters on his mind, though,’ said the hostess, shaking her head, ‘for he talks, sir, in the strangest way you ever heard. He is far from easy in his thoughts, and wants some proper advice from those whose goodness makes it worth his having.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then,’ said Mr Pecksniff, ‘he is the sort of customer for me.’ But though he said this in the plainest language, he didn’t speak a word. He only shook his head; disparagingly of himself too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid, sir,’ continued the landlady, first looking round to assure herself that there was nobody within hearing, and then looking down upon the floor. ‘I am very much afraid, sir, that his conscience is troubled by his not being related to—or—or even married to—a very young lady—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mrs Lupin!’ said Mr Pecksniff, holding up his hand with something in his manner as nearly approaching to severity as any expression of his, mild being that he was, could ever do. ‘Person! young person?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("‘A very young person,’ said Mrs Lupin, curtseying and blushing; ‘—I beg your pardon, sir, but I have been so hurried ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("to-night, that I don’t know what I say—who is with him now.’")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who is with him now,’ ruminated Mr Pecksniff, warming his back (as he had warmed his hands) as if it were a widow’s back, or an orphan’s back, or an enemy’s back, or a back that any less excellent man would have suffered to be cold. ‘Oh dear me, dear me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At the same time I am bound to say, and I do say with all my heart,’ observed the hostess, earnestly, ‘that her looks and manner almost disarm suspicion.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your suspicion, Mrs Lupin,’ said Mr Pecksniff gravely, ‘is very natural.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Touching which remark, let it be written down to their confusion, that the enemies of this worthy man unblushingly maintained that he always said of what was very bad, that it was very natural; and that he unconsciously betrayed his own nature in doing so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your suspicion, Mrs Lupin,’ he repeated, ‘is very natural, and I have no doubt correct. I will wait upon these travellers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that he took off his great-coat, and having run his fingers through his hair, thrust one hand gently in the bosom of his waist-coat and meekly signed to her to lead the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Shall I knock?’ asked Mrs Lupin, when they reached the chamber door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pecksniff, ‘enter if you please.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They went in on tiptoe; or rather the hostess took that precaution for Mr Pecksniff always walked softly. The old gentleman was still asleep, and his young companion still sat reading by the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid,’ said Mr Pecksniff, pausing at the door, and giving his head a melancholy roll, ‘I am afraid that this looks artful. I am afraid, Mrs Lupin, do you know, that this looks very artful!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("As he finished this whisper, he advanced before the hostess; and at the same time the young lady, hearing footsteps, rose. Mr Pecksniff glanced at the volume she held, and whispered Mrs Lupin again; if possible, with increased despondency.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, ma’am,’ he said, ‘it is a good book. I was fearful of that beforehand. I am apprehensive that this is a very deep thing indeed!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What gentleman is this?’ inquired the object of his virtuous doubts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hush! don’t trouble yourself, ma’am,’ said Mr Pecksniff, as the landlady was about to answer. ‘This young’—in spite of himself he hesitated when “person” rose to his lips, and substituted another word: ‘this young stranger, Mrs Lupin, will excuse me for replying briefly, that I reside in this village; it may be in an influential manner, however, undeserved; and that I have been summoned here by you. I am here, as I am everywhere, I hope, in sympathy for the sick and sorry.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With these impressive words, Mr Pecksniff passed over to the bedside, where, after patting the counterpane once or twice in a very solemn manner, as if by that means he gained a clear insight into the patient’s disorder, he took his seat in a large arm-chair, and in an attitude of some thoughtfulness and much comfort, waited for his waking. Whatever objection the young lady urged to Mrs Lupin went no further, for nothing more was said to Mr Pecksniff, and Mr Pecksniff said nothing more to anybody else.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("Full half an hour elapsed before the old man stirred, but at length he turned himself in bed, and, though not yet awake, gave tokens that his sleep was drawing to an end. By little and little he removed the bed-clothes from about his head, and turned still more towards the side where Mr Pecksniff sat. In ")]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("course of time his eyes opened; and he lay for a few moments as people newly roused sometimes will, gazing indolently at his visitor, without any distinct consciousness of his presence.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was nothing remarkable in these proceedings, except the influence they worked on Mr Pecksniff, which could hardly have been surpassed by the most marvellous of natural phenomena. Gradually his hands became tightly clasped upon the elbows of the chair, his eyes dilated with surprise, his mouth opened, his hair stood more erect upon his forehead than its custom was, until, at length, when the old man rose in bed, and stared at him with scarcely less emotion than he showed himself, the Pecksniff doubts were all resolved, and he exclaimed aloud:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" Martin Chuzzlewit!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His consternation of surprise was so genuine, that the old man, with all the disposition that he clearly entertained to believe it assumed, was convinced of its reality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am Martin Chuzzlewit,’ he said, bitterly: ‘and Martin Chuzzlewit wishes you had been hanged, before you had come here to disturb him in his sleep. Why, I dreamed of this fellow!’ he said, lying down again, and turning away his face, ‘before I knew that he was near me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My good cousin—’ said Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There! His very first words!’ cried the old man, shaking his grey head to and fro upon the pillow, and throwing up his hands. ‘In his very first words he asserts his relationship! I knew he would; they all do it! Near or distant, blood or water, it’s all one. Ugh! What a calendar of deceit, and lying, and false-witnessing, the sound of any word of kindred opens before me!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("‘Pray do not be hasty, Mr Chuzzlewit,’ said Pecksniff, in a tone that was at once in the sublimest degree compassionate ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("and dispassionate; for he had by this time recovered from his surprise, and was in full possession of his virtuous self. ‘You will regret being hasty, I know you will.’")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know!’ said Martin, contemptuously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ retorted Mr Pecksniff. ‘Aye, aye, Mr Chuzzlewit; and don’t imagine that I mean to court or flatter you; for nothing is further from my intention. Neither, sir, need you entertain the least misgiving that I shall repeat that obnoxious word which has given you so much offence already. Why should I? What do I expect or want from you? There is nothing in your possession that I know of, Mr Chuzzlewit, which is much to be coveted for the happiness it brings you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s true enough,’ muttered the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Apart from that consideration,’ said Mr Pecksniff, watchful of the effect he made, ‘it must be plain to you (I am sure) by this time, that if I had wished to insinuate myself into your good opinion, I should have been, of all things, careful not to address you as a relative; knowing your humour, and being quite certain beforehand that I could not have a worse letter of recommendation.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin made not any verbal answer; but he as clearly implied though only by a motion of his legs beneath the bed-clothes, that there was reason in this, and that he could not dispute it, as if he had said as much in good set terms.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("‘No,’ said Mr Pecksniff, keeping his hand in his waistcoat as though he were ready, on the shortest notice, to produce his heart for Martin Chuzzlewit’s inspection, ‘I came here to offer my services to a stranger. I make no offer of them to you, because I know you would distrust me if I did. But lying on that bed, sir, I regard you as a stranger, and I have just that amount of interest in you which I hope I should feel in any stranger, circumstanced as you are. Beyond that, I am quite as indifferent ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("to you, Mr Chuzzlewit, as you are to me.’")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Having said which, Mr Pecksniff threw himself back in the easy-chair; so radiant with ingenuous honesty, that Mrs Lupin almost wondered not to see a stained-glass Glory, such as the Saint wore in the church, shining about his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A long pause succeeded. The old man, with increased restlessness, changed his posture several times. Mrs Lupin and the young lady gazed in silence at the counterpane. Mr Pecksniff toyed abstractedly with his eye-glass, and kept his eyes shut, that he might ruminate the better.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Eh?’ he said at last, opening them suddenly, and looking towards the bed. ‘I beg your pardon. I thought you spoke. Mrs Lupin,’ he continued, slowly rising ‘I am not aware that I can be of any service to you here. The gentleman is better, and you are as good a nurse as he can have. Eh?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This last note of interrogation bore reference to another change of posture on the old man’s part, which brought his face towards Mr Pecksniff for the first time since he had turned away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you desire to speak to me before I go, sir,’ continued that gentleman, after another pause, ‘you may command my leisure; but I must stipulate, in justice to myself, that you do so as to a stranger, strictly as to a stranger.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Now if Mr Pecksniff knew, from anything Martin Chuzzlewit had expressed in gestures, that he wanted to speak to him, he could only have found it out on some such principle as prevails in melodramas, and in virtue of which the elderly farmer with the comic son always knows what the dumb girl means when she takes refuge in his garden, and relates her personal memoirs in incomprehensible pantomime. But without stopping to make any inquiry on this point, Martin Chuzzlewit signed to his young companion to withdraw, which she immediately ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("did, along with the landlady leaving him and Mr Pecksniff alone together. For some time they looked at each other in silence; or rather the old man looked at Mr Pecksniff, and Mr Pecksniff again closing his eyes on all outward objects, took an inward survey of his own breast. That it amply repaid him for his trouble, and afforded a delicious and enchanting prospect, was clear from the expression of his face.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You wish me to speak to you as to a total stranger,’ said the old man, ‘do you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff replied, by a shrug of his shoulders and an apparent turning round of his eyes in their sockets before he opened them, that he was still reduced to the necessity of entertaining that desire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You shall be gratified,’ said Martin. ‘Sir, I am a rich man. Not so rich as some suppose, perhaps, but yet wealthy. I am not a miser sir, though even that charge is made against me, as I hear, and currently believed. I have no pleasure in hoarding. I have no pleasure in the possession of money, The devil that we call by that name can give me nothing but unhappiness.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would be no description of Mr Pecksniff’s gentleness of manner to adopt the common parlance, and say that he looked at this moment as if butter wouldn’t melt in his mouth. He rather looked as if any quantity of butter might have been made out of him, by churning the milk of human kindness, as it spouted upwards from his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For the same reason that I am not a hoarder of money,’ said the old man, ‘I am not lavish of it. Some people find their gratification in storing it up; and others theirs in parting with it; but I have no gratification connected with the thing. Pain and bitterness are the only goods it ever could procure for me. I hate it. It is a spectre walking before me through the world, and making every social pleasure hideous.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("A thought arose in Pecksniff’s mind, which must have instantly mounted to his face, or Martin Chuzzlewit would not have resumed as quickly and as sternly as he did:")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You would advise me for my peace of mind, to get rid of this source of misery, and transfer it to some one who could bear it better. Even you, perhaps, would rid me of a burden under which I suffer so grievously. But, kind stranger,’ said the old man, whose every feature darkened as he spoke, ‘good Christian stranger, that is a main part of my trouble. In other hands, I have known money do good; in other hands I have known it triumphed in, and boasted of with reason, as the master-key to all the brazen gates that close upon the paths to worldly honour, fortune, and enjoyment. To what man or woman; to what worthy, honest, incorruptible creature; shall I confide such a talisman, either now or when I die? Do you know any such person? "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" virtues are of course inestimable, but can you tell me of any other living creature who will bear the test of contact with myself?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of contact with yourself, sir?’ echoed Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye,’ returned the old man, ‘the test of contact with me—with me. You have heard of him whose misery (the gratification of his own foolish wish) was, that he turned every thing he touched into gold. The curse of my existence, and the realisation of my own mad desire is that by the golden standard which I bear about me, I am doomed to try the metal of all other men, and find it false and hollow.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff shook his head, and said, ‘You think so.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("‘Oh yes,’ cried the old man, ‘I think so! and in your telling me “I think so,” I recognize the true unworldly ring of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" metal. I tell you, man,’ he added, with increasing bitterness, ‘that I have gone, a rich man, among people of all grades and kinds; relatives, friends, and strangers; among ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("people in whom, when I was poor, I had confidence, and justly, for they never once deceived me then, or, to me, wronged each other. But I have never found one nature, no, not one, in which, being wealthy and alone, I was not forced to detect the latent corruption that lay hid within it waiting for such as I to bring it forth. Treachery, deceit, and low design; hatred of competitors, real or fancied, for my favour; meanness, falsehood, baseness, and servility; or,’ and here he looked closely in his cousin’s eyes, ‘or an assumption of honest independence, almost worse than all; these are the beauties which my wealth has brought to light. Brother against brother, child against parent, friends treading on the faces of friends, this is the social company by whom my way has been attended. There are stories told—they may be true or false—of rich men who, in the garb of poverty, have found out virtue and rewarded it. They were dolts and idiots for their pains. They should have made the search in their own characters. They should have shown themselves fit objects to be robbed and preyed upon and plotted against and adulated by any knaves, who, but for joy, would have spat upon their coffins when they died their dupes; and then their search would have ended as mine has done, and they would be what I am.’")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff, not at all knowing what it might be best to say in the momentary pause which ensued upon these remarks, made an elaborate demonstration of intending to deliver something very oracular indeed; trusting to the certainty of the old man interrupting him, before he should utter a word. Nor was he mistaken, for Martin Chuzzlewit having taken breath, went on to say:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("‘Hear me to an end; judge what profit you are like to gain from any repetition of this visit; and leave me. I have so corrupted and changed the nature of all those who have ever attended ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("on me, by breeding avaricious plots and hopes within them; I have engendered such domestic strife and discord, by tarrying even with members of my own family; I have been such a lighted torch in peaceful homes, kindling up all the inflammable gases and vapours in their moral atmosphere, which, but for me, might have proved harmless to the end, that I have, I may say, fled from all who knew me, and taking refuge in secret places have lived, of late, the life of one who is hunted. The young girl whom you just now saw—what! your eye lightens when I talk of her! You hate her already, do you?’")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Upon my word, sir!’ said Mr Pecksniff, laying his hand upon his breast, and dropping his eyelids.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I forgot,’ cried the old man, looking at him with a keenness which the other seemed to feel, although he did not raise his eyes so as to see it. ‘I ask your pardon. I forgot you were a stranger. For the moment you reminded me of one Pecksniff, a cousin of mine. As I was saying—the young girl whom you just now saw, is an orphan child, whom, with one steady purpose, I have bred and educated, or, if you prefer the word, adopted. For a year or more she has been my constant companion, and she is my only one. I have taken, as she knows, a solemn oath never to leave her sixpence when I die, but while I live I make her an annual allowance; not extravagant in its amount and yet not stinted. There is a compact between us that no term of affectionate cajolery shall ever be addressed by either to the other, but that she shall call me always by my Christian name; I her, by hers. She is bound to me in life by ties of interest, and losing by my death, and having no expectation disappointed, will mourn it, perhaps; though for that I care little. This is the only kind of friend I have or will have. Judge from such premises what a profitable hour you have spent in coming here, and leave me, to return no more.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("With these words, the old man fell slowly back upon his pillow. Mr Pecksniff as slowly rose, and, with a prefatory hem, began as follows:")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Chuzzlewit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There. Go!’ interposed the other. ‘Enough of this. I am weary of you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am sorry for that, sir,’ rejoined Mr Pecksniff, ‘because I have a duty to discharge, from which, depend upon it, I shall not shrink. No, sir, I shall not shrink.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a lamentable fact, that as Mr Pecksniff stood erect beside the bed, in all the dignity of Goodness, and addressed him thus, the old man cast an angry glance towards the candlestick, as if he were possessed by a strong inclination to launch it at his cousin’s head. But he constrained himself, and pointing with his finger to the door, informed him that his road lay there.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("‘Thank you,’ said Mr Pecksniff; ‘I am aware of that. I am going. But before I go, I crave your leave to speak, and more than that, Mr Chuzzlewit, I must and will—yes indeed, I repeat it, must and will—be heard. I am not surprised, sir, at anything you have told me tonight. It is natural, very natural, and the greater part of it was known to me before. I will not say,’ continued Mr Pecksniff, drawing out his pocket-handkerchief, and winking with both eyes at once, as it were, against his will, ‘I will not say that you are mistaken in me. While you are in your present mood I would not say so for the world. I almost wish, indeed, that I had a different nature, that I might repress even this slight confession of weakness; which I cannot disguise from you; which I feel is humiliating; but which you will have the goodness to excuse. We will say, if you please,’ added Mr Pecksniff, with great tenderness of manner, ‘that it arises from a cold in the head, or is attributable to snuff, or smelling-salts, ")]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("or onions, or anything but the real cause.’")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Here he paused for an instant, and concealed his face behind his pocket-handkerchief. Then, smiling faintly, and holding the bed furniture with one hand, he resumed:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But, Mr Chuzzlewit, while I am forgetful of myself, I owe it to myself, and to my character—aye, sir, and I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" a character which is very dear to me, and will be the best inheritance of my two daughters—to tell you, on behalf of another, that your conduct is wrong, unnatural, indefensible, monstrous. And I tell you, sir,’ said Mr Pecksniff, towering on tiptoe among the curtains, as if he were literally rising above all worldly considerations, and were fain to hold on tight, to keep himself from darting skyward like a rocket, ‘I tell you without fear or favour, that it will not do for you to be unmindful of your grandson, young Martin, who has the strongest natural claim upon you. It will not do, sir,’ repeated Mr Pecksniff, shaking his head. ‘You may think it will do, but it won’t. You must provide for that young man; you shall provide for him; you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("will")]), _vm._v(" provide for him. I believe,’ said Mr Pecksniff, glancing at the pen-and-ink, ‘that in secret you have already done so. Bless you for doing so. Bless you for doing right, sir. Bless you for hating me. And good night!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So saying, Mr Pecksniff waved his right hand with much solemnity, and once more inserting it in his waistcoat, departed. There was emotion in his manner, but his step was firm. Subject to human weaknesses, he was upheld by conscience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin lay for some time, with an expression on his face of silent wonder, not unmixed with rage; at length he muttered in a whisper:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("‘What does this mean? Can the false-hearted boy have chosen such a tool as yonder fellow who has just gone out? Why not! He has conspired against me, like the rest, and they are ")]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("but birds of one feather. A new plot; a new plot! Oh self, self, self! At every turn nothing but self!’")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He fell to trifling, as he ceased to speak, with the ashes of the burnt paper in the candlestick. He did so, at first, in pure abstraction, but they presently became the subject of his thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Another will made and destroyed,’ he said, ‘nothing determined on, nothing done, and I might have died to-night! I plainly see to what foul uses all this money will be put at last,’ he cried, almost writhing in the bed; ‘after filling me with cares and miseries all my life, it will perpetuate discord and bad passions when I am dead. So it always is. What lawsuits grow out of the graves of rich men, every day; sowing perjury, hatred, and lies among near kindred, where there should be nothing but love! Heaven help us, we have much to answer for! Oh self, self, self! Every man for himself, and no creature for me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Universal self! Was there nothing of its shadow in these reflections, and in the history of Martin Chuzzlewit, on his own showing?")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Chapter Four")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("From which it will Appear that if Union be Strength, and Family Affection be Pleasant to Contemplate, the Chuzzlewits were the Strongest and Most Agreeable Family in the World")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That worthy man Mr Pecksniff having taken leave of his cousin in the solemn terms recited in the last chapter, withdrew to his own home, and remained there three whole days; not so much as going out for a walk beyond the boundaries of his own garden, lest he should be hastily summoned to the bedside of his penitent and remorseful relative, whom, in his ample benevolence, he had made up his mind to forgive unconditionally, and to love on any terms. But such was the obstinacy and such the bitter nature of that stern old man, that no repentant summons came; and the fourth day found Mr Pecksniff apparently much farther from his Christian object than the first.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("During the whole of this interval, he haunted the Dragon at all times and seasons in the day and night, and, returning good for evil evinced the deepest solicitude in the progress of the ")]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("obdurate invalid, in so much that Mrs Lupin was fairly melted by his disinterested anxiety (for he often particularly required her to take notice that he would do the same by any stranger or pauper in the like condition), and shed many tears of admiration and delight.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Meantime, old Martin Chuzzlewit remained shut up in his own chamber, and saw no person but his young companion, saving the hostess of the Blue Dragon, who was, at certain times, admitted to his presence. So surely as she came into the room, however, Martin feigned to fall asleep. It was only when he and the young lady were alone, that he would utter a word, even in answer to the simplest inquiry; though Mr Pecksniff could make out, by hard listening at the door, that they two being left together, he was talkative enough.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("It happened on the fourth evening, that Mr Pecksniff walking, as usual, into the bar of the Dragon and finding no Mrs Lupin there, went straight upstairs; purposing, in the fervour of his affectionate zeal, to apply his ear once more to the keyhole, and quiet his mind by assuring himself that the hard-hearted patient was going on well. It happened that Mr Pecksniff, coming softly upon the dark passage into which a spiral ray of light usually darted through the same keyhole, was astonished to find no such ray visible; and it happened that Mr Pecksniff, when he had felt his way to the chamber-door, stooping hurriedly down to ascertain by personal inspection whether the jealousy of the old man had caused this keyhole to be stopped on the inside, brought his head into such violent contact with another head that he could not help uttering in an audible voice the monosyllable ‘Oh!’ which was, as it were, sharply unscrewed and jerked out of him by very anguish. It happened then, and lastly, that Mr Pecksniff found himself immediately collared by something which smelt like several ")]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("damp umbrellas, a barrel of beer, a cask of warm brandy-and-water, and a small parlour-full of stale tobacco smoke, mixed; and was straightway led downstairs into the bar from which he had lately come, where he found himself standing opposite to, and in the grasp of, a perfectly strange gentleman of still stranger appearance who, with his disengaged hand, rubbed his own head very hard, and looked at him, Pecksniff, with an evil countenance.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The gentleman was of that order of appearance which is currently termed shabby-genteel, though in respect of his dress he can hardly be said to have been in any extremities, as his fingers were a long way out of his gloves, and the soles of his feet were at an inconvenient distance from the upper leather of his boots. His nether garments were of a bluish grey—violent in its colours once, but sobered now by age and dinginess—and were so stretched and strained in a tough conflict between his braces and his straps, that they appeared every moment in danger of flying asunder at the knees. His coat, in colour blue and of a military cut, was buttoned and frogged up to his chin. His cravat was, in hue and pattern, like one of those mantles which hairdressers are accustomed to wrap about their clients, during the progress of the professional mysteries. His hat had arrived at such a pass that it would have been hard to determine whether it was originally white or black. But he wore a moustache—a shaggy moustache too; nothing in the meek and merciful way, but quite in the fierce and scornful style; the regular Satanic sort of thing—and he wore, besides, a vast quantity of unbrushed hair. He was very dirty and very jaunty; very bold and very mean; very swaggering and very slinking; very much like a man who might have been something better, and unspeakably like a man who deserved to be something worse.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("‘You were eaves-dropping at that door, you vagabond!’ said this gentleman.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff cast him off, as Saint George might have repudiated the Dragon in that animal’s last moments, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where is Mrs Lupin, I wonder! can the good woman possibly be aware that there is a person here who—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stay!’ said the gentleman. ‘Wait a bit. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("does")]), _vm._v(" know. What then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What then, sir?’ cried Mr Pecksniff. ‘What then? Do you know, sir, that I am the friend and relative of that sick gentleman? That I am his protector, his guardian, his—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not his niece’s husband,’ interposed the stranger, ‘I’ll be sworn; for he was there before you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean?’ said Mr Pecksniff, with indignant surprise. ‘What do you tell me, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wait a bit!’ cried the other, ‘Perhaps you are a cousin—the cousin who lives in this place?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" the cousin who lives in this place,’ replied the man of worth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your name is Pecksniff?’ said the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am proud to know you, and I ask your pardon,’ said the gentleman, touching his hat, and subsequently diving behind his cravat for a shirt-collar, which however he did not succeed in bringing to the surface. ‘You behold in me, sir, one who has also an interest in that gentleman upstairs. Wait a bit.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("As he said this, he touched the tip of his high nose, by way of intimation that he would let Mr Pecksniff into a secret presently; and pulling off his hat, began to search inside the crown among a mass of crumpled documents and small pieces of what may be called the bark of broken cigars; whence he presently selected the cover of an old letter, begrimed with ")]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("dirt and redolent of tobacco.")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Read that,’ he cried, giving it to Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This is addressed to Chevy Slyme, Esquire,’ said that gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know Chevy Slyme, Esquire, I believe?’ returned the stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff shrugged his shoulders as though he would say ‘I know there is such a person, and I am sorry for it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good,’ remarked the gentleman. ‘That is my interest and business here.’ With that he made another dive for his shirt-collar and brought up a string.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, this is very distressing, my friend,’ said Mr Pecksniff, shaking his head and smiling composedly. ‘It is very distressing to me, to be compelled to say that you are not the person you claim to be. I know Mr Slyme, my friend; this will not do; honesty is the best policy you had better not; you had indeed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stop’ cried the gentleman, stretching forth his right arm, which was so tightly wedged into his threadbare sleeve that it looked like a cloth sausage. ‘Wait a bit!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused to establish himself immediately in front of the fire with his back towards it. Then gathering the skirts of his coat under his left arm, and smoothing his moustache with his right thumb and forefinger, he resumed:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("‘I understand your mistake, and I am not offended. Why? Because it’s complimentary. You suppose I would set myself up for Chevy Slyme. Sir, if there is a man on earth whom a gentleman would feel proud and honoured to be mistaken for, that man is my friend Slyme. For he is, without an exception, the highest-minded, the most independent-spirited, most original, spiritual, classical, talented, the most thoroughly Shakspearian, if not Miltonic, and at the same time the most disgustingly-unappreciated dog I know. But, sir, I have not the ")]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("vanity to attempt to pass for Slyme. Any other man in the wide world, I am equal to; but Slyme is, I frankly confess, a great many cuts above me. Therefore you are wrong.’")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I judged from this,’ said Mr Pecksniff, holding out the cover of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No doubt you did,’ returned the gentleman. ‘But, Mr Pecksniff, the whole thing resolves itself into an instance of the peculiarities of genius. Every man of true genius has his peculiarity. Sir, the peculiarity of my friend Slyme is, that he is always waiting round the corner. He is perpetually round the corner, sir. He is round the corner at this instant. Now,’ said the gentleman, shaking his forefinger before his nose, and planting his legs wider apart as he looked attentively in Mr Pecksniff’s face, ‘that is a remarkably curious and interesting trait in Mr Slyme’s character; and whenever Slyme’s life comes to be written, that trait must be thoroughly worked out by his biographer or society will not be satisfied. Observe me, society will not be satisfied!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff coughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Slyme’s biographer, sir, whoever he may be,’ resumed the gentleman, ‘must apply to me; or, if I am gone to that what’s-his-name from which no thingumbob comes back, he must apply to my executors for leave to search among my papers. I have taken a few notes in my poor way, of some of that man’s proceedings—my adopted brother, sir,—which would amaze you. He made use of an expression, sir, only on the fifteenth of last month when he couldn’t meet a little bill and the other party wouldn’t renew, which would have done honour to Napoleon Bonaparte in addressing the French army.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("‘And pray,’ asked Mr Pecksniff, obviously not quite at his ease, ‘what may be Mr Slyme’s business here, if I may be permitted to inquire, who am compelled by a regard for my own ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("character to disavow all interest in his proceedings?’")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the first place,’ returned the gentleman, ‘you will permit me to say, that I object to that remark, and that I strongly and indignantly protest against it on behalf of my friend Slyme. In the next place, you will give me leave to introduce myself. My name, sir, is Tigg. The name of Montague Tigg will perhaps be familiar to you, in connection with the most remarkable events of the Peninsular War?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff gently shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No matter,’ said the gentleman. ‘That man was my father, and I bear his name. I am consequently proud—proud as Lucifer. Excuse me one moment. I desire my friend Slyme to be present at the remainder of this conference.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With this announcement he hurried away to the outer door of the Blue Dragon, and almost immediately returned with a companion shorter than himself, who was wrapped in an old blue camlet cloak with a lining of faded scarlet. His sharp features being much pinched and nipped by long waiting in the cold, and his straggling red whiskers and frowzy hair being more than usually dishevelled from the same cause, he certainly looked rather unwholesome and uncomfortable than Shakspearian or Miltonic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now,’ said Mr Tigg, clapping one hand on the shoulder of his prepossessing friend, and calling Mr Pecksniff’s attention to him with the other, ‘you two are related; and relations never did agree, and never will; which is a wise dispensation and an inevitable thing, or there would be none but family parties, and everybody in the world would bore everybody else to death. If you were on good terms, I should consider you a most confoundedly unnatural pair; but standing towards each other as you do, I took upon you as a couple of devilish deep-thoughted fellows, who may be reasoned with to any extent.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("Here Mr Chevy Slyme, whose great abilities seemed one and all to point towards the sneaking quarter of the moral compass, nudged his friend stealthily with his elbow, and whispered in his ear.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Chiv,’ said Mr Tigg aloud, in the high tone of one who was not to be tampered with. ‘I shall come to that presently. I act upon my own responsibility, or not at all. To the extent of such a trifling loan as a crownpiece to a man of your talents, I look upon Mr Pecksniff as certain;’ and seeing at this juncture that the expression of Mr Pecksniff’s face by no means betokened that he shared this certainty, Mr Tigg laid his finger on his nose again for that gentleman’s private and especial behoof; calling upon him thereby to take notice that the requisition of small loans was another instance of the peculiarities of genius as developed in his friend Slyme; that he, Tigg, winked at the same, because of the strong metaphysical interest which these weaknesses possessed; and that in reference to his own personal advocacy of such small advances, he merely consulted the humour of his friend, without the least regard to his own advantage or necessities.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("‘Oh, Chiv, Chiv!’ added Mr Tigg, surveying his adopted brother with an air of profound contemplation after dismissing this piece of pantomime. ‘You are, upon my life, a strange instance of the little frailties that beset a mighty mind. If there had never been a telescope in the world, I should have been quite certain from my observation of you, Chiv, that there were spots on the sun! I wish I may die, if this isn’t the queerest state of existence that we find ourselves forced into without knowing why or wherefore, Mr Pecksniff! Well, never mind! Moralise as we will, the world goes on. As Hamlet says, Hercules may lay about him with his club in every possible direction, but he can’t prevent the cats from making a most ")]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("intolerable row on the roofs of the houses, or the dogs from being shot in the hot weather if they run about the streets unmuzzled. Life’s a riddle; a most infernally hard riddle to guess, Mr Pecksniff. My own opinions, that like that celebrated conundrum, “Why’s a man in jail like a man out of jail?” there’s no answer to it. Upon my soul and body, it’s the queerest sort of thing altogether—but there’s no use in talking about it. Ha! Ha!’")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With which consolatory deduction from the gloomy premises recited, Mr Tigg roused himself by a great effort, and proceeded in his former strain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now I’ll tell you what it is. I’m a most confoundedly soft-hearted kind of fellow in my way, and I cannot stand by, and see you two blades cutting each other’s throats when there’s nothing to be got by it. Mr Pecksniff, you’re the cousin of the testator upstairs and we’re the nephew—I say we, meaning Chiv. Perhaps in all essential points you are more nearly related to him than we are. Very good. If so, so be it. But you can’t get at him, neither can we. I give you my brightest word of honour, sir, that I’ve been looking through that keyhole with short intervals of rest, ever since nine o’clock this morning, in expectation of receiving an answer to one of the most moderate and gentlemanly applications for a little temporary assistance—only fifteen pounds, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" security—that the mind of man can conceive. In the meantime, sir, he is perpetually closeted with, and pouring his whole confidence into the bosom of, a stranger. Now I say decisively with regard to this state of circumstances, that it won’t do; that it won’t act; that it can’t be; and that it must not be suffered to continue.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("‘Every man,’ said Mr Pecksniff, ‘has a right, an undoubted right, (which I, for one, would not call in question for any earthly consideration; oh no!) to regulate his own proceedings ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("by his own likings and dislikings, supposing they are not immoral and not irreligious. I may feel in my own breast, that Mr Chuzzlewit does not regard—me, for instance; say me—with exactly that amount of Christian love which should subsist between us. I may feel grieved and hurt at the circumstance; still I may not rush to the conclusion that Mr Chuzzlewit is wholly without a justification in all his coldnesses. Heaven forbid! Besides; how, Mr Tigg,’ continued Pecksniff even more gravely and impressively than he had spoken yet, ‘how could Mr Chuzzlewit be prevented from having these peculiar and most extraordinary confidences of which you speak; the existence of which I must admit; and which I cannot but deplore—for his sake? Consider, my good sir—’ and here Mr Pecksniff eyed him wistfully—‘how very much at random you are talking.’")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, as to that,’ rejoined Tigg, ‘it certainly is a difficult question.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Undoubtedly it is a difficult question,’ Mr Pecksniff answered. As he spoke he drew himself aloft, and seemed to grow more mindful, suddenly, of the moral gulf between himself and the creature he addressed. ‘Undoubtedly it is a very difficult question. And I am far from feeling sure that it is a question any one is authorized to discuss. Good evening to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t know that the Spottletoes are here, I suppose?’ said Mr Tigg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean, sir? what Spottletoes?’ asked Pecksniff, stopping abruptly on his way to the door.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("‘Mr and Mrs Spottletoe,’ said Chevy Slyme, Esquire, speaking aloud for the first time, and speaking very sulkily; shambling with his legs the while. ‘Spottletoe married my father’s brother’s child, didn’t he? And Mrs Spottletoe is Chuzzlewit’s own niece, isn’t she? She was his favourite once. You may well ")]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("ask what Spottletoes.’")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now upon my sacred word!’ cried Mr Pecksniff, looking upwards. ‘This is dreadful. The rapacity of these people is absolutely frightful!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s not only the Spottletoes either, Tigg,’ said Slyme, looking at that gentleman and speaking at Mr Pecksniff. ‘Anthony Chuzzlewit and his son have got wind of it, and have come down this afternoon. I saw ‘em not five minutes ago, when I was waiting round the corner.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, Mammon, Mammon!’ cried Mr Pecksniff, smiting his forehead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So there,’ said Slyme, regardless of the interruption, ‘are his brother and another nephew for you, already.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This is the whole thing, sir,’ said Mr Tigg; ‘this is the point and purpose at which I was gradually arriving when my friend Slyme here, with six words, hit it full. Mr Pecksniff, now that your cousin (and Chiv’s uncle) has turned up, some steps must be taken to prevent his disappearing again; and, if possible, to counteract the influence which is exercised over him now, by this designing favourite. Everybody who is interested feels it, sir. The whole family is pouring down to this place. The time has come when individual jealousies and interests must be forgotten for a time, sir, and union must be made against the common enemy. When the common enemy is routed, you will all set up for yourselves again; every lady and gentleman who has a part in the game, will go in on their own account and bowl away, to the best of their ability, at the testator’s wicket, and nobody will be in a worse position than before. Think of it. Don’t commit yourself now. You’ll find us at the Half Moon and Seven Stars in this village, at any time, and open to any reasonable proposition. Hem! Chiv, my dear fellow, go out and see what sort of a night it is.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("Mr Slyme lost no time in disappearing, and it is to be presumed in going round the corner. Mr Tigg, planting his legs as wide apart as he could be reasonably expected by the most sanguine man to keep them, shook his head at Mr Pecksniff and smiled.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We must not be too hard,’ he said, ‘upon the little eccentricities of our friend Slyme. You saw him whisper me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff had seen him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You heard my answer, I think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff had heard it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Five shillings, eh?’ said Mr Tigg, thoughtfully. ‘Ah! what an extraordinary fellow! Very moderate too!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff made no answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Five shillings!’ pursued Mr Tigg, musing; ‘and to be punctually repaid next week; that’s the best of it. You heard that?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff had not heard that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No! You surprise me!’ cried Tigg. ‘That’s the cream of the thing sir. I never knew that man fail to redeem a promise, in my life. You’re not in want of change, are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pecksniff, ‘thank you. Not at all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just so,’ returned Mr Tigg. ‘If you had been, I’d have got it for you.’ With that he began to whistle; but a dozen seconds had not elapsed when he stopped short, and looking earnestly at Mr Pecksniff, said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Perhaps you’d rather not lend Slyme five shillings?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I would much rather not,’ Mr Pecksniff rejoined.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Egad!’ cried Tigg, gravely nodding his head as if some ground of objection occurred to him at that moment for the first time, ‘it’s very possible you may be right. Would you entertain the same sort of objection to lending me five shillings now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, I couldn’t do it, indeed,’ said Mr Pecksniff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("‘Not even half-a-crown, perhaps?’ urged Mr Tigg.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not even half-a-crown.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, then we come,’ said Mr Tigg, ‘to the ridiculously small amount of eighteen pence. Ha! ha!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And that,’ said Mr Pecksniff, ‘would be equally objectionable.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On receipt of this assurance, Mr Tigg shook him heartily by both hands, protesting with much earnestness, that he was one of the most consistent and remarkable men he had ever met, and that he desired the honour of his better acquaintance. He moreover observed that there were many little characteristics about his friend Slyme, of which he could by no means, as a man of strict honour, approve; but that he was prepared to forgive him all these slight drawbacks, and much more, in consideration of the great pleasure he himself had that day enjoyed in his social intercourse with Mr Pecksniff, which had given him a far higher and more enduring delight than the successful negotiation of any small loan on the part of his friend could possibly have imparted. With which remarks he would beg leave, he said, to wish Mr Pecksniff a very good evening. And so he took himself off; as little abashed by his recent failure as any gentleman would desire to be.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("The meditations of Mr Pecksniff that evening at the bar of the Dragon, and that night in his own house, were very serious and grave indeed; the more especially as the intelligence he had received from Messrs Tigg and Slyme touching the arrival of other members of the family, were fully confirmed on more particular inquiry. For the Spottletoes had actually gone straight to the Dragon, where they were at that moment housed and mounting guard, and where their appearance had occasioned such a vast sensation that Mrs Lupin, scenting their errand before they had been under her roof half an hour, ")]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("carried the news herself with all possible secrecy straight to Mr Pecksniff’s house; indeed it was her great caution in doing so which occasioned her to miss that gentleman, who entered at the front door of the Dragon just as she emerged from the back one. Moreover, Mr Anthony Chuzzlewit and his son Jonas were economically quartered at the Half Moon and Seven Stars, which was an obscure ale-house; and by the very next coach there came posting to the scene of action, so many other affectionate members of the family (who quarrelled with each other, inside and out, all the way down, to the utter distraction of the coachman), that in less than four-and-twenty hours the scanty tavern accommodation was at a premium, and all the private lodgings in the place, amounting to full four beds and sofa, rose cent per cent in the market.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In a word, things came to that pass that nearly the whole family sat down before the Blue Dragon, and formally invested it; and Martin Chuzzlewit was in a state of siege. But he resisted bravely; refusing to receive all letters, messages, and parcels; obstinately declining to treat with anybody; and holding out no hope or promise of capitulation. Meantime the family forces were perpetually encountering each other in divers parts of the neighbourhood; and, as no one branch of the Chuzzlewit tree had ever been known to agree with another within the memory of man, there was such a skirmishing, and flouting, and snapping off of heads, in the metaphorical sense of that expression; such a bandying of words and calling of names; such an upturning of noses and wrinkling of brows; such a formal interment of good feelings and violent resurrection of ancient grievances; as had never been known in those quiet parts since the earliest record of their civilized existence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("At length, in utter despair and hopelessness, some few of ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("the belligerents began to speak to each other in only moderate terms of mutual aggravation; and nearly all addressed themselves with a show of tolerable decency to Mr Pecksniff, in recognition of his high character and influential position. Thus, by little and little, they made common cause of Martin Chuzzlewit’s obduracy, until it was agreed (if such a word can be used in connection with the Chuzzlewits) that there should be a general council and conference held at Mr Pecksniff’s house upon a certain day at noon; which all members of the family who had brought themselves within reach of the summons, were forthwith bidden and invited, solemnly, to attend.")])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("If ever Mr Pecksniff wore an apostolic look, he wore it on this memorable day. If ever his unruffled smile proclaimed the words, ‘I am a messenger of peace!’ that was its mission now. If ever man combined within himself all the mild qualities of the lamb with a considerable touch of the dove, and not a dash of the crocodile, or the least possible suggestion of the very mildest seasoning of the serpent, that man was he. And, oh, the two Miss Pecksniffs! Oh, the serene expression on the face of Charity, which seemed to say, ‘I know that all my family have injured me beyond the possibility of reparation, but I forgive them, for it is my duty so to do!’ And, oh, the gay simplicity of Mercy; so charming, innocent, and infant-like, that if she had gone out walking by herself, and it had been a little earlier in the season, the robin-redbreasts might have covered her with leaves against her will, believing her to be one of the sweet children in the wood, come out of it, and issuing forth once more to look for blackberries in the young freshness of her heart! What words can paint the Pecksniffs in that trying hour? Oh, none; for words have naughty company among them, and the Pecksniffs were all goodness.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("But when the company arrived! That was the time. When ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("Mr Pecksniff, rising from his seat at the table’s head, with a daughter on either hand, received his guests in the best parlour and motioned them to chairs, with eyes so overflowing and countenance so damp with gracious perspiration, that he may be said to have been in a kind of moist meekness! And the company; the jealous stony-hearted distrustful company, who were all shut up in themselves, and had no faith in anybody, and wouldn’t believe anything, and would no more allow themselves to be softened or lulled asleep by the Pecksniffs than if they had been so many hedgehogs or porcupines!")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("First, there was Mr Spottletoe, who was so bald and had such big whiskers, that he seemed to have stopped his hair, by the sudden application of some powerful remedy, in the very act of falling off his head, and to have fastened it irrevocably on his face. Then there was Mrs Spottletoe, who being much too slim for her years, and of a poetical constitution, was accustomed to inform her more intimate friends that the said whiskers were ‘the lodestar of her existence;’ and who could now, by reason of her strong affection for her uncle Chuzzlewit, and the shock it gave her to be suspected of testamentary designs upon him, do nothing but cry—except moan. Then there were Anthony Chuzzlewit, and his son Jonas; the face of the old man so sharpened by the wariness and cunning of his life, that it seemed to cut him a passage through the crowded room, as he edged away behind the remotest chairs; while the son had so well profited by the precept and example of the father, that he looked a year or two the elder of the twain, as they stood winking their red eyes, side by side, and whispering to each other softly. Then there was the widow of a deceased brother of Mr Martin Chuzzlewit, who being almost supernaturally disagreeable, and having a dreary face and a bony figure and a masculine voice, was, in right of these qualities, ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("what is commonly called a strong-minded woman; and who, if she could, would have established her claim to the title, and have shown herself, mentally speaking, a perfect Samson, by shutting up her brother-in-law in a private madhouse, until he proved his complete sanity by loving her very much. Beside her sat her spinster daughters, three in number, and of gentlemanly deportment, who had so mortified themselves with tight stays, that their tempers were reduced to something less than their waists, and sharp lacing was expressed in their very noses. Then there was a young gentleman, grandnephew of Mr Martin Chuzzlewit, very dark and very hairy, and apparently born for no particular purpose but to save looking-glasses the trouble of reflecting more than just the first idea and sketchy notion of a face, which had never been carried out. Then there was a solitary female cousin who was remarkable for nothing but being very deaf, and living by herself, and always having the toothache. Then there was George Chuzzlewit, a gay bachelor cousin, who claimed to be young but had been younger, and was inclined to corpulency, and rather overfed himself; to that extent, indeed, that his eyes were strained in their sockets, as if with constant surprise; and he had such an obvious disposition to pimples, that the bright spots on his cravat, the rich pattern on his waistcoat, and even his glittering trinkets, seemed to have broken out upon him, and not to have come into existence comfortably. Last of all there were present Mr Chevy Slyme and his friend Tigg. And it is worthy of remark, that although each person present disliked the other, mainly because he or she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" belong to the family, they one and all concurred in hating Mr Tigg because he didn’t.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20096m.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("Such was the pleasant little family circle now assembled in Mr Pecksniff’s best parlour, agreeably prepared to fall foul of ")]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("Mr Pecksniff or anybody else who might venture to say anything whatever upon any subject.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This,’ said Mr Pecksniff, rising and looking round upon them with folded hands, ‘does me good. It does my daughters good. We thank you for assembling here. We are grateful to you with our whole hearts. It is a blessed distinction that you have conferred upon us, and believe me’—it is impossible to conceive how he smiled here—‘we shall not easily forget it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am sorry to interrupt you, Pecksniff,’ remarked Mr Spottletoe, with his whiskers in a very portentous state; ‘but you are assuming too much to yourself, sir. Who do you imagine has it in contemplation to confer a distinction upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(", sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A general murmur echoed this inquiry, and applauded it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you are about to pursue the course with which you have begun, sir,’ pursued Mr Spottletoe in a great heat, and giving a violent rap on the table with his knuckles, ‘the sooner you desist, and this assembly separates, the better. I am no stranger, sir, to your preposterous desire to be regarded as the head of this family, but I can tell "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(", sir—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh yes, indeed! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v(" tell. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v("! What? He was the head, was he? From the strong-minded woman downwards everybody fell, that instant, upon Mr. Spottletoe, who after vainly attempting to be heard in silence was fain to sit down again, folding his arms and shaking his head most wrathfully, and giving Mrs Spottletoe to understand in dumb show, that that scoundrel Pecksniff might go on for the present, but he would cut in presently, and annihilate him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am not sorry,’ said Mr Pecksniff in resumption of his address, ‘I am really not sorry that this little incident has happened. It is good to feel that we are met here without disguise. It is good to know that we have no reserve before each other, but are appearing freely in our own characters.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("Here, the eldest daughter of the strong-minded woman rose a little way from her seat, and trembling violently from head to foot, more as it seemed with passion than timidity, expressed a general hope that some people "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("would")]), _vm._v(" appear in their own characters, if it were only for such a proceeding having the attraction of novelty to recommend it; and that when they (meaning the some people before mentioned) talked about their relations, they would be careful to observe who was present in company at the time; otherwise it might come round to those relations’ ears, in a way they little expected; and as to red noses (she observed) she had yet to learn that a red nose was any disgrace, inasmuch as people neither made nor coloured their own noses, but had that feature provided for them without being first consulted; though even upon that branch of the subject she had great doubts whether certain noses were redder than other noses, or indeed half as red as some. This remark being received with a shrill titter by the two sisters of the speaker, Miss Charity Pecksniff begged with much politeness to be informed whether any of those very low observations were levelled at her; and receiving no more explanatory answer than was conveyed in the adage ‘Those the cap fits, let them wear it,’ immediately commenced a somewhat acrimonious and personal retort, wherein she was much comforted and abetted by her sister Mercy, who laughed at the same with great heartiness; indeed far more naturally than life. And it being quite impossible that any difference of opinion can take place among women without every woman who is within hearing taking active part in it, the strong-minded lady and her two daughters, and Mrs Spottletoe, and the deaf cousin (who was not at all disqualified from joining in the dispute by reason of being perfectly unacquainted with its merits), one and all plunged ")]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("into the quarrel directly.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The two Miss Pecksniffs being a pretty good match for the three Miss Chuzzlewits, and all five young ladies having, in the figurative language of the day, a great amount of steam to dispose of, the altercation would no doubt have been a long one but for the high valour and prowess of the strong-minded woman, who, in right of her reputation for powers of sarcasm, did so belabour and pummel Mrs Spottletoe with taunting words that the poor lady, before the engagement was two minutes old, had no refuge but in tears. These she shed so plentifully, and so much to the agitation and grief of Mr Spottletoe, that that gentleman, after holding his clenched fist close to Mr Pecksniff’s eyes, as if it were some natural curiosity from the near inspection whereof he was likely to derive high gratification and improvement, and after offering (for no particular reason that anybody could discover) to kick Mr George Chuzzlewit for, and in consideration of, the trifling sum of sixpence, took his wife under his arm and indignantly withdrew. This diversion, by distracting the attention of the combatants, put an end to the strife, which, after breaking out afresh some twice or thrice in certain inconsiderable spurts and dashes, died away in silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was then that Mr Pecksniff once more rose from his chair. It was then that the two Miss Pecksniffs composed themselves to look as if there were no such beings—not to say present, but in the whole compass of the world—as the three Miss Chuzzlewits; while the three Miss Chuzzlewits became equally unconscious of the existence of the two Miss Pecksniffs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("‘It is to be lamented,’ said Mr Pecksniff, with a forgiving recollection of Mr Spottletoe’s fist, ‘that our friend should have withdrawn himself so very hastily, though we have cause ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("for mutual congratulation even in that, since we are assured that he is not distrustful of us in regard to anything we may say or do while he is absent. Now, that is very soothing, is it not?’")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pecksniff,’ said Anthony, who had been watching the whole party with peculiar keenness from the first—‘don’t you be a hypocrite.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A what, my good sir?’ demanded Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A hypocrite.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Charity, my dear,’ said Mr Pecksniff, ‘when I take my chamber candlestick to-night, remind me to be more than usually particular in praying for Mr Anthony Chuzzlewit; who has done me an injustice.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was said in a very bland voice, and aside, as being addressed to his daughter’s private ear. With a cheerfulness of conscience, prompting almost a sprightly demeanour, he then resumed:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All our thoughts centring in our very dear but unkind relative, and he being as it were beyond our reach, we are met to-day, really as if we were a funeral party, except—a blessed exception—that there is no body in the house.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The strong-minded lady was not at all sure that this was a blessed exception. Quite the contrary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, my dear madam!’ said Mr Pecksniff. ‘Be that as it may, here we are; and being here, we are to consider whether it is possible by any justifiable means—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, you know as well as I,’ said the strong-minded lady, ‘that any means are justifiable in such a case, don’t you?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("‘Very good, my dear madam, very good; whether it is possible by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" means, we will say by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("any")]), _vm._v(" means, to open the eyes of our valued relative to his present infatuation. Whether it is possible to make him acquainted by any means with the real ")]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("character and purpose of that young female whose strange, whose very strange position, in reference to himself’—here Mr Pecksniff sunk his voice to an impressive whisper—‘really casts a shadow of disgrace and shame upon this family; and who, we know’—here he raised his voice again—‘else why is she his companion? harbours the very basest designs upon his weakness and his property.’")])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In their strong feeling on this point, they, who agreed in nothing else, all concurred as one mind. Good Heaven, that she should harbour designs upon his property! The strong-minded lady was for poison, her three daughters were for Bridewell and bread-and-water, the cousin with the toothache advocated Botany Bay, the two Miss Pecksniffs suggested flogging. Nobody but Mr Tigg, who, notwithstanding his extreme shabbiness, was still understood to be in some sort a lady’s man, in right of his upper lip and his frogs, indicated a doubt of the justifiable nature of these measures; and he only ogled the three Miss Chuzzlewits with the least admixture of banter in his admiration, as though he would observe, ‘You are positively down upon her to too great an extent, my sweet creatures, upon my soul you are!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now,’ said Mr Pecksniff, crossing his two forefingers in a manner which was at once conciliatory and argumentative; ‘I will not, upon the one hand, go so far as to say that she deserves all the inflictions which have been so very forcibly and hilariously suggested;’ one of his ornamental sentences; ‘nor will I, upon the other, on any account compromise my common understanding as a man, by making the assertion that she does not. What I would observe is, that I think some practical means might be devised of inducing our respected, shall I say our revered—?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No!’ interposed the strong-minded woman in a loud voice.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("‘Then I will not,’ said Mr Pecksniff. ‘You are quite right, my dear madam, and I appreciate and thank you for your discriminating objection—our respected relative, to dispose himself to listen to the promptings of nature, and not to the—’")])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go on, Pa!’ cried Mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, the truth is, my dear,’ said Mr Pecksniff, smiling upon his assembled kindred, ‘that I am at a loss for a word. The name of those fabulous animals (pagan, I regret to say) who used to sing in the water, has quite escaped me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr George Chuzzlewit suggested ‘swans.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pecksniff. ‘Not swans. Very like swans, too. Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The nephew with the outline of a countenance, speaking for the first and last time on that occasion, propounded ‘Oysters.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pecksniff, with his own peculiar urbanity, ‘nor oysters. But by no means unlike oysters; a very excellent idea; thank you, my dear sir, very much. Wait! Sirens. Dear me! sirens, of course. I think, I say, that means might be devised of disposing our respected relative to listen to the promptings of nature, and not to the siren-like delusions of art. Now we must not lose sight of the fact that our esteemed friend has a grandson, to whom he was, until lately, very much attached, and whom I could have wished to see here to-day, for I have a real and deep regard for him. A fine young man, a very fine young man! I would submit to you, whether we might not remove Mr Chuzzlewit’s distrust of us, and vindicate our own disinterestedness by—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If Mr George Chuzzlewit has anything to say to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(",’ interposed the strong-minded woman, sternly, ‘I beg him to speak out like a man; and not to look at me and my daughters as if he could eat us.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("‘As to looking, I have heard it said, Mrs Ned,’ returned Mr George, angrily, ‘that a cat is free to contemplate a monarch; and therefore I hope I have some right, having been born a member of this family, to look at a person who only came into it by marriage. As to eating, I beg to say, whatever bitterness your jealousies and disappointed expectations may suggest to you, that I am not a cannibal, ma’am.’")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know that!’ cried the strong-minded woman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At all events, if I was a cannibal,’ said Mr George Chuzzlewit, greatly stimulated by this retort, ‘I think it would occur to me that a lady who had outlived three husbands, and suffered so very little from their loss, must be most uncommonly tough.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The strong-minded woman immediately rose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And I will further add,’ said Mr George, nodding his head violently at every second syllable; ‘naming no names, and therefore hurting nobody but those whose consciences tell them they are alluded to, that I think it would be much more decent and becoming, if those who hooked and crooked themselves into this family by getting on the blind side of some of its members before marriage, and manslaughtering them afterwards by crowing over them to that strong pitch that they were glad to die, would refrain from acting the part of vultures in regard to other members of this family who are living. I think it would be full as well, if not better, if those individuals would keep at home, contenting themselves with what they have got (luckily for them) already; instead of hovering about, and thrusting their fingers into, a family pie, which they flavour much more than enough, I can tell them, when they are fifty miles away.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("‘I might have been prepared for this!’ cried the strong-minded woman, looking about her with a disdainful smile as ")]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("she moved towards the door, followed by her three daughters. ‘Indeed I was fully prepared for it from the first. What else could I expect in such an atmosphere as this!’")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t direct your halfpay-officers’ gaze at me, ma’am, if you please,’ interposed Miss Charity; ‘for I won’t bear it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was a smart stab at a pension enjoyed by the strong-minded woman, during her second widowhood and before her last coverture. It told immensely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I passed from the memory of a grateful country, you very miserable minx,’ said Mrs Ned, ‘when I entered this family; and I feel now, though I did not feel then, that it served me right, and that I lost my claim upon the United Kingdom of Great Britain and Ireland when I so degraded myself. Now, my dears, if you’re quite ready, and have sufficiently improved yourselves by taking to heart the genteel example of these two young ladies, I think we’ll go. Mr Pecksniff, we are very much obliged to you, really. We came to be entertained, and you have far surpassed our utmost expectations, in the amusement you have provided for us. Thank you. Good-bye!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With such departing words, did this strong-minded female paralyse the Pecksniffian energies; and so she swept out of the room, and out of the house, attended by her daughters, who, as with one accord, elevated their three noses in the air, and joined in a contemptuous titter. As they passed the parlour window on the outside, they were seen to counterfeit a perfect transport of delight among themselves; and with this final blow and great discouragement for those within, they vanished.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("Before Mr Pecksniff or any of his remaining visitors could offer a remark, another figure passed this window, coming, at a great rate in the opposite direction; and immediately afterwards, Mr Spottletoe burst into the chamber. Compared with ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("his present state of heat, he had gone out a man of snow or ice. His head distilled such oil upon his whiskers, that they were rich and clogged with unctuous drops; his face was violently inflamed, his limbs trembled; and he gasped and strove for breath.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My good sir!’ cried Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh yes!’ returned the other; ‘oh yes, certainly! Oh to be sure! Oh, of course! You hear him? You hear him? all of you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the matter?’ cried several voices.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh nothing!’ cried Spottletoe, still gasping. ‘Nothing at all! It’s of no consequence! Ask him! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("He")]), _vm._v("’ll tell you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I do not understand our friend,’ said Mr Pecksniff, looking about him in utter amazement. ‘I assure you that he is quite unintelligible to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Unintelligible, sir!’ cried the other. ‘Unintelligible! Do you mean to say, sir, that you don’t know what has happened! That you haven’t decoyed us here, and laid a plot and a plan against us! Will you venture to say that you didn’t know Mr Chuzzlewit was going, sir, and that you don’t know he’s gone, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gone!’ was the general cry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Gone,’ echoed Mr Spottletoe. ‘Gone while we were sitting here. Gone. Nobody knows where he’s gone. Oh, of course not! Nobody knew he was going. Oh, of course not! The landlady thought up to the very last moment that they were merely going for a ride; she had no other suspicion. Oh, of course not! She’s not this fellow’s creature. Oh, of course not!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adding to these exclamations a kind of ironical howl, and gazing upon the company for one brief instant afterwards, in a sudden silence, the irritated gentleman started off again at the same tremendous pace, and was seen no more.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("It was in vain for Mr Pecksniff to assure them that this new ")]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("and opportune evasion of the family was at least as great a shock and surprise to him as to anybody else. Of all the bullyings and denunciations that were ever heaped on one unlucky head, none can ever have exceeded in energy and heartiness those with which he was complimented by each of his remaining relatives, singly, upon bidding him farewell.")])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The moral position taken by Mr Tigg was something quite tremendous; and the deaf cousin, who had the complicated aggravation of seeing all the proceedings and hearing nothing but the catastrophe, actually scraped her shoes upon the scraper, and afterwards distributed impressions of them all over the top step, in token that she shook the dust from her feet before quitting that dissembling and perfidious mansion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff had, in short, but one comfort, and that was the knowledge that all these his relations and friends had hated him to the very utmost extent before; and that he, for his part, had not distributed among them any more love than, with his ample capital in that respect, he could comfortably afford to part with. This view of his affairs yielded him great consolation; and the fact deserves to be noted, as showing with what ease a good man may be consoled under circumstances of failure and disappointment.")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("Chapter Five")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Containing a Full Account of the Installation of Mr Pecksniff’s New Pupil into the Bosom of Mr Pecksniff’s Family. With all the Festivities Held on that Occasion, and the Great Enjoyment of Mr Pinch")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("The best of architects and land surveyors kept a horse, in whom the enemies already mentioned more than once in these pages pretended to detect a fanciful resemblance to his master. Not in his outward person, for he was a raw-boned, haggard horse, always on a much shorter allowance of corn than Mr Pecksniff; but in his moral character, wherein, said they, he was full of promise, but of no performance. He was always in a manner, going to go, and never going. When at his slowest rate of travelling he would sometimes lift up his legs so high, and display such mighty action, that it was difficult to believe he was doing less than fourteen miles an hour; and he was for ever so perfectly satisfied with his own speed, and so little disconcerted by opportunities of comparing himself with the fastest trotters, that the illusion was the more difficult of resistance. He was a kind of animal who infused into the ")]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("breasts of strangers a lively sense of hope, and possessed all those who knew him better with a grim despair. In what respect, having these points of character, he might be fairly likened to his master, that good man’s slanderers only can explain. But it is a melancholy truth, and a deplorable instance of the uncharitableness of the world, that they made the comparison.")])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In this horse, and the hooded vehicle, whatever its proper name might be, to which he was usually harnessed—it was more like a gig with a tumour than anything else—all Mr Pinch’s thoughts and wishes centred, one bright frosty morning; for with this gallant equipage he was about to drive to Salisbury alone, there to meet with the new pupil, and thence to bring him home in triumph.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("Blessings on thy simple heart, Tom Pinch, how proudly dost thou button up that scanty coat, called by a sad misnomer, for these many years, a ‘great’ one; and how thoroughly, as with thy cheerful voice thou pleasantly adjurest Sam the hostler ‘not to let him go yet,’ dost thou believe that quadruped desires to go, and would go if he might! Who could repress a smile—of love for thee, Tom Pinch, and not in jest at thy expense, for thou art poor enough already, Heaven knows—to think that such a holiday as lies before thee should awaken that quick flow and hurry of the spirits, in which thou settest down again, almost untasted, on the kitchen window-sill, that great white mug (put by, by thy own hands, last night, that breakfast might not hold thee late), and layest yonder crust upon the seat beside thee, to be eaten on the road, when thou art calmer in thy high rejoicing! Who, as thou drivest off, a happy, man, and noddest with a grateful lovingness to Pecksniff in his nightcap at his chamber-window, would not cry, ‘Heaven speed thee, Tom, and send that thou wert going off ")]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("for ever to some quiet home where thou mightst live at peace, and sorrow should not touch thee!’")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("What better time for driving, riding, walking, moving through the air by any means, than a fresh, frosty morning, when hope runs cheerily through the veins with the brisk blood, and tingles in the frame from head to foot! This was the glad commencement of a bracing day in early winter, such as may put the languid summer season (speaking of it when it can’t be had) to the blush, and shame the spring for being sometimes cold by halves. The sheep-bells rang as clearly in the vigorous air, as if they felt its wholesome influence like living creatures; the trees, in lieu of leaves or blossoms, shed upon the ground a frosty rime that sparkled as it fell, and might have been the dust of diamonds. So it was to Tom. From cottage chimneys, smoke went streaming up high, high, as if the earth had lost its grossness, being so fair, and must not be oppressed by heavy vapour. The crust of ice on the else rippling brook was so transparent, and so thin in texture, that the lively water might of its own free will have stopped—in Tom’s glad mind it had—to look upon the lovely morning. And lest the sun should break this charm too eagerly, there moved between him and the ground, a mist like that which waits upon the moon on summer nights—the very same to Tom—and wooed him to dissolve it gently.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Tom Pinch went on; not fast, but with a sense of rapid motion, which did just as well; and as he went, all kinds of things occurred to keep him happy. Thus when he came within sight of the turnpike, and was—oh a long way off!—he saw the tollman’s wife, who had that moment checked a waggon, run back into the little house again like mad, to say (she knew) that Mr Pinch was coming up. And she was right, for when he drew within hail of the gate, forth rushed the tollman’s children, ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("shrieking in tiny chorus, ‘Mr Pinch!’ to Tom’s intense delight. The very tollman, though an ugly chap in general, and one whom folks were rather shy of handling, came out himself to take the toll, and give him rough good morning; and that with all this, and a glimpse of the family breakfast on a little round table before the fire, the crust Tom Pinch had brought away with him acquired as rich a flavour as though it had been cut from a fairy loaf.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But there was more than this. It was not only the married people and the children who gave Tom Pinch a welcome as he passed. No, no. Sparkling eyes and snowy breasts came hurriedly to many an upper casement as he clattered by, and gave him back his greeting: not stinted either, but sevenfold, good measure. They were all merry. They all laughed. And some of the wickedest among them even kissed their hands as Tom looked back. For who minded poor Mr Pinch? There was no harm in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And now the morning grew so fair, and all things were so wide awake and gay, that the sun seeming to say—Tom had no doubt he said—’I can’t stand it any longer; I must have a look,’ streamed out in radiant majesty. The mist, too shy and gentle for such lusty company, fled off, quite scared, before it; and as it swept away, the hills and mounds and distant pasture lands, teeming with placid sheep and noisy crows, came out as bright as though they were unrolled bran new for the occasion. In compliment to which discovery, the brook stood still no longer, but ran briskly off to bear the tidings to the water-mill, three miles away.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("Mr Pinch was jogging along, full of pleasant thoughts and cheerful influences, when he saw, upon the path before him, going in the same direction with himself, a traveller on foot, who walked with a light quick step, and sang as he went—for ")]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("certain in a very loud voice, but not unmusically. He was a young fellow, of some five or six-and-twenty perhaps, and was dressed in such a free and fly-away fashion, that the long ends of his loose red neckcloth were streaming out behind him quite as often as before; and the bunch of bright winter berries in the buttonhole of his velveteen coat was as visible to Mr Pinch’s rearward observation, as if he had worn that garment wrong side foremost. He continued to sing with so much energy, that he did not hear the sound of wheels until it was close behind him; when he turned a whimsical face and a very merry pair of blue eyes on Mr Pinch, and checked himself directly.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, Mark?’ said Tom Pinch, stopping. ‘Who’d have thought of seeing you here? Well! this is surprising!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark touched his hat, and said, with a very sudden decrease of vivacity, that he was going to Salisbury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And how spruce you are, too!’ said Mr Pinch, surveying him with great pleasure. ‘Really, I didn’t think you were half such a tight-made fellow, Mark!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thankee, Mr Pinch. Pretty well for that, I believe. It’s not my fault, you know. With regard to being spruce, sir, that’s where it is, you see.’ And here he looked particularly gloomy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where what is?’ Mr Pinch demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Where the aggravation of it is. Any man may be in good spirits and good temper when he’s well dressed. There an’t much credit in that. If I was very ragged and very jolly, then I should begin to feel I had gained a point, Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So you were singing just now, to bear up, as it were, against being well dressed, eh, Mark?’ said Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your conversation’s always equal to print, sir,’ rejoined Mark, with a broad grin. ‘That was it.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("‘Well!’ cried Pinch, ‘you are the strangest young man, Mark, ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("I ever knew in my life. I always thought so; but now I am quite certain of it. I am going to Salisbury, too. Will you get in? I shall be very glad of your company.’")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young fellow made his acknowledgments and accepted the offer; stepping into the carriage directly, and seating himself on the very edge of the seat with his body half out of it, to express his being there on sufferance, and by the politeness of Mr Pinch. As they went along, the conversation proceeded after this manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I more than half believed, just now, seeing you so very smart,’ said Pinch, ‘that you must be going to be married, Mark.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, sir, I’ve thought of that, too,’ he replied. ‘There might be some credit in being jolly with a wife, ‘specially if the children had the measles and that, and was very fractious indeed. But I’m a’most afraid to try it. I don’t see my way clear.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not very fond of anybody, perhaps?’ said Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not particular, sir, I think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But the way would be, you know, Mark, according to your views of things,’ said Mr Pinch, ‘to marry somebody you didn’t like, and who was very disagreeable.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So it would, sir; but that might be carrying out a principle a little too far, mightn’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Perhaps it might,’ said Mr Pinch. At which they both laughed gayly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("‘Lord bless you, sir,’ said Mark, ‘you don’t half know me, though. I don’t believe there ever was a man as could come out so strong under circumstances that would make other men miserable, as I could, if I could only get a chance. But I can’t get a chance. It’s my opinion that nobody never will know half of what’s in me, unless something very unexpected turns up. And I don’t see any prospect of that. I’m a-going to ")]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("leave the Dragon, sir.’")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Going to leave the Dragon!’ cried Mr Pinch, looking at him with great astonishment. ‘Why, Mark, you take my breath away!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, sir,’ he rejoined, looking straight before him and a long way off, as men do sometimes when they cogitate profoundly. ‘What’s the use of my stopping at the Dragon? It an’t at all the sort of place for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(". When I left London (I’m a Kentish man by birth, though), and took that situation here, I quite made up my mind that it was the dullest little out-of-the-way corner in England, and that there would be some credit in being jolly under such circumstances. But, Lord, there’s no dullness at the Dragon! Skittles, cricket, quoits, nine-pins, comic songs, choruses, company round the chimney corner every winter’s evening. Any man could be jolly at the Dragon. There’s no credit in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But if common report be true for once, Mark, as I think it is, being able to confirm it by what I know myself,’ said Mr Pinch, ‘you are the cause of half this merriment, and set it going.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There may be something in that, too, sir,’ answered Mark. ‘But that’s no consolation.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well!’ said Mr Pinch, after a short silence, his usually subdued tone being even now more subdued than ever. ‘I can hardly think enough of what you tell me. Why, what will become of Mrs Lupin, Mark?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark looked more fixedly before him, and further off still, as he answered that he didn’t suppose it would be much of an object to her. There were plenty of smart young fellows as would be glad of the place. He knew a dozen himself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("‘That’s probable enough,’ said Mr Pinch, ‘but I am not at all sure that Mrs Lupin would be glad of them. Why, I always ")]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("supposed that Mrs Lupin and you would make a match of it, Mark; and so did every one, as far as I know.’")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I never,’ Mark replied, in some confusion, ‘said nothing as was in a direct way courting-like to her, nor she to me, but I don’t know what I mightn’t do one of these odd times, and what she mightn’t say in answer. Well, sir, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" wouldn’t suit.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not to be landlord of the Dragon, Mark?’ cried Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, sir, certainly not,’ returned the other, withdrawing his gaze from the horizon, and looking at his fellow-traveller. ‘Why that would be the ruin of a man like me. I go and sit down comfortably for life, and no man never finds me out. What would be the credit of the landlord of the Dragon’s being jolly? Why, he couldn’t help it, if he tried.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Does Mrs Lupin know you are going to leave her?’ Mr Pinch inquired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I haven’t broke it to her yet, sir, but I must. I’m looking out this morning for something new and suitable,’ he said, nodding towards the city.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What kind of thing now?’ Mr Pinch demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was thinking,’ Mark replied, ‘of something in the grave-digging way.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good gracious, Mark?’ cried Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a good damp, wormy sort of business, sir,’ said Mark, shaking his head argumentatively, ‘and there might be some credit in being jolly, with one’s mind in that pursuit, unless grave-diggers is usually given that way; which would be a drawback. You don’t happen to know how that is in general, do you, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pinch, ‘I don’t indeed. I never thought upon the subject.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("‘In case of that not turning out as well as one could wish, you know,’ said Mark, musing again, ‘there’s other businesses. ")]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Undertaking now. That’s gloomy. There might be credit to be gained there. A broker’s man in a poor neighbourhood wouldn’t be bad perhaps. A jailor sees a deal of misery. A doctor’s man is in the very midst of murder. A bailiff’s an’t a lively office nat’rally. Even a tax-gatherer must find his feelings rather worked upon, at times. There’s lots of trades in which I should have an opportunity, I think.’")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch was so perfectly overwhelmed by these remarks that he could do nothing but occasionally exchange a word or two on some indifferent subject, and cast sidelong glances at the bright face of his odd friend (who seemed quite unconscious of his observation), until they reached a certain corner of the road, close upon the outskirts of the city, when Mark said he would jump down there, if he pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But bless my soul, Mark,’ said Mr Pinch, who in the progress of his observation just then made the discovery that the bosom of his companion’s shirt was as much exposed as if it was Midsummer, and was ruffled by every breath of air, ‘why don’t you wear a waistcoat?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the good of one, sir?’ asked Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good of one?’ said Mr Pinch. ‘Why, to keep your chest warm.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lord love you, sir!’ cried Mark, ‘you don’t know me. My chest don’t want no warming. Even if it did, what would no waistcoat bring it to? Inflammation of the lungs, perhaps? Well, there’d be some credit in being jolly, with a inflammation of the lungs.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("As Mr Pinch returned no other answer than such as was conveyed in his breathing very hard, and opening his eyes very wide, and nodding his head very much, Mark thanked him for his ride, and without troubling him to stop, jumped lightly down. And away he fluttered, with his red neckerchief, ")]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("and his open coat, down a cross-lane; turning back from time to time to nod to Mr Pinch, and looking one of the most careless, good-humoured comical fellows in life. His late companion, with a thoughtful face pursued his way to Salisbury.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("Mr Pinch had a shrewd notion that Salisbury was a very desperate sort of place; an exceeding wild and dissipated city; and when he had put up the horse, and given the hostler to understand that he would look in again in the course of an hour or two to see him take his corn, he set forth on a stroll about the streets with a vague and not unpleasant idea that they teemed with all kinds of mystery and bedevilment. To one of his quiet habits this little delusion was greatly assisted by the circumstance of its being market-day, and the thoroughfares about the market-place being filled with carts, horses, donkeys, baskets, waggons, garden-stuff, meat, tripe, pies, poultry and huckster’s wares of every opposite description and possible variety of character. Then there were young farmers and old farmers with smock-frocks, brown great-coats, drab great-coats, red worsted comforters, leather-leggings, wonderful shaped hats, hunting-whips, and rough sticks, standing about in groups, or talking noisily together on the tavern steps, or paying and receiving huge amounts of greasy wealth, with the assistance of such bulky pocket-books that when they were in their pockets it was apoplexy to get them out, and when they were out it was spasms to get them in again. Also there were farmers’ wives in beaver bonnets and red cloaks, riding shaggy horses purged of all earthly passions, who went soberly into all manner of places without desiring to know why, and who, if required, would have stood stock still in a china shop, with a complete dinner-service at each hoof. Also a great many dogs, who were strongly interested in the state of the market and the bargains of their masters; ")]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("and a great confusion of tongues, both brute and human.")])]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch regarded everything exposed for sale with great delight, and was particularly struck by the itinerant cutlery, which he considered of the very keenest kind, insomuch that he purchased a pocket knife with seven blades in it, and not a cut (as he afterwards found out) among them. When he had exhausted the market-place, and watched the farmers safe into the market dinner, he went back to look after the horse. Having seen him eat unto his heart’s content he issued forth again, to wander round the town and regale himself with the shop windows; previously taking a long stare at the bank, and wondering in what direction underground the caverns might be where they kept the money; and turning to look back at one or two young men who passed him, whom he knew to be articled to solicitors in the town; and who had a sort of fearful interest in his eyes, as jolly dogs who knew a thing or two, and kept it up tremendously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the shops. First of all there were the jewellers’ shops, with all the treasures of the earth displayed therein, and such large silver watches hanging up in every pane of glass, that if they were anything but first-rate goers it certainly was not because the works could decently complain of want of room. In good sooth they were big enough, and perhaps, as the saying is, ugly enough, to be the most correct of all mechanical performers; in Mr Pinch’s eyes, however they were smaller than Geneva ware; and when he saw one very bloated watch announced as a repeater, gifted with the uncommon power of striking every quarter of an hour inside the pocket of its happy owner, he almost wished that he were rich enough to buy it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("But what were even gold and silver, precious stones and clockwork, to the bookshops, whence a pleasant smell of paper ")]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("freshly pressed came issuing forth, awakening instant recollections of some new grammar had at school, long time ago, with ‘Master Pinch, Grove House Academy,’ inscribed in faultless writing on the fly-leaf! That whiff of russia leather, too, and all those rows on rows of volumes neatly ranged within—what happiness did they suggest! And in the window were the spick-and-span new works from London, with the title-pages, and sometimes even the first page of the first chapter, laid wide open; tempting unwary men to begin to read the book, and then, in the impossibility of turning over, to rush blindly in, and buy it! Here too were the dainty frontispiece and trim vignette, pointing like handposts on the outskirts of great cities, to the rich stock of incident beyond; and store of books, with many a grave portrait and time-honoured name, whose matter he knew well, and would have given mines to have, in any form, upon the narrow shell beside his bed at Mr Pecksniff’s. What a heart-breaking shop it was!")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("There was another; not quite so bad at first, but still a trying shop; where children’s books were sold, and where poor Robinson Crusoe stood alone in his might, with dog and hatchet, goat-skin cap and fowling-pieces; calmly surveying Philip Quarn and the host of imitators round him, and calling Mr Pinch to witness that he, of all the crowd, impressed one solitary footprint on the shore of boyish memory, whereof the tread of generations should not stir the lightest grain of sand. And there too were the Persian tales, with flying chests and students of enchanted books shut up for years in caverns; and there too was Abudah, the merchant, with the terrible little old woman hobbling out of the box in his bedroom; and there the mighty talisman, the rare Arabian Nights, with Cassim Baba, divided by four, like the ghost of a dreadful sum, hanging up, all gory, in the robbers’ cave. Which matchless wonders, ")]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("coming fast on Mr Pinch’s mind, did so rub up and chafe that wonderful lamp within him, that when he turned his face towards the busy street, a crowd of phantoms waited on his pleasure, and he lived again, with new delight, the happy days before the Pecksniff era.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He had less interest now in the chemists’ shops, with their great glowing bottles (with smaller repositories of brightness in their very stoppers); and in their agreeable compromises between medicine and perfumery, in the shape of toothsome lozenges and virgin honey. Neither had he the least regard (but he never had much) for the tailors’, where the newest metropolitan waistcoat patterns were hanging up, which by some strange transformation always looked amazing there, and never appeared at all like the same thing anywhere else. But he stopped to read the playbill at the theatre and surveyed the doorway with a kind of awe, which was not diminished when a sallow gentleman with long dark hair came out, and told a boy to run home to his lodgings and bring down his broadsword. Mr Pinch stood rooted to the spot on hearing this, and might have stood there until dark, but that the old cathedral bell began to ring for vesper service, on which he tore himself away.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Now, the organist’s assistant was a friend of Mr Pinch’s, which was a good thing, for he too was a very quiet gentle soul, and had been, like Tom, a kind of old-fashioned boy at school, though well liked by the noisy fellow too. As good luck would have it (Tom always said he had great good luck) the assistant chanced that very afternoon to be on duty by himself, with no one in the dusty organ loft but Tom; so while he played, Tom helped him with the stops; and finally, the service being just over, Tom took the organ himself. It was then turning dark, and the yellow light that streamed in through the ")]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("ancient windows in the choir was mingled with a murky red. As the grand tones resounded through the church, they seemed, to Tom, to find an echo in the depth of every ancient tomb, no less than in the deep mystery of his own heart. Great thoughts and hopes came crowding on his mind as the rich music rolled upon the air and yet among them—something more grave and solemn in their purpose, but the same—were all the images of that day, down to its very lightest recollection of childhood. The feeling that the sounds awakened, in the moment of their existence, seemed to include his whole life and being; and as the surrounding realities of stone and wood and glass grew dimmer in the darkness, these visions grew so much the brighter that Tom might have forgotten the new pupil and the expectant master, and have sat there pouring out his grateful heart till midnight, but for a very earthy old verger insisting on locking up the cathedral forthwith. So he took leave of his friend, with many thanks, groped his way out, as well as he could, into the now lamp-lighted streets, and hurried off to get his dinner.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("All the farmers being by this time jogging homewards, there was nobody in the sanded parlour of the tavern where he had left the horse; so he had his little table drawn out close before the fire, and fell to work upon a well-cooked steak and smoking hot potatoes, with a strong appreciation of their excellence, and a very keen sense of enjoyment. Beside him, too, there stood a jug of most stupendous Wiltshire beer; and the effect of the whole was so transcendent, that he was obliged every now and then to lay down his knife and fork, rub his hands, and think about it. By the time the cheese and celery came, Mr Pinch had taken a book out of his pocket, and could afford to trifle with the viands; now eating a little, now drinking a little, now reading a little, and now stopping to wonder ")]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("what sort of a young man the new pupil would turn out to be. He had passed from this latter theme and was deep in his book again, when the door opened, and another guest came in, bringing with him such a quantity of cold air, that he positively seemed at first to put the fire out.")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very hard frost to-night, sir,’ said the newcomer, courteously acknowledging Mr Pinch’s withdrawal of the little table, that he might have place: ‘Don’t disturb yourself, I beg.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though he said this with a vast amount of consideration for Mr Pinch’s comfort, he dragged one of the great leather-bottomed chairs to the very centre of the hearth, notwithstanding; and sat down in front of the fire, with a foot on each hob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My feet are quite numbed. Ah! Bitter cold to be sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have been in the air some considerable time, I dare say?’ said Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All day. Outside a coach, too.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That accounts for his making the room so cool,’ thought Mr Pinch. ‘Poor fellow! How thoroughly chilled he must be!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The stranger became thoughtful likewise, and sat for five or ten minutes looking at the fire in silence. At length he rose and divested himself of his shawl and great-coat, which (far different from Mr Pinch’s) was a very warm and thick one; but he was not a whit more conversational out of his great-coat than in it, for he sat down again in the same place and attitude, and leaning back in his chair, began to bite his nails. He was young—one-and-twenty, perhaps—and handsome; with a keen dark eye, and a quickness of look and manner which made Tom sensible of a great contrast in his own bearing, and caused him to feel even more shy than usual.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("There was a clock in the room, which the stranger often turned to look at. Tom made frequent reference to it also; ")]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("partly from a nervous sympathy with its taciturn companion; and partly because the new pupil was to inquire for him at half after six, and the hands were getting on towards that hour. Whenever the stranger caught him looking at this clock, a kind of confusion came upon Tom as if he had been found out in something; and it was a perception of his uneasiness which caused the younger man to say, perhaps, with a smile:")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We both appear to be rather particular about the time. The fact is, I have an engagement to meet a gentleman here.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So have I,’ said Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At half-past six,’ said the stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At half-past six,’ said Tom in the very same breath; whereupon the other looked at him with some surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The young gentleman, I expect,’ remarked Tom, timidly, ‘was to inquire at that time for a person by the name of Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear me!’ cried the other, jumping up. ‘And I have been keeping the fire from you all this while! I had no idea you were Mr Pinch. I am the Mr Martin for whom you were to inquire. Pray excuse me. How do you do? Oh, do draw nearer, pray!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ said Tom, ‘thank you. I am not at all cold, and you are; and we have a cold ride before us. Well, if you wish it, I will. I—I am very glad,’ said Tom, smiling with an embarrassed frankness peculiarly his, and which was as plainly a confession of his own imperfections, and an appeal to the kindness of the person he addressed, as if he had drawn one up in simple language and committed it to paper: ‘I am very glad indeed that you turn out to be the party I expected. I was thinking, but a minute ago, that I could wish him to be like you.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("‘I am very glad to hear it,’ returned Martin, shaking hands with him again; ‘for I assure you, I was thinking there could be ")]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("no such luck as Mr Pinch’s turning out like you.’")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, really!’ said Tom, with great pleasure. ‘Are you serious?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Upon my word I am,’ replied his new acquaintance. ‘You and I will get on excellently well, I know; which it’s no small relief to me to feel, for to tell you the truth, I am not at all the sort of fellow who could get on with everybody, and that’s the point on which I had the greatest doubts. But they’re quite relieved now.—Do me the favour to ring the bell, will you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch rose, and complied with great alacrity—the handle hung just over Martin’s head, as he warmed himself—and listened with a smiling face to what his friend went on to say. It was:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you like punch, you’ll allow me to order a glass apiece, as hot as it can be made, that we may usher in our friendship in a becoming manner. To let you into a secret, Mr Pinch, I never was so much in want of something warm and cheering in my life; but I didn’t like to run the chance of being found drinking it, without knowing what kind of person you were; for first impressions, you know, often go a long way, and last a long time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch assented, and the punch was ordered. In due course it came; hot and strong. After drinking to each other in the steaming mixture, they became quite confidential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m a sort of relation of Pecksniff’s, you know,’ said the young man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed!’ cried Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes. My grandfather is his cousin, so he’s kith and kin to me, somehow, if you can make that out. I can’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then Martin is your Christian name?’ said Mr Pinch, thoughtfully. ‘Oh!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("‘Of course it is,’ returned his friend: ‘I wish it was my surname ")]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("for my own is not a very pretty one, and it takes a long time to sign. Chuzzlewit is my name.’")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear me!’ cried Mr Pinch, with an involuntary start.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not surprised at my having two names, I suppose?’ returned the other, setting his glass to his lips. ‘Most people have.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, no,’ said Mr Pinch, ‘not at all. Oh dear no! Well!’ And then remembering that Mr Pecksniff had privately cautioned him to say nothing in reference to the old gentleman of the same name who had lodged at the Dragon, but to reserve all mention of that person for him, he had no better means of hiding his confusion than by raising his own glass to his mouth. They looked at each other out of their respective tumblers for a few seconds, and then put them down empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told them in the stable to be ready for us ten minutes ago,’ said Mr Pinch, glancing at the clock again. ‘Shall we go?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you please,’ returned the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Would you like to drive?’ said Mr Pinch; his whole face beaming with a consciousness of the splendour of his offer. ‘You shall, if you wish.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, that depends, Mr Pinch,’ said Martin, laughing, ‘upon what sort of a horse you have. Because if he’s a bad one, I would rather keep my hands warm by holding them comfortably in my greatcoat pockets.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He appeared to think this such a good joke, that Mr Pinch was quite sure it must be a capital one. Accordingly, he laughed too, and was fully persuaded that he enjoyed it very much. Then he settled his bill, and Mr Chuzzlewit paid for the punch; and having wrapped themselves up, to the extent of their respective means, they went out together to the front door, where Mr Pecksniff’s property stopped the way.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("‘I won’t drive, thank you, Mr Pinch,’ said Martin, getting into ")]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("the sitter’s place. ‘By the bye, there’s a box of mine. Can we manage to take it?’")])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, certainly,’ said Tom. ‘Put it in, Dick, anywhere!’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20117m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was not precisely of that convenient size which would admit of its being squeezed into any odd corner, but Dick the hostler got it in somehow, and Mr Chuzzlewit helped him. It was all on Mr Pinch’s side, and Mr Chuzzlewit said he was very much afraid it would encumber him; to which Tom said, ‘Not at all;’ though it forced him into such an awkward position, that he had much ado to see anything but his own knees. But it is an ill wind that blows nobody any good; and the wisdom of the saying was verified in this instance; for the cold air came from Mr Pinch’s side of the carriage, and by interposing a perfect wall of box and man between it and the new pupil, he shielded that young gentleman effectually; which was a great comfort.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("It was a clear evening, with a bright moon. The whole landscape was silvered by its light and by the hoar-frost; and everything looked exquisitely beautiful. At first, the great serenity and peace through which they travelled, disposed them both to silence; but in a very short time the punch within them and the healthful air without, made them loquacious, and they talked incessantly. When they were halfway home, and stopped to give the horse some water, Martin (who was very generous with his money) ordered another glass of punch, which they drank between them, and which had not the effect of making them less conversational than before. Their principal topic of discourse was naturally Mr Pecksniff and his family; of whom, and of the great obligations they had heaped upon him, Tom Pinch, with the tears standing in his eyes, drew such a picture as would have inclined any one of common feeling almost to revere them; and of which Mr Pecksniff had not ")]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("the slightest foresight or preconceived idea, or he certainly (being very humble) would not have sent Tom Pinch to bring the pupil home.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In this way they went on, and on, and on—in the language of the story-books—until at last the village lights appeared before them, and the church spire cast a long reflection on the graveyard grass; as if it were a dial (alas, the truest in the world!) marking, whatever light shone out of Heaven, the flight of days and weeks and years, by some new shadow on that solemn ground.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A pretty church!’ said Martin, observing that his companion slackened the slack pace of the horse, as they approached.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is it not?’ cried Tom, with great pride. ‘There’s the sweetest little organ there you ever heard. I play it for them.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed?’ said Martin. ‘It is hardly worth the trouble, I should think. What do you get for that, now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing,’ answered Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well,’ returned his friend, ‘you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" a very strange fellow!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To which remark there succeeded a brief silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When I say nothing,’ observed Mr Pinch, cheerfully, ‘I am wrong, and don’t say what I mean, because I get a great deal of pleasure from it, and the means of passing some of the happiest hours I know. It led to something else the other day; but you will not care to hear about that I dare say?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh yes I shall. What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It led to my seeing,’ said Tom, in a lower voice, ‘one of the loveliest and most beautiful faces you can possibly picture to yourself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And yet I am able to picture a beautiful one,’ said his friend, thoughtfully, ‘or should be, if I have any memory.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("‘She came’ said Tom, laying his hand upon the other’s arm, ‘for the first time very early in the morning, when it was hardly ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("light; and when I saw her, over my shoulder, standing just within the porch, I turned quite cold, almost believing her to be a spirit. A moment’s reflection got the better of that, of course, and fortunately it came to my relief so soon, that I didn’t leave off playing.’")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why fortunately?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why? Because she stood there, listening. I had my spectacles on, and saw her through the chinks in the curtains as plainly as I see you; and she was beautiful. After a while she glided off, and I continued to play until she was out of hearing.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why did you do that?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t you see?’ responded Tom. ‘Because she might suppose I hadn’t seen her; and might return.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And did she?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Certainly she did. Next morning, and next evening too; but always when there were no people about, and always alone. I rose earlier and sat there later, that when she came, she might find the church door open, and the organ playing, and might not be disappointed. She strolled that way for some days, and always stayed to listen. But she is gone now, and of all unlikely things in this wide world, it is perhaps the most improbable that I shall ever look upon her face again.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t know anything more about her?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And you never followed her when she went away?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("‘Why should I distress her by doing that?’ said Tom Pinch. ‘Is it likely that she wanted my company? She came to hear the organ, not to see me; and would you have had me scare her from a place she seemed to grow quite fond of? Now, Heaven bless her!’ cried Tom, ‘to have given her but a minute’s pleasure every day, I would have gone on playing the organ at ")]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("those times until I was an old man; quite contented if she sometimes thought of a poor fellow like me, as a part of the music; and more than recompensed if she ever mixed me up with anything she liked as well as she liked that!’")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The new pupil was clearly very much amazed by Mr Pinch’s weakness, and would probably have told him so, and given him some good advice, but for their opportune arrival at Mr Pecksniff’s door; the front door this time, on account of the occasion being one of ceremony and rejoicing. The same man was in waiting for the horse who had been adjured by Mr Pinch in the morning not to yield to his rabid desire to start; and after delivering the animal into his charge, and beseeching Mr Chuzzlewit in a whisper never to reveal a syllable of what he had just told him in the fullness of his heart, Tom led the pupil in, for instant presentation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff had clearly not expected them for hours to come; for he was surrounded by open books, and was glancing from volume to volume, with a black lead-pencil in his mouth, and a pair of compasses in his hand, at a vast number of mathematical diagrams, of such extraordinary shapes that they looked like designs for fireworks. Neither had Miss Charity expected them, for she was busied, with a capacious wicker basket before her, in making impracticable nightcaps for the poor. Neither had Miss Mercy expected them, for she was sitting upon her stool, tying on the—oh good gracious!—the petticoat of a large doll that she was dressing for a neighbour’s child—really, quite a grown-up doll, which made it more confusing—and had its little bonnet dangling by the ribbon from one of her fair curls, to which she had fastened it lest it should be lost or sat upon. It would be difficult, if not impossible, to conceive a family so thoroughly taken by surprise as the Pecksniffs were, on this occasion.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("Bless my life!’ said Mr Pecksniff, looking up, and gradually exchanging his abstracted face for one of joyful recognition. ‘Here already! Martin, my dear boy, I am delighted to welcome you to my poor house!’")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("With this kind greeting, Mr Pecksniff fairly took him to his arms, and patted him several times upon the back with his right hand the while, as if to express that his feelings during the embrace were too much for utterance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But here,’ he said, recovering, ‘are my daughters, Martin; my two only children, whom (if you ever saw them) you have not beheld—ah, these sad family divisions!—since you were infants together. Nay, my dears, why blush at being detected in your everyday pursuits? We had prepared to give you the reception of a visitor, Martin, in our little room of state,’ said Mr Pecksniff, smiling, ‘but I like this better, I like this better!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh blessed star of Innocence, wherever you may be, how did you glitter in your home of ether, when the two Miss Pecksniffs put forth each her lily hand, and gave the same, with mantling cheeks, to Martin! How did you twinkle, as if fluttering with sympathy, when Mercy, reminded of the bonnet in her hair, hid her fair face and turned her head aside; the while her gentle sister plucked it out, and smote her with a sister’s soft reproof, upon her buxom shoulder!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And how,’ said Mr Pecksniff, turning round after the contemplation of these passages, and taking Mr Pinch in a friendly manner by the elbow, ‘how has our friend used you, Martin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well indeed, sir. We are on the best terms, I assure you.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("‘Old Tom Pinch!’ said Mr Pecksniff, looking on him with affectionate sadness. ‘Ah! It seems but yesterday that Thomas was a boy fresh from a scholastic course. Yet years have ")]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("passed, I think, since Thomas Pinch and I first walked the world together!’")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch could say nothing. He was too much moved. But he pressed his master’s hand, and tried to thank him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And Thomas Pinch and I,’ said Mr Pecksniff, in a deeper voice, ‘will walk it yet, in mutual faithfulness and friendship! And if it comes to pass that either of us be run over in any of those busy crossings which divide the streets of life, the other will convey him to the hospital in Hope, and sit beside his bed in Bounty!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, well, well!’ he added in a happier tone, as he shook Mr Pinch’s elbow hard. ‘No more of this! Martin, my dear friend, that you may be at home within these walls, let me show you how we live, and where. Come!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that he took up a lighted candle, and, attended by his young relative, prepared to leave the room. At the door, he stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ll bear us company, Tom Pinch?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aye, cheerfully, though it had been to death, would Tom have followed him; glad to lay down his life for such a man!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This,’ said Mr Pecksniff, opening the door of an opposite parlour, ‘is the little room of state, I mentioned to you. My girls have pride in it, Martin! This,’ opening another door, ‘is the little chamber in which my works (slight things at best) have been concocted. Portrait of myself by Spiller. Bust by Spoker. The latter is considered a good likeness. I seem to recognize something about the left-hand corner of the nose, myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin thought it was very like, but scarcely intellectual enough. Mr Pecksniff observed that the same fault had been found with it before. It was remarkable it should have struck his young relation too. He was glad to see he had an eye for art.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("‘Various books you observe,’ said Mr Pecksniff, waving his hand towards the wall, ‘connected with our pursuit. I have scribbled myself, but have not yet published. Be careful how you come upstairs. This,’ opening another door, ‘is my chamber. I read here when the family suppose I have retired to rest. Sometimes I injure my health rather more than I can quite justify to myself, by doing so; but art is long and time is short. Every facility you see for jotting down crude notions, even here.’")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("These latter words were explained by his pointing to a small round table on which were a lamp, divers sheets of paper, a piece of India rubber, and a case of instruments; all put ready, in case an architectural idea should come into Mr Pecksniff’s head in the night; in which event he would instantly leap out of bed, and fix it for ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff opened another door on the same floor, and shut it again, all at once, as if it were a Blue Chamber. But before he had well done so, he looked smilingly round, and said, ‘Why not?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin couldn’t say why not, because he didn’t know anything at all about it. So Mr Pecksniff answered himself, by throwing open the door, and saying:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My daughters’ room. A poor first-floor to us, but a bower to them. Very neat. Very airy. Plants you observe; hyacinths; books again; birds.’ These birds, by the bye, comprised, in all, one staggering old sparrow without a tail, which had been borrowed expressly from the kitchen. ‘Such trifles as girls love are here. Nothing more. Those who seek heartless splendour, would seek here in vain.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that he led them to the floor above.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("‘This,’ said Mr Pecksniff, throwing wide the door of the ")]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("memorable two-pair front; ‘is a room where some talent has been developed I believe. This is a room in which an idea for a steeple occurred to me that I may one day give to the world. We work here, my dear Martin. Some architects have been bred in this room; a few, I think, Mr Pinch?’")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom fully assented; and, what is more, fully believed it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You see,’ said Mr Pecksniff, passing the candle rapidly from roll to roll of paper, ‘some traces of our doings here. Salisbury Cathedral from the north. From the south. From the east. From the west. From the south-east. From the nor’west. A bridge. An almshouse. A jail. A church. A powder-magazine. A wine-cellar. A portico. A summer-house. An ice-house. Plans, elevations, sections, every kind of thing. And this,’ he added, having by this time reached another large chamber on the same story, with four little beds in it, ‘this is your room, of which Mr Pinch here is the quiet sharer. A southern aspect; a charming prospect; Mr Pinch’s little library, you perceive; everything agreeable and appropriate. If there is any additional comfort you would desire to have here at anytime, pray mention it. Even to strangers, far less to you, my dear Martin, there is no restriction on that point.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was undoubtedly true, and may be stated in corroboration of Mr Pecksniff, that any pupil had the most liberal permission to mention anything in this way that suggested itself to his fancy. Some young gentlemen had gone on mentioning the very same thing for five years without ever being stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The domestic assistants,’ said Mr Pecksniff, ‘sleep above; and that is all.’ After which, and listening complacently as he went, to the encomiums passed by his young friend on the arrangements generally, he led the way to the parlour again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Here a great change had taken place; for festive preparations on a rather extensive scale were already completed, and ")]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("the two Miss Pecksniffs were awaiting their return with hospitable looks. There were two bottles of currant wine, white and red; a dish of sandwiches (very long and very slim); another of apples; another of captain’s biscuits (which are always a moist and jovial sort of viand); a plate of oranges cut up small and gritty; with powdered sugar, and a highly geological home-made cake. The magnitude of these preparations quite took away Tom Pinch’s breath; for though the new pupils were usually let down softly, as one may say, particularly in the wine department, which had so many stages of declension, that sometimes a young gentleman was a whole fortnight in getting to the pump; still this was a banquet; a sort of Lord Mayor’s feast in private life; a something to think of, and hold on by, afterwards.")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To this entertainment, which apart from its own intrinsic merits, had the additional choice quality, that it was in strict keeping with the night, being both light and cool, Mr Pecksniff besought the company to do full justice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Martin,’ he said, ‘will seat himself between you two, my dears, and Mr Pinch will come by me. Let us drink to our new inmate, and may we be happy together! Martin, my dear friend, my love to you! Mr Pinch, if you spare the bottle we shall quarrel.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And trying (in his regard for the feelings of the rest) to look as if the wine were not acid and didn’t make him wink, Mr Pecksniff did honour to his own toast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This,’ he said, in allusion to the party, not the wine, ‘is a mingling that repays one for much disappointment and vexation. Let us be merry.’ Here he took a captain’s biscuit. ‘It is a poor heart that never rejoices; and our hearts are not poor. No!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("With such stimulants to merriment did he beguile the time, ")]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("and do the honours of the table; while Mr Pinch, perhaps to assure himself that what he saw and heard was holiday reality, and not a charming dream, ate of everything, and in particular disposed of the slim sandwiches to a surprising extent. Nor was he stinted in his draughts of wine; but on the contrary, remembering Mr Pecksniff’s speech, attacked the bottle with such vigour, that every time he filled his glass anew, Miss Charity, despite her amiable resolves, could not repress a fixed and stony glare, as if her eyes had rested on a ghost. Mr Pecksniff also became thoughtful at those moments, not to say dejected; but as he knew the vintage, it is very likely he may have been speculating on the probable condition of Mr Pinch upon the morrow, and discussing within himself the best remedies for colic.")])]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin and the young ladies were excellent friends already, and compared recollections of their childish days, to their mutual liveliness and entertainment. Miss Mercy laughed immensely at everything that was said; and sometimes, after glancing at the happy face of Mr Pinch, was seized with such fits of mirth as brought her to the very confines of hysterics. But for these bursts of gaiety, her sister, in her better sense, reproved her; observing, in an angry whisper, that it was far from being a theme for jest; and that she had no patience with the creature; though it generally ended in her laughing too—but much more moderately—and saying that indeed it was a little too ridiculous and intolerable to be serious about.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("At length it became high time to remember the first clause of that great discovery made by the ancient philosopher, for securing health, riches, and wisdom; the infallibility of which has been for generations verified by the enormous fortunes constantly amassed by chimney-sweepers and other persons who get up early and go to bed betimes. The young ladies accordingly ")]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("rose, and having taken leave of Mr Chuzzlewit with much sweetness, and of their father with much duty and of Mr Pinch with much condescension, retired to their bower. Mr Pecksniff insisted on accompanying his young friend upstairs for personal superintendence of his comforts; and taking him by the arm, conducted him once more to his bedroom, followed by Mr Pinch, who bore the light.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Pinch,’ said Pecksniff, seating himself with folded arms on one of the spare beds. ‘I don’t see any snuffers in that candlestick. Will you oblige me by going down, and asking for a pair?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch, only too happy to be useful, went off directly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You will excuse Thomas Pinch’s want of polish, Martin,’ said Mr Pecksniff, with a smile of patronage and pity, as soon as he had left the room. ‘He means well.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is a very good fellow, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes,’ said Mr Pecksniff. ‘Yes. Thomas Pinch means well. He is very grateful. I have never regretted having befriended Thomas Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should think you never would, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Mr Pecksniff. ‘No. I hope not. Poor fellow, he is always disposed to do his best; but he is not gifted. You will make him useful to you, Martin, if you please. If Thomas has a fault, it is that he is sometimes a little apt to forget his position. But that is soon checked. Worthy soul! You will find him easy to manage. Good night!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good night, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By this time Mr Pinch had returned with the snuffers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And good night to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(", Mr Pinch,’ said Pecksniff. ‘And sound sleep to you both. Bless you! Bless you!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Invoking this benediction on the heads of his young friends with great fervour, he withdrew to his own room; while they, ")]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("being tired, soon fell asleep. If Martin dreamed at all, some clue to the matter of his visions may possibly be gathered from the after-pages of this history. Those of Thomas Pinch were all of holidays, church organs, and seraphic Pecksniffs. It was some time before Mr Pecksniff dreamed at all, or even sought his pillow, as he sat for full two hours before the fire in his own chamber, looking at the coals and thinking deeply. But he, too, slept and dreamed at last. Thus in the quiet hours of the night, one house shuts in as many incoherent and incongruous fancies as a madman’s head.")])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  })])])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("Chapter Six")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Comprises, among other Important Matters, Pecksniffian and Architectural, and Exact Relation of the Progress made by Mr Pinch in the Confidence and Friendship of the New Pupil")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was morning; and the beautiful Aurora, of whom so much hath been written, said, and sung, did, with her rosy fingers, nip and tweak Miss Pecksniff’s nose. It was the frolicsome custom of the Goddess, in her intercourse with the fair Cherry, so to do; or in more prosaic phrase, the tip of that feature in the sweet girl’s countenance was always very red at breakfast-time. For the most part, indeed, it wore, at that season of the day, a scraped and frosty look, as if it had been rasped; while a similar phenomenon developed itself in her humour, which was then observed to be of a sharp and acid quality, as though an extra lemon (figuratively speaking) had been squeezed into the nectar of her disposition, and had rather damaged its flavour.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("This additional pungency on the part of the fair young creature led, on ordinary occasions, to such slight consequences ")]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("as the copious dilution of Mr Pinch’s tea, or to his coming off uncommonly short in respect of butter, or to other the like results. But on the morning after the Installation Banquet, she suffered him to wander to and fro among the eatables and drinkables, a perfectly free and unchecked man; so utterly to Mr Pinch’s wonder and confusion, that like the wretched captive who recovered his liberty in his old age, he could make but little use of his enlargement, and fell into a strange kind of flutter for want of some kind hand to scrape his bread, and cut him off in the article of sugar with a lump, and pay him those other little attentions to which he was accustomed. There was something almost awful, too, about the self-possession of the new pupil; who ‘troubled’ Mr Pecksniff for the loaf, and helped himself to a rasher of that gentleman’s own particular and private bacon, with all the coolness in life. He even seemed to think that he was doing quite a regular thing, and to expect that Mr Pinch would follow his example, since he took occasion to observe of that young man ‘that he didn’t get on’; a speech of so tremendous a character, that Tom cast down his eyes involuntarily, and felt as if he himself had committed some horrible deed and heinous breach of Mr Pecksniff’s confidence. Indeed, the agony of having such an indiscreet remark addressed to him before the assembled family, was breakfast enough in itself, and would, without any other matter of reflection, have settled Mr Pinch’s business and quenched his appetite, for one meal, though he had been never so hungry.")])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young ladies, however, and Mr Pecksniff likewise, remained in the very best of spirits in spite of these severe trials, though with something of a mysterious understanding among themselves. When the meal was nearly over, Mr Pecksniff smilingly explained the cause of their common satisfaction.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_124"
    }
  }), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("‘It is not often,’ he said, ‘Martin, that my daughters and I desert our quiet home to pursue the giddy round of pleasures that revolves abroad. But we think of doing so to-day.’")])]), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed, sir!’ cried the new pupil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Mr Pecksniff, tapping his left hand with a letter which he held in his right. ‘I have a summons here to repair to London; on professional business, my dear Martin; strictly on professional business; and I promised my girls, long ago, that whenever that happened again, they should accompany me. We shall go forth to-night by the heavy coach—like the dove of old, my dear Martin—and it will be a week before we again deposit our olive-branches in the passage. When I say olive-branches,’ observed Mr Pecksniff, in explanation, ‘I mean, our unpretending luggage.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I hope the young ladies will enjoy their trip,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! that I’m sure we shall!’ cried Mercy, clapping her hands. ‘Good gracious, Cherry, my darling, the idea of London!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ardent child!’ said Mr Pecksniff, gazing on her in a dreamy way. ‘And yet there is a melancholy sweetness in these youthful hopes! It is pleasant to know that they never can be realised. I remember thinking once myself, in the days of my childhood, that pickled onions grew on trees, and that every elephant was born with an impregnable castle on his back. I have not found the fact to be so; far from it; and yet those visions have comforted me under circumstances of trial. Even when I have had the anguish of discovering that I have nourished in my breast on ostrich, and not a human pupil—even in that hour of agony, they have soothed me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this dread allusion to John Westlock, Mr Pinch precipitately choked in his tea; for he had that very morning received a letter from him, as Mr Pecksniff very well knew.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("‘You will take care, my dear Martin,’ said Mr Pecksniff, resuming his former cheerfulness, ‘that the house does not run away in our absence. We leave you in charge of everything. There is no mystery; all is free and open. Unlike the young man in the Eastern tale—who is described as a one-eyed almanac, if I am not mistaken, Mr Pinch?—’")])]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A one-eyed calender, I think, sir,’ faltered Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘They are pretty nearly the same thing, I believe,’ said Mr Pecksniff, smiling compassionately; ‘or they used to be in my time. Unlike that young man, my dear Martin, you are forbidden to enter no corner of this house; but are requested to make yourself perfectly at home in every part of it. You will be jovial, my dear Martin, and will kill the fatted calf if you please!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was not the least objection, doubtless, to the young man’s slaughtering and appropriating to his own use any calf, fat or lean, that he might happen to find upon the premises; but as no such animal chanced at that time to be grazing on Mr Pecksniff’s estate, this request must be considered rather as a polite compliment that a substantial hospitality. It was the finishing ornament of the conversation; for when he had delivered it, Mr Pecksniff rose and led the way to that hotbed of architectural genius, the two-pair front.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Let me see,’ he said, searching among the papers, ‘how you can best employ yourself, Martin, while I am absent. Suppose you were to give me your idea of a monument to a Lord Mayor of London; or a tomb for a sheriff; or your notion of a cow-house to be erected in a nobleman’s park. Do you know, now,’ said Mr Pecksniff, folding his hands, and looking at his young relation with an air of pensive interest, ‘that I should very much like to see your notion of a cow-house?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Martin by no means appeared to relish this suggestion.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("‘A pump,’ said Mr Pecksniff, ‘is very chaste practice. I have found that a lamp post is calculated to refine the mind and give it a classical tendency. An ornamental turnpike has a remarkable effect upon the imagination. What do you say to beginning with an ornamental turnpike?’")])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Whatever Mr Pecksniff pleased,’ said Martin, doubtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stay,’ said that gentleman. ‘Come! as you’re ambitious, and are a very neat draughtsman, you shall—ha ha!—you shall try your hand on these proposals for a grammar-school; regulating your plan, of course, by the printed particulars. Upon my word, now,’ said Mr Pecksniff, merrily, ‘I shall be very curious to see what you make of the grammar-school. Who knows but a young man of your taste might hit upon something, impracticable and unlikely in itself, but which I could put into shape? For it really is, my dear Martin, it really is in the finishing touches alone, that great experience and long study in these matters tell. Ha, ha, ha! Now it really will be,’ continued Mr Pecksniff, clapping his young friend on the back in his droll humour, ‘an amusement to me, to see what you make of the grammar-school.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin readily undertook this task, and Mr Pecksniff forthwith proceeded to entrust him with the materials necessary for its execution; dwelling meanwhile on the magical effect of a few finishing touches from the hand of a master; which, indeed, as some people said (and these were the old enemies again!) was unquestionably very surprising, and almost miraculous; as there were cases on record in which the masterly introduction of an additional back window, or a kitchen door, or half-a-dozen steps, or even a water spout, had made the design of a pupil Mr Pecksniff’s own work, and had brought substantial rewards into that gentleman’s pocket. But such is the magic of genius, which changes all it handles into gold!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("‘When your mind requires to be refreshed by change of occupation,’ said Mr Pecksniff, ‘Thomas Pinch will instruct you in the art of surveying the back garden, or in ascertaining the dead level of the road between this house and the finger-post, or in any other practical and pleasing pursuit. There are a cart-load of loose bricks, and a score or two of old flower-pots, in the back yard. If you could pile them up my dear Martin, into any form which would remind me on my return say of St. Peter’s at Rome, or the Mosque of St. Sophia at Constantinople, it would be at once improving to you and agreeable to my feelings. And now,’ said Mr Pecksniff, in conclusion, ‘to drop, for the present, our professional relations and advert to private matters, I shall be glad to talk with you in my own room, while I pack up my portmanteau.’")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin attended him; and they remained in secret conference together for an hour or more; leaving Tom Pinch alone. When the young man returned, he was very taciturn and dull, in which state he remained all day; so that Tom, after trying him once or twice with indifferent conversation, felt a delicacy in obtruding himself upon hihts,s thoug and said no more.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("He would not have had leisure to say much, had his new friend been ever so loquacious; for first of all Mr Pecksniff called him down to stand upon the top of his portmanteau and represent ancient statues there, until such time as it would consent to be locked; and then Miss Charity called him to come and cord her trunk; and then Miss Mercy sent for him to come and mend her box; and then he wrote the fullest possible cards for all the luggage; and then he volunteered to carry it all downstairs; and after that to see it safely carried on a couple of barrows to the old finger-post at the end of the lane; and then to mind it till the coach came up. In short, his day’s ")]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("work would have been a pretty heavy one for a porter, but his thorough good-will made nothing of it; and as he sat upon the luggage at last, waiting for the Pecksniffs, escorted by the new pupil, to come down the lane, his heart was light with the hope of having pleased his benefactor.")])]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was almost afraid,’ said Tom, taking a letter from his pocket and wiping his face, for he was hot with bustling about though it was a cold day, ‘that I shouldn’t have had time to write it, and that would have been a thousand pities; postage from such a distance being a serious consideration, when one’s not rich. She will be glad to see my hand, poor girl, and to hear that Pecksniff is as kind as ever. I would have asked John Westlock to call and see her, and tell her all about me by word of mouth, but I was afraid he might speak against Pecksniff to her, and make her uneasy. Besides, they are particular people where she is, and it might have rendered her situation uncomfortable if she had had a visit from a young man like John. Poor Ruth!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom Pinch seemed a little disposed to be melancholy for half a minute or so, but he found comfort very soon, and pursued his ruminations thus:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("‘I’m a nice man, I don’t think, as John used to say (John was a kind, merry-hearted fellow; I wish he had liked Pecksniff better), to be feeling low, on account of the distance between us, when I ought to be thinking, instead, of my extraordinary good luck in having ever got here. I must have been born with a silver spoon in my mouth, I am sure, to have ever come across Pecksniff. And here have I fallen again into my usual good luck with the new pupil! Such an affable, generous, free fellow, as he is, I never saw. Why, we were companions directly! and he a relation of Pecksniff’s too, and a clever, dashing youth who might cut his way through the world as if it were a ")]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("cheese! Here he comes while the words are on my lips’ said Tom; ‘walking down the lane as if the lane belonged to him.’")])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In truth, the new pupil, not at all disconcerted by the honour of having Miss Mercy Pecksniff on his arm, or by the affectionate adieux of that young lady, approached as Mr Pinch spoke, followed by Miss Charity and Mr Pecksniff. As the coach appeared at the same moment, Tom lost no time in entreating the gentleman last mentioned, to undertake the delivery of his letter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ said Mr Pecksniff, glancing at the superscription. ‘For your sister, Thomas. Yes, oh yes, it shall be delivered, Mr Pinch. Make your mind easy upon that score. She shall certainly have it, Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made the promise with so much condescension and patronage, that Tom felt he had asked a great deal (this had not occurred to his mind before), and thanked him earnestly. The Miss Pecksniffs, according to a custom they had, were amused beyond description at the mention of Mr Pinch’s sister. Oh the fright! The bare idea of a Miss Pinch! Good heavens!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom was greatly pleased to see them so merry, for he took it as a token of their favour, and good-humoured regard. Therefore he laughed too and rubbed his hands and wished them a pleasant journey and safe return, and was quite brisk. Even when the coach had rolled away with the olive-branches in the boot and the family of doves inside, he stood waving his hand and bowing; so much gratified by the unusually courteous demeanour of the young ladies, that he was quite regardless, for the moment, of Martin Chuzzlewit, who stood leaning thoughtfully against the finger-post, and who after disposing of his fair charge had hardly lifted his eyes from the ground.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("The perfect silence which ensued upon the bustle and departure ")]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("of the coach, together with the sharp air of the wintry afternoon, roused them both at the same time. They turned, as by mutual consent, and moved off arm-in-arm.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How melancholy you are!’ said Tom; ‘what is the matter?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing worth speaking of,’ said Martin. ‘Very little more than was the matter yesterday, and much more, I hope, than will be the matter to-morrow. I’m out of spirits, Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well,’ cried Tom, ‘now do you know I am in capital spirits today, and scarcely ever felt more disposed to be good company. It was a very kind thing in your predecessor, John, to write to me, was it not?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, yes,’ said Martin carelessly; ‘I should have thought he would have had enough to do to enjoy himself, without thinking of you, Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just what I felt to be so very likely,’ Tom rejoined; ‘but no, he keeps his word, and says, “My dear Pinch, I often think of you,” and all sorts of kind and considerate things of that description.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He must be a devilish good-natured fellow,’ said Martin, somewhat peevishly: ‘because he can’t mean that, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t suppose he can, eh?’ said Tom, looking wistfully in his companion’s face. ‘He says so to please me, you think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, is it likely,’ rejoined Martin, with greater earnestness, ‘that a young man newly escaped from this kennel of a place, and fresh to all the delights of being his own master in London, can have much leisure or inclination to think favourably of anything or anybody he has left behind him here? I put it to you, Pinch, is it natural?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a short reflection, Mr Pinch replied, in a more subdued tone, that to be sure it was unreasonable to expect any such thing, and that he had no doubt Martin knew best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course I know best,’ Martin observed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("‘Yes, I feel that,’ said Mr Pinch mildly. ‘I said so.’ And when he had made this rejoinder, they fell into a blank silence again, which lasted until they reached home; by which time it was dark.")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, Miss Charity Pecksniff, in consideration of the inconvenience of carrying them with her in the coach, and the impossibility of preserving them by artificial means until the family’s return, had set forth, in a couple of plates, the fragments of yesterday’s feast. In virtue of which liberal arrangement, they had the happiness to find awaiting them in the parlour two chaotic heaps of the remains of last night’s pleasure, consisting of certain filmy bits of oranges, some mummied sandwiches, various disrupted masses of the geological cake, and several entire captain’s biscuits. That choice liquor in which to steep these dainties might not be wanting, the remains of the two bottles of currant wine had been poured together and corked with a curl-paper; so that every material was at hand for making quite a heavy night of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin Chuzzlewit beheld these roystering preparations with infinite contempt, and stirring the fire into a blaze (to the great destruction of Mr Pecksniff’s coals), sat moodily down before it, in the most comfortable chair he could find. That he might the better squeeze himself into the small corner that was left for him, Mr Pinch took up his position on Miss Mercy Pecksniff’s stool, and setting his glass down upon the hearthrug and putting his plate upon his knees, began to enjoy himself.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20132m.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("If Diogenes coming to life again could have rolled himself, tub and all, into Mr Pecksniff’s parlour and could have seen Tom Pinch as he sat on Mercy Pecksniff’s stool with his plate and glass before him he could not have faced it out, though in his surliest mood, but must have smiled good-temperedly. The ")]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("perfect and entire satisfaction of Tom; his surpassing appreciation of the husky sandwiches, which crumbled in his mouth like saw-dust; the unspeakable relish with which he swallowed the thin wine by drops, and smacked his lips, as though it were so rich and generous that to lose an atom of its fruity flavour were a sin; the look with which he paused sometimes, with his glass in his hand, proposing silent toasts to himself; and the anxious shade that came upon his contented face when, after wandering round the room, exulting in its uninvaded snugness, his glance encountered the dull brow of his companion; no cynic in the world, though in his hatred of its men a very griffin, could have withstood these things in Thomas Pinch.")])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Some men would have slapped him on the back, and pledged him in a bumper of the currant wine, though it had been the sharpest vinegar—aye, and liked its flavour too; some would have seized him by his honest hand, and thanked him for the lesson that his simple nature taught them. Some would have laughed with, and others would have laughed at him; of which last class was Martin Chuzzlewit, who, unable to restrain himself, at last laughed loud and long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s right,’ said Tom, nodding approvingly. ‘Cheer up! That’s capital!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At which encouragement young Martin laughed again; and said, as soon as he had breath and gravity enough:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I never saw such a fellow as you are, Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Didn’t you though?’ said Tom. ‘Well, it’s very likely you do find me strange, because I have hardly seen anything of the world, and you have seen a good deal I dare say?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("‘Pretty well for my time of life,’ rejoined Martin, drawing his chair still nearer to the fire, and spreading his feet out on the fender. ‘Deuce take it, I must talk openly to somebody. I’ll ")]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("talk openly to you, Pinch.’")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do!’ said Tom. ‘I shall take it as being very friendly of you,’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not in your way, am I?’ inquired Martin, glancing down at Mr Pinch, who was by this time looking at the fire over his leg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all!’ cried Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You must know then, to make short of a long story,’ said Martin, beginning with a kind of effort, as if the revelation were not agreeable to him; ‘that I have been bred up from childhood with great expectations, and have always been taught to believe that I should be, one day, very rich. So I should have been, but for certain brief reasons which I am going to tell you, and which have led to my being disinherited.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘By your father?’ inquired Mr Pinch, with open eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘By my grandfather. I have had no parents these many years. Scarcely within my remembrance.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Neither have I,’ said Tom, touching the young man’s hand with his own and timidly withdrawing it again. ‘Dear me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, as to that, you know, Pinch,’ pursued the other, stirring the fire again, and speaking in his rapid, off-hand way; ‘it’s all very right and proper to be fond of parents when we have them, and to bear them in remembrance after they’re dead, if you have ever known anything of them. But as I never did know anything about mine personally, you know, why, I can’t be expected to be very sentimental about ‘em. And I am not; that’s the truth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch was just then looking thoughtfully at the bars. But on his companion pausing in this place, he started, and said ‘Oh! of course’—and composed himself to listen again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("‘In a word,’ said Martin, ‘I have been bred and reared all my life by this grandfather of whom I have just spoken. Now, he has a great many good points—there is no doubt about ")]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("that; I’ll not disguise the fact from you—but he has two very great faults, which are the staple of his bad side. In the first place, he has the most confirmed obstinacy of character you ever met with in any human creature. In the second, he is most abominably selfish.’")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is he indeed?’ cried Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In those two respects,’ returned the other, ‘there never was such a man. I have often heard from those who know, that they have been, time out of mind, the failings of our family; and I believe there’s some truth in it. But I can’t say of my own knowledge. All I have to do, you know, is to be very thankful that they haven’t descended to me, and, to be very careful that I don’t contract ‘em.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To be sure,’ said Mr Pinch. ‘Very proper.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, sir,’ resumed Martin, stirring the fire once more, and drawing his chair still closer to it, ‘his selfishness makes him exacting, you see; and his obstinacy makes him resolute in his exactions. The consequence is that he has always exacted a great deal from me in the way of respect, and submission, and self-denial when his wishes were in question, and so forth. I have borne a great deal from him, because I have been under obligations to him (if one can ever be said to be under obligations to one’s own grandfather), and because I have been really attached to him; but we have had a great many quarrels for all that, for I could not accommodate myself to his ways very often—not out of the least reference to myself, you understand, but because—’ he stammered here, and was rather at a loss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch being about the worst man in the world to help anybody out of a difficulty of this sort, said nothing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("‘Well! as you understand me,’ resumed Martin, quickly, ‘I needn’t hunt for the precise expression I want. Now I come to ")]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("the cream of my story, and the occasion of my being here. I am in love, Pinch.’")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch looked up into his face with increased interest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I say I am in love. I am in love with one of the most beautiful girls the sun ever shone upon. But she is wholly and entirely dependent upon the pleasure of my grandfather; and if he were to know that she favoured my passion, she would lose her home and everything she possesses in the world. There is nothing very selfish in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" love, I think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Selfish!’ cried Tom. ‘You have acted nobly. To love her as I am sure you do, and yet in consideration for her state of dependence, not even to disclose—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What are you talking about, Pinch?’ said Martin pettishly: ‘don’t make yourself ridiculous, my good fellow! What do you mean by not disclosing?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I beg your pardon,’ answered Tom. ‘I thought you meant that, or I wouldn’t have said it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I didn’t tell her I loved her, where would be the use of my being in love?’ said Martin: ‘unless to keep myself in a perpetual state of worry and vexation?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s true,’ Tom answered. ‘Well! I can guess what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" said when you told her,’ he added, glancing at Martin’s handsome face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, not exactly, Pinch,’ he rejoined, with a slight frown; ‘because she has some girlish notions about duty and gratitude, and all the rest of it, which are rather hard to fathom; but in the main you are right. Her heart was mine, I found.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just what I supposed,’ said Tom. ‘Quite natural!’ and, in his great satisfaction, he took a long sip out of his wine-glass.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("‘Although I had conducted myself from the first with the utmost circumspection,’ pursued Martin, ‘I had not managed matters so well but that my grandfather, who is full of jealousy ")]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("and distrust, suspected me of loving her. He said nothing to her, but straightway attacked me in private, and charged me with designing to corrupt the fidelity to himself (there you observe his selfishness), of a young creature whom he had trained and educated to be his only disinterested and faithful companion, when he should have disposed of me in marriage to his heart’s content. Upon that, I took fire immediately, and told him that with his good leave I would dispose of myself in marriage, and would rather not be knocked down by him or any other auctioneer to any bidder whomsoever.’")])]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch opened his eyes wider, and looked at the fire harder than he had done yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You may be sure,’ said Martin, ‘that this nettled him, and that he began to be the very reverse of complimentary to myself. Interview succeeded interview; words engendered words, as they always do; and the upshot of it was, that I was to renounce her, or be renounced by him. Now you must bear in mind, Pinch, that I am not only desperately fond of her (for though she is poor, her beauty and intellect would reflect great credit on anybody, I don’t care of what pretensions who might become her husband), but that a chief ingredient in my composition is a most determined—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Obstinacy,’ suggested Tom in perfect good faith. But the suggestion was not so well received as he had expected; for the young man immediately rejoined, with some irritation,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What a fellow you are, Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I beg your pardon,’ said Tom, ‘I thought you wanted a word.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t want that word,’ he rejoined. ‘I told you obstinacy was no part of my character, did I not? I was going to say, if you had given me leave, that a chief ingredient in my composition is a most determined firmness.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_137"
    }
  }), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("‘Oh!’ cried Tom, screwing up his mouth, and nodding. ‘Yes, yes; I see!’")])]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And being firm,’ pursued Martin, ‘of course I was not going to yield to him, or give way by so much as the thousandth part of an inch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘On the contrary, the more he urged, the more I was determined to oppose him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To be sure!’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well,’ rejoined Martin, throwing himself back in his chair, with a careless wave of both hands, as if the subject were quite settled, and nothing more could be said about it—’There is an end of the matter, and here am I!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch sat staring at the fire for some minutes with a puzzled look, such as he might have assumed if some uncommonly difficult conundrum had been proposed, which he found it impossible to guess. At length he said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pecksniff, of course, you had known before?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Only by name. No, I had never seen him, for my grandfather kept not only himself but me, aloof from all his relations. But our separation took place in a town in the adjoining country. From that place I came to Salisbury, and there I saw Pecksniff’s advertisement, which I answered, having always had some natural taste, I believe, in the matters to which it referred, and thinking it might suit me. As soon as I found it to be his, I was doubly bent on coming to him if possible, on account of his being—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Such an excellent man,’ interposed Tom, rubbing his hands: ‘so he is. You were quite right.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("‘Why, not so much on that account, if the truth must be spoken,’ returned Martin, ‘as because my grandfather has an inveterate dislike to him, and after the old man’s arbitrary ")]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("treatment of me, I had a natural desire to run as directly counter to all his opinions as I could. Well! As I said before, here I am. My engagement with the young lady I have been telling you about is likely to be a tolerably long one; for neither her prospects nor mine are very bright; and of course I shall not think of marrying until I am well able to do so. It would never do, you know, for me to be plunging myself into poverty and shabbiness and love in one room up three pair of stairs, and all that sort of thing.’")])]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To say nothing of her,’ remarked Tom Pinch, in a low voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Exactly so,’ rejoined Martin, rising to warm his back, and leaning against the chimney-piece. ‘To say nothing of her. At the same time, of course it’s not very hard upon her to be obliged to yield to the necessity of the case; first, because she loves me very much; and secondly, because I have sacrificed a great deal on her account, and might have done much better, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a very long time before Tom said ‘Certainly;’ so long, that he might have taken a nap in the interval, but he did say it at last.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, there is one odd coincidence connected with this love-story,’ said Martin, ‘which brings it to an end. You remember what you told me last night as we were coming here, about your pretty visitor in the church?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Surely I do,’ said Tom, rising from his stool, and seating himself in the chair from which the other had lately risen, that he might see his face. ‘Undoubtedly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That was she.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I knew what you were going to say,’ cried Tom, looking fixedly at him, and speaking very softly. ‘You don’t tell me so?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("‘That was she,’ repeated the young man. ‘After what I have ")]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("heard from Pecksniff, I have no doubt that she came and went with my grandfather.—Don’t you drink too much of that sour wine, or you’ll have a fit of some sort, Pinch, I see.’")])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is not very wholesome, I am afraid,’ said Tom, setting down the empty glass he had for some time held. ‘So that was she, was it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin nodded assent; and adding, with a restless impatience, that if he had been a few days earlier he would have seen her; and that now she might be, for anything he knew, hundreds of miles away; threw himself, after a few turns across the room, into a chair, and chafed like a spoilt child.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom Pinch’s heart was very tender, and he could not bear to see the most indifferent person in distress; still less one who had awakened an interest in him, and who regarded him (either in fact, or as he supposed) with kindness, and in a spirit of lenient construction. Whatever his own thoughts had been a few moments before—and to judge from his face they must have been pretty serious—he dismissed them instantly, and gave his young friend the best counsel and comfort that occurred to him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("‘All will be well in time,’ said Tom, ‘I have no doubt; and some trial and adversity just now will only serve to make you more attached to each other in better days. I have always read that the truth is so, and I have a feeling within me, which tells me how natural and right it is that it should be. That never ran smooth yet,’ said Tom, with a smile which, despite the homeliness of his face, was pleasanter to see than many a proud beauty’s brightest glance; ‘what never ran smooth yet, can hardly be expected to change its character for us; so we must take it as we find it, and fashion it into the very best shape we can, by patience and good-humour. I have no power at all; I needn’t tell you that; but I have an excellent will; and if I could ")]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("ever be of use to you, in any way whatever, how very glad I should be!’")])]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ said Martin, shaking his hand. ‘You’re a good fellow, upon my word, and speak very kindly. Of course you know,’ he added, after a moment’s pause, as he drew his chair towards the fire again, ‘I should not hesitate to avail myself of your services if you could help me at all; but mercy on us!’—Here he rumpled his hair impatiently with his hand, and looked at Tom as if he took it rather ill that he was not somebody else—‘you might as well be a toasting-fork or a frying-pan, Pinch, for any help you can render me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Except in the inclination,’ said Tom, gently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! to be sure. I meant that, of course. If inclination went for anything, I shouldn’t want help. I tell you what you may do, though, if you will, and at the present moment too.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What is that?’ demanded Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Read to me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I shall be delighted,’ cried Tom, catching up the candle with enthusiasm. ‘Excuse my leaving you in the dark a moment, and I’ll fetch a book directly. What will you like? Shakespeare?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye!’ replied his friend, yawning and stretching himself. ‘He’ll do. I am tired with the bustle of to-day, and the novelty of everything about me; and in such a case, there’s no greater luxury in the world, I think, than being read to sleep. You won’t mind my going to sleep, if I can?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all!’ cried Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then begin as soon as you like. You needn’t leave off when you see me getting drowsy (unless you feel tired), for it’s pleasant to wake gradually to the sounds again. Did you ever try that?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, I never tried that,’ said Tom")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_141"
    }
  }), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("‘Well! You can, you know, one of these days when we’re both in the right humour. Don’t mind leaving me in the dark. Look sharp!’")])]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch lost no time in moving away; and in a minute or two returned with one of the precious volumes from the shelf beside his bed. Martin had in the meantime made himself as comfortable as circumstances would permit, by constructing before the fire a temporary sofa of three chairs with Mercy’s stool for a pillow, and lying down at full-length upon it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t be too loud, please,’ he said to Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re sure you’re not cold’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all!’ cried Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am quite ready, then.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch accordingly, after turning over the leaves of his book with as much care as if they were living and highly cherished creatures, made his own selection, and began to read. Before he had completed fifty lines his friend was snoring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Poor fellow!’ said Tom, softly, as he stretched out his head to peep at him over the backs of the chairs. ‘He is very young to have so much trouble. How trustful and generous in him to bestow all this confidence in me. And that was she, was it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But suddenly remembering their compact, he took up the poem at the place where he had left off, and went on reading; always forgetting to snuff the candle, until its wick looked like a mushroom. He gradually became so much interested, that he quite forgot to replenish the fire; and was only reminded of his neglect by Martin Chuzzlewit starting up after the lapse of an hour or so, and crying with a shiver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, it’s nearly out, I declare! No wonder I dreamed of being frozen. Do call for some coals. What a fellow you are, Pinch!’")])])])])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("Chapter Seven")])]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("In which Mr Chevy Slyme Asserts the Independence of His Spirit, and the Blue Dragon Loses a Limb")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("Martin began to work at the grammar-school next morning, with so much vigour and expedition, that Mr Pinch had new reason to do homage to the natural endowments of that young gentleman, and to acknowledge his infinite superiority to himself. The new pupil received Tom’s compliments very graciously; and having by this time conceived a real regard for him, in his own peculiar way, predicted that they would always be the very best of friends, and that neither of them, he was certain (but particularly Tom), would ever have reason to regret the day on which they became acquainted. Mr Pinch was delighted to hear him say this, and felt so much flattered by his kind assurances of friendship and protection, that he was at a loss how to express the pleasure they afforded him. And indeed it may be observed of this friendship, such as it was, that it had within it more likely materials of endurance than many a sworn brotherhood that has been rich in promise; for so long as the one party found a pleasure in patronizing, and the other in being patronised (which was in the very essence of their respective characters), it was of all possible events among the least probable, that the twin demons, Envy ")]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("and Pride, would ever arise between them. So in very many cases of friendship, or what passes for it, the old axiom is reversed, and like clings to unlike more than to like.")])]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were both very busy on the afternoon succeeding the family’s departure—Martin with the grammar-school, and Tom in balancing certain receipts of rents, and deducting Mr Pecksniff’s commission from the same; in which abstruse employment he was much distracted by a habit his new friend had of whistling aloud while he was drawing—when they were not a little startled by the unexpected obtrusion into that sanctuary of genius, of a human head which, although a shaggy and somewhat alarming head in appearance, smiled affably upon them from the doorway, in a manner that was at once waggish, conciliatory, and expressive of approbation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am not industrious myself, gents both,’ said the head, ‘but I know how to appreciate that quality in others. I wish I may turn grey and ugly, if it isn’t in my opinion, next to genius, one of the very charmingest qualities of the human mind. Upon my soul, I am grateful to my friend Pecksniff for helping me to the contemplation of such a delicious picture as you present. You remind me of Whittington, afterwards thrice Lord Mayor of London. I give you my unsullied word of honour, that you very strongly remind me of that historical character. You are a pair of Whittingtons, gents, without the cat; which is a most agreeable and blessed exception to me, for I am not attached to the feline species. My name is Tigg; how do you do?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin looked to Mr Pinch for an explanation; and Tom, who had never in his life set eyes on Mr Tigg before, looked to that gentleman himself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("‘Chevy Slyme?’ said Mr Tigg, interrogatively, and kissing his left hand in token of friendship. ‘You will understand me ")]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("when I say that I am the accredited agent of Chevy Slyme; that I am the ambassador from the court of Chiv? Ha ha!’")])]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Heyday!’ asked Martin, starting at the mention of a name he knew. ‘Pray, what does he want with me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If your name is Pinch’—Mr Tigg began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is not’ said Martin, checking himself. ‘That is Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If that is Mr Pinch,’ cried Tigg, kissing his hand again, and beginning to follow his head into the room, ‘he will permit me to say that I greatly esteem and respect his character, which has been most highly commended to me by my friend Pecksniff; and that I deeply appreciate his talent for the organ, notwithstanding that I do not, if I may use the expression, grind myself. If that is Mr Pinch, I will venture to express a hope that I see him well, and that he is suffering no inconvenience from the easterly wind?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ said Tom. ‘I am very well.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That is a comfort,’ Mr Tigg rejoined. ‘Then,’ he added, shielding his lips with the palm of his hand, and applying them close to Mr Pinch’s ear, ‘I have come for the letter.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For the letter,’ said Tom, aloud. ‘What letter?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The letter,’ whispered Tigg in the same cautious manner as before, ‘which my friend Pecksniff addressed to Chevy Slyme, Esquire, and left with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He didn’t leave any letter with me,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hush!’ cried the other. ‘It’s all the same thing, though not so delicately done by my friend Pecksniff as I could have wished. The money.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The money!’ cried Tom quite scared.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("‘Exactly so,’ said Mr Tigg. With which he rapped Tom twice or thrice upon the breast and nodded several times, as though he would say that he saw they understood each other; that it was unnecessary to mention the circumstance before a third ")]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("person; and that he would take it as a particular favour if Tom would slip the amount into his hand, as quietly as possible.")])]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch, however, was so very much astounded by this (to him) inexplicable deportment, that he at once openly declared there must be some mistake, and that he had been entrusted with no commission whatever having any reference to Mr Tigg or to his friend, either. Mr Tigg received this declaration with a grave request that Mr Pinch would have the goodness to make it again; and on Tom’s repeating it in a still more emphatic and unmistakable manner, checked it off, sentence for sentence, by nodding his head solemnly at the end of each. When it had come to a close for the second time, Mr Tigg sat himself down in a chair and addressed the young men as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then I tell you what it is, gents both. There is at this present moment in this very place, a perfect constellation of talent and genius, who is involved, through what I cannot but designate as the culpable negligence of my friend Pecksniff, in a situation as tremendous, perhaps, as the social intercourse of the nineteenth century will readily admit of. There is actually at this instant, at the Blue Dragon in this village—an ale-house, observe; a common, paltry, low-minded, clodhopping, pipe-smoking ale-house—an individual, of whom it may be said, in the language of the Poet, that nobody but himself can in any way come up to him; who is detained there for his bill. Ha! ha! For his bill. I repeat it—for his bill. Now,’ said Mr Tigg, ‘we have heard of Fox’s Book of Martyrs, I believe, and we have heard of the Court of Requests, and the Star Chamber; but I fear the contradiction of no man alive or dead, when I assert that my friend Chevy Slyme being held in pawn for a bill, beats any amount of cockfighting with which I am acquainted.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_146"
    }
  }), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("Martin and Mr Pinch looked, first at each other, and afterwards at Mr Tigg, who with his arms folded on his breast surveyed them, half in despondency and half in bitterness.")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t mistake me, gents both,’ he said, stretching forth his right hand. ‘If it had been for anything but a bill, I could have borne it, and could still have looked upon mankind with some feeling of respect; but when such a man as my friend Slyme is detained for a score—a thing in itself essentially mean; a low performance on a slate, or possibly chalked upon the back of a door—I do feel that there is a screw of such magnitude loose somewhere, that the whole framework of society is shaken, and the very first principles of things can no longer be trusted. In short, gents both,’ said Mr Tigg with a passionate flourish of his hands and head, ‘when a man like Slyme is detained for such a thing as a bill, I reject the superstitions of ages, and believe nothing. I don’t even believe that I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("don’t")]), _vm._v(" believe, curse me if I do!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am very sorry, I am sure,’ said Tom after a pause, ‘but Mr Pecksniff said nothing to me about it, and I couldn’t act without his instructions. Wouldn’t it be better, sir, if you were to go to—to wherever you came from—yourself, and remit the money to your friend?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How can that be done, when I am detained also?’ said Mr Tigg; ‘and when moreover, owing to the astounding, and I must add, guilty negligence of my friend Pecksniff, I have no money for coach-hire?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("Tom thought of reminding the gentleman (who, no doubt, in his agitation had forgotten it) that there was a post-office in the land; and that possibly if he wrote to some friend or agent for a remittance it might not be lost upon the road; or at all events that the chance, however desperate, was worth trusting to. But, as his good-nature presently suggested to him certain ")]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("reasons for abstaining from this hint, he paused again, and then asked:")])]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Did you say, sir, that you were detained also?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come here,’ said Mr Tigg, rising. ‘You have no objection to my opening this window for a moment?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Certainly not,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good,’ said Mr Tigg, lifting the sash. ‘You see a fellow down there in a red neckcloth and no waistcoat?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course I do,’ cried Tom. ‘That’s Mark Tapley.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mark Tapley is it?’ said the gentleman. ‘Then Mark Tapley had not only the great politeness to follow me to this house, but is waiting now, to see me home again. And for that attention, sir,’ added Mr Tigg, stroking his moustache, ‘I can tell you, that Mark Tapley had better in his infancy have been fed to suffocation by Mrs Tapley, than preserved to this time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch was not so dismayed by this terrible threat, but that he had voice enough to call to Mark to come in, and upstairs; a summons which he so speedily obeyed, that almost as soon as Tom and Mr Tigg had drawn in their heads and closed the window again, he, the denounced, appeared before them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come here, Mark!’ said Mr Pinch. ‘Good gracious me! what’s the matter between Mrs Lupin and this gentleman?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What gentleman, sir?’ said Mark. ‘I don’t see no gentleman here sir, excepting you and the new gentleman,’ to whom he made a rough kind of bow—‘and there’s nothing wrong between Mrs Lupin and either of you, Mr Pinch, I am sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nonsense, Mark!’ cried Tom. ‘You see Mr—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tigg,’ interposed that gentleman. ‘Wait a bit. I shall crush him soon. All in good time!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v("!’ rejoined Mark, with an air of careless defiance. ‘Yes, I see "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(". I could see him a little better, if he’d shave himself, and get his hair cut.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_148"
    }
  }), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("Mr Tigg shook his head with a ferocious look, and smote himself once upon the breast.")])]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s no use,’ said Mark. ‘If you knock ever so much in that quarter, you’ll get no answer. I know better. There’s nothing there but padding; and a greasy sort it is.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nay, Mark,’ urged Mr Pinch, interposing to prevent hostilities, ‘tell me what I ask you. You’re not out of temper, I hope?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Out of temper, sir!’ cried Mark, with a grin; ‘why no, sir. There’s a little credit—not much—in being jolly, when such fellows as him is a-going about like roaring lions; if there is any breed of lions, at least, as is all roar and mane. What is there between him and Mrs Lupin, sir? Why, there’s a score between him and Mrs Lupin. And I think Mrs Lupin lets him and his friend off very easy in not charging ‘em double prices for being a disgrace to the Dragon. That’s my opinion. I wouldn’t have any such Peter the Wild Boy as him in my house, sir, not if I was paid race-week prices for it. He’s enough to turn the very beer in the casks sour with his looks; he is! So he would, if it had judgment enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not answering my question, you know, Mark,’ observed Mr Pinch.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("‘Well, sir,’ said Mark, ‘I don’t know as there’s much to answer further than that. Him and his friend goes and stops at the Moon and Stars till they’ve run a bill there; and then comes and stops with us and does the same. The running of bills is common enough Mr Pinch; it an’t that as we object to; it’s the ways of this chap. Nothing’s good enough for him; all the women is dying for him he thinks, and is overpaid if he winks at ‘em; and all the men was made to be ordered about by him. This not being aggravation enough, he says this morning to me, in his usual captivating way, “We’re going to-night, my man.” “Are you, sir?” says I. “Perhaps you’d like the bill got ")]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("ready, sir?” “Oh no, my man,” he says; “you needn’t mind that. I’ll give Pecksniff orders to see to that.” In reply to which, the Dragon makes answer, “Thankee, sir, you’re very kind to honour us so far, but as we don’t know any particular good of you, and you don’t travel with luggage, and Mr Pecksniff an’t at home (which perhaps you mayn’t happen to be aware of, sir), we should prefer something more satisfactory;” and that’s where the matter stands. And I ask,’ said Mr Tapley, pointing, in conclusion, to Mr Tigg, with his hat, ‘any lady or gentleman, possessing ordinary strength of mind, to say whether he’s a disagreeable-looking chap or not!’")])]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Let me inquire,’ said Martin, interposing between this candid speech and the delivery of some blighting anathema by Mr Tigg, ‘what the amount of this debt may be?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In point of money, sir, very little,’ answered Mark. ‘Only just turned of three pounds. But it an’t that; it’s the—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, yes, you told us so before,’ said Martin. ‘Pinch, a word with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What is it?’ asked Tom, retiring with him to a corner of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, simply—I am ashamed to say—that this Mr Slyme is a relation of mine, of whom I never heard anything pleasant; and that I don’t want him here just now, and think he would be cheaply got rid of, perhaps, for three or four pounds. You haven’t enough money to pay this bill, I suppose?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom shook his head to an extent that left no doubt of his entire sincerity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s unfortunate, for I am poor too; and in case you had had it, I’d have borrowed it of you. But if we told this landlady we would see her paid, I suppose that would answer the same purpose?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh dear, yes!’ said Tom. ‘She knows me, bless you!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_150"
    }
  }), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("‘Then let us go down at once and tell her so; for the sooner we are rid of their company the better. As you have conducted the conversation with this gentleman hitherto, perhaps you’ll tell him what we purpose doing; will you?’")])]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch, complying, at once imparted the intelligence to Mr Tigg, who shook him warmly by the hand in return, assuring him that his faith in anything and everything was again restored. It was not so much, he said, for the temporary relief of this assistance that he prized it, as for its vindication of the high principle that Nature’s Nobs felt with Nature’s Nobs, and that true greatness of soul sympathized with true greatness of soul, all the world over. It proved to him, he said, that like him they admired genius, even when it was coupled with the alloy occasionally visible in the metal of his friend Slyme; and on behalf of that friend, he thanked them; as warmly and heartily as if the cause were his own. Being cut short in these speeches by a general move towards the stairs, he took possession at the street door of the lapel of Mr Pinch’s coat, as a security against further interruption; and entertained that gentleman with some highly improving discourse until they reached the Dragon, whither they were closely followed by Mark and the new pupil.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("The rosy hostess scarcely needed Mr Pinch’s word as a preliminary to the release of her two visitors, of whom she was glad to be rid on any terms; indeed, their brief detention had originated mainly with Mr Tapley, who entertained a constitutional dislike to gentleman out-at-elbows who flourished on false pretences; and had conceived a particular aversion to Mr Tigg and his friend, as choice specimens of the species. The business in hand thus easily settled, Mr Pinch and Martin would have withdrawn immediately, but for the urgent entreaties of Mr Tigg that they would allow him the honour of ")]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("presenting them to his friend Slyme, which were so very difficult of resistance that, yielding partly to these persuasions and partly to their own curiosity, they suffered themselves to be ushered into the presence of that distinguished gentleman.")])]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He was brooding over the remains of yesterday’s decanter of brandy, and was engaged in the thoughtful occupation of making a chain of rings on the top of the table with the wet foot of his drinking-glass. Wretched and forlorn as he looked, Mr Slyme had once been in his way, the choicest of swaggerers; putting forth his pretensions boldly, as a man of infinite taste and most undoubted promise. The stock-in-trade requisite to set up an amateur in this department of business is very slight, and easily got together; a trick of the nose and a curl of the lip sufficient to compound a tolerable sneer, being ample provision for any exigency. But, in an evil hour, this off-shoot of the Chuzzlewit trunk, being lazy, and ill qualified for any regular pursuit and having dissipated such means as he ever possessed, had formally established himself as a professor of Taste for a livelihood; and finding, too late, that something more than his old amount of qualifications was necessary to sustain him in this calling, had quickly fallen to his present level, where he retained nothing of his old self but his boastfulness and his bile, and seemed to have no existence separate or apart from his friend Tigg. And now so abject and so pitiful was he—at once so maudlin, insolent, beggarly, and proud—that even his friend and parasite, standing erect beside him, swelled into a Man by contrast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Chiv,’ said Mr Tigg, clapping him on the back, ‘my friend Pecksniff not being at home, I have arranged our trifling piece of business with Mr Pinch and friend. Mr Pinch and friend, Mr Chevy Slyme! Chiv, Mr Pinch and friend!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("‘These are agreeable circumstances in which to be introduced ")]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("to strangers,’ said Chevy Slyme, turning his bloodshot eyes towards Tom Pinch. ‘I am the most miserable man in the world, I believe!’")])]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom begged he wouldn’t mention it; and finding him in this condition, retired, after an awkward pause, followed by Martin. But Mr Tigg so urgently conjured them, by coughs and signs, to remain in the shadow of the door, that they stopped there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I swear,’ cried Mr Slyme, giving the table an imbecile blow with his fist, and then feebly leaning his head upon his hand, while some drunken drops oozed from his eyes, ‘that I am the wretchedest creature on record. Society is in a conspiracy against me. I’m the most literary man alive. I’m full of scholarship. I’m full of genius; I’m full of information; I’m full of novel views on every subject; yet look at my condition! I’m at this moment obliged to two strangers for a tavern bill!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Tigg replenished his friend’s glass, pressed it into his hand, and nodded an intimation to the visitors that they would see him in a better aspect immediately.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Obliged to two strangers for a tavern bill, eh!’ repeated Mr Slyme, after a sulky application to his glass. ‘Very pretty! And crowds of impostors, the while, becoming famous; men who are no more on a level with me than—Tigg, I take you to witness that I am the most persecuted hound on the face of the earth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a whine, not unlike the cry of the animal he named, in its lowest state of humiliation, he raised his glass to his mouth again. He found some encouragement in it; for when he set it down he laughed scornfully. Upon that Mr Tigg gesticulated to the visitors once more, and with great expression, implying that now the time was come when they would see Chiv in his greatness.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("‘Ha, ha, ha,’ laughed Mr Slyme. ‘Obliged to two strangers for a tavern bill! Yet I think I’ve a rich uncle, Tigg, who could buy up the uncles of fifty strangers! Have I, or have I not? I come of a good family, I believe! Do I, or do I not? I’m not a man of common capacity or accomplishments, I think! Am I, or am I not?’")])]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are the American aloe of the human race, my dear Chiv,’ said Mr Tigg, ‘which only blooms once in a hundred years!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ha, ha, ha!’ laughed Mr Slyme again. ‘Obliged to two strangers for a tavern bill! I obliged to two architect’s apprentices. Fellows who measure earth with iron chains, and build houses like bricklayers. Give me the names of those two apprentices. How dare they oblige me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Tigg was quite lost in admiration of this noble trait in his friend’s character; as he made known to Mr Pinch in a neat little ballet of action, spontaneously invented for the purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ll let ‘em know, and I’ll let all men know,’ cried Chevy Slyme, ‘that I’m none of the mean, grovelling, tame characters they meet with commonly. I have an independent spirit. I have a heart that swells in my bosom. I have a soul that rises superior to base considerations.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh Chiv, Chiv,’ murmured Mr Tigg, ‘you have a nobly independent nature, Chiv!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You go and do your duty, sir,’ said Mr Slyme, angrily, ‘and borrow money for travelling expenses; and whoever you borrow it of, let ‘em know that I possess a haughty spirit, and a proud spirit, and have infernally finely-touched chords in my nature, which won’t brook patronage. Do you hear? Tell ‘em I hate ‘em, and that that’s the way I preserve my self-respect; and tell ‘em that no man ever respected himself more than I do!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_154"
    }
  }), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("He might have added that he hated two sorts of men; all those who did him favours, and all those who were better off than himself; as in either case their position was an insult to a man of his stupendous merits. But he did not; for with the apt closing words above recited, Mr Slyme; of too haughty a stomach to work, to beg, to borrow, or to steal; yet mean enough to be worked or borrowed, begged or stolen for, by any catspaw that would serve his turn; too insolent to lick the hand that fed him in his need, yet cur enough to bite and tear it in the dark; with these apt closing words Mr Slyme fell forward with his head upon the table, and so declined into a sodden sleep.")])]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Was there ever,’ cried Mr Tigg, joining the young men at the door, and shutting it carefully behind him, ‘such an independent spirit as is possessed by that extraordinary creature? Was there ever such a Roman as our friend Chiv? Was there ever a man of such a purely classical turn of thought, and of such a toga-like simplicity of nature? Was there ever a man with such a flow of eloquence? Might he not, gents both, I ask, have sat upon a tripod in the ancient times, and prophesied to a perfectly unlimited extent, if previously supplied with gin-and-water at the public cost?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch was about to contest this latter position with his usual mildness, when, observing that his companion had already gone downstairs, he prepared to follow him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are not going, Mr Pinch?’ said Tigg.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ answered Tom. ‘Yes. Don’t come down.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you know that I should like one little word in private with you Mr Pinch?’ said Tigg, following him. ‘One minute of your company in the skittle-ground would very much relieve my mind. Might I beseech that favour?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("‘Oh, certainly,’ replied Tom, ‘if you really wish it.’ So he accompanied Mr Tigg to the retreat in question; on arriving at ")]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("which place that gentleman took from his hat what seemed to be the fossil remains of an antediluvian pocket-handkerchief, and wiped his eyes therewith.")])]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have not beheld me this day,’ said Mr Tigg, ‘in a favourable light.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t mention that,’ said Tom, ‘I beg.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But you have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(",’ cried Tigg. ‘I must persist in that opinion. If you could have seen me, Mr Pinch, at the head of my regiment on the coast of Africa, charging in the form of a hollow square, with the women and children and the regimental plate-chest in the centre, you would not have known me for the same man. You would have respected me, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom had certain ideas of his own upon the subject of glory; and consequently he was not quite so much excited by this picture as Mr Tigg could have desired.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But no matter!’ said that gentleman. ‘The school-boy writing home to his parents and describing the milk-and-water, said “This is indeed weakness.” I repeat that assertion in reference to myself at the present moment; and I ask your pardon. Sir, you have seen my friend Slyme?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No doubt,’ said Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sir, you have been impressed by my friend Slyme?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not very pleasantly, I must say,’ answered Tom, after a little hesitation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("‘I am grieved but not surprised,’ cried Mr Tigg, detaining him with both hands, ‘to hear that you have come to that conclusion; for it is my own. But, Mr Pinch, though I am a rough and thoughtless man, I can honour Mind. I honour Mind in following my friend. To you of all men, Mr Pinch, I have a right to make appeal on Mind’s behalf, when it has not the art to push its fortune in the world. And so, sir—not for myself, who have no claim upon you, but for my crushed, my sensitive and independent ")]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_vm._v("friend, who has—I ask the loan of three half-crowns. I ask you for the loan of three half-crowns, distinctly, and without a blush. I ask it, almost as a right. And when I add that they will be returned by post, this week, I feel that you will blame me for that sordid stipulation.’")])]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch took from his pocket an old-fashioned red-leather purse with a steel clasp, which had probably once belonged to his deceased grandmother. It held one half-sovereign and no more. All Tom’s worldly wealth until next quarter-day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stay!’ cried Mr Tigg, who had watched this proceeding keenly. ‘I was just about to say, that for the convenience of posting you had better make it gold. Thank you. A general direction, I suppose, to Mr Pinch at Mr Pecksniff’s—will that find you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’ll find me,’ said Tom. ‘You had better put Esquire to Mr Pecksniff’s name, if you please. Direct to me, you know, at Seth Pecksniff’s, Esquire.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At Seth Pecksniff’s, Esquire,’ repeated Mr Tigg, taking an exact note of it with a stump of pencil. ‘We said this week, I believe?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes; or Monday will do,’ observed Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no, I beg your pardon. Monday will "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" do,’ said Mr Tigg. ‘If we stipulated for this week, Saturday is the latest day. Did we stipulate for this week?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Since you are so particular about it,’ said Tom, ‘I think we did.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_vm._v("Mr Tigg added this condition to his memorandum; read the entry over to himself with a severe frown; and that the transaction might be the more correct and business-like, appended his initials to the whole. That done, he assured Mr Pinch that everything was now perfectly regular; and, after squeezing his ")]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("hand with great fervour, departed.")])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom entertained enough suspicion that Martin might possibly turn this interview into a jest, to render him desirous to avoid the company of that young gentleman for the present. With this view he took a few turns up and down the skittle-ground, and did not re-enter the house until Mr Tigg and his friend had quitted it, and the new pupil and Mark were watching their departure from one of the windows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was just a-saying, sir, that if one could live by it,’ observed Mark, pointing after their late guests, ‘that would be the sort of service for me. Waiting on such individuals as them would be better than grave-digging, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And staying here would be better than either, Mark,’ replied Tom. ‘So take my advice, and continue to swim easily in smooth water.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s too late to take it now, sir,’ said Mark. ‘I have broke it to her, sir. I am off to-morrow morning.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Off!’ cried Mr Pinch, ‘where to?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I shall go up to London, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What to be?’ asked Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well! I don’t know yet, sir. Nothing turned up that day I opened my mind to you, as was at all likely to suit me. All them trades I thought of was a deal too jolly; there was no credit at all to be got in any of ‘em. I must look for a private service, I suppose, sir. I might be brought out strong, perhaps, in a serious family, Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Perhaps you might come out rather too strong for a serious family’s taste, Mark.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("‘That’s possible, sir. If I could get into a wicked family, I might do myself justice; but the difficulty is to make sure of one’s ground, because a young man can’t very well advertise that he wants a place, and wages an’t so much an object as a ")]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("wicked sitivation; can he, sir?’")])]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, no,’ said Mr Pinch, ‘I don’t think he can.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘An envious family,’ pursued Mark, with a thoughtful face; ‘or a quarrelsome family, or a malicious family, or even a good out-and-out mean family, would open a field of action as I might do something in. The man as would have suited me of all other men was that old gentleman as was took ill here, for he really was a trying customer. Howsever, I must wait and see what turns up, sir; and hope for the worst.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are determined to go then?’ said Mr Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My box is gone already, sir, by the waggon, and I’m going to walk on to-morrow morning, and get a lift by the day coach when it overtakes me. So I wish you good-bye, Mr Pinch—and you too, sir—and all good luck and happiness!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They both returned his greeting laughingly, and walked home arm-in-arm. Mr Pinch imparting to his new friend, as they went, such further particulars of Mark Tapley’s whimsical restlessness as the reader is already acquainted with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime Mark, having a shrewd notion that his mistress was in very low spirits, and that he could not exactly answer for the consequences of any lengthened "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tete-a-tete")]), _vm._v(" in the bar, kept himself obstinately out of her way all the afternoon and evening. In this piece of generalship he was very much assisted by the great influx of company into the taproom; for the news of his intention having gone abroad, there was a perfect throng there all the evening, and much drinking of healths and clinking of mugs. At length the house was closed for the night; and there being now no help for it, Mark put the best face he could upon the matter, and walked doggedly to the bar-door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I look at her,’ said Mark to himself, ‘I’m done. I feel that I’m a-going fast.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_159"
    }
  }), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("‘You have come at last,’ said Mrs Lupin.")])]), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Aye, Mark said: There he was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And you are determined to leave us, Mark?’ cried Mrs Lupin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, yes; I am,’ said Mark; keeping his eyes hard upon the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought,’ pursued the landlady, with a most engaging hesitation, ‘that you had been—fond—of the Dragon?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So I am,’ said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then,’ pursued the hostess—and it really was not an unnatural inquiry—‘why do you desert it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But as he gave no manner of answer to this question; not even on its being repeated; Mrs Lupin put his money into his hand, and asked him—not unkindly, quite the contrary—what he would take?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is proverbial that there are certain things which flesh and blood cannot bear. Such a question as this, propounded in such a manner, at such a time, and by such a person, proved (at least, as far as, Mark’s flesh and blood were concerned) to be one of them. He looked up in spite of himself directly; and having once looked up, there was no looking down again; for of all the tight, plump, buxom, bright-eyed, dimple-faced landladies that ever shone on earth, there stood before him then, bodily in that bar, the very pink and pineapple.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("‘Why, I tell you what,’ said Mark, throwing off all his constraint in an instant and seizing the hostess round the waist—at which she was not at all alarmed, for she knew what a good young man he was—‘if I took what I liked most, I should take you. If I only thought what was best for me, I should take you. If I took what nineteen young fellows in twenty would be glad to take, and would take at any price, I should take you. Yes, I should,’ cried Mr Tapley, shaking his head expressively ")]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("enough, and looking (in a momentary state of forgetfulness) rather hard at the hostess’s ripe lips. ‘And no man wouldn’t wonder if I did!’")])]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Lupin said he amazed her. She was astonished how he could say such things. She had never thought it of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, I never thought if of myself till now!’ said Mark, raising his eyebrows with a look of the merriest possible surprise. ‘I always expected we should part, and never have no explanation; I meant to do it when I come in here just now; but there’s something about you, as makes a man sensible. Then let us have a word or two together; letting it be understood beforehand,’ he added this in a grave tone, to prevent the possibility of any mistake, ‘that I’m not a-going to make no love, you know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was for just one second a shade, though not by any means a dark one, on the landlady’s open brow. But it passed off instantly, in a laugh that came from her very heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, very good!’ she said; ‘if there is to be no love-making, you had better take your arm away.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lord, why should I!’ cried Mark. ‘It’s quite innocent.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course it’s innocent,’ returned the hostess, ‘or I shouldn’t allow it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very well!’ said Mark. ‘Then let it be.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was so much reason in this that the landlady laughed again, suffered it to remain, and bade him say what he had to say, and be quick about it. But he was an impudent fellow, she added.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ha ha! I almost think I am!’ cried Mark, ‘though I never thought so before. Why, I can say anything to-night!’ ‘Say what you’re going to say if you please, and be quick,’ returned the landlady, ‘for I want to get to bed.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("‘Why, then, my dear good soul,’ said Mark, ‘and a kinder ")]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("woman than you are never drawed breath—let me see the man as says she did!—what would be the likely consequence of us two being—’")])]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh nonsense!’ cried Mrs Lupin. ‘Don’t talk about that any more.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no, but it an’t nonsense,’ said Mark; ‘and I wish you’d attend. What would be the likely consequence of us two being married? If I can’t be content and comfortable in this here lively Dragon now, is it to be looked for as I should be then? By no means. Very good. Then you, even with your good humour, would be always on the fret and worrit, always uncomfortable in your own mind, always a-thinking as you was getting too old for my taste, always a-picturing me to yourself as being chained up to the Dragon door, and wanting to break away. I don’t know that it would be so,’ said Mark, ‘but I don’t know that it mightn’t be. I am a roving sort of chap, I know. I’m fond of change. I’m always a-thinking that with my good health and spirits it would be more creditable in me to be jolly where there’s things a-going on to make one dismal. It may be a mistake of mine you see, but nothing short of trying how it acts will set it right. Then an’t it best that I should go; particular when your free way has helped me out to say all this, and we can part as good friends as we have ever been since first I entered this here noble Dragon, which,’ said Mr Tapley in conclusion, ‘has my good word and my good wish to the day of my death!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hostess sat quite silent for a little time, but she very soon put both her hands in Mark’s and shook them heartily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For you are a good man,’ she said; looking into his face with a smile, which was rather serious for her. ‘And I do believe have been a better friend to me to-night than ever I have had in all my life.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_162"
    }
  }), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("‘Oh! as to that, you know,’ said Mark, ‘that’s nonsense. But love my heart alive!’ he added, looking at her in a sort of rapture, ‘if you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" that way disposed, what a lot of suitable husbands there is as you may drive distracted!’")])]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She laughed again at this compliment; and, once more shaking him by both hands, and bidding him, if he should ever want a friend, to remember her, turned gayly from the little bar and up the Dragon staircase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Humming a tune as she goes,’ said Mark, listening, ‘in case I should think she’s at all put out, and should be made down-hearted. Come, here’s some credit in being jolly, at last!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that piece of comfort, very ruefully uttered, he went, in anything but a jolly manner, to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He rose early next morning, and was a-foot soon after sunrise. But it was of no use; the whole place was up to see Mark Tapley off; the boys, the dogs, the children, the old men, the busy people and the idlers; there they were, all calling out ‘Good-b’ye, Mark,’ after their own manner, and all sorry he was going. Somehow he had a kind of sense that his old mistress was peeping from her chamber-window, but he couldn’t make up his mind to look back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("‘Good-b’ye one, good-b’ye all!’ cried Mark, waving his hat on the top of his walking-stick, as he strode at a quick pace up the little street. ‘Hearty chaps them wheelwrights—hurrah! Here’s the butcher’s dog a-coming out of the garden—down, old fellow! And Mr Pinch a-going to his organ—good-b’ye, sir! And the terrier-bitch from over the way—hie, then, lass! And children enough to hand down human natur to the latest posterity—good-b’ye, boys and girls! There’s some credit in it now. I’m a-coming out strong at last. These are the circumstances that would try a ordinary mind; but I’m uncommon jolly. Not quite as jolly as I could wish to be, but very near. ")]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_vm._v("Good-b’ye! good-b’ye!’")])]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  })])])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("Chapter Eight")])]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Accompanies Mr Pecksniff and His Charming Daughters to the City of London; And Relates what Fell out upon their Way Thither")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When Mr Pecksniff and the two young ladies got into the heavy coach at the end of the lane, they found it empty, which was a great comfort; particularly as the outside was quite full and the passengers looked very frosty. For as Mr Pecksniff justly observed—when he and his daughters had burrowed their feet deep in the straw, wrapped themselves to the chin, and pulled up both windows—it is always satisfactory to feel, in keen weather, that many other people are not as warm as you are. And this, he said, was quite natural, and a very beautiful arrangement; not confined to coaches, but extending itself into many social ramifications. ‘For’ (he observed), ‘if every one were warm and well-fed, we should lose the satisfaction of admiring the fortitude with which certain conditions of men bear cold and hunger. And if we were no better off than anybody else, what would become of our sense of gratitude; which,’ said Mr Pecksniff with tears in his eyes, as he shook his fist at a beggar who wanted to get up behind, ‘is one of the holiest feelings of our common nature.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("His children heard with becoming reverence these moral precepts from the lips of their father, and signified their acquiescence in the same, by smiles. That he might the better feed and cherish that sacred flame of gratitude in his breast, Mr Pecksniff remarked that he would trouble his eldest daughter, even in this early stage of their journey, for the brandy-bottle. And from the narrow neck of that stone vessel he imbibed a copious refreshment.")])]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What are we?’ said Mr Pecksniff, ‘but coaches? Some of us are slow coaches’—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Goodness, Pa!’ cried Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Some of us, I say,’ resumed her parent with increased emphasis, ‘are slow coaches; some of us are fast coaches. Our passions are the horses; and rampant animals too—!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Really, Pa,’ cried both the daughters at once. ‘How very unpleasant.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And rampant animals too’ repeated Mr Pecksniff with so much determination, that he may be said to have exhibited, at the moment a sort of moral rampancy himself;’—and Virtue is the drag. We start from The Mother’s Arms, and we run to The Dust Shovel.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When he had said this, Mr Pecksniff, being exhausted, took some further refreshment. When he had done that, he corked the bottle tight, with the air of a man who had effectually corked the subject also; and went to sleep for three stages.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("The tendency of mankind when it falls asleep in coaches, is to wake up cross; to find its legs in its way; and its corns an aggravation. Mr Pecksniff not being exempt from the common lot of humanity found himself, at the end of his nap, so decidedly the victim of these infirmities, that he had an irresistible inclination to visit them upon his daughters; which he had already begun to do in the shape of divers random kicks, and ")]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("other unexpected motions of his shoes, when the coach stopped, and after a short delay the door was opened.")])]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now mind,’ said a thin sharp voice in the dark. ‘I and my son go inside, because the roof is full, but you agree only to charge us outside prices. It’s quite understood that we won’t pay more. Is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All right, sir,’ replied the guard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is there anybody inside now?’ inquired the voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Three passengers,’ returned the guard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then I ask the three passengers to witness this bargain, if they will be so good,’ said the voice. ‘My boy, I think we may safely get in.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In pursuance of which opinion, two people took their seats in the vehicle, which was solemnly licensed by Act of Parliament to carry any six persons who could be got in at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That was lucky!’ whispered the old man, when they moved on again. ‘And a great stroke of policy in you to observe it. He, he, he! We couldn’t have gone outside. I should have died of the rheumatism!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whether it occurred to the dutiful son that he had in some degree over-reached himself by contributing to the prolongation of his father’s days; or whether the cold had effected his temper; is doubtful. But he gave his father such a nudge in reply, that that good old gentleman was taken with a cough which lasted for full five minutes without intermission, and goaded Mr Pecksniff to that pitch of irritation, that he said at last—and very suddenly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There is no room! There is really no room in this coach for any gentleman with a cold in his head!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mine,’ said the old man, after a moment’s pause, ‘is upon my chest, Pecksniff.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("The voice and manner, together, now that he spoke out; ")]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("the composure of the speaker; the presence of his son; and his knowledge of Mr Pecksniff; afforded a clue to his identity which it was impossible to mistake.")])]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hem! I thought,’ said Mr Pecksniff, returning to his usual mildness, ‘that I addressed a stranger. I find that I address a relative, Mr Anthony Chuzzlewit and his son Mr Jonas—for they, my dear children, are our travelling companions—will excuse me for an apparently harsh remark. It is not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" desire to wound the feelings of any person with whom I am connected in family bonds. I may be a Hypocrite,’ said Mr Pecksniff, cuttingly; ‘but I am not a Brute.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pooh, pooh!’ said the old man. ‘What signifies that word, Pecksniff? Hypocrite! why, we are all hypocrites. We were all hypocrites t’other day. I am sure I felt that to be agreed upon among us, or I shouldn’t have called you one. We should not have been there at all, if we had not been hypocrites. The only difference between you and the rest was—shall I tell you the difference between you and the rest now, Pecksniff?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you please, my good sir; if you please.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, the annoying quality in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(", is,’ said the old man, ‘that you never have a confederate or partner in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" juggling; you would deceive everybody, even those who practise the same art; and have a way with you, as if you—he, he, he!—as if you really believed yourself. I’d lay a handsome wager now,’ said the old man, ‘if I laid wagers, which I don’t and never did, that you keep up appearances by a tacit understanding, even before your own daughters here. Now I, when I have a business scheme in hand, tell Jonas what it is, and we discuss it openly. You’re not offended, Pecksniff?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Offended, my good sir!’ cried that gentleman, as if he had received the highest compliments that language could convey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are you travelling to London, Mr Pecksniff?’ asked the son.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_168"
    }
  }), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("‘Yes, Mr Jonas, we are travelling to London. We shall have the pleasure of your company all the way, I trust?’")])]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! ecod, you had better ask father that,’ said Jonas. ‘I am not a-going to commit myself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff was, as a matter of course, greatly entertained by this retort. His mirth having subsided, Mr Jonas gave him to understand that himself and parent were in fact travelling to their home in the metropolis; and that, since the memorable day of the great family gathering, they had been tarrying in that part of the country, watching the sale of certain eligible investments, which they had had in their copartnership eye when they came down; for it was their custom, Mr Jonas said, whenever such a thing was practicable, to kill two birds with one stone, and never to throw away sprats, but as bait for whales. When he had communicated to Mr Pecksniff these pithy scraps of intelligence, he said, ‘That if it was all the same to him, he would turn him over to father, and have a chat with the gals;’ and in furtherance of this polite scheme, he vacated his seat adjoining that gentleman, and established himself in the opposite corner, next to the fair Miss Mercy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("The education of Mr Jonas had been conducted from his cradle on the strictest principles of the main chance. The very first word he learnt to spell was ‘gain,’ and the second (when he got into two syllables), ‘money.’ But for two results, which were not clearly foreseen perhaps by his watchful parent in the beginning, his training may be said to have been unexceptionable. One of these flaws was, that having been long taught by his father to over-reach everybody, he had imperceptibly acquired a love of over-reaching that venerable monitor himself. The other, that from his early habits of considering everything as a question of property, he had gradually come to look, with impatience, on his parent as a certain amount of personal ")]), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_vm._v("estate, which had no right whatever to be going at large, but ought to be secured in that particular description of iron safe which is commonly called a coffin, and banked in the grave.")])]), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, cousin!’ said Mr Jonas—’Because we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" cousins, you know, a few times removed—so you’re going to London?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Mercy replied in the affirmative, pinching her sister’s arm at the same time, and giggling excessively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lots of beaux in London, cousin!’ said Mr Jonas, slightly advancing his elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed, sir!’ cried the young lady. ‘They won’t hurt us, sir, I dare say.’ And having given him this answer with great demureness she was so overcome by her own humour, that she was fain to stifle her merriment in her sister’s shawl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Merry,’ cried that more prudent damsel, ‘really I am ashamed of you. How can you go on so? You wild thing!’ At which Miss Merry only laughed the more, of course.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I saw a wildness in her eye, t’other day,’ said Mr Jonas, addressing Charity. ‘But you’re the one to sit solemn! I say—You were regularly prim, cousin!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! The old-fashioned fright!’ cried Merry, in a whisper. ‘Cherry my dear, upon my word you must sit next him. I shall die outright if he talks to me any more; I shall, positively!’ To prevent which fatal consequence, the buoyant creature skipped out of her seat as she spoke, and squeezed her sister into the place from which she had risen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t mind crowding me,’ cried Mr Jonas. ‘I like to be crowded by gals. Come a little closer, cousin.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, thank you, sir,’ said Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There’s that other one a-laughing again,’ said Mr Jonas; ‘she’s a-laughing at my father, I shouldn’t wonder. If he puts on that old flannel nightcap of his, I don’t know what she’ll do! Is that my father a-snoring, Pecksniff?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_170"
    }
  }), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("‘Yes, Mr Jonas.’")])]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tread upon his foot, will you be so good?’ said the young gentleman. ‘The foot next you’s the gouty one.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff hesitating to perform this friendly office, Mr Jonas did it himself; at the same time crying:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come, wake up, father, or you’ll be having the nightmare, and screeching out, I know.—Do you ever have the nightmare, cousin?’ he asked his neighbour, with characteristic gallantry, as he dropped his voice again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sometimes,’ answered Charity. ‘Not often.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The other one,’ said Mr Jonas, after a pause. ‘Does "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" ever have the nightmare?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know,’ replied Charity. ‘You had better ask her.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She laughs so,’ said Jonas; ‘there’s no talking to her. Only hark how she’s a-going on now! You’re the sensible one, cousin!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tut, tut!’ cried Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! But you are! You know you are!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mercy is a little giddy,’ said Miss Charity. But she’ll sober down in time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’ll be a very long time, then, if she does at all,’ rejoined her cousin. ‘Take a little more room.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid of crowding you,’ said Charity. But she took it notwithstanding; and after one or two remarks on the extreme heaviness of the coach, and the number of places it stopped at, they fell into a silence which remained unbroken by any member of the party until supper-time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("Although Mr Jonas conducted Charity to the hotel and sat himself beside her at the board, it was pretty clear that he had an eye to ‘the other one’ also, for he often glanced across at Mercy, and seemed to draw comparisons between the personal appearance of the two, which were not unfavourable to ")]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("the superior plumpness of the younger sister. He allowed himself no great leisure for this kind of observation, however, being busily engaged with the supper, which, as he whispered in his fair companion’s ear, was a contract business, and therefore the more she ate, the better the bargain was. His father and Mr Pecksniff, probably acting on the same wise principle, demolished everything that came within their reach, and by that means acquired a greasy expression of countenance, indicating contentment, if not repletion, which it was very pleasant to contemplate.")])]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When they could eat no more, Mr Pecksniff and Mr Jonas subscribed for two sixpenny-worths of hot brandy-and-water, which the latter gentleman considered a more politic order than one shillingsworth; there being a chance of their getting more spirit out of the innkeeper under this arrangement than if it were all in one glass. Having swallowed his share of the enlivening fluid, Mr Pecksniff, under pretence of going to see if the coach were ready, went secretly to the bar, and had his own little bottle filled, in order that he might refresh himself at leisure in the dark coach without being observed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These arrangements concluded, and the coach being ready, they got into their old places and jogged on again. But before he composed himself for a nap, Mr Pecksniff delivered a kind of grace after meat, in these words:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("‘The process of digestion, as I have been informed by anatomical friends, is one of the most wonderful works of nature. I do not know how it may be with others, but it is a great satisfaction to me to know, when regaling on my humble fare, that I am putting in motion the most beautiful machinery with which we have any acquaintance. I really feel at such times as if I was doing a public service. When I have wound myself up, if I may employ such a term,’ said Mr Pecksniff with exquisite ")]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("tenderness, ‘and know that I am Going, I feel that in the lesson afforded by the works within me, I am a Benefactor to my Kind!’")])]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As nothing could be added to this, nothing was said; and Mr Pecksniff, exulting, it may be presumed, in his moral utility, went to sleep again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rest of the night wore away in the usual manner. Mr Pecksniff and Old Anthony kept tumbling against each other and waking up much terrified, or crushed their heads in opposite corners of the coach and strangely tattooed the surface of their faces—Heaven knows how—in their sleep. The coach stopped and went on, and went on and stopped, times out of number. Passengers got up and passengers got down, and fresh horses came and went and came again, with scarcely any interval between each team as it seemed to those who were dozing, and with a gap of a whole night between every one as it seemed to those who were broad awake. At length they began to jolt and rumble over horribly uneven stones, and Mr Pecksniff looking out of window said it was to-morrow morning, and they were there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Very soon afterwards the coach stopped at the office in the city; and the street in which it was situated was already in a bustle, that fully bore out Mr Pecksniff’s words about its being morning, though for any signs of day yet appearing in the sky it might have been midnight. There was a dense fog too; as if it were a city in the clouds, which they had been travelling to all night up a magic beanstalk; and there was a thick crust upon the pavement like oilcake; which, one of the outsides (mad, no doubt) said to another (his keeper, of course), was Snow.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("Taking a confused leave of Anthony and his son, and leaving the luggage of himself and daughters at the office to be called for afterwards, Mr Pecksniff, with one of the young ladies ")]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_vm._v("under each arm, dived across the street, and then across other streets, and so up the queerest courts, and down the strangest alleys and under the blindest archways, in a kind of frenzy; now skipping over a kennel, now running for his life from a coach and horses; now thinking he had lost his way, now thinking he had found it; now in a state of the highest confidence, now despondent to the last degree, but always in a great perspiration and flurry; until at length they stopped in a kind of paved yard near the Monument. That is to say, Mr Pecksniff told them so; for as to anything they could see of the Monument, or anything else but the buildings close at hand, they might as well have been playing blindman’s buff at Salisbury.")])]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff looked about him for a moment, and then knocked at the door of a very dingy edifice, even among the choice collection of dingy edifices at hand; on the front of which was a little oval board like a tea-tray, with this inscription—’Commercial Boarding-House: M. Todgers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seemed that M. Todgers was not up yet, for Mr Pecksniff knocked twice and rang thrice, without making any impression on anything but a dog over the way. At last a chain and some bolts were withdrawn with a rusty noise, as if the weather had made the very fastenings hoarse, and a small boy with a large red head, and no nose to speak of, and a very dirty Wellington boot on his left arm, appeared; who (being surprised) rubbed the nose just mentioned with the back of a shoe-brush, and said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Still a-bed my man?’ asked Mr Pecksniff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_vm._v("‘Still a-bed!’ replied the boy. ‘I wish they wos still a-bed. They’re very noisy a-bed; all calling for their boots at once. I thought you was the Paper, and wondered why you didn’t shove yourself through the grating as usual. What do you ")]), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_vm._v("want?’")])]), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Considering his years, which were tender, the youth may be said to have preferred this question sternly, and in something of a defiant manner. But Mr Pecksniff, without taking umbrage at his bearing put a card in his hand, and bade him take that upstairs, and show them in the meanwhile into a room where there was a fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Or if there’s one in the eating parlour,’ said Mr Pecksniff, ‘I can find it myself.’ So he led his daughters, without waiting for any further introduction, into a room on the ground-floor, where a table-cloth (rather a tight and scanty fit in reference to the table it covered) was already spread for breakfast; displaying a mighty dish of pink boiled beef; an instance of that particular style of loaf which is known to housekeepers as a slack-baked, crummy quartern; a liberal provision of cups and saucers; and the usual appendages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside the fender were some half-dozen pairs of shoes and boots, of various sizes, just cleaned and turned with the soles upwards to dry; and a pair of short black gaiters, on one of which was chalked—in sport, it would appear, by some gentleman who had slipped down for the purpose, pending his toilet, and gone up again—’Jinkins’s Particular,’ while the other exhibited a sketch in profile, claiming to be the portrait of Jinkins himself.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_vm._v("M. Todgers’s Commercial Boarding-House was a house of that sort which is likely to be dark at any time; but that morning it was especially dark. There was an odd smell in the passage, as if the concentrated essence of all the dinners that had been cooked in the kitchen since the house was built, lingered at the top of the kitchen stairs to that hour, and like the Black Friar in Don Juan, ‘wouldn’t be driven away.’ In particular, there was a sensation of cabbage; as if all the greens that had ")]), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("ever been boiled there, were evergreens, and flourished in immortal strength. The parlour was wainscoted, and communicated to strangers a magnetic and instinctive consciousness of rats and mice. The staircase was very gloomy and very broad, with balustrades so thick and heavy that they would have served for a bridge. In a sombre corner on the first landing, stood a gruff old giant of a clock, with a preposterous coronet of three brass balls on his head; whom few had ever seen—none ever looked in the face—and who seemed to continue his heavy tick for no other reason than to warn heedless people from running into him accidentally. It had not been papered or painted, hadn’t Todgers’s, within the memory of man. It was very black, begrimed, and mouldy. And, at the top of the staircase, was an old, disjointed, rickety, ill-favoured skylight, patched and mended in all kinds of ways, which looked distrustfully down at everything that passed below, and covered Todgers’s up as if it were a sort of human cucumber-frame, and only people of a peculiar growth were reared there.")])]), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff and his fair daughters had not stood warming themselves at the fire ten minutes, when the sound of feet was heard upon the stairs, and the presiding deity of the establishment came hurrying in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("M. Todgers was a lady, rather a bony and hard-featured lady, with a row of curls in front of her head, shaped like little barrels of beer; and on the top of it something made of net—you couldn’t call it a cap exactly—which looked like a black cobweb. She had a little basket on her arm, and in it a bunch of keys that jingled as she came. In her other hand she bore a flaming tallow candle, which, after surveying Mr Pecksniff for one instant by its light, she put down upon the table, to the end that she might receive him with the greater cordiality.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_176"
    }
  }), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("‘Mr Pecksniff!’ cried Mrs Todgers. ‘Welcome to London! Who would have thought of such a visit as this, after so—dear, dear!—so many years! How do you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(", Mr Pecksniff?’")])]), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As well as ever; and as glad to see you, as ever;’ Mr Pecksniff made response. ‘Why, you are younger than you used to be!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" are, I am sure!’ said Mrs Todgers. ‘You’re not a bit changed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you say to this?’ cried Mr Pecksniff, stretching out his hand towards the young ladies. ‘Does this make me no older?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not your daughters!’ exclaimed the lady, raising her hands and clasping them. ‘Oh, no, Mr Pecksniff! Your second, and her bridesmaid!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff smiled complacently; shook his head; and said, ‘My daughters, Mrs Todgers. Merely my daughters.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah!’ sighed the good lady, ‘I must believe you, for now I look at ‘em I think I should have known ‘em anywhere. My dear Miss Pecksniffs, how happy your Pa has made me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hugged them both; and being by this time overpowered by her feelings or the inclemency of the morning, jerked a little pocket handkerchief out of the little basket, and applied the same to her face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, my good madam,’ said Mr Pecksniff, ‘I know the rules of your establishment, and that you only receive gentlemen boarders. But it occurred to me, when I left home, that perhaps you would give my daughters house room, and make an exception in their favour.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Perhaps?’ cried Mrs Todgers ecstatically. ‘Perhaps?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("‘I may say then, that I was sure you would,’ said Mr Pecksniff. ‘I know that you have a little room of your own, and that they can be comfortable there, without appearing at the general ")]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_vm._v("table.’")])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear girls!’ said Mrs Todgers. ‘I must take that liberty once more.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Todgers meant by this that she must embrace them once more, which she accordingly did with great ardour. But the truth was that the house being full with the exception of one bed, which would now be occupied by Mr Pecksniff, she wanted time for consideration; and so much time too (for it was a knotty point how to dispose of them), that even when this second embrace was over, she stood for some moments gazing at the sisters, with affection beaming in one eye, and calculation shining out of the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I think I know how to arrange it,’ said Mrs Todgers, at length. ‘A sofa bedstead in the little third room which opens from my own parlour.—Oh, you dear girls!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thereupon she embraced them once more, observing that she could not decide which was most like their poor mother (which was highly probable, seeing that she had never beheld that lady), but that she rather thought the youngest was; and then she said that as the gentlemen would be down directly, and the ladies were fatigued with travelling, would they step into her room at once?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_vm._v("It was on the same floor; being, in fact, the back parlour; and had, as Mrs Todgers said, the great advantage (in London) of not being overlooked; as they would see when the fog cleared off. Nor was this a vainglorious boast, for it commanded at a perspective of two feet, a brown wall with a black cistern on the top. The sleeping apartment designed for the young ladies was approached from this chamber by a mightily convenient little door, which would only open when fallen against by a strong person. It commanded from a similar point of sight another angle of the wall, and another side of the cistern. ")]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_vm._v("‘Not the damp side,’ said Mrs Todgers. ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" is Mr Jinkins’s.’")])]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the first of these sanctuaries a fire was speedily kindled by the youthful porter, who, whistling at his work in the absence of Mrs Todgers (not to mention his sketching figures on his corduroys with burnt firewood), and being afterwards taken by that lady in the fact, was dismissed with a box on his ears. Having prepared breakfast for the young ladies with her own hands, she withdrew to preside in the other room; where the joke at Mr Jinkins’s expense seemed to be proceeding rather noisily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I won’t ask you yet, my dears,’ said Mr Pecksniff, looking in at the door, ‘how you like London. Shall I?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We haven’t seen much of it, Pa!’ cried Merry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing, I hope,’ said Cherry. (Both very miserably.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed,’ said Mr Pecksniff, ‘that’s true. We have our pleasure, and our business too, before us. All in good time. All in good time!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whether Mr Pecksniff’s business in London was as strictly professional as he had given his new pupil to understand, we shall see, to adopt that worthy man’s phraseology, ‘all in good time.’")])])])])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_vm._v("Chapter Nine")])]), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_c('p', {
    staticClass: "ch-suba"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Town and Todger’s")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Surely there never was, in any other borough, city, or hamlet in the world, such a singular sort of a place as Todgers’s. And surely London, to judge from that part of it which hemmed Todgers’s round and hustled it, and crushed it, and stuck its brick-and-mortar elbows into it, and kept the air from it, and stood perpetually between it and the light, was worthy of Todgers’s, and qualified to be on terms of close relationship and alliance with hundreds and thousands of the odd family to which Todgers’s belonged.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_vm._v("You couldn’t walk about Todgers’s neighbourhood, as you could in any other neighbourhood. You groped your way for an hour through lanes and byways, and court-yards, and passages; and you never once emerged upon anything that might be reasonably called a street. A kind of resigned distraction came over the stranger as he trod those devious mazes, and, giving himself up for lost, went in and out and round about and quietly turned back again when he came to a dead wall or was stopped by an iron railing, and felt that the means of escape might possibly present themselves in their own good time, but that to anticipate them was hopeless. Instances were known of people who, being asked to dine at Todgers’s, had travelled round and round for a weary time, with its very chimney-pots in view; and finding it, at last, impossible of attainment, ")]), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_vm._v("had gone home again with a gentle melancholy on their spirits, tranquil and uncomplaining. Nobody had ever found Todgers’s on a verbal direction, though given within a few minutes’ walk of it. Cautious emigrants from Scotland or the North of England had been known to reach it safely, by impressing a charity-boy, town-bred, and bringing him along with them; or by clinging tenaciously to the postman; but these were rare exceptions, and only went to prove the rule that Todgers’s was in a labyrinth, whereof the mystery was known but to a chosen few.")])]), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_vm._v("Several fruit-brokers had their marts near Todgers’s; and one of the first impressions wrought upon the stranger’s senses was of oranges—of damaged oranges—with blue and green bruises on them, festering in boxes, or mouldering away in cellars. All day long, a stream of porters from the wharves beside the river, each bearing on his back a bursting chest of oranges, poured slowly through the narrow passages; while underneath the archway by the public-house, the knots of those who rested and regaled within, were piled from morning until night. Strange solitary pumps were found near Todgers’s hiding themselves for the most part in blind alleys, and keeping company with fire-ladders. There were churches also by dozens, with many a ghostly little churchyard, all overgrown with such straggling vegetation as springs up spontaneously from damp, and graves, and rubbish. In some of these dingy resting-places which bore much the same analogy to green churchyards, as the pots of earth for mignonette and wall-flower in the windows overlooking them did to rustic gardens, there were trees; tall trees; still putting forth their leaves in each succeeding year, with such a languishing remembrance of their kind (so one might fancy, looking on their sickly boughs) as birds in cages have of theirs. Here, paralysed ")]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("old watchmen guarded the bodies of the dead at night, year after year, until at last they joined that solemn brotherhood; and, saving that they slept below the ground a sounder sleep than even they had ever known above it, and were shut up in another kind of box, their condition can hardly be said to have undergone any material change when they, in turn, were watched themselves.")])]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("Among the narrow thoroughfares at hand, there lingered, here and there, an ancient doorway of carved oak, from which, of old, the sounds of revelry and feasting often came; but now these mansions, only used for storehouses, were dark and dull, and, being filled with wool, and cotton, and the like—such heavy merchandise as stifles sound and stops the throat of echo—had an air of palpable deadness about them which, added to their silence and desertion, made them very grim. In like manner, there were gloomy courtyards in these parts, into which few but belated wayfarers ever strayed, and where vast bags and packs of goods, upward or downward bound, were for ever dangling between heaven and earth from lofty cranes There were more trucks near Todgers’s than you would suppose whole city could ever need; not active trucks, but a vagabond race, for ever lounging in the narrow lanes before their masters’ doors and stopping up the pass; so that when a stray hackney-coach or lumbering waggon came that way, they were the cause of such an uproar as enlivened the whole neighbourhood, and made the bells in the next churchtower vibrate again. In the throats and maws of dark no-thoroughfares near Todgers’s, individual wine-merchants and wholesale dealers in grocery-ware had perfect little towns of their own; and, deep among the foundations of these buildings, the ground was undermined and burrowed out into stables, where cart-horses, troubled by rats, might be heard on a ")]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_vm._v("quiet Sunday rattling their halters, as disturbed spirits in tales of haunted houses are said to clank their chains.")])]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To tell of half the queer old taverns that had a drowsy and secret existence near Todgers’s, would fill a goodly book; while a second volume no less capacious might be devoted to an account of the quaint old guests who frequented their dimly lighted parlours. These were, in general, ancient inhabitants of that region; born, and bred there from boyhood, who had long since become wheezy and asthmatical, and short of breath, except in the article of story-telling; in which respect they were still marvellously long-winded. These gentry were much opposed to steam and all new-fangled ways, and held ballooning to be sinful, and deplored the degeneracy of the times; which that particular member of each little club who kept the keys of the nearest church, professionally, always attributed to the prevalence of dissent and irreligion; though the major part of the company inclined to the belief that virtue went out with hair-powder, and that Old England’s greatness had decayed amain with barbers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_vm._v("As to Todgers’s itself—speaking of it only as a house in that neighbourhood, and making no reference to its merits as a commercial boarding establishment—it was worthy to stand where it did. There was one staircase-window in it, at the side of the house, on the ground floor; which tradition said had not been opened for a hundred years at least, and which, abutting on an always dirty lane, was so begrimed and coated with a century’s mud, that no one pane of glass could possibly fall out, though all were cracked and broken twenty times. But the grand mystery of Todgers’s was the cellarage, approachable only by a little back door and a rusty grating; which cellarage within the memory of man had had no connection with the house, but had always been the freehold property of somebody ")]), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("else, and was reported to be full of wealth; though in what shape—whether in silver, brass, or gold, or butts of wine, or casks of gun-powder—was matter of profound uncertainty and supreme indifference to Todgers’s and all its inmates.")])]), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The top of the house was worthy of notice. There was a sort of terrace on the roof, with posts and fragments of rotten lines, once intended to dry clothes upon; and there were two or three tea-chests out there, full of earth, with forgotten plants in them, like old walking-sticks. Whoever climbed to this observatory, was stunned at first from having knocked his head against the little door in coming out; and after that, was for the moment choked from having looked perforce, straight down the kitchen chimney; but these two stages over, there were things to gaze at from the top of Todgers’s, well worth your seeing too. For first and foremost, if the day were bright, you observed upon the house-tops, stretching far away, a long dark path; the shadow of the Monument; and turning round, the tall original was close beside you, with every hair erect upon his golden head, as if the doings of the city frightened him. Then there were steeples, towers, belfries, shining vanes, and masts of ships; a very forest. Gables, housetops, garret-windows, wilderness upon wilderness. Smoke and noise enough for all the world at once.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("After the first glance, there were slight features in the midst of this crowd of objects, which sprung out from the mass without any reason, as it were, and took hold of the attention whether the spectator would or no. Thus, the revolving chimney-pots on one great stack of buildings seemed to be turning gravely to each other every now and then, and whispering the result of their separate observation of what was going on below. Others, of a crook-backed shape, appeared to ")]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("be maliciously holding themselves askew, that they might shut the prospect out and baffle Todgers’s. The man who was mending a pen at an upper window over the way, became of paramount importance in the scene, and made a blank in it, ridiculously disproportionate in its extent, when he retired. The gambols of a piece of cloth upon the dyer’s pole had far more interest for the moment than all the changing motion of the crowd. Yet even while the looker-on felt angry with himself for this, and wondered how it was, the tumult swelled into a roar; the hosts of objects seemed to thicken and expand a hundredfold, and after gazing round him, quite scared, he turned into Todgers’s again, much more rapidly than he came out; and ten to one he told M. Todgers afterwards that if he hadn’t done so, he would certainly have come into the street by the shortest cut; that is to say, head-foremost.")])]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("So said the two Miss Pecksniffs, when they retired with Mrs Todgers from this place of espial, leaving the youthful porter to close the door and follow them downstairs; who, being of a playful temperament, and contemplating with a delight peculiar to his sex and time of life, any chance of dashing himself into small fragments, lingered behind to walk upon the parapet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It being the second day of their stay in London, the Miss Pecksniffs and Mrs Todgers were by this time highly confidential, insomuch that the last-named lady had already communicated the particulars of three early disappointments of a tender nature; and had furthermore possessed her young friends with a general summary of the life, conduct, and character of Mr Todgers. Who, it seemed, had cut his matrimonial career rather short, by unlawfully running away from his happiness, and establishing himself in foreign countries as a bachelor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("‘Your pa was once a little particular in his attentions, my ")]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("dears,’ said Mrs Todgers, ‘but to be your ma was too much happiness denied me. You’d hardly know who this was done for, perhaps?’")])]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She called their attention to an oval miniature, like a little blister, which was tacked up over the kettle-holder, and in which there was a dreamy shadowing forth of her own visage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a speaking likeness!’ cried the two Miss Pecksniffs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was considered so once,’ said Mrs Todgers, warming herself in a gentlemanly manner at the fire; ‘but I hardly thought you would have known it, my loves.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They would have known it anywhere. If they could have met with it in the street, or seen it in a shop window, they would have cried ‘Good gracious! Mrs Todgers!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Presiding over an establishment like this, makes sad havoc with the features, my dear Miss Pecksniffs,’ said Mrs Todgers. ‘The gravy alone, is enough to add twenty years to one’s age, I do assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lor’!’ cried the two Miss Pecksniffs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The anxiety of that one item, my dears,’ said Mrs Todgers, ‘keeps the mind continually upon the stretch. There is no such passion in human nature, as the passion for gravy among commercial gentlemen. It’s nothing to say a joint won’t yield—a whole animal wouldn’t yield—the amount of gravy they expect each day at dinner. And what I have undergone in consequence,’ cried Mrs Todgers, raising her eyes and shaking her head, ‘no one would believe!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just like Mr Pinch, Merry!’ said Charity. ‘We have always noticed it in him, you remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, my dear,’ giggled Merry, ‘but we have never given it him, you know.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("‘You, my dears, having to deal with your pa’s pupils who can’t help themselves, are able to take your own way,’ said ")]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("Mrs Todgers; ‘but in a commercial establishment, where any gentleman may say any Saturday evening, “Mrs Todgers, this day week we part, in consequence of the cheese,” it is not so easy to preserve a pleasant understanding. Your pa was kind enough,’ added the good lady, ‘to invite me to take a ride with you to-day; and I think he mentioned that you were going to call upon Miss Pinch. Any relation to the gentleman you were speaking of just now, Miss Pecksniff?’")])]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For goodness sake, Mrs Todgers,’ interposed the lively Merry, ‘don’t call him a gentleman. My dear Cherry, Pinch a gentleman! The idea!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What a wicked girl you are!’ cried Mrs Todgers, embracing her with great affection. ‘You are quite a quiz, I do declare! My dear Miss Pecksniff, what a happiness your sister’s spirits must be to your pa and self!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s the most hideous, goggle-eyed creature, Mrs Todgers, in existence,’ resumed Merry: ‘quite an ogre. The ugliest, awkwardest frightfullest being, you can imagine. This is his sister, so I leave you to suppose what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she")]), _vm._v(" is. I shall be obliged to laugh outright, I know I shall!’ cried the charming girl, ‘I never shall be able to keep my countenance. The notion of a Miss Pinch presuming to exist at all is sufficient to kill one, but to see her—oh my stars!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Todgers laughed immensely at the dear love’s humour, and declared she was quite afraid of her, that she was. She was so very severe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who is severe?’ cried a voice at the door. ‘There is no such thing as severity in our family, I hope!’ And then Mr Pecksniff peeped smilingly into the room, and said, ‘May I come in, Mrs Todgers?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("Mrs Todgers almost screamed, for the little door of communication between that room and the inner one being wide ")]), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("open, there was a full disclosure of the sofa bedstead in all its monstrous impropriety. But she had the presence of mind to close this portal in the twinkling of an eye; and having done so, said, though not without confusion, ‘Oh yes, Mr Pecksniff, you can come in, if you please.’")])]), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How are we to-day,’ said Mr Pecksniff, jocosely, ‘and what are our plans? Are we ready to go and see Tom Pinch’s sister? Ha, ha, ha! Poor Thomas Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are we ready,’ returned Mrs Todgers, nodding her head with mysterious intelligence, ‘to send a favourable reply to Mr Jinkins’s round-robin? That’s the first question, Mr Pecksniff.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why Mr Jinkins’s robin, my dear madam?’ asked Mr Pecksniff, putting one arm round Mercy, and the other round Mrs Todgers, whom he seemed, in the abstraction of the moment, to mistake for Charity. ‘Why Mr Jinkins’s?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Because he began to get it up, and indeed always takes the lead in the house,’ said Mrs Todgers, playfully. ‘That’s why, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jinkins is a man of superior talents,’ observed Mr Pecksniff. ‘I have conceived a great regard for Jinkins. I take Jinkins’s desire to pay polite attention to my daughters, as an additional proof of the friendly feeling of Jinkins, Mrs Todgers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well now,’ returned that lady, ‘having said so much, you must say the rest, Mr Pecksniff; so tell the dear young ladies all about it.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("With these words she gently eluded Mr Pecksniff’s grasp, and took Miss Charity into her own embrace; though whether she was impelled to this proceeding solely by the irrepressible affection she had conceived for that young lady, or whether it had any reference to a lowering, not to say distinctly spiteful expression which had been visible in her face for some moments, ")]), _c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_vm._v("has never been exactly ascertained. Be this as it may, Mr Pecksniff went on to inform his daughters of the purport and history of the round-robin aforesaid, which was in brief, that the commercial gentlemen who helped to make up the sum and substance of that noun of multitude signifying many, called Todgers’s, desired the honour of their presence at the general table, so long as they remained in the house, and besought that they would grace the board at dinner-time next day, the same being Sunday. He further said, that Mrs Todgers being a consenting party to this invitation, he was willing, for his part, to accept it; and so left them that he might write his gracious answer, the while they armed themselves with their best bonnets for the utter defeat and overthrow of Miss Pinch.")])]), _c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom Pinch’s sister was governess in a family, a lofty family; perhaps the wealthiest brass and copper founders’ family known to mankind. They lived at Camberwell; in a house so big and fierce, that its mere outside, like the outside of a giant’s castle, struck terror into vulgar minds and made bold persons quail. There was a great front gate; with a great bell, whose handle was in itself a note of admiration; and a great lodge; which being close to the house, rather spoilt the look-out certainly but made the look-in tremendous. At this entry, a great porter kept constant watch and ward; and when he gave the visitor high leave to pass, he rang a second great bell, responsive to whose note a great footman appeared in due time at the great halldoor, with such great tags upon his liveried shoulder that he was perpetually entangling and hooking himself among the chairs and tables, and led a life of torment which could scarcely have been surpassed, if he had been a blue-bottle in a world of cobwebs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_vm._v("To this mansion Mr Pecksniff, accompanied by his daughters and Mrs Todgers, drove gallantly in a one-horse fly. The ")]), _c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_vm._v("foregoing ceremonies having been all performed, they were ushered into the house; and so, by degrees, they got at last into a small room with books in it, where Mr Pinch’s sister was at that moment instructing her eldest pupil; to wit, a premature little woman of thirteen years old, who had already arrived at such a pitch of whalebone and education that she had nothing girlish about her, which was a source of great rejoicing to all her relations and friends.")])]), _c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Visitors for Miss Pinch!’ said the footman. He must have been an ingenious young man, for he said it very cleverly; with a nice discrimination between the cold respect with which he would have announced visitors to the family, and the warm personal interest with which he would have announced visitors to the cook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Visitors for Miss Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Pinch rose hastily; with such tokens of agitation as plainly declared that her list of callers was not numerous. At the same time, the little pupil became alarmingly upright, and prepared herself to take mental notes of all that might be said and done. For the lady of the establishment was curious in the natural history and habits of the animal called Governess, and encouraged her daughters to report thereon whenever occasion served; which was, in reference to all parties concerned, very laudable, improving, and pleasant.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20174m.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_vm._v("It is a melancholy fact; but it must be related, that Mr Pinch’s sister was not at all ugly. On the contrary, she had a good face; a very mild and prepossessing face; and a pretty little figure—slight and short, but remarkable for its neatness. There was something of her brother, much of him indeed, in a certain gentleness of manner, and in her look of timid trustfulness; but she was so far from being a fright, or a dowdy, or a horror, or anything else, predicted by the two Miss Pecksniffs, ")]), _c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_vm._v("that those young ladies naturally regarded her with great indignation, feeling that this was by no means what they had come to see.")])]), _c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Mercy, as having the larger share of gaiety, bore up the best against this disappointment, and carried it off, in outward show at least, with a titter; but her sister, not caring to hide her disdain, expressed it pretty openly in her looks. As to Mrs Todgers, she leaned on Mr Pecksniff’s arm and preserved a kind of genteel grimness, suitable to any state of mind, and involving any shade of opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t be alarmed, Miss Pinch,’ said Mr Pecksniff, taking her hand condescendingly in one of his, and patting it with the other. ‘I have called to see you, in pursuance of a promise given to your brother, Thomas Pinch. My name—compose yourself, Miss Pinch—is Pecksniff.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The good man emphasised these words as though he would have said, ‘You see in me, young person, the benefactor of your race; the patron of your house; the preserver of your brother, who is fed with manna daily from my table; and in right of whom there is a considerable balance in my favour at present standing in the books beyond the sky. But I have no pride, for I can afford to do without it!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The poor girl felt it all as if it had been Gospel truth. Her brother writing in the fullness of his simple heart, had often told her so, and how much more! As Mr Pecksniff ceased to speak, she hung her head, and dropped a tear upon his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh very well, Miss Pinch!’ thought the sharp pupil, ‘crying before strangers, as if you didn’t like the situation!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_vm._v("‘Thomas is well,’ said Mr Pecksniff; ‘and sends his love and this letter. I cannot say, poor fellow, that he will ever be distinguished in our profession; but he has the will to do well, which is the next thing to having the power; and, therefore, ")]), _c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_vm._v("we must bear with him. Eh?’")])]), _c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know he has the will, sir,’ said Tom Pinch’s sister, ‘and I know how kindly and considerately you cherish it, for which neither he nor I can ever be grateful enough, as we very often say in writing to each other. The young ladies too,’ she added, glancing gratefully at his two daughters, ‘I know how much we owe to them.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dears,’ said Mr Pecksniff, turning to them with a smile: ‘Thomas’s sister is saying something you will be glad to hear, I think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We can’t take any merit to ourselves, papa!’ cried Cherry, as they both apprised Tom Pinch’s sister, with a curtsey, that they would feel obliged if she would keep her distance. ‘Mr Pinch’s being so well provided for is owing to you alone, and we can only say how glad we are to hear that he is as grateful as he ought to be.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh very well, Miss Pinch!’ thought the pupil again. ‘Got a grateful brother, living on other people’s kindness!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It was very kind of you,’ said Tom Pinch’s sister, with Tom’s own simplicity and Tom’s own smile, ‘to come here; very kind indeed; though how great a kindness you have done me in gratifying my wish to see you, and to thank you with my own lips, you, who make so light of benefits conferred, can scarcely think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very grateful; very pleasant; very proper,’ murmured Mr Pecksniff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_vm._v("‘It makes me happy too,’ said Ruth Pinch, who now that her first surprise was over, had a chatty, cheerful way with her, and a single-hearted desire to look upon the best side of everything, which was the very moral and image of Tom; ‘very happy to think that you will be able to tell him how more than comfortably I am situated here, and how unnecessary it is that ")]), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("he should ever waste a regret on my being cast upon my own resources. Dear me! So long as I heard that he was happy, and he heard that I was,’ said Tom’s sister, ‘we could both bear, without one impatient or complaining thought, a great deal more than ever we have had to endure, I am very certain.’ And if ever the plain truth were spoken on this occasionally false earth, Tom’s sister spoke it when she said that.")])]), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah!’ cried Mr Pecksniff whose eyes had in the meantime wandered to the pupil; ‘certainly. And how do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" do, my very interesting child?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Quite well, I thank you, sir,’ replied that frosty innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A sweet face this, my dears,’ said Mr Pecksniff, turning to his daughters. ‘A charming manner!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both young ladies had been in ecstasies with the scion of a wealthy house (through whom the nearest road and shortest cut to her parents might be supposed to lie) from the first. Mrs Todgers vowed that anything one quarter so angelic she had never seen. ‘She wanted but a pair of wings, a dear,’ said that good woman, ‘to be a young syrup’—meaning, possibly, young sylph, or seraph.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you will give that to your distinguished parents, my amiable little friend,’ said Mr Pecksniff, producing one of his professional cards, ‘and will say that I and my daughters—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And Mrs Todgers, pa,’ said Merry.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("‘And Mrs Todgers, of London,’ added Mr Pecksniff; ‘that I, and my daughters, and Mrs Todgers, of London, did not intrude upon them, as our object simply was to take some notice of Miss Pinch, whose brother is a young man in my employment; but that I could not leave this very chaste mansion, without adding my humble tribute, as an Architect, to the correctness and elegance of the owner’s taste, and to his just appreciation of that beautiful art to the cultivation of which I ")]), _c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_vm._v("have devoted a life, and to the promotion of whose glory and advancement I have sacrified a—a fortune—I shall be very much obliged to you.’")])]), _c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Missis’s compliments to Miss Pinch,’ said the footman, suddenly appearing, and speaking in exactly the same key as before, ‘and begs to know wot my young lady is a-learning of just now.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ said Mr Pecksniff, ‘Here is the young man. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" will take the card. With my compliments, if you please, young man. My dears, we are interrupting the studies. Let us go.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some confusion was occasioned for an instant by Mrs Todgers’s unstrapping her little flat hand-basket, and hurriedly entrusting the ‘young man’ with one of her own cards, which, in addition to certain detailed information relative to the terms of the commercial establishment, bore a foot-note to the effect that M. T. took that opportunity of thanking those gentlemen who had honoured her with their favours, and begged they would have the goodness, if satisfied with the table, to recommend her to their friends. But Mr Pecksniff, with admirable presence of mind, recovered this document, and buttoned it up in his own pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he said to Miss Pinch—with more condescension and kindness than ever, for it was desirable the footman should expressly understand that they were not friends of hers, but patrons:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good morning. Good-bye. God bless you! You may depend upon my continued protection of your brother Thomas. Keep your mind quite at ease, Miss Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ said Tom’s sister heartily; ‘a thousand times.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_vm._v("‘Not at all,’ he retorted, patting her gently on the head. ‘Don’t mention it. You will make me angry if you do. My sweet child’—to the pupil—‘farewell! That fairy creature,’ said Mr ")]), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("Pecksniff, looking in his pensive mood hard at the footman, as if he meant him, ‘has shed a vision on my path, refulgent in its nature, and not easily to be obliterated. My dears, are you ready?’")])]), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were not quite ready yet, for they were still caressing the pupil. But they tore themselves away at length; and sweeping past Miss Pinch with each a haughty inclination of the head and a curtsey strangled in its birth, flounced into the passage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young man had rather a long job in showing them out; for Mr Pecksniff’s delight in the tastefulness of the house was such that he could not help often stopping (particularly when they were near the parlour door) and giving it expression, in a loud voice and very learned terms. Indeed, he delivered, between the study and the hall, a familiar exposition of the whole science of architecture as applied to dwelling-houses, and was yet in the freshness of his eloquence when they reached the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you look,’ said Mr Pecksniff, backing from the steps, with his head on one side and his eyes half-shut that he might the better take in the proportions of the exterior: ‘If you look, my dears, at the cornice which supports the roof, and observe the airiness of its construction, especially where it sweeps the southern angle of the building, you will feel with me—How do you do, sir? I hope you’re well?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Interrupting himself with these words, he very politely bowed to a middle-aged gentleman at an upper window, to whom he spoke—not because the gentleman could hear him (for he certainly could not), but as an appropriate accompaniment to his salutation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("‘I have no doubt, my dears,’ said Mr Pecksniff, feigning to point out other beauties with his hand, ‘that this is the proprietor. ")]), _c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_vm._v("I should be glad to know him. It might lead to something. Is he looking this way, Charity?’")])]), _c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is opening the window pa!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ha, ha!’ cried Mr Pecksniff softly. ‘All right! He has found I’m professional. He heard me inside just now, I have no doubt. Don’t look! With regard to the fluted pillars in the portico, my dears—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hallo!’ cried the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sir, your servant!’ said Mr Pecksniff, taking off his hat. ‘I am proud to make your acquaintance.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come off the grass, will you!’ roared the gentleman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I beg your pardon, sir,’ said Mr Pecksniff, doubtful of his having heard aright. ‘Did you—?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come off the grass!’ repeated the gentleman, warmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We are unwilling to intrude, sir,’ Mr Pecksniff smilingly began.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" intruding,’ returned the other, ‘unwarrantably intruding. Trespassing. You see a gravel walk, don’t you? What do you think it’s meant for? Open the gate there! Show that party out!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that he clapped down the window again, and disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff put on his hat, and walked with great deliberation and in profound silence to the fly, gazing at the clouds as he went, with great interest. After helping his daughters and Mrs Todgers into that conveyance, he stood looking at it for some moments, as if he were not quite certain whether it was a carriage or a temple; but having settled this point in his mind, he got into his place, spread his hands out on his knees, and smiled upon the three beholders.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_196"
    }
  }, [_vm._v("But his daughters, less tranquil-minded, burst into a torrent of indignation. This came, they said, of cherishing such ")]), _c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_vm._v("creatures as the Pinches. This came of lowering themselves to their level. This came of putting themselves in the humiliating position of seeming to know such bold, audacious, cunning, dreadful girls as that. They had expected this. They had predicted it to Mrs Todgers, as she (Todgers) could depone, that very morning. To this, they added, that the owner of the house, supposing them to be Miss Pinch’s friends, had acted, in their opinion, quite correctly, and had done no more than, under such circumstances, might reasonably have been expected. To that they added (with a trifling inconsistency), that he was a brute and a bear; and then they merged into a flood of tears, which swept away all wandering epithets before it.")])]), _c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps Miss Pinch was scarcely so much to blame in the matter as the Seraph, who, immediately on the withdrawal of the visitors, had hastened to report them at head-quarters, with a full account of their having presumptuously charged her with the delivery of a message afterwards consigned to the footman; which outrage, taken in conjunction with Mr Pecksniff’s unobtrusive remarks on the establishment, might possibly have had some share in their dismissal. Poor Miss Pinch, however, had to bear the brunt of it with both parties; being so severely taken to task by the Seraph’s mother for having such vulgar acquaintances, that she was fain to retire to her own room in tears, which her natural cheerfulness and submission, and the delight of having seen Mr Pecksniff, and having received a letter from her brother, were at first insufficient to repress.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_197"
    }
  }, [_vm._v("As to Mr Pecksniff, he told them in the fly, that a good action was its own reward; and rather gave them to understand, that if he could have been kicked in such a cause, he would have liked it all the better. But this was no comfort to the young ladies, who scolded violently the whole way back, and ")]), _c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_vm._v("even exhibited, more than once, a keen desire to attack the devoted Mrs Todgers; on whose personal appearance, but particularly on whose offending card and hand-basket, they were secretly inclined to lay the blame of half their failure.")])]), _c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Todgers’s was in a great bustle that evening, partly owing to some additional domestic preparations for the morrow, and partly to the excitement always inseparable in that house from Saturday night, when every gentleman’s linen arrived at a different hour in its own little bundle, with his private account pinned on the outside. There was always a great clinking of pattens downstairs, too, until midnight or so, on Saturdays; together with a frequent gleaming of mysterious lights in the area; much working at the pump; and a constant jangling of the iron handle of the pail. Shrill altercations from time to time arose between Mrs Todgers and unknown females in remote back kitchens; and sounds were occasionally heard, indicative of small articles of iron mongery and hardware being thrown at the boy. It was the custom of that youth on Saturdays, to roll up his shirt sleeves to his shoulders, and pervade all parts of the house in an apron of coarse green baize; moreover, he was more strongly tempted on Saturdays than on other days (it being a busy time), to make excursive bolts into the neighbouring alleys when he answered the door, and there to play at leap-frog and other sports with vagrant lads, until pursued and brought back by the hair of his head or the lobe of his ear; thus he was quite a conspicuous feature among the peculiar incidents of the last day in the week at Todgers’s.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_198"
    }
  }, [_vm._v("He was especially so on this particular Saturday evening, and honoured the Miss Pecksniffs with a deal of notice; seldom passing the door of Mrs Todgers’s private room, where they sat alone before the fire, working by the light of a solitary ")]), _c('a', {
    attrs: {
      "id": "page_199"
    }
  }, [_vm._v("candle, without putting in his head and greeting them with some such compliments as, ‘There you are agin!’ ‘An’t it nice?’—and similar humorous attentions.")])]), _c('a', {
    attrs: {
      "id": "page_199"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I say,’ he whispered, stopping in one of his journeys to and fro, ‘young ladies, there’s soup to-morrow. She’s a-making it now. An’t she a-putting in the water? Oh! not at all neither!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the course of answering another knock, he thrust in his head again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I say! There’s fowls to-morrow. Not skinny ones. Oh no!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Presently he called through the key-hole:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There’s a fish to-morrow. Just come. Don’t eat none of him!’ And, with this special warning, vanished again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By-and-bye, he returned to lay the cloth for supper; it having been arranged between Mrs Todgers and the young ladies, that they should partake of an exclusive veal-cutlet together in the privacy of that apartment. He entertained them on this occasion by thrusting the lighted candle into his mouth, and exhibiting his face in a state of transparency; after the performance of which feat, he went on with his professional duties; brightening every knife as he laid it on the table, by breathing on the blade and afterwards polishing the same on the apron already mentioned. When he had completed his preparations, he grinned at the sisters, and expressed his belief that the approaching collation would be of ‘rather a spicy sort.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Will it be long, before it’s ready, Bailey?’ asked Mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Bailey, ‘it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" cooked. When I come up, she was dodging among the tender pieces with a fork, and eating of ‘em.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But he had scarcely achieved the utterance of these words, when he received a manual compliment on the head, which sent him staggering against the wall; and Mrs Todgers, dish in hand, stood indignantly before him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_199"
    }
  }), _c('a', {
    attrs: {
      "id": "page_200"
    }
  }, [_vm._v("‘Oh you little villain!’ said that lady. ‘Oh you bad, false boy!’")])]), _c('a', {
    attrs: {
      "id": "page_200"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No worse than yerself,’ retorted Bailey, guarding his head, on a principle invented by Mr Thomas Cribb. ‘Ah! Come now! Do that again, will yer?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s the most dreadful child,’ said Mrs Todgers, setting down the dish, ‘I ever had to deal with. The gentlemen spoil him to that extent, and teach him such things, that I’m afraid nothing but hanging will ever do him any good.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Won’t it!’ cried Bailey. ‘Oh! Yes! Wot do you go a-lowerin the table-beer for then, and destroying my constitooshun?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Go downstairs, you vicious boy,’ said Mrs Todgers, holding the door open. ‘Do you hear me? Go along!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After two or three dexterous feints, he went, and was seen no more that night, save once, when he brought up some tumblers and hot water, and much disturbed the two Miss Pecksniffs by squinting hideously behind the back of the unconscious Mrs Todgers. Having done this justice to his wounded feelings, he retired underground; where, in company with a swarm of black beetles and a kitchen candle, he employed his faculties in cleaning boots and brushing clothes until the night was far advanced.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_200"
    }
  }, [_vm._v("Benjamin was supposed to be the real name of this young retainer but he was known by a great variety of names. Benjamin, for instance, had been converted into Uncle Ben, and that again had been corrupted into Uncle; which, by an easy transition, had again passed into Barnwell, in memory of the celebrated relative in that degree who was shot by his nephew George, while meditating in his garden at Camberwell. The gentlemen at Todgers’s had a merry habit, too, of bestowing upon him, for the time being, the name of any notorious malefactor or minister; and sometimes when current events were flat they even sought the pages of history for these distinctions; ")]), _c('a', {
    attrs: {
      "id": "page_201"
    }
  }, [_vm._v("as Mr Pitt, Young Brownrigg, and the like. At the period of which we write, he was generally known among the gentlemen as Bailey junior; a name bestowed upon him in contradistinction, perhaps, to Old Bailey; and possibly as involving the recollection of an unfortunate lady of the same name, who perished by her own hand early in life, and has been immortalised in a ballad.")])]), _c('a', {
    attrs: {
      "id": "page_201"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The usual Sunday dinner-hour at Todgers’s was two o’clock—a suitable time, it was considered for all parties; convenient to Mrs Todgers, on account of the bakers; and convenient to the gentlemen with reference to their afternoon engagements. But on the Sunday which was to introduce the two Miss Pecksniffs to a full knowledge of Todgers’s and its society, the dinner was postponed until five, in order that everything might be as genteel as the occasion demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the hour drew nigh, Bailey junior, testifying great excitement, appeared in a complete suit of cast-off clothes several sizes too large for him, and in particular, mounted a clean shirt of such extraordinary magnitude, that one of the gentlemen (remarkable for his ready wit) called him ‘collars’ on the spot. At about a quarter before five, a deputation, consisting of Mr Jinkins, and another gentleman, whose name was Gander, knocked at the door of Mrs Todgers’s room, and, being formally introduced to the two Miss Pecksniffs by their parent who was in waiting, besought the honour of conducting them upstairs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_201"
    }
  }, [_vm._v("The drawing-room at Todgers’s was out of the common style; so much so indeed, that you would hardly have taken it to be a drawingroom, unless you were told so by somebody who was in the secret. It was floor-clothed all over; and the ceiling, including a great beam in the middle, was papered. Besides the three little windows, with seats in them, commanding ")]), _c('a', {
    attrs: {
      "id": "page_202"
    }
  }, [_vm._v("the opposite archway, there was another window looking point blank, without any compromise at all about it into Jinkins’s bedroom; and high up, all along one side of the wall was a strip of panes of glass, two-deep, giving light to the staircase. There were the oddest closets possible, with little casements in them like eight-day clocks, lurking in the wainscot and taking the shape of the stairs; and the very door itself (which was painted black) had two great glass eyes in its forehead, with an inquisitive green pupil in the middle of each.")])]), _c('a', {
    attrs: {
      "id": "page_202"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Here the gentlemen were all assembled. There was a general cry of ‘Hear, hear!’ and ‘Bravo Jink!’ when Mr Jinkins appeared with Charity on his arm; which became quite rapturous as Mr Gander followed, escorting Mercy, and Mr Pecksniff brought up the rear with Mrs Todgers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_202"
    }
  }, [_vm._v("Then the presentations took place. They included a gentleman of a sporting turn, who propounded questions on jockey subjects to the editors of Sunday papers, which were regarded by his friends as rather stiff things to answer; and they included a gentleman of a theatrical turn, who had once entertained serious thoughts of ‘coming out,’ but had been kept in by the wickedness of human nature; and they included a gentleman of a debating turn, who was strong at speech-making; and a gentleman of a literary turn, who wrote squibs upon the rest, and knew the weak side of everybody’s character but his own. There was a gentleman of a vocal turn, and a gentleman of a smoking turn, and a gentleman of a convivial turn; some of the gentlemen had a turn for whist, and a large proportion of the gentlemen had a strong turn for billiards and betting. They had all, it may be presumed, a turn for business; being all commercially employed in one way or other; and had, every one in his own way, a decided turn for pleasure to boot. Mr Jinkins was of a fashionable turn; being a regular frequenter of ")]), _c('a', {
    attrs: {
      "id": "page_203"
    }
  }, [_vm._v("the Parks on Sundays, and knowing a great many carriages by sight. He spoke mysteriously, too, of splendid women, and was suspected of having once committed himself with a Countess. Mr Gander was of a witty turn being indeed the gentleman who had originated the sally about ‘collars;’ which sparkling pleasantry was now retailed from mouth to mouth, under the title of Gander’s Last, and was received in all parts of the room with great applause. Mr Jinkins it may be added, was much the oldest of the party; being a fish-salesman’s book-keeper, aged forty. He was the oldest boarder also; and in right of his double seniority, took the lead in the house, as Mrs Todgers had already said.")])]), _c('a', {
    attrs: {
      "id": "page_203"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There was considerable delay in the production of dinner, and poor Mrs Todgers, being reproached in confidence by Jinkins, slipped in and out, at least twenty times to see about it; always coming back as though she had no such thing upon her mind, and hadn’t been out at all. But there was no hitch in the conversation nevertheless; for one gentleman, who travelled in the perfumery line, exhibited an interesting nick-nack, in the way of a remarkable cake of shaving soap which he had lately met with in Germany; and the gentleman of a literary turn repeated (by desire) some sarcastic stanzas he had recently produced on the freezing of the tank at the back of the house. These amusements, with the miscellaneous conversation arising out of them, passed the time splendidly, until dinner was announced by Bailey junior in these terms:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The wittles is up!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On which notice they immediately descended to the banquet-hall; some of the more facetious spirits in the rear taking down gentlemen as if they were ladies, in imitation of the fortunate possessors of the two Miss Pecksniffs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_203"
    }
  }, [_vm._v("Mr Pecksniff said grace—a short and pious grace, involving ")]), _c('a', {
    attrs: {
      "id": "page_204"
    }
  }, [_vm._v("a blessing on the appetites of those present, and committing all persons who had nothing to eat, to the care of Providence; whose business (so said the grace, in effect) it clearly was, to look after them. This done, they fell to with less ceremony than appetite; the table groaning beneath the weight, not only of the delicacies whereof the Miss Pecksniffs had been previously forewarned, but of boiled beef, roast veal, bacon, pies and abundance of such heavy vegetables as are favourably known to housekeepers for their satisfying qualities. Besides which, there were bottles of stout, bottles of wine, bottles of ale, and divers other strong drinks, native and foreign.")])]), _c('a', {
    attrs: {
      "id": "page_204"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All this was highly agreeable to the two Miss Pecksniffs, who were in immense request; sitting one on either hand of Mr Jinkins at the bottom of the table; and who were called upon to take wine with some new admirer every minute. They had hardly ever felt so pleasant, and so full of conversation, in their lives; Mercy, in particular, was uncommonly brilliant, and said so many good things in the way of lively repartee that she was looked upon as a prodigy. ‘In short,’ as that young lady observed, ‘they felt now, indeed, that they were in London, and for the first time too.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_204"
    }
  }, [_vm._v("Their young friend Bailey sympathized in these feelings to the fullest extent, and, abating nothing of his patronage, gave them every encouragement in his power; favouring them, when the general attention was diverted from his proceedings, with many nods and winks and other tokens of recognition, and occasionally touching his nose with a corkscrew, as if to express the Bacchanalian character of the meeting. In truth, perhaps even the spirits of the two Miss Pecksniffs, and the hungry watchfulness of Mrs Todgers, were less worthy of note than the proceedings of this remarkable boy, whom nothing disconcerted or put out of his way. If any piece of crockery, a ")]), _c('a', {
    attrs: {
      "id": "page_205"
    }
  }, [_vm._v("dish or otherwise, chanced to slip through his hands (which happened once or twice), he let it go with perfect good breeding, and never added to the painful emotions of the company by exhibiting the least regret. Nor did he, by hurrying to and fro, disturb the repose of the assembly, as many well-trained servants do; on the contrary, feeling the hopelessness of waiting upon so large a party, he left the gentlemen to help themselves to what they wanted, and seldom stirred from behind Mr Jinkins’s chair, where, with his hands in his pockets, and his legs planted pretty wide apart, he led the laughter, and enjoyed the conversation.")])]), _c('a', {
    attrs: {
      "id": "page_205"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The dessert was splendid. No waiting either. The pudding-plates had been washed in a little tub outside the door while cheese was on, and though they were moist and warm with friction, still there they were again, up to the mark, and true to time. Quarts of almonds; dozens of oranges; pounds of raisins; stacks of biffins; soup-plates full of nuts.—Oh, Todgers’s could do it when it chose! mind that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then more wine came on; red wines and white wines; and a large china bowl of punch, brewed by the gentleman of a convivial turn, who adjured the Miss Pecksniffs not to be despondent on account of its dimensions, as there were materials in the house for the decoction of half a dozen more of the same size. Good gracious, how they laughed! How they coughed when they sipped it, because it was so strong; and how they laughed again when somebody vowed that but for its colour it might have been mistaken, in regard of its innocuous qualities, for new milk! What a shout of ‘No!’ burst from the gentlemen when they pathetically implored Mr Jinkins to suffer them to qualify it with hot water; and how blushingly, by little and little, did each of them drink her whole glassful, down to its very dregs!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_205"
    }
  }), _c('a', {
    attrs: {
      "id": "page_206"
    }
  }, [_vm._v("Now comes the trying time. The sun, as Mr Jinkins says (gentlemanly creature, Jinkins—never at a loss!), is about to leave the firmament. ‘Miss Pecksniff!’ says Mrs Todgers, softly, ‘will you—?’ ‘Oh dear, no more, Mrs Todgers.’ Mrs Todgers rises; the two Miss Pecksniffs rise; all rise. Miss Mercy Pecksniff looks downward for her scarf. Where is it? Dear me, where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _vm._v(" it be? Sweet girl, she has it on; not on her fair neck, but loose upon her flowing figure. A dozen hands assist her. She is all confusion. The youngest gentleman in company thirsts to murder Jinkins. She skips and joins her sister at the door. Her sister has her arm about the waist of Mrs Todgers. She winds her arm around her sister. Diana, what a picture! The last things visible are a shape and a skip. ‘Gentlemen, let us drink the ladies!’")])]), _c('a', {
    attrs: {
      "id": "page_206"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The enthusiasm is tremendous. The gentleman of a debating turn rises in the midst, and suddenly lets loose a tide of eloquence which bears down everything before it. He is reminded of a toast—a toast to which they will respond. There is an individual present; he has him in his eye; to whom they owe a debt of gratitude. He repeats it—a debt of gratitude. Their rugged natures have been softened and ameliorated that day, by the society of lovely woman. There is a gentleman in company whom two accomplished and delightful females regard with veneration, as the fountain of their existence. Yes, when yet the two Miss Pecksniffs lisped in language scarce intelligible, they called that individual ‘Father!’ There is great applause. He gives them ‘Mr Pecksniff, and God bless him!’ They all shake hands with Mr Pecksniff, as they drink the toast. The youngest gentleman in company does so with a thrill; for he feels that a mysterious influence pervades the man who claims that being in the pink scarf for his daughter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_206"
    }
  }, [_vm._v("What saith Mr Pecksniff in reply? Or rather let the question ")]), _c('a', {
    attrs: {
      "id": "page_207"
    }
  }, [_vm._v("be, What leaves he unsaid? Nothing. More punch is called for, and produced, and drunk. Enthusiasm mounts still higher. Every man comes out freely in his own character. The gentleman of a theatrical turn recites. The vocal gentleman regales them with a song. Gander leaves the Gander of all former feasts whole leagues behind. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" rises to propose a toast. It is, The Father of Todgers’s. It is their common friend Jink—it is old Jink, if he may call him by that familiar and endearing appellation. The youngest gentleman in company utters a frantic negative. He won’t have it—he can’t bear it—it mustn’t be. But his depth of feeling is misunderstood. He is supposed to be a little elevated; and nobody heeds him.")])]), _c('a', {
    attrs: {
      "id": "page_207"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Jinkins thanks them from his heart. It is, by many degrees, the proudest day in his humble career. When he looks around him on the present occasion, he feels that he wants words in which to express his gratitude. One thing he will say. He hopes it has been shown that Todgers’s can be true to itself; and that, an opportunity arising, it can come out quite as strong as its neighbours—perhaps stronger. He reminds them, amidst thunders of encouragement, that they have heard of a somewhat similar establishment in Cannon Street; and that they have heard it praised. He wishes to draw no invidious comparisons; he would be the last man to do it; but when that Cannon Street establishment shall be able to produce such a combination of wit and beauty as has graced that board that day, and shall be able to serve up (all things considered) such a dinner as that of which they have just partaken, he will be happy to talk to it. Until then, gentlemen, he will stick to Todgers’s.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_207"
    }
  }, [_vm._v("More punch, more enthusiasm, more speeches. Everybody’s health is drunk, saving the youngest gentleman’s in company. He sits apart, with his elbow on the back of a vacant ")]), _c('a', {
    attrs: {
      "id": "page_208"
    }
  }, [_vm._v("chair, and glares disdainfully at Jinkins. Gander, in a convulsing speech, gives them the health of Bailey junior; hiccups are heard; and a glass is broken. Mr Jinkins feels that it is time to join the ladies. He proposes, as a final sentiment, Mrs Todgers. She is worthy to be remembered separately. Hear, hear. So she is; no doubt of it. They all find fault with her at other times; but every man feels now, that he could die in her defence.")])]), _c('a', {
    attrs: {
      "id": "page_208"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They go upstairs, where they are not expected so soon; for Mrs Todgers is asleep, Miss Charity is adjusting her hair, and Mercy, who has made a sofa of one of the window-seats is in a gracefully recumbent attitude. She is rising hastily, when Mr Jinkins implores her, for all their sakes, not to stir; she looks too graceful and too lovely, he remarks, to be disturbed. She laughs, and yields, and fans herself, and drops her fan, and there is a rush to pick it up. Being now installed, by one consent, as the beauty of the party, she is cruel and capricious, and sends gentlemen on messages to other gentlemen, and forgets all about them before they can return with the answer, and invents a thousand tortures, rending their hearts to pieces. Bailey brings up the tea and coffee. There is a small cluster of admirers round Charity; but they are only those who cannot get near her sister. The youngest gentleman in company is pale, but collected, and still sits apart; for his spirit loves to hold communion with itself, and his soul recoils from noisy revellers. She has a consciousness of his presence and adoration. He sees it flashing sometimes in the corner of her eye. Have a care, Jinkins, ere you provoke a desperate man to frenzy!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_208"
    }
  }, [_vm._v("Mr Pecksniff had followed his younger friends upstairs, and taken a chair at the side of Mrs Todgers. He had also spilt a cup of coffee over his legs without appearing to be aware of the circumstance; nor did he seem to know that there was ")]), _c('a', {
    attrs: {
      "id": "page_209"
    }
  }, [_vm._v("muffin on his knee.")])]), _c('a', {
    attrs: {
      "id": "page_209"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And how have they used you downstairs, sir?’ asked the hostess.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Their conduct has been such, my dear madam,’ said Mr Pecksniff, ‘as I can never think of without emotion, or remember without a tear. Oh, Mrs Todgers!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My goodness!’ exclaimed that lady. ‘How low you are in your spirits, sir!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am a man, my dear madam,’ said Mr Pecksniff, shedding tears and speaking with an imperfect articulation, ‘but I am also a father. I am also a widower. My feelings, Mrs Todgers, will not consent to be entirely smothered, like the young children in the Tower. They are grown up, and the more I press the bolster on them, the more they look round the corner of it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He suddenly became conscious of the bit of muffin, and stared at it intently; shaking his head the while, in a forlorn and imbecile manner, as if he regarded it as his evil genius, and mildly reproached it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She was beautiful, Mrs Todgers,’ he said, turning his glazed eye again upon her, without the least preliminary notice. ‘She had a small property.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So I have heard,’ cried Mrs Todgers with great sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Those are her daughters,’ said Mr Pecksniff, pointing out the young ladies, with increased emotion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Todgers had no doubt about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mercy and Charity,’ said Mr Pecksniff, ‘Charity and Mercy. Not unholy names, I hope?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Pecksniff!’ cried Mrs Todgers. ‘What a ghastly smile! Are you ill, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pressed his hand upon her arm, and answered in a solemn manner, and a faint voice, ‘Chronic.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_209"
    }
  }), _c('a', {
    attrs: {
      "id": "page_210"
    }
  }, [_vm._v("‘Cholic?’ cried the frightened Mrs Todgers.")])]), _c('a', {
    attrs: {
      "id": "page_210"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Chron-ic,’ he repeated with some difficulty. ‘Chron-ic. A chronic disorder. I have been its victim from childhood. It is carrying me to my grave.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Heaven forbid!’ cried Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, it is,’ said Mr Pecksniff, reckless with despair. ‘I am rather glad of it, upon the whole. You are like her, Mrs Todgers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t squeeze me so tight, pray, Mr Pecksniff. If any of the gentlemen should notice us.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For her sake,’ said Mr Pecksniff. ‘Permit me—in honour of her memory. For the sake of a voice from the tomb. You are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" like her Mrs Todgers! What a world this is!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah! Indeed you may say that!’ cried Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m afraid it is a vain and thoughtless world,’ said Mr Pecksniff, overflowing with despondency. ‘These young people about us. Oh! what sense have they of their responsibilities? None. Give me your other hand, Mrs Todgers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lady hesitated, and said ‘she didn’t like.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Has a voice from the grave no influence?’ said Mr Pecksniff, with, dismal tenderness. ‘This is irreligious! My dear creature.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Hush!’ urged Mrs Todgers. ‘Really you mustn’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s not me,’ said Mr Pecksniff. ‘Don’t suppose it’s me; it’s the voice; it’s her voice.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Pecksniff deceased, must have had an unusually thick and husky voice for a lady, and rather a stuttering voice, and to say the truth somewhat of a drunken voice, if it had ever borne much resemblance to that in which Mr Pecksniff spoke just then. But perhaps this was delusion on his part.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It has been a day of enjoyment, Mrs Todgers, but still it has been a day of torture. It has reminded me of my loneliness. What am I in the world?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_210"
    }
  }), _c('a', {
    attrs: {
      "id": "page_211"
    }
  }, [_vm._v("‘An excellent gentleman, Mr Pecksniff,’ said Mrs Todgers.")])]), _c('a', {
    attrs: {
      "id": "page_211"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There is consolation in that too,’ cried Mr Pecksniff. ‘Am I?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There is no better man living,’ said Mrs Todgers, ‘I am sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff smiled through his tears, and slightly shook his head. ‘You are very good,’ he said, ‘thank you. It is a great happiness to me, Mrs Todgers, to make young people happy. The happiness of my pupils is my chief object. I dote upon ‘em. They dote upon me too—sometimes.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Always,’ said Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When they say they haven’t improved, ma’am,’ whispered Mr Pecksniff, looking at her with profound mystery, and motioning to her to advance her ear a little closer to his mouth. ‘When they say they haven’t improved, ma’am, and the premium was too high, they lie! I shouldn’t wish it to be mentioned; you will understand me; but I say to you as to an old friend, they lie.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Base wretches they must be!’ said Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Madam,’ said Mr Pecksniff, ‘you are right. I respect you for that observation. A word in your ear. To Parents and Guardians. This is in confidence, Mrs Todgers?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The strictest, of course!’ cried that lady.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To Parents and Guardians,’ repeated Mr Pecksniff. ‘An eligible opportunity now offers, which unites the advantages of the best practical architectural education with the comforts of a home, and the constant association with some, who, however humble their sphere and limited their capacity—observe!—are not unmindful of their moral responsibilities.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_211"
    }
  }, [_vm._v("Mrs Todgers looked a little puzzled to know what this might mean, as well she might; for it was, as the reader may perchance remember, Mr Pecksniff’s usual form of advertisement when he wanted a pupil; and seemed to have no particular ")]), _c('a', {
    attrs: {
      "id": "page_212"
    }
  }, [_vm._v("reference, at present, to anything. But Mr Pecksniff held up his finger as a caution to her not to interrupt him.")])]), _c('a', {
    attrs: {
      "id": "page_212"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you know any parent or guardian, Mrs Todgers,’ said Mr Pecksniff, ‘who desires to avail himself of such an opportunity for a young gentleman? An orphan would be preferred. Do you know of any orphan with three or four hundred pound?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Todgers reflected, and shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When you hear of an orphan with three or four hundred pound,’ said Mr Pecksniff, ‘let that dear orphan’s friends apply, by letter post-paid, to S. P., Post Office, Salisbury. I don’t know who he is exactly. Don’t be alarmed, Mrs Todgers,’ said Mr Pecksniff, falling heavily against her; ‘Chronic—chronic! Let’s have a little drop of something to drink.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bless my life, Miss Pecksniffs!’ cried Mrs Todgers, aloud, ‘your dear pa’s took very poorly!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff straightened himself by a surprising effort, as every one turned hastily towards him; and standing on his feet, regarded the assembly with a look of ineffable wisdom. Gradually it gave place to a smile; a feeble, helpless, melancholy smile; bland, almost to sickliness. ‘Do not repine, my friends,’ said Mr Pecksniff, tenderly. ‘Do not weep for me. It is chronic.’ And with these words, after making a futile attempt to pull off his shoes, he fell into the fireplace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The youngest gentleman in company had him out in a second. Yes, before a hair upon his head was singed, he had him on the hearth-rug—her father!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_212"
    }
  }, [_vm._v("She was almost beside herself. So was her sister. Jinkins consoled them both. They all consoled them. Everybody had something to say, except the youngest gentleman in company, who with a noble self-devotion did the heavy work, and held up Mr Pecksniff’s head without being taken notice of by anybody. ")]), _c('a', {
    attrs: {
      "id": "page_213"
    }
  }, [_vm._v("At last they gathered round, and agreed to carry him upstairs to bed. The youngest gentleman in company was rebuked by Jinkins for tearing Mr Pecksniff’s coat! Ha, ha! But no matter.")])]), _c('a', {
    attrs: {
      "id": "page_213"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They carried him upstairs, and crushed the youngest gentleman at every step. His bedroom was at the top of the house, and it was a long way; but they got him there in course of time. He asked them frequently on the road for a little drop of something to drink. It seemed an idiosyncrasy. The youngest gentleman in company proposed a draught of water. Mr Pecksniff called him opprobious names for the suggestion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jinkins and Gander took the rest upon themselves, and made him as comfortable as they could, on the outside of his bed; and when he seemed disposed to sleep, they left him. But before they had all gained the bottom of the staircase, a vision of Mr Pecksniff, strangely attired, was seen to flutter on the top landing. He desired to collect their sentiments, it seemed, upon the nature of human life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My friends,’ cried Mr Pecksniff, looking over the banisters, ‘let us improve our minds by mutual inquiry and discussion. Let us be moral. Let us contemplate existence. Where is Jinkins?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Here,’ cried that gentleman. ‘Go to bed again’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To bed!’ said Mr Pecksniff. ‘Bed! ‘Tis the voice of the sluggard, I hear him complain, you have woke me too soon, I must slumber again. If any young orphan will repeat the remainder of that simple piece from Doctor Watts’s collection, an eligible opportunity now offers.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody volunteered.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_213"
    }
  }, [_vm._v("‘This is very soothing,’ said Mr Pecksniff, after a pause. ‘Extremely so. Cool and refreshing; particularly to the legs! The legs of the human subject, my friends, are a beautiful production. ")]), _c('a', {
    attrs: {
      "id": "page_214"
    }
  }, [_vm._v("Compare them with wooden legs, and observe the difference between the anatomy of nature and the anatomy of art. Do you know,’ said Mr Pecksniff, leaning over the banisters, with an odd recollection of his familiar manner among new pupils at home, ‘that I should very much like to see Mrs Todgers’s notion of a wooden leg, if perfectly agreeable to herself!’")])]), _c('a', {
    attrs: {
      "id": "page_214"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As it appeared impossible to entertain any reasonable hopes of him after this speech, Mr Jinkins and Mr Gander went upstairs again, and once more got him into bed. But they had not descended to the second floor before he was out again; nor, when they had repeated the process, had they descended the first flight, before he was out again. In a word, as often as he was shut up in his own room, he darted out afresh, charged with some new moral sentiment, which he continually repeated over the banisters, with extraordinary relish, and an irrepressible desire for the improvement of his fellow creatures that nothing could subdue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under these circumstances, when they had got him into bed for the thirtieth time or so, Mr Jinkins held him, while his companion went downstairs in search of Bailey junior, with whom he presently returned. That youth having been apprised of the service required of him, was in great spirits, and brought up a stool, a candle, and his supper; to the end that he might keep watch outside the bedroom door with tolerable comfort.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_214"
    }
  }, [_vm._v("When he had completed his arrangements, they locked Mr Pecksniff in, and left the key on the outside; charging the young page to listen attentively for symptoms of an apoplectic nature, with which the patient might be troubled, and, in case of any such presenting themselves, to summon them without delay. To which Mr Bailey modestly replied that ‘he hoped he ")]), _c('a', {
    attrs: {
      "id": "page_215"
    }
  }, [_vm._v("knowed wot o’clock it wos in gineral, and didn’t date his letters to his friends from Todgers’s for nothing.’")])]), _c('a', {
    attrs: {
      "id": "page_215"
    }
  })])])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_216"
    }
  }, [_vm._v("Chapter Ten")])]), _c('a', {
    attrs: {
      "id": "page_216"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Containing Strange Matter, on which many Events in this History May, for their Good or Evil Influence, Chiefly Depend")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But Mr Pecksniff came to town on business. Had he forgotten that? Was he always taking his pleasure with Todgers’s jovial brood, unmindful of the serious demands, whatever they might be, upon his calm consideration? No.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time and tide will wait for no man, saith the adage. But all men have to wait for time and tide. That tide which, taken at the flood, would lead Seth Pecksniff on to fortune, was marked down in the table, and about to flow. No idle Pecksniff lingered far inland, unmindful of the changes of the stream; but there, upon the water’s edge, over his shoes already, stood the worthy creature, prepared to wallow in the very mud, so that it slid towards the quarter of his hope.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The trustfulness of his two fair daughters was beautiful indeed. They had that firm reliance on their parent’s nature, which taught them to feel certain that in all he did he had his purpose straight and full before him. And that its noble end and object was himself, which almost of necessity included them, they knew. The devotion of these maids was perfect.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_216"
    }
  }), _c('a', {
    attrs: {
      "id": "page_217"
    }
  }, [_vm._v("Their filial confidence was rendered the more touching, by their having no knowledge of their parent’s real designs, in the present instance. All that they knew of his proceedings was, that every morning, after the early breakfast, he repaired to the post office and inquired for letters. That task performed, his business for the day was over; and he again relaxed, until the rising of another sun proclaimed the advent of another post.")])]), _c('a', {
    attrs: {
      "id": "page_217"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This went on for four or five days. At length, one morning, Mr Pecksniff returned with a breathless rapidity, strange to observe in him, at other times so calm; and, seeking immediate speech with his daughters, shut himself up with them in private conference for two whole hours. Of all that passed in this period, only the following words of Mr Pecksniff’s utterance are known:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How he has come to change so very much (if it should turn out as I expect, that he has), we needn’t stop to inquire. My dears, I have my thoughts upon the subject, but I will not impart them. It is enough that we will not be proud, resentful, or unforgiving. If he wants our friendship he shall have it. We know our duty, I hope!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That same day at noon, an old gentleman alighted from a hackney-coach at the post-office, and, giving his name, inquired for a letter addressed to himself, and directed to be left till called for. It had been lying there some days. The superscription was in Mr Pecksniff’s hand, and it was sealed with Mr Pecksniff’s seal.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_217"
    }
  }, [_vm._v("It was very short, containing indeed nothing more than an address ‘with Mr Pecksniff’s respectful, and (not withstanding what has passed) sincerely affectionate regards.’ The old gentleman tore off the direction—scattering the rest in fragments to the winds—and giving it to the coachman, bade him drive ")]), _c('a', {
    attrs: {
      "id": "page_218"
    }
  }, [_vm._v("as near that place as he could. In pursuance of these instructions he was driven to the Monument; where he again alighted, and dismissed the vehicle, and walked towards Todgers’s.")])]), _c('a', {
    attrs: {
      "id": "page_218"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Though the face, and form, and gait of this old man, and even his grip of the stout stick on which he leaned, were all expressive of a resolution not easily shaken, and a purpose (it matters little whether right or wrong, just now) such as in other days might have survived the rack, and had its strongest life in weakest death; still there were grains of hesitation in his mind, which made him now avoid the house he sought, and loiter to and fro in a gleam of sunlight, that brightened the little churchyard hard by. There may have been, in the presence of those idle heaps of dust among the busiest stir of life, something to increase his wavering; but there he walked, awakening the echoes as he paced up and down, until the church clock, striking the quarters for the second time since he had been there, roused him from his meditation. Shaking off his incertitude as the air parted with the sound of the bells, he walked rapidly to the house, and knocked at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff was seated in the landlady’s little room, and his visitor found him reading—by an accident; he apologised for it—an excellent theological work. There were cake and wine upon a little table—by another accident, for which he also apologised. Indeed he said, he had given his visitor up, and was about to partake of that simple refreshment with his children, when he knocked at the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your daughters are well?’ said old Martin, laying down his hat and stick.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_218"
    }
  }, [_vm._v("Mr Pecksniff endeavoured to conceal his agitation as a father when he answered Yes, they were. They were good girls, he said, very good. He would not venture to recommend Mr Chuzzlewit to take the easy-chair, or to keep out of the ")]), _c('a', {
    attrs: {
      "id": "page_219"
    }
  }, [_vm._v("draught from the door. If he made any such suggestion, he would expose himself, he feared, to most unjust suspicion. He would, therefore, content himself with remarking that there was an easy-chair in the room, and that the door was far from being air-tight. This latter imperfection, he might perhaps venture to add, was not uncommonly to be met with in old houses.")])]), _c('a', {
    attrs: {
      "id": "page_219"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man sat down in the easy-chair, and after a few moments’ silence, said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the first place, let me thank you for coming to London so promptly, at my almost unexplained request; I need scarcely add, at my cost.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘At "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" cost, my good sir!’ cried Mr Pecksniff, in a tone of great surprise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is not,’ said Martin, waving his hand impatiently, ‘my habit to put my—well! my relatives—to any personal expense to gratify my caprices.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Caprices, my good sir!’ cried Mr Pecksniff")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That is scarcely the proper word either, in this instance,’ said the old man. ‘No. You are right.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff was inwardly very much relieved to hear it, though he didn’t at all know why.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are right,’ repeated Martin. ‘It is not a caprice. It is built up on reason, proof, and cool comparison. Caprices never are. Moreover, I am not a capricious man. I never was.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Most assuredly not,’ said Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How do you know?’ returned the other quickly. ‘You are to begin to know it now. You are to test and prove it, in time to come. You and yours are to find that I can be constant, and am not to be diverted from my end. Do you hear?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Perfectly,’ said Mr Pecksniff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_219"
    }
  }, [_vm._v("‘I very much regret,’ Martin resumed, looking steadily at ")]), _c('a', {
    attrs: {
      "id": "page_220"
    }
  }, [_vm._v("him, and speaking in a slow and measured tone; ‘I very much regret that you and I held such a conversation together, as that which passed between us at our last meeting. I very much regret that I laid open to you what were then my thoughts of you, so freely as I did. The intentions that I bear towards you now are of another kind; deserted by all in whom I have ever trusted; hoodwinked and beset by all who should help and sustain me; I fly to you for refuge. I confide in you to be my ally; to attach yourself to me by ties of Interest and Expectation’—he laid great stress upon these words, though Mr Pecksniff particularly begged him not to mention it; ‘and to help me to visit the consequences of the very worst species of meanness, dissimulation, and subtlety, on the right heads.’")])]), _c('a', {
    attrs: {
      "id": "page_220"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My noble sir!’ cried Mr Pecksniff, catching at his outstretched hand. ‘And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" regret the having harboured unjust thoughts of me! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" with those grey hairs!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Regrets,’ said Martin, ‘are the natural property of grey hairs; and I enjoy, in common with all other men, at least my share of such inheritance. And so enough of that. I regret having been severed from you so long. If I had known you sooner, and sooner used you as you well deserve, I might have been a happier man.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff looked up to the ceiling, and clasped his hands in rapture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your daughters,’ said Martin, after a short silence. ‘I don’t know them. Are they like you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the nose of my eldest and the chin of my youngest, Mr Chuzzlewit,’ returned the widower, ‘their sainted parent (not myself, their mother) lives again.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t mean in person,’ said the old man. ‘Morally, morally.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_220"
    }
  }, [_vm._v("“Tis not for me to say,’ retorted Mr Pecksniff with a gentle ")]), _c('a', {
    attrs: {
      "id": "page_221"
    }
  }, [_vm._v("smile. ‘I have done my best, sir.’")])]), _c('a', {
    attrs: {
      "id": "page_221"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I could wish to see them,’ said Martin; ‘are they near at hand?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They were, very near; for they had in fact been listening at the door from the beginning of this conversation until now, when they precipitately retired. Having wiped the signs of weakness from his eyes, and so given them time to get upstairs, Mr Pecksniff opened the door, and mildly cried in the passage,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My own darlings, where are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Here, my dear pa!’ replied the distant voice of Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come down into the back parlour, if you please, my love,’ said Mr Pecksniff, ‘and bring your sister with you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, my dear pa,’ cried Merry; and down they came directly (being all obedience), singing as they came.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing could exceed the astonishment of the two Miss Pecksniffs when they found a stranger with their dear papa. Nothing could surpass their mute amazement when he said, ‘My children, Mr Chuzzlewit!’ But when he told them that Mr Chuzzlewit and he were friends, and that Mr Chuzzlewit had said such kind and tender words as pierced his very heart, the two Miss Pecksniffs cried with one accord, ‘Thank Heaven for this!’ and fell upon the old man’s neck. And when they had embraced him with such fervour of affection that no words can describe it, they grouped themselves about his chair, and hung over him, as figuring to themselves no earthly joy like that of ministering to his wants, and crowding into the remainder of his life, the love they would have diffused over their whole existence, from infancy, if he—dear obdurate!—had but consented to receive the precious offering.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20196m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man looked attentively from one to the other, and then at Mr Pecksniff, several times.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_221"
    }
  }), _c('a', {
    attrs: {
      "id": "page_222"
    }
  }, [_vm._v("‘What,’ he asked of Mr Pecksniff, happening to catch his eye in its descent; for until now it had been piously upraised, with something of that expression which the poetry of ages has attributed to a domestic bird, when breathing its last amid the ravages of an electric storm: ‘What are their names?’")])]), _c('a', {
    attrs: {
      "id": "page_222"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff told him, and added, rather hastily; his caluminators would have said, with a view to any testamentary thoughts that might be flitting through old Martin’s mind; ‘Perhaps, my dears, you had better write them down. Your humble autographs are of no value in themselves, but affection may prize them.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Affection,’ said the old man, ‘will expend itself on the living originals. Do not trouble yourselves, my girls, I shall not so easily forget you, Charity and Mercy, as to need such tokens of remembrance. Cousin!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sir!’ said Mr Pecksniff, with alacrity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you never sit down?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why—yes—occasionally, sir,’ said Mr Pecksniff, who had been standing all this time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Will you do so now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Can you ask me,’ returned Mr Pecksniff, slipping into a chair immediately, ‘whether I will do anything that you desire?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You talk confidently,’ said Martin, ‘and you mean well; but I fear you don’t know what an old man’s humours are. You don’t know what it is to be required to court his likings and dislikings; to adapt yourself to his prejudices; to do his bidding, be it what it may; to bear with his distrusts and jealousies; and always still be zealous in his service. When I remember how numerous these failings are in me, and judge of their occasional enormity by the injurious thoughts I lately entertained of you, I hardly dare to claim you for my friend.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_222"
    }
  }), _c('a', {
    attrs: {
      "id": "page_223"
    }
  }, [_vm._v("‘My worthy sir,’ returned his relative, ‘how "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _vm._v(" you talk in such a painful strain! What was more natural than that you should make one slight mistake, when in all other respects you were so very correct, and have had such reason—such very sad and undeniable reason—to judge of every one about you in the worst light!’")])]), _c('a', {
    attrs: {
      "id": "page_223"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘True,’ replied the other. ‘You are very lenient with me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We always said, my girls and I,’ cried Mr Pecksniff with increasing obsequiousness, ‘that while we mourned the heaviness of our misfortune in being confounded with the base and mercenary, still we could not wonder at it. My dears, you remember?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh vividly! A thousand times!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We uttered no complaint,’ said Mr Pecksniff. ‘Occasionally we had the presumption to console ourselves with the remark that Truth would in the end prevail, and Virtue be triumphant; but not often. My loves, you recollect?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recollect! Could he doubt it! Dearest pa, what strange unnecessary questions!")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/0075m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And when I saw you,’ resumed Mr Pecksniff, with still greater deference, ‘in the little, unassuming village where we take the liberty of dwelling, I said you were mistaken in me, my dear sir; that was all, I think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No—not all,’ said Martin, who had been sitting with his hand upon his brow for some time past, and now looked up again; ‘you said much more, which, added to other circumstances that have come to my knowledge, opened my eyes. You spoke to me, disinterestedly, on behalf of—I needn’t name him. You know whom I mean.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Trouble was expressed in Mr Pecksniff’s visage, as he pressed his hot hands together, and replied, with humility, ‘Quite disinterestedly, sir, I assure you.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_223"
    }
  }), _c('a', {
    attrs: {
      "id": "page_224"
    }
  }, [_vm._v("‘I know it,’ said old Martin, in his quiet way. ‘I am sure of it. I said so. It was disinterested too, in you, to draw that herd of harpies off from me, and be their victim yourself; most other men would have suffered them to display themselves in all their rapacity, and would have striven to rise, by contrast, in my estimation. You felt for me, and drew them off, for which I owe you many thanks. Although I left the place, I know what passed behind my back, you see!’")])]), _c('a', {
    attrs: {
      "id": "page_224"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You amaze me, sir!’ cried Mr Pecksniff; which was true enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My knowledge of your proceedings,’ said the old man, does not stop at this. You have a new inmate in your house.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, sir,’ rejoined the architect, ‘I have.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He must quit it’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For—for yours?’ asked Mr Pecksniff, with a quavering mildness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For any shelter he can find,’ the old man answered. ‘He has deceived you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I hope not’ said Mr Pecksniff, eagerly. ‘I trust not. I have been extremely well disposed towards that young man. I hope it cannot be shown that he has forfeited all claim to my protection. Deceit—deceit, my dear Mr Chuzzlewit, would be final. I should hold myself bound, on proof of deceit, to renounce him instantly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The old man glanced at both his fair supporters, but especially at Miss Mercy, whom, indeed, he looked full in the face, with a greater demonstration of interest than had yet appeared in his features. His gaze again encountered Mr Pecksniff, as he said, composedly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course you know that he has made his matrimonial choice?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_224"
    }
  }, [_vm._v("‘Oh dear!’ cried Mr Pecksniff, rubbing his hair up very stiff ")]), _c('a', {
    attrs: {
      "id": "page_225"
    }
  }, [_vm._v("upon his head, and staring wildly at his daughters. ‘This is becoming tremendous!’")])]), _c('a', {
    attrs: {
      "id": "page_225"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know the fact?’ repeated Martin")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Surely not without his grandfather’s consent and approbation my dear sir!’ cried Mr Pecksniff. ‘Don’t tell me that. For the honour of human nature, say you’re not about to tell me that!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought he had suppressed it,’ said the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The indignation felt by Mr Pecksniff at this terrible disclosure, was only to be equalled by the kindling anger of his daughters. What! Had they taken to their hearth and home a secretly contracted serpent; a crocodile, who had made a furtive offer of his hand; an imposition on society; a bankrupt bachelor with no effects, trading with the spinster world on false pretences! And oh, to think that he should have disobeyed and practised on that sweet, that venerable gentleman, whose name he bore; that kind and tender guardian; his more than father—to say nothing at all of mother—horrible, horrible! To turn him out with ignominy would be treatment much too good. Was there nothing else that could be done to him? Had he incurred no legal pains and penalties? Could it be that the statutes of the land were so remiss as to have affixed no punishment to such delinquency? Monster; how basely had they been deceived!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am glad to find you second me so warmly,’ said the old man holding up his hand to stay the torrent of their wrath. ‘I will not deny that it is a pleasure to me to find you so full of zeal. We will consider that topic as disposed of.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, my dear sir,’ cried Mr Pecksniff, ‘not as disposed of, until I have purged my house of this pollution.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That will follow,’ said the old man, ‘in its own time. I look upon that as done.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_225"
    }
  }), _c('a', {
    attrs: {
      "id": "page_226"
    }
  }, [_vm._v("‘You are very good, sir,’ answered Mr Pecksniff, shaking his hand. ‘You do me honour. You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("may")]), _vm._v(" look upon it as done, I assure you.’")])]), _c('a', {
    attrs: {
      "id": "page_226"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There is another topic,’ said Martin, ‘on which I hope you will assist me. You remember Mary, cousin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The young lady that I mentioned to you, my dears, as having interested me so very much,’ remarked Mr Pecksniff. ‘Excuse my interrupting you, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I told you her history?’ said the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Which I also mentioned, you will recollect, my dears,’ cried Mr Pecksniff. ‘Silly girls, Mr Chuzzlewit—quite moved by it, they were!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, look now!’ said Martin, evidently pleased; ‘I feared I should have had to urge her case upon you, and ask you to regard her favourably for my sake. But I find you have no jealousies! Well! You have no cause for any, to be sure. She has nothing to gain from me, my dears, and she knows it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two Miss Pecksniffs murmured their approval of this wise arrangement, and their cordial sympathy with its interesting object.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I could have anticipated what has come to pass between us four,’ said the old man thoughfully; ‘but it is too late to think of that. You would receive her courteously, young ladies, and be kind to her, if need were?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where was the orphan whom the two Miss Pecksniffs would not have cherished in their sisterly bosom! But when that orphan was commended to their care by one on whom the dammed-up love of years was gushing forth, what exhaustless stores of pure affection yearned to expend themselves upon her!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_226"
    }
  }, [_vm._v("An interval ensued, during which Mr Chuzzlewit, in an absent frame of mind, sat gazing at the ground, without uttering ")]), _c('a', {
    attrs: {
      "id": "page_227"
    }
  }, [_vm._v("a word; and as it was plain that he had no desire to be interrupted in his meditations, Mr Pecksniff and his daughters were profoundly silent also. During the whole of the foregoing dialogue, he had borne his part with a cold, passionless promptitude, as though he had learned and painfully rehearsed it all a hundred times. Even when his expressions were warmest and his language most encouraging, he had retained the same manner, without the least abatement. But now there was a keener brightness in his eye, and more expression in his voice, as he said, awakening from his thoughtful mood:")])]), _c('a', {
    attrs: {
      "id": "page_227"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know what will be said of this? Have you reflected?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Said of what, my dear sir?’ Mr Pecksniff asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of this new understanding between us.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff looked benevolently sagacious, and at the same time far above all earthly misconstruction, as he shook his head, and observed that a great many things would be said of it, no doubt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A great many,’ rejoined the old man. ‘Some will say that I dote in my old age; that illness has shaken me; that I have lost all strength of mind, and have grown childish. You can bear that?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff answered that it would be dreadfully hard to bear, but he thought he could, if he made a great effort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Others will say—I speak of disappointed, angry people only—that you have lied and fawned, and wormed yourself through dirty ways into my favour; by such concessions and such crooked deeds, such meannesses and vile endurances, as nothing could repay; no, not the legacy of half the world we live in. You can bear that?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_227"
    }
  }, [_vm._v("Mr Pecksniff made reply that this would be also very hard to bear, as reflecting, in some degree, on the discernment of ")]), _c('a', {
    attrs: {
      "id": "page_228"
    }
  }, [_vm._v("Mr Chuzzlewit. Still he had a modest confidence that he could sustain the calumny, with the help of a good conscience, and that gentleman’s friendship.")])]), _c('a', {
    attrs: {
      "id": "page_228"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘With the great mass of slanderers,’ said old Martin, leaning back in his chair, ‘the tale, as I clearly foresee, will run thus: That to mark my contempt for the rabble whom I despised, I chose from among them the very worst, and made him do my will, and pampered and enriched him at the cost of all the rest. That, after casting about for the means of a punishment which should rankle in the bosoms of these kites the most, and strike into their gall, I devised this scheme at a time when the last link in the chain of grateful love and duty, that held me to my race, was roughly snapped asunder; roughly, for I loved him well; roughly, for I had ever put my trust in his affection; roughly, for that he broke it when I loved him most—God help me!—and he without a pang could throw me off, while I clung about his heart! Now,’ said the old man, dismissing this passionate outburst as suddenly as he had yielded to it, ‘is your mind made up to bear this likewise? Lay your account with having it to bear, and put no trust in being set right by me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear Mr Chuzzlewit,’ cried Pecksniff in an ecstasy, ‘for such a man as you have shown yourself to be this day; for a man so injured, yet so very humane; for a man so—I am at a loss what precise term to use—yet at the same time so remarkably—I don’t know how to express my meaning; for such a man as I have described, I hope it is no presumption to say that I, and I am sure I may add my children also (my dears, we perfectly agree in this, I think?), would bear anything whatever!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Enough,’ said Martin. ‘You can charge no consequences on me. When do you retire home?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_228"
    }
  }, [_vm._v("‘Whenever you please, my dear sir. To-night if you desire ")]), _c('a', {
    attrs: {
      "id": "page_229"
    }
  }, [_vm._v("it.’")])]), _c('a', {
    attrs: {
      "id": "page_229"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I desire nothing,’ returned the old man, ‘that is unreasonable. Such a request would be. Will you be ready to return at the end of this week?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The very time of all others that Mr Pecksniff would have suggested if it had been left to him to make his own choice. As to his daughters—the words, ‘Let us be at home on Saturday, dear pa,’ were actually upon their lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your expenses, cousin,’ said Martin, taking a folded slip of paper from his pocketbook, ‘may possibly exceed that amount. If so, let me know the balance that I owe you, when we next meet. It would be useless if I told you where I live just now; indeed, I have no fixed abode. When I have, you shall know it. You and your daughters may expect to see me before long; in the meantime I need not tell you that we keep our own confidence. What you will do when you get home is understood between us. Give me no account of it at any time; and never refer to it in any way. I ask that as a favour. I am commonly a man of few words, cousin; and all that need be said just now is said, I think.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘One glass of wine—one morsel of this homely cake?’ cried Mr Pecksniff, venturing to detain him. ‘My dears—!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sisters flew to wait upon him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Poor girls!’ said Mr Pecksniff. ‘You will excuse their agitation, my dear sir. They are made up of feeling. A bad commodity to go through the world with, Mr Chuzzlewit! My youngest daughter is almost as much of a woman as my eldest, is she not, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Which "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" the youngest?’ asked the old man.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_229"
    }
  }, [_vm._v("‘Mercy, by five years,’ said Mr Pecksniff. ‘We sometimes venture to consider her rather a fine figure, sir. Speaking as an artist, I may perhaps be permitted to suggest that its outline is ")]), _c('a', {
    attrs: {
      "id": "page_230"
    }
  }, [_vm._v("graceful and correct. I am naturally,’ said Mr Pecksniff, drying his hands upon his handkerchief, and looking anxiously in his cousin’s face at almost every word, ‘proud, if I may use the expression, to have a daughter who is constructed on the best models.’")])]), _c('a', {
    attrs: {
      "id": "page_230"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She seems to have a lively disposition,’ observed Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear me!’ said Mr Pecksniff. ‘That is quite remarkable. You have defined her character, my dear sir, as correctly as if you had known her from her birth. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" a lively disposition. I assure you, my dear sir, that in our unpretending home her gaiety is delightful.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No doubt,’ returned the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Charity, upon the other hand,’ said Mr Pecksniff, ‘is remarkable for strong sense, and for rather a deep tone of sentiment, if the partiality of a father may be excused in saying so. A wonderful affection between them, my dear sir! Allow me to drink your health. Bless you!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I little thought,’ retorted Martin, ‘but a month ago, that I should be breaking bread and pouring wine with you. I drink to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not at all abashed by the extraordinary abruptness with which these latter words were spoken, Mr Pecksniff thanked him devoutly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now let me go,’ said Martin, putting down the wine when he had merely touched it with his lips. ‘My dears, good morning!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_230"
    }
  }, [_vm._v("But this distant form of farewell was by no means tender enough for the yearnings of the young ladies, who again embraced him with all their hearts—with all their arms at any rate—to which parting caresses their new-found friend submitted with a better grace than might have been expected from one who, not a moment before, had pledged their parent ")]), _c('a', {
    attrs: {
      "id": "page_231"
    }
  }, [_vm._v("in such a very uncomfortable manner. These endearments terminated, he took a hasty leave of Mr Pecksniff and withdrew, followed to the door by both father and daughters, who stood there kissing their hands and beaming with affection until he disappeared; though, by the way, he never once looked back, after he had crossed the threshold.")])]), _c('a', {
    attrs: {
      "id": "page_231"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When they returned into the house, and were again alone in Mrs Todgers’s room, the two young ladies exhibited an unusual amount of gaiety; insomuch that they clapped their hands, and laughed, and looked with roguish aspects and a bantering air upon their dear papa. This conduct was so very unaccountable, that Mr Pecksniff (being singularly grave himself) could scarcely choose but ask them what it meant; and took them to task, in his gentle manner, for yielding to such light emotions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If it was possible to divine any cause for this merriment, even the most remote,’ he said, ‘I should not reprove you. But when you can have none whatever—oh, really, really!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This admonition had so little effect on Mercy, that she was obliged to hold her handkerchief before her rosy lips, and to throw herself back in her chair, with every demonstration of extreme amusement; which want of duty so offended Mr Pecksniff that he reproved her in set terms, and gave her his parental advice to correct herself in solitude and contemplation. But at that juncture they were disturbed by the sound of voices in dispute; and as it proceeded from the next room, the subject matter of the altercation quickly reached their ears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t care that! Mrs Todgers,’ said the young gentleman who had been the youngest gentleman in company on the day of the festival; ‘I don’t care "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(", ma’am,’ said he, snapping his fingers, ‘for Jinkins. Don’t suppose I do.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_231"
    }
  }, [_vm._v("‘I am quite certain you don’t, sir,’ replied Mrs Todgers. ‘You ")]), _c('a', {
    attrs: {
      "id": "page_232"
    }
  }, [_vm._v("have too independent a spirit, I know, to yield to anybody. And quite right. There is no reason why you should give way to any gentleman. Everybody must be well aware of that.’")])]), _c('a', {
    attrs: {
      "id": "page_232"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should think no more of admitting daylight into the fellow,’ said the youngest gentleman, in a desperate voice, ‘than if he was a bulldog.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mrs Todgers did not stop to inquire whether, as a matter of principle, there was any particular reason for admitting daylight even into a bulldog, otherwise than by the natural channel of his eyes, but she seemed to wring her hands, and she moaned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Let him be careful,’ said the youngest gentleman. ‘I give him warning. No man shall step between me and the current of my vengeance. I know a Cove—’ he used that familiar epithet in his agitation but corrected himself by adding, ‘a gentleman of property, I mean—who practices with a pair of pistols (fellows too) of his own. If I am driven to borrow ‘em, and to send at friend to Jinkins, a tragedy will get into the papers. That’s all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again Mrs Todgers moaned.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have borne this long enough,’ said the youngest gentleman but now my soul rebels against it, and I won’t stand it any longer. I left home originally, because I had that within me which wouldn’t be domineered over by a sister; and do you think I’m going to be put down by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v("? No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is very wrong in Mr Jinkins; I know it is perfectly inexcusable in Mr Jinkins, if he intends it,’ observed Mrs Todgers")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_232"
    }
  }, [_vm._v("‘If he intends it!’ cried the youngest gentleman. ‘Don’t he interrupt and contradict me on every occasion? Does he ever fail to interpose himself between me and anything or anybody that he sees I have set my mind upon? Does he make a point of always pretending to forget me, when he’s pouring out the ")]), _c('a', {
    attrs: {
      "id": "page_233"
    }
  }, [_vm._v("beer? Does he make bragging remarks about his razors, and insulting allusions to people who have no necessity to shave more than once a week? But let him look out! He’ll find himself shaved, pretty close, before long, and so I tell him.’")])]), _c('a', {
    attrs: {
      "id": "page_233"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young gentleman was mistaken in this closing sentence, inasmuch as he never told it to Jinkins, but always to Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘However,’ he said, ‘these are not proper subjects for ladies’ ears. All I’ve got to say to you, Mrs Todgers, is, a week’s notice from next Saturday. The same house can’t contain that miscreant and me any longer. If we get over the intermediate time without bloodshed, you may think yourself pretty fortunate. I don’t myself expect we shall.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear, dear!’ cried Mrs Todgers, ‘what would I have given to have prevented this? To lose you, sir, would be like losing the house’s right-hand. So popular as you are among the gentlemen; so generally looked up to; and so much liked! I do hope you’ll think better of it; if on nobody else’s account, on mine.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There’s Jinkins,’ said the youngest gentleman, moodily. ‘Your favourite. He’ll console you, and the gentlemen too, for the loss of twenty such as me. I’m not understood in this house. I never have been.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t run away with that opinion, sir!’ cried Mrs Todgers, with a show of honest indignation. ‘Don’t make such a charge as that against the establishment, I must beg of you. It is not so bad as that comes to, sir. Make any remark you please against the gentlemen, or against me; but don’t say you’re not understood in this house.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m not treated as if I was,’ said the youngest gentleman.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_233"
    }
  }, [_vm._v("‘There you make a great mistake, sir,’ returned Mrs Todgers, in the same strain. ‘As many of the gentlemen and I ")]), _c('a', {
    attrs: {
      "id": "page_234"
    }
  }, [_vm._v("have often said, you are too sensitive. That’s where it is. You are of too susceptible a nature; it’s in your spirit.’")])]), _c('a', {
    attrs: {
      "id": "page_234"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young gentleman coughed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And as,’ said Mrs Todgers, ‘as to Mr Jinkins, I must beg of you, if we "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" to part, to understand that I don’t abet Mr Jinkins by any means. Far from it. I could wish that Mr Jinkins would take a lower tone in this establishment, and would not be the means of raising differences between me and gentlemen that I can much less bear to part with than I could with Mr Jinkins. Mr Jinkins is not such a boarder, sir,’ added Mrs Todgers, ‘that all considerations of private feeling and respect give way before him. Quite the contrary, I assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young gentleman was so much mollified by these and similar speeches on the part of Mrs Todgers, that he and that lady gradually changed positions; so that she became the injured party, and he was understood to be the injurer; but in a complimentary, not in an offensive sense; his cruel conduct being attributable to his exalted nature, and to that alone. So, in the end, the young gentleman withdrew his notice, and assured Mrs Todgers of his unalterable regard; and having done so, went back to business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Goodness me, Miss Pecksniffs!’ cried that lady, as she came into the back room, and sat wearily down, with her basket on her knees, and her hands folded upon it, ‘what a trial of temper it is to keep a house like this! You must have heard most of what has just passed. Now did you ever hear the like?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Never!’ said the two Miss Pecksniffs.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_234"
    }
  }, [_vm._v("‘Of all the ridiculous young fellows that ever I had to deal with,’ resumed Mrs Todgers, ‘that is the most ridiculous and unreasonable. Mr Jinkins is hard upon him sometimes, but not half as hard as he deserves. To mention such a gentleman as Mr Jinkins in the same breath with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v("—you know it’s too ")]), _c('a', {
    attrs: {
      "id": "page_235"
    }
  }, [_vm._v("much! And yet he’s as jealous of him, bless you, as if he was his equal.’")])]), _c('a', {
    attrs: {
      "id": "page_235"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young ladies were greatly entertained by Mrs Todgers’s account, no less than with certain anecdotes illustrative of the youngest gentleman’s character, which she went on to tell them. But Mr Pecksniff looked quite stern and angry; and when she had concluded, said in a solemn voice:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pray, Mrs Todgers, if I may inquire, what does that young gentleman contribute towards the support of these premises?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, sir, for what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" has, he pays about eighteen shillings a week!’ said Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Eighteen shillings a week!’ repeated Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Taking one week with another; as near that as possible,’ said Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff rose from his chair, folded his arms, looked at her, and shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And do you mean to say, ma’am—is it possible, Mrs Todgers—that for such a miserable consideration as eighteen shillings a week, a female of your understanding can so far demean herself as to wear a double face, even for an instant?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am forced to keep things on the square if I can, sir,’ faltered Mrs Todgers. ‘I must preserve peace among them, and keep my connection together, if possible, Mr Pecksniff. The profit is very small.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The profit!’ cried that gentleman, laying great stress upon the word. ‘The profit, Mrs Todgers! You amaze me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was so severe, that Mrs Todgers shed tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The profit!’ repeated Mr pecksniff. ‘The profit of dissimulation! To worship the golden calf of Baal, for eighteen shillings a week!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t in your own goodness be too hard upon me, Mr Pecksniff,’ cried Mrs Todgers, taking out her handkerchief.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_235"
    }
  }), _c('a', {
    attrs: {
      "id": "page_236"
    }
  }, [_vm._v("‘Oh Calf, Calf!’ cried Mr Pecksniff mournfully. ‘Oh, Baal, Baal! oh my friend, Mrs Todgers! To barter away that precious jewel, self-esteem, and cringe to any mortal creature—for eighteen shillings a week!’")])]), _c('a', {
    attrs: {
      "id": "page_236"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He was so subdued and overcome by the reflection, that he immediately took down his hat from its peg in the passage, and went out for a walk, to compose his feelings. Anybody passing him in the street might have known him for a good man at first sight; for his whole figure teemed with a consciousness of the moral homily he had read to Mrs Todgers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eighteen shillings a week! Just, most just, thy censure, upright Pecksniff! Had it been for the sake of a ribbon, star, or garter; sleeves of lawn, a great man’s smile, a seat in parliament, a tap upon the shoulder from a courtly sword; a place, a party, or a thriving lie, or eighteen thousand pounds, or even eighteen hundred;—but to worship the golden calf for eighteen shillings a week! oh pitiful, pitiful!")])])])])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_237"
    }
  }, [_vm._v("Chapter Eleven")])]), _c('a', {
    attrs: {
      "id": "page_237"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Wherein a Certain Gentleman Becomes Particular in His Attentions to a Certain Lady; And more Coming Events than One, Cast their shadows Before")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_237"
    }
  }, [_vm._v("The family were within two or three days of their departure from Mrs Todgers’s, and the commercial gentlemen were to a man despondent and not to be comforted, because of the approaching separation, when Bailey junior, at the jocund time of noon, presented himself before Miss Charity Pecksniff, then sitting with her sister in the banquet chamber, hemming six new pocket-handkerchiefs for Mr Jinkins; and having expressed a hope, preliminary and pious, that he might be blest, gave her in his pleasant way to understand that a visitor attended to pay his respects to her, and was at that moment waiting in the drawing-room. Perhaps this last announcement showed in a more striking point of view than many lengthened speeches could have done, the trustfulness and faith of Bailey’s nature; since he had, in fact, last seen the visitor on the door-mat, where, after signifying to him that he would do well to go upstairs, he had left him to the guidance of his own ")]), _c('a', {
    attrs: {
      "id": "page_238"
    }
  }, [_vm._v("sagacity. Hence it was at least an even chance that the visitor was then wandering on the roof of the house, or vainly seeking to extricate himself from the maze of bedrooms; Todgers’s being precisely that kind of establishment in which an unpiloted stranger is pretty sure to find himself in some place where he least expects and least desires to be.")])]), _c('a', {
    attrs: {
      "id": "page_238"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A gentleman for me!’ cried Charity, pausing in her work; ‘my gracious, Bailey!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah!’ said Bailey. ‘It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" my gracious, an’t it? Wouldn’t I be gracious neither, not if I wos him!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The remark was rendered somewhat obscure in itself, by reason (as the reader may have observed) of a redundancy of negatives; but accompanied by action expressive of a faithful couple walking arm-in-arm towards a parochial church, mutually exchanging looks of love, it clearly signified this youth’s conviction that the caller’s purpose was of an amorous tendency. Miss Charity affected to reprove so great a liberty; but she could not help smiling. He was a strange boy, to be sure. There was always some ground of probability and likelihood mingled with his absurd behaviour. That was the best of it!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But I don’t know any gentlemen, Bailey,’ said Miss Pecksniff. ‘I think you must have made a mistake.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Bailey smiled at the extreme wildness of such a supposition, and regarded the young ladies with unimpaired affability.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear Merry,’ said Charity, ‘who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("can")]), _vm._v(" it be? Isn’t it odd? I have a great mind not to go to him really. So very strange, you know!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_238"
    }
  }, [_vm._v("The younger sister plainly considered that this appeal had its origin in the pride of being called upon and asked for; and that it was intended as an assertion of superiority, and a retaliation upon her for having captured the commercial gentlemen. ")]), _c('a', {
    attrs: {
      "id": "page_239"
    }
  }, [_vm._v("Therefore, she replied, with great affection and politeness, that it was, no doubt, very strange indeed; and that she was totally at a loss to conceive what the ridiculous person unknown could mean by it.")])]), _c('a', {
    attrs: {
      "id": "page_239"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Quite impossible to divine!’ said Charity, with some sharpness, ‘though still, at the same time, you needn’t be angry, my dear.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ retorted Merry, singing at her needle. ‘I am quite aware of that, my love.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid your head is turned, you silly thing,’ said Cherry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you know, my dear,’ said Merry, with engaging candour, ‘that I have been afraid of that, myself, all along! So much incense and nonsense, and all the rest of it, is enough to turn a stronger head than mine. What a relief it must be to you, my dear, to be so very comfortable in that respect, and not to be worried by those odious men! How do you do it, Cherry?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_239"
    }
  }, [_vm._v("This artless inquiry might have led to turbulent results, but for the strong emotions of delight evinced by Bailey junior, whose relish in the turn the conversation had lately taken was so acute, that it impelled and forced him to the instantaneous performance of a dancing step, extremely difficult in its nature, and only to be achieved in a moment of ecstasy, which is commonly called The Frog’s Hornpipe. A manifestation so lively, brought to their immediate recollection the great virtuous precept, ‘Keep up appearances whatever you do,’ in which they had been educated. They forbore at once, and jointly signified to Mr Bailey that if he should presume to practice that figure any more in their presence, they would instantly acquaint Mrs Todgers with the fact, and would demand his condign punishment, at the hands of that lady. The young gentleman ")]), _c('a', {
    attrs: {
      "id": "page_240"
    }
  }, [_vm._v("having expressed the bitterness of his contrition by affecting to wipe away scalding tears with his apron, and afterwards feigning to wring a vast amount of water from that garment, held the door open while Miss Charity passed out; and so that damsel went in state upstairs to receive her mysterious adorer.")])]), _c('a', {
    attrs: {
      "id": "page_240"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("By some strange occurrence of favourable circumstances he had found out the drawing-room, and was sitting there alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah, cousin!’ he said. ‘Here I am, you see. You thought I was lost, I’ll be bound. Well! how do you find yourself by this time?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Charity replied that she was quite well, and gave Mr Jonas Chuzzlewit her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s right,’ said Mr Jonas, ‘and you’ve got over the fatigues of the journey have you? I say. How’s the other one?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My sister is very well, I believe,’ returned the young lady. ‘I have not heard her complain of any indisposition, sir. Perhaps you would like to see her, and ask her yourself?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no cousin!’ said Mr Jonas, sitting down beside her on the window-seat. ‘Don’t be in a hurry. There’s no occasion for that, you know. What a cruel girl you are!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s impossible for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" to know,’ said Cherry, ‘whether I am or not.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, perhaps it is,’ said Mr Jonas. ‘I say—Did you think I was lost? You haven’t told me that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t think at all about it,’ answered Cherry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Didn’t you though?’ said Jonas, pondering upon this strange reply. ‘Did the other one?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am sure it’s impossible for me to say what my sister may, or may not have thought on such a subject,’ cried Cherry. ‘She never said anything to me about it, one way or other.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_240"
    }
  }), _c('a', {
    attrs: {
      "id": "page_241"
    }
  }, [_vm._v("‘Didn’t she laugh about it?’ inquired Jonas.")])]), _c('a', {
    attrs: {
      "id": "page_241"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No. She didn’t even laugh about it,’ answered Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She’s a terrible one to laugh, an’t she?’ said Jonas, lowering his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She is very lively,’ said Cherry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Liveliness is a pleasant thing—when it don’t lead to spending money. An’t it?’ asked Mr Jonas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very much so, indeed,’ said Cherry, with a demureness of manner that gave a very disinterested character to her assent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Such liveliness as yours I mean, you know,’ observed Mr Jonas, as he nudged her with his elbow. ‘I should have come to see you before, but I didn’t know where you was. How quick you hurried off, that morning!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I was amenable to my papa’s directions,’ said Miss Charity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wish he had given me his direction,’ returned her cousin, ‘and then I should have found you out before. Why, I shouldn’t have found you even now, if I hadn’t met him in the street this morning. What a sleek, sly chap he is! Just like a tomcat, an’t he?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I must trouble you to have the goodness to speak more respectfully of my papa, Mr Jonas,’ said Charity. ‘I can’t allow such a tone as that, even in jest.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ecod, you may say what you like of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" father, then, and so I give you leave,’ said Jonas. ‘I think it’s liquid aggravation that circulates through his veins, and not regular blood. How old should you think my father was, cousin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Old, no doubt,’ replied Miss Charity; ‘but a fine old gentleman.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A fine old gentleman!’ repeated Jonas, giving the crown of his hat an angry knock. ‘Ah! It’s time he was thinking of being drawn out a little finer too. Why, he’s eighty!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is he, indeed?’ said the young lady.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_241"
    }
  }), _c('a', {
    attrs: {
      "id": "page_242"
    }
  }, [_vm._v("‘And ecod,’ cried Jonas, ‘now he’s gone so far without giving in, I don’t see much to prevent his being ninety; no, nor even a hundred. Why, a man with any feeling ought to be ashamed of being eighty, let alone more. Where’s his religion, I should like to know, when he goes flying in the face of the Bible like that? Threescore-and-ten’s the mark, and no man with a conscience, and a proper sense of what’s expected of him, has any business to live longer.’")])]), _c('a', {
    attrs: {
      "id": "page_242"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Is any one surprised at Mr Jonas making such a reference to such a book for such a purpose? Does any one doubt the old saw, that the Devil (being a layman) quotes Scripture for his own ends? If he will take the trouble to look about him, he may find a greater number of confirmations of the fact in the occurrences of any single day, than the steam-gun can discharge balls in a minute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But there’s enough of my father,’ said Jonas; ‘it’s of no use to go putting one’s self out of the way by talking about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(". I called to ask you to come and take a walk, cousin, and see some of the sights; and to come to our house afterwards, and have a bit of something. Pecksniff will most likely look in in the evening, he says, and bring you home. See, here’s his writing; I made him put it down this morning when he told me he shouldn’t be back before I came here; in case you wouldn’t believe me. There’s nothing like proof, is there? Ha, ha! I say—you’ll bring the other one, you know!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_242"
    }
  }, [_vm._v("Miss Charity cast her eyes upon her father’s autograph, which merely said—’Go, my children, with your cousin. Let there be union among us when it is possible;’ and after enough of hesitation to impart a proper value to her consent, withdrew to prepare her sister and herself for the excursion. She soon returned, accompanied by Miss Mercy, who was by no means pleased to leave the brilliant triumphs of Todgers’s ")]), _c('a', {
    attrs: {
      "id": "page_243"
    }
  }, [_vm._v("for the society of Mr Jonas and his respected father.")])]), _c('a', {
    attrs: {
      "id": "page_243"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aha!’ cried Jonas. ‘There you are, are you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, fright,’ said Mercy, ‘here I am; and I would much rather be anywhere else, I assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t mean that,’ cried Mr Jonas. ‘You can’t, you know. It isn’t possible.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You can have what opinion you like, fright,’ retorted Mercy. ‘I am content to keep mine; and mine is that you are a very unpleasant, odious, disagreeable person.’ Here she laughed heartily, and seemed to enjoy herself very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, you’re a sharp gal!’ said Mr Jonas. ‘She’s a regular teaser, an’t she, cousin?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Charity replied in effect, that she was unable to say what the habits and propensities of a regular teaser might be; and that even if she possessed such information, it would ill become her to admit the existence of any creature with such an unceremonious name in her family; far less in the person of a beloved sister; ‘whatever,’ added Cherry with an angry glance, ‘whatever her real nature may be.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, my dear,’ said Merry, ‘the only observation I have to make is, that if we don’t go out at once, I shall certainly take my bonnet off again, and stay at home.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This threat had the desired effect of preventing any farther altercation, for Mr Jonas immediately proposed an adjournment, and the same being carried unanimously, they departed from the house straightway. On the doorstep, Mr Jonas gave an arm to each cousin; which act of gallantry being observed by Bailey junior, from the garret window, was by him saluted with a loud and violent fit of coughing, to which paroxysm he was still the victim when they turned the corner.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_243"
    }
  }, [_vm._v("Mr Jonas inquired in the first instance if they were good walkers and being answered, ‘Yes,’ submitted their pedestrian ")]), _c('a', {
    attrs: {
      "id": "page_244"
    }
  }, [_vm._v("powers to a pretty severe test; for he showed them as many sights, in the way of bridges, churches, streets, outsides of theatres, and other free spectacles, in that one forenoon, as most people see in a twelvemonth. It was observable in this gentleman, that he had an insurmountable distaste to the insides of buildings, and that he was perfectly acquainted with the merits of all shows, in respect of which there was any charge for admission, which it seemed were every one detestable, and of the very lowest grade of merit. He was so thoroughly possessed with this opinion, that when Miss Charity happened to mention the circumstance of their having been twice or thrice to the theatre with Mr Jinkins and party, he inquired, as a matter of course, ‘where the orders came from?’ and being told that Mr Jinkins and party paid, was beyond description entertained, observing that ‘they must be nice flats, certainly;’ and often in the course of the walk, bursting out again into a perfect convulsion of laughter at the surpassing silliness of those gentlemen, and (doubtless) at his own superior wisdom.")])]), _c('a', {
    attrs: {
      "id": "page_244"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When they had been out for some hours and were thoroughly fatigued, it being by that time twilight, Mr Jonas intimated that he would show them one of the best pieces of fun with which he was acquainted. This joke was of a practical kind, and its humour lay in taking a hackney-coach to the extreme limits of possibility for a shilling. Happily it brought them to the place where Mr Jonas dwelt, or the young ladies might have rather missed the point and cream of the jest.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_244"
    }
  }, [_vm._v("The old-established firm of Anthony Chuzzlewit and Son, Manchester Warehousemen, and so forth, had its place of business in a very narrow street somewhere behind the Post Office; where every house was in the brightest summer morning very gloomy; and where light porters watered the pavement, ")]), _c('a', {
    attrs: {
      "id": "page_245"
    }
  }, [_vm._v("each before his own employer’s premises, in fantastic patterns, in the dog-days; and where spruce gentlemen with their hands in the pockets of symmetrical trousers, were always to be seen in warm weather, contemplating their undeniable boots in dusty warehouse doorways; which appeared to be the hardest work they did, except now and then carrying pens behind their ears. A dim, dirty, smoky, tumble-down, rotten old house it was, as anybody would desire to see; but there the firm of Anthony Chuzzlewit and Son transacted all their business and their pleasure too, such as it was; for neither the young man nor the old had any other residence, or any care or thought beyond its narrow limits.")])]), _c('a', {
    attrs: {
      "id": "page_245"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_245"
    }
  }, [_vm._v("Business, as may be readily supposed, was the main thing in this establishment; insomuch indeed that it shouldered comfort out of doors, and jostled the domestic arrangements at every turn. Thus in the miserable bedrooms there were files of moth-eaten letters hanging up against the walls; and linen rollers, and fragments of old patterns, and odds and ends of spoiled goods, strewed upon the ground; while the meagre bedsteads, washing-stands, and scraps of carpet, were huddled away into corners as objects of secondary consideration, not to be thought of but as disagreeable necessities, furnishing no profit, and intruding on the one affair of life. The single sitting-room was on the same principle, a chaos of boxes and old papers, and had more counting-house stools in it than chairs; not to mention a great monster of a desk straddling over the middle of the floor, and an iron safe sunk into the wall above the fireplace. The solitary little table for purposes of refection and social enjoyment, bore as fair a proportion to the desk and other business furniture, as the graces and harmless relaxations of life had ever done, in the persons of the old man and his son, to their pursuit of wealth. It was meanly laid out ")]), _c('a', {
    attrs: {
      "id": "page_246"
    }
  }, [_vm._v("now for dinner; and in a chair before the fire sat Anthony himself, who rose to greet his son and his fair cousins as they entered.")])]), _c('a', {
    attrs: {
      "id": "page_246"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("An ancient proverb warns us that we should not expect to find old heads upon young shoulders; to which it may be added that we seldom meet with that unnatural combination, but we feel a strong desire to knock them off; merely from an inherent love we have of seeing things in their right places. It is not improbable that many men, in no wise choleric by nature, felt this impulse rising up within them, when they first made the acquaintance of Mr Jonas; but if they had known him more intimately in his own house, and had sat with him at his own board, it would assuredly have been paramount to all other considerations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, ghost!’ said Mr Jonas, dutifully addressing his parent by that title. ‘Is dinner nearly ready?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should think it was,’ rejoined the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the good of that?’ rejoined the son. ‘I should think it was. I want to know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah! I don’t know for certain,’ said Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t know for certain,’ rejoined his son in a lower tone. ‘No. You don’t know anything for certain, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" don’t. Give me your candle here. I want it for the gals.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_246"
    }
  }, [_vm._v("Anthony handed him a battered old office candlestick, with which Mr Jonas preceded the young ladies to the nearest bedroom, where he left them to take off their shawls and bonnets; and returning, occupied himself in opening a bottle of wine, sharpening the carving-knife, and muttering compliments to his father, until they and the dinner appeared together. The repast consisted of a hot leg of mutton with greens and potatoes; and the dishes having been set upon the table by a slipshod old woman, they were left to enjoy it after their own ")]), _c('a', {
    attrs: {
      "id": "page_247"
    }
  }, [_vm._v("manner.")])]), _c('a', {
    attrs: {
      "id": "page_247"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bachelor’s Hall, you know, cousin,’ said Mr Jonas to Charity. ‘I say—the other one will be having a laugh at this when she gets home, won’t she? Here; you sit on the right side of me, and I’ll have her upon the left. Other one, will you come here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re such a fright,’ replied Mercy, ‘that I know I shall have no appetite if I sit so near you; but I suppose I must.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘An’t she lively?’ whispered Mr Jonas to the elder sister, with his favourite elbow emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh I really don’t know!’ replied Miss Pecksniff, tartly. ‘I am tired of being asked such ridiculous questions.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s that precious old father of mine about now?’ said Mr Jonas, seeing that his parent was travelling up and down the room instead of taking his seat at table. ‘What are you looking for?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’ve lost my glasses, Jonas,’ said old Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Sit down without your glasses, can’t you?’ returned his son. ‘You don’t eat or drink out of ‘em, I think; and where’s that sleepy-headed old Chuffey got to! Now, stupid. Oh! you know your name, do you?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_247"
    }
  }, [_vm._v("It would seem that he didn’t, for he didn’t come until the father called. As he spoke, the door of a small glass office, which was partitioned off from the rest of the room, was slowly opened, and a little blear-eyed, weazen-faced, ancient man came creeping out. He was of a remote fashion, and dusty, like the rest of the furniture; he was dressed in a decayed suit of black; with breeches garnished at the knees with rusty wisps of ribbon, the very paupers of shoestrings; on the lower portion of his spindle legs were dingy worsted stockings of the same colour. He looked as if he had been put away and forgotten half a century before, and somebody had just found him in ")]), _c('a', {
    attrs: {
      "id": "page_248"
    }
  }, [_vm._v("a lumber-closet.")])]), _c('a', {
    attrs: {
      "id": "page_248"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Such as he was, he came slowly creeping on towards the table, until at last he crept into the vacant chair, from which, as his dim faculties became conscious of the presence of strangers, and those strangers ladies, he rose again, apparently intending to make a bow. But he sat down once more without having made it, and breathing on his shrivelled hands to warm them, remained with his poor blue nose immovable above his plate, looking at nothing, with eyes that saw nothing, and a face that meant nothing. Take him in that state, and he was an embodiment of nothing. Nothing else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Our clerk,’ said Mr Jonas, as host and master of the ceremonies: ‘Old Chuffey.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is he deaf?’ inquired one of the young ladies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, I don’t know that he is. He an’t deaf, is he, father?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I never heard him say he was,’ replied the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Blind?’ inquired the young ladies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘N—no. I never understood that he was at all blind,’ said Jonas, carelessly. ‘You don’t consider him so, do you, father?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Certainly not,’ replied Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What is he, then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, I’ll tell you what he is,’ said Mr Jonas, apart to the young ladies, ‘he’s precious old, for one thing; and I an’t best pleased with him for that, for I think my father must have caught it of him. He’s a strange old chap, for another,’ he added in a louder voice, ‘and don’t understand any one hardly, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v("!’ He pointed to his honoured parent with the carving-fork, in order that they might know whom he meant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How very strange!’ cried the sisters.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_248"
    }
  }, [_vm._v("‘Why, you see,’ said Mr Jonas, ‘he’s been addling his old brains with figures and book-keeping all his life; and twenty years ago or so he went and took a fever. All the time he was ")]), _c('a', {
    attrs: {
      "id": "page_249"
    }
  }, [_vm._v("out of his head (which was three weeks) he never left off casting up; and he got to so many million at last that I don’t believe he’s ever been quite right since. We don’t do much business now though, and he an’t a bad clerk.’")])]), _c('a', {
    attrs: {
      "id": "page_249"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A very good one,’ said Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well! He an’t a dear one at all events,’ observed Jonas; ‘and he earns his salt, which is enough for our look-out. I was telling you that he hardly understands any one except my father; he always understands him, though, and wakes up quite wonderful. He’s been used to his ways so long, you see! Why, I’ve seen him play whist, with my father for a partner; and a good rubber too; when he had no more notion what sort of people he was playing against, than you have.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Has he no appetite?’ asked Merry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes,’ said Jonas, plying his own knife and fork very fast. ‘He eats—when he’s helped. But he don’t care whether he waits a minute or an hour, as long as father’s here; so when I’m at all sharp set, as I am to-day, I come to him after I’ve taken the edge off my own hunger, you know. Now, Chuffey, stupid, are you ready?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chuffey remained immovable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Always a perverse old file, he was,’ said Mr Jonas, coolly helping himself to another slice. ‘Ask him, father.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Are you ready for your dinner, Chuffey?’ asked the old man")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, yes,’ said Chuffey, lighting up into a sentient human creature at the first sound of the voice, so that it was at once a curious and quite a moving sight to see him. ‘Yes, yes. Quite ready, Mr Chuzzlewit. Quite ready, sir. All ready, all ready, all ready.’ With that he stopped, smilingly, and listened for some further address; but being spoken to no more, the light forsook his face by little and little, until he was nothing again.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_249"
    }
  }), _c('a', {
    attrs: {
      "id": "page_250"
    }
  }, [_vm._v("‘He’ll be very disagreeable, mind,’ said Jonas, addressing his cousins as he handed the old man’s portion to his father. ‘He always chokes himself when it an’t broth. Look at him, now! Did you ever see a horse with such a wall-eyed expression as he’s got? If it hadn’t been for the joke of it I wouldn’t have let him come in to-day; but I thought he’d amuse you.’")])]), _c('a', {
    attrs: {
      "id": "page_250"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The poor old subject of this humane speech was, happily for himself, as unconscious of its purport as of most other remarks that were made in his presence. But the mutton being tough, and his gums weak, he quickly verified the statement relative to his choking propensities, and underwent so much in his attempts to dine, that Mr Jonas was infinitely amused; protesting that he had seldom seen him better company in all his life, and that he was enough to make a man split his sides with laughing. Indeed, he went so far as to assure the sisters, that in this point of view he considered Chuffey superior to his own father; which, as he significantly added, was saying a great deal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was strange enough that Anthony Chuzzlewit, himself so old a man, should take a pleasure in these gibings of his estimable son at the expense of the poor shadow at their table. But he did, unquestionably; though not so much—to do him justice—with reference to their ancient clerk, as in exultation at the sharpness of Jonas. For the same reason that young man’s coarse allusions, even to himself, filled him with a stealthy glee; causing him to rub his hands and chuckle covertly, as if he said in his sleeve, ‘I taught him. I trained him. This is the heir of my bringing-up. Sly, cunning, and covetous, he’ll not squander my money. I worked for this; I hoped for this; it has been the great end and aim of my life.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_250"
    }
  }, [_vm._v("What a noble end and aim it was to contemplate in the attainment truly! But there be some who manufacture idols after ")]), _c('a', {
    attrs: {
      "id": "page_251"
    }
  }, [_vm._v("the fashion of themselves, and fail to worship them when they are made; charging their deformity on outraged nature. Anthony was better than these at any rate.")])]), _c('a', {
    attrs: {
      "id": "page_251"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Chuffey boggled over his plate so long, that Mr Jonas, losing patience, took it from him at last with his own hands, and requested his father to signify to that venerable person that he had better ‘peg away at his bread;’ which Anthony did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye, aye!’ cried the old man, brightening up as before, when this was communicated to him in the same voice, ‘quite right, quite right. He’s your own son, Mr Chuzzlewit! Bless him for a sharp lad! Bless him, bless him!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Jonas considered this so particularly childish (perhaps with some reason), that he only laughed the more, and told his cousins that he was afraid one of these fine days, Chuffey would be the death of him. The cloth was then removed, and the bottle of wine set upon the table, from which Mr Jonas filled the young ladies’ glasses, calling on them not to spare it, as they might be certain there was plenty more where that came from. But he added with some haste after this sally that it was only his joke, and they wouldn’t suppose him to be in earnest, he was sure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I shall drink,’ said Anthony, ‘to Pecksniff. Your father, my dears. A clever man, Pecksniff. A wary man! A hypocrite, though, eh? A hypocrite, girls, eh? Ha, ha, ha! Well, so he is. Now, among friends, he is. I don’t think the worse of him for that, unless it is that he overdoes it. You may overdo anything, my darlings. You may overdo even hypocrisy. Ask Jonas!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You can’t overdo taking care of yourself,’ observed that hopeful gentleman with his mouth full.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you hear that, my dears?’ cried Anthony, quite enraptured. ‘Wisdom, wisdom! A good exception, Jonas. No. It’s not easy to overdo that.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_251"
    }
  }), _c('a', {
    attrs: {
      "id": "page_252"
    }
  }, [_vm._v("‘Except,’ whispered Mr Jonas to his favourite cousin, ‘except when one lives too long. Ha, ha! Tell the other one that—I say!’")])]), _c('a', {
    attrs: {
      "id": "page_252"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good gracious me!’ said Cherry, in a petulant manner. ‘You can tell her yourself, if you wish, can’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She seems to make such game of one,’ replied Mr Jonas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then why need you trouble yourself about her?’ said Charity. ‘I am sure she doesn’t trouble herself much about you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t she though?’ asked Jonas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good gracious me, need I tell you that she don’t?’ returned the young lady.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Jonas made no verbal rejoinder, but he glanced at Mercy with an odd expression in his face; and said "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" wouldn’t break his heart, she might depend upon it. Then he looked on Charity with even greater favour than before, and besought her, as his polite manner was, to ‘come a little closer.’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/0085m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There’s another thing that’s not easily overdone, father,’ remarked Jonas, after a short silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s that?’ asked the father; grinning already in anticipation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A bargain,’ said the son. ‘Here’s the rule for bargains—“Do other men, for they would do you.” That’s the true business precept. All others are counterfeits.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_252"
    }
  }, [_vm._v("The delighted father applauded this sentiment to the echo; and was so much tickled by it, that he was at the pains of imparting the same to his ancient clerk, who rubbed his hands, nodded his palsied head, winked his watery eyes, and cried in his whistling tones, ‘Good! good! Your own son, Mr Chuzzlewit’ with every feeble demonstration of delight that he was capable of making. But this old man’s enthusiasm had the redeeming quality of being felt in sympathy with the only creature to whom he was linked by ties of long association, and by ")]), _c('a', {
    attrs: {
      "id": "page_253"
    }
  }, [_vm._v("his present helplessness. And if there had been anybody there, who cared to think about it, some dregs of a better nature unawakened, might perhaps have been descried through that very medium, melancholy though it was, yet lingering at the bottom of the worn-out cask called Chuffey.")])]), _c('a', {
    attrs: {
      "id": "page_253"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("As matters stood, nobody thought or said anything upon the subject; so Chuffey fell back into a dark corner on one side of the fireplace, where he always spent his evenings, and was neither seen nor heard again that night; save once, when a cup of tea was given him, in which he was seen to soak his bread mechanically. There was no reason to suppose that he went to sleep at these seasons, or that he heard, or saw, or felt, or thought. He remained, as it were, frozen up—if any term expressive of such a vigorous process can be applied to him—until he was again thawed for the moment by a word or touch from Anthony.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Charity made tea by desire of Mr Jonas, and felt and looked so like the lady of the house that she was in the prettiest confusion imaginable; the more so from Mr Jonas sitting close beside her, and whispering a variety of admiring expressions in her ear. Miss Mercy, for her part, felt the entertainment of the evening to be so distinctly and exclusively theirs, that she silently deplored the commercial gentlemen—at that moment, no doubt, wearying for her return—and yawned over yesterday’s newspaper. As to Anthony, he went to sleep outright, so Jonas and Cherry had a clear stage to themselves as long as they chose to keep possession of it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_253"
    }
  }, [_vm._v("When the tea-tray was taken away, as it was at last, Mr Jonas produced a dirty pack of cards, and entertained the sisters with divers small feats of dexterity: whereof the main purpose of every one was, that you were to decoy somebody into laying a wager with you that you couldn’t do it; and were then ")]), _c('a', {
    attrs: {
      "id": "page_254"
    }
  }, [_vm._v("immediately to win and pocket his money. Mr Jonas informed them that these accomplishments were in high vogue in the most intellectual circles, and that large amounts were constantly changing hands on such hazards. And it may be remarked that he fully believed this; for there is a simplicity of cunning no less than a simplicity of innocence; and in all matters where a lively faith in knavery and meanness was required as the ground-work of belief, Mr Jonas was one of the most credulous of men. His ignorance, which was stupendous, may be taken into account, if the reader pleases, separately.")])]), _c('a', {
    attrs: {
      "id": "page_254"
    }
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20219m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This fine young man had all the inclination to be a profligate of the first water, and only lacked the one good trait in the common catalogue of debauched vices—open-handedness—to be a notable vagabond. But there his griping and penurious habits stepped in; and as one poison will sometimes neutralise another, when wholesome remedies would not avail, so he was restrained by a bad passion from quaffing his full measure of evil, when virtue might have sought to hold him back in vain.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_254"
    }
  }, [_vm._v("By the time he had unfolded all the peddling schemes he knew upon the cards, it was growing late in the evening; and Mr Pecksniff not making his appearance, the young ladies expressed a wish to return home. But this, Mr Jonas, in his gallantry, would by no means allow, until they had partaken of some bread and cheese and porter; and even then he was excessively unwilling to allow them to depart; often beseeching Miss Charity to come a little closer, or to stop a little longer, and preferring many other complimentary petitions of that nature in his own hospitable and earnest way. When all his efforts to detain them were fruitless, he put on his hat and greatcoat preparatory to escorting them to Todgers’s; remarking that he knew they would rather walk thither than ride; ")]), _c('a', {
    attrs: {
      "id": "page_255"
    }
  }, [_vm._v("and that for his part he was quite of their opinion.")])]), _c('a', {
    attrs: {
      "id": "page_255"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good night,’ said Anthony. ‘Good night; remember me to—ha, ha, ha!—to Pecksniff. Take care of your cousin, my dears; beware of Jonas; he’s a dangerous fellow. Don’t quarrel for him, in any case!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, the creature!’ cried Mercy. ‘The idea of quarrelling for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v("! You may take him, Cherry, my love, all to yourself. I make you a present of my share.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What! I’m a sour grape, am I, cousin?’ said Jonas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Charity was more entertained by this repartee than one would have supposed likely, considering its advanced age and simple character. But in her sisterly affection she took Mr Jonas to task for leaning so very hard upon a broken reed, and said that he must not be so cruel to poor Merry any more, or she (Charity) would positively be obliged to hate him. Mercy, who really had her share of good humour, only retorted with a laugh; and they walked home in consequence without any angry passages of words upon the way. Mr Jonas being in the middle, and having a cousin on each arm, sometimes squeezed the wrong one; so tightly too, as to cause her not a little inconvenience; but as he talked to Charity in whispers the whole time, and paid her great attention, no doubt this was an accidental circumstance. When they arrived at Todgers’s, and the door was opened, Mercy broke hastily from them, and ran upstairs; but Charity and Jonas lingered on the steps talking together for more than five minutes; so, as Mrs Todgers observed next morning, to a third party, ‘It was pretty clear what was going on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("there")]), _vm._v(", and she was glad of it, for it really was high time that Miss Pecksniff thought of settling.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_255"
    }
  }, [_vm._v("And now the day was coming on, when that bright vision which had burst on Todgers’s so suddenly, and made a sunshine in the shady breast of Jinkins, was to be seen no more; ")]), _c('a', {
    attrs: {
      "id": "page_256"
    }
  }, [_vm._v("when it was to be packed, like a brown paper parcel, or a fish-basket, or an oyster barrel or a fat gentleman, or any other dull reality of life, in a stagecoach and carried down into the country.")])]), _c('a', {
    attrs: {
      "id": "page_256"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Never, my dear Miss Pecksniffs,’ said Mrs Todgers, when they retired to rest on the last night of their stay, ‘never have I seen an establishment so perfectly broken-hearted as mine is at this present moment of time. I don’t believe the gentlemen will be the gentlemen they were, or anything like it—no, not for weeks to come. You have a great deal to answer for, both of you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They modestly disclaimed any wilful agency in this disastrous state of things, and regretted it very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Your pious pa, too,’ said Mrs Todgers. ‘There’s a loss! My dear Miss Pecksniffs, your pa is a perfect missionary of peace and love.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Entertaining an uncertainty as to the particular kind of love supposed to be comprised in Mr Pecksniff’s mission, the young ladies received the compliment rather coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I dared,’ said Mrs Todgers, perceiving this, ‘to violate a confidence which has been reposed in me, and to tell you why I must beg of you to leave the little door between your room and mine open tonight, I think you would be interested. But I mustn’t do it, for I promised Mr Jinkins faithfully, that I would be as silent as the tomb.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear Mrs Todgers! What can you mean?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_256"
    }
  }, [_vm._v("‘Why, then, my sweet Miss Pecksniffs,’ said the lady of the house; ‘my own loves, if you will allow me the privilege of taking that freedom on the eve of our separation, Mr Jinkins and the gentlemen have made up a little musical party among themselves, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" intend, in the dead of this night, to perform a serenade upon the stairs outside the door. I could have ")]), _c('a', {
    attrs: {
      "id": "page_257"
    }
  }, [_vm._v("wished, I own,’ said Mrs Todgers, with her usual foresight, ‘that it had been fixed to take place an hour or two earlier; because when gentlemen sit up late they drink, and when they drink they’re not so musical, perhaps, as when they don’t. But this is the arrangement; and I know you will be gratified, my dear Miss Pecksniffs, by such a mark of their attention.’")])]), _c('a', {
    attrs: {
      "id": "page_257"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The young ladies were at first so much excited by the news, that they vowed they couldn’t think of going to bed until the serenade was over. But half an hour of cool waiting so altered their opinion that they not only went to bed, but fell asleep; and were, moreover, not ecstatically charmed to be awakened some time afterwards by certain dulcet strains breaking in upon the silent watches of the night.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_257"
    }
  }, [_vm._v("It was very affecting—very. Nothing more dismal could have been desired by the most fastidious taste. The gentleman of a vocal turn was head mute, or chief mourner; Jinkins took the bass; and the rest took anything they could get. The youngest gentleman blew his melancholy into a flute. He didn’t blow much out of it, but that was all the better. If the two Miss Pecksniffs and Mrs Todgers had perished by spontaneous combustion, and the serenade had been in honour of their ashes, it would have been impossible to surpass the unutterable despair expressed in that one chorus, ‘Go where glory waits thee!’ It was a requiem, a dirge, a moan, a howl, a wail, a lament, an abstract of everything that is sorrowful and hideous in sound. The flute of the youngest gentleman was wild and fitful. It came and went in gusts, like the wind. For a long time together he seemed to have left off, and when it was quite settled by Mrs Todgers and the young ladies that, overcome by his feelings, he had retired in tears, he unexpectedly turned up again at the very top of the tune, gasping for breath. He was a tremendous performer. There was no knowing ")]), _c('a', {
    attrs: {
      "id": "page_258"
    }
  }, [_vm._v("where to have him; and exactly when you thought he was doing nothing at all, then was he doing the very thing that ought to astonish you most.")])]), _c('a', {
    attrs: {
      "id": "page_258"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There were several of these concerted pieces; perhaps two or three too many, though that, as Mrs Todgers said, was a fault on the right side. But even then, even at that solemn moment, when the thrilling sounds may be presumed to have penetrated into the very depths of his nature, if he had any depths, Jinkins couldn’t leave the youngest gentleman alone. He asked him distinctly, before the second song began—as a personal favour too, mark the villain in that—not to play. Yes; he said so; not to play. The breathing of the youngest gentleman was heard through the key-hole of the door. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("didn’t")]), _vm._v(" play. What vent was a flute for the passions swelling up within his breast? A trombone would have been a world too mild.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The serenade approached its close. Its crowning interest was at hand. The gentleman of a literary turn had written a song on the departure of the ladies, and adapted it to an old tune. They all joined, except the youngest gentleman in company, who, for the reasons aforesaid, maintained a fearful silence. The song (which was of a classical nature) invoked the oracle of Apollo, and demanded to know what would become of Todgers’s when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("CHARITY")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("MERCY")]), _vm._v(" were banished from its walls. The oracle delivered no opinion particularly worth remembering, according to the not infrequent practice of oracles from the earliest ages down to the present time. In the absence of enlightenment on that subject, the strain deserted it, and went on to show that the Miss Pecksniffs were nearly related to Rule Britannia, and that if Great Britain hadn’t been an island, there could have been no Miss Pecksniffs. And being now on a nautical tack, it closed with this verse:")])]), _c('p', {
    staticClass: "poem1"
  }, [_c('a', {
    attrs: {
      "id": "page_258"
    }
  }), _c('a', {
    attrs: {
      "id": "page_259"
    }
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("All hail to the vessel of Pecksniff the sire")]), _vm._v("!")])]), _c('a', {
    attrs: {
      "id": "page_259"
    }
  }, [_c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And favouring breezes to fan;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("While Tritons flock round it, and proudly admire")])]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The architect, artist, and man!’")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("As they presented this beautiful picture to the imagination, the gentlemen gradually withdrew to bed to give the music the effect of distance; and so it died away, and Todgers’s was left to its repose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Bailey reserved his vocal offering until the morning, when he put his head into the room as the young ladies were kneeling before their trunks, packing up, and treated them to an imitation of the voice of a young dog in trying circumstances; when that animal is supposed by persons of a lively fancy, to relieve his feelings by calling for pen and ink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, young ladies,’ said the youth, ‘so you’re a-going home, are you, worse luck?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, Bailey, we’re going home,’ returned Mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘An’t you a-going to leave none of ‘em a lock of your hair?’ inquired the youth. ‘It’s real, an’t it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They laughed at this, and told him of course it was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, is it of course, though?’ said Bailey. ‘I know better than that. Hers an’t. Why, I see it hanging up once, on that nail by the winder. Besides, I have gone behind her at dinner-time and pulled it; and she never know’d. I say, young ladies, I’m a-going to leave. I an’t a-going to stand being called names by her, no longer.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Miss Mercy inquired what his plans for the future might be; in reply to whom Mr Bailey intimated that he thought of going either into top-boots, or into the army.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Into the army!’ cried the young ladies, with a laugh.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_259"
    }
  }, [_vm._v("‘Ah!’ said Bailey, ‘why not? There’s a many drummers in ")]), _c('a', {
    attrs: {
      "id": "page_260"
    }
  }, [_vm._v("the Tower. I’m acquainted with ‘em. Don’t their country set a valley on ‘em, mind you! Not at all!’")])]), _c('a', {
    attrs: {
      "id": "page_260"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’ll be shot, I see,’ observed Mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well!’ cried Mr Bailey, ‘wot if I am? There’s something gamey in it, young ladies, an’t there? I’d sooner be hit with a cannon-ball than a rolling-pin, and she’s always a-catching up something of that sort, and throwing it at me, when the gentlemans’ appetites is good. Wot,’ said Mr Bailey, stung by the recollection of his wrongs, ‘wot, if they "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("do")]), _vm._v(" consume the per-vishuns. It an’t "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my")]), _vm._v(" fault, is it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Surely no one says it is,’ said Mercy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Don’t they though?’ retorted the youth. ‘No. Yes. Ah! oh! No one mayn’t say it is! but some one knows it is. But I an’t a-going to have every rise in prices wisited on me. I an’t a-going to be killed because the markets is dear. I won’t stop. And therefore,’ added Mr Bailey, relenting into a smile, ‘wotever you mean to give me, you’d better give me all at once, becos if ever you come back agin, I shan’t be here; and as to the other boy, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" won’t deserve nothing, I know.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The young ladies, on behalf of Mr Pecksniff and themselves, acted on this thoughtful advice; and in consideration of their private friendship, presented Mr Bailey with a gratuity so liberal that he could hardly do enough to show his gratitude; which found but an imperfect vent, during the remainder of the day, in divers secret slaps upon his pocket, and other such facetious pantomime. Nor was it confined to these ebullitions; for besides crushing a bandbox, with a bonnet in it, he seriously damaged Mr Pecksniff’s luggage, by ardently hauling it down from the top of the house; and in short evinced, by every means in his power, a lively sense of the favours he had received from that gentleman and his family.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_260"
    }
  }, [_vm._v("Mr Pecksniff and Mr Jinkins came home to dinner arm-in-arm; ")]), _c('a', {
    attrs: {
      "id": "page_261"
    }
  }, [_vm._v("for the latter gentleman had made half-holiday on purpose; thus gaining an immense advantage over the youngest gentleman and the rest, whose time, as it perversely chanced, was all bespoke, until the evening. The bottle of wine was Mr Pecksniff’s treat, and they were very sociable indeed; though full of lamentations on the necessity of parting. While they were in the midst of their enjoyment, old Anthony and his son were announced; much to the surprise of Mr Pecksniff, and greatly to the discomfiture of Jinkins.")])]), _c('a', {
    attrs: {
      "id": "page_261"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come to say good-bye, you see,’ said Anthony, in a low voice, to Mr Pecksniff, as they took their seats apart at the table, while the rest conversed among themselves. ‘Where’s the use of a division between you and me? We are the two halves of a pair of scissors, when apart, Pecksniff; but together we are something. Eh?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Unanimity, my good sir,’ rejoined Mr Pecksniff, ‘is always delightful.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know about that,’ said the old man, ‘for there are some people I would rather differ from than agree with. But you know my opinion of you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff, still having ‘hypocrite’ in his mind, only replied by a motion of his head, which was something between an affirmative bow, and a negative shake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Complimentary,’ said Anthony. ‘Complimentary, upon my word. It was an involuntary tribute to your abilities, even at the time; and it was not a time to suggest compliments either. But we agreed in the coach, you know, that we quite understood each other.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, quite!’ assented Mr Pecksniff, in a manner which implied that he himself was misunderstood most cruelly, but would not complain.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_261"
    }
  }, [_vm._v("Anthony glanced at his son as he sat beside Miss Charity, ")]), _c('a', {
    attrs: {
      "id": "page_262"
    }
  }, [_vm._v("and then at Mr Pecksniff, and then at his son again, very many times. It happened that Mr Pecksniff’s glances took a similar direction; but when he became aware of it, he first cast down his eyes, and then closed them; as if he were determined that the old man should read nothing there.")])]), _c('a', {
    attrs: {
      "id": "page_262"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jonas is a shrewd lad,’ said the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He appears,’ rejoined Mr Pecksniff in his most candid manner, ‘to be very shrewd.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And careful,’ said the old man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And careful, I have no doubt,’ returned Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Look ye!’ said Anthony in his ear. ‘I think he is sweet upon you daughter.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tut, my good sir,’ said Mr Pecksniff, with his eyes still closed; ‘young people—young people—a kind of cousins, too—no more sweetness than is in that, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, there is very little sweetness in that, according to our experience,’ returned Anthony. ‘Isn’t there a trifle more here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Impossible to say,’ rejoined Mr Pecksniff. ‘Quite impossible! You surprise me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, I know that,’ said the old man, drily. ‘It may last; I mean the sweetness, not the surprise; and it may die off. Supposing it should last, perhaps (you having feathered your nest pretty well, and I having done the same), we might have a mutual interest in the matter.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff, smiling gently, was about to speak, but Anthony stopped him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_262"
    }
  }, [_vm._v("‘I know what you are going to say. It’s quite unnecessary. You have never thought of this for a moment; and in a point so nearly affecting the happiness of your dear child, you couldn’t, as a tender father, express an opinion; and so forth. Yes, quite right. And like you! But it seems to me, my dear Pecksniff,’ ")]), _c('a', {
    attrs: {
      "id": "page_263"
    }
  }, [_vm._v("added Anthony, laying his hand upon his sleeve, ‘that if you and I kept up the joke of pretending not to see this, one of us might possibly be placed in a position of disadvantage; and as I am very unwilling to be that party myself, you will excuse my taking the liberty of putting the matter beyond a doubt thus early; and having it distinctly understood, as it is now, that we do see it, and do know it. Thank you for your attention. We are now upon an equal footing; which is agreeable to us both, I am sure.’")])]), _c('a', {
    attrs: {
      "id": "page_263"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He rose as he spoke; and giving Mr Pecksniff a nod of intelligence, moved away from him to where the young people were sitting; leaving that good man somewhat puzzled and discomfited by such very plain dealing, and not quite free from a sense of having been foiled in the exercise of his familiar weapons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the night-coach had a punctual character, and it was time to join it at the office; which was so near at hand that they had already sent their luggage and arranged to walk. Thither the whole party repaired, therefore, after no more delay than sufficed for the equipment of the Miss Pecksniffs and Mrs Todgers. They found the coach already at its starting-place, and the horses in; there, too, were a large majority of the commercial gentlemen, including the youngest, who was visibly agitated, and in a state of deep mental dejection.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_263"
    }
  }, [_vm._v("Nothing could equal the distress of Mrs Todgers in parting from the young ladies, except the strong emotions with which she bade adieu to Mr Pecksniff. Never surely was a pocket-handkerchief taken in and out of a flat reticule so often as Mrs Todgers’s was, as she stood upon the pavement by the coach-door supported on either side by a commercial gentleman; and by the sight of the coach-lamps caught such brief snatches and glimpses of the good man’s face, as the constant interposition ")]), _c('a', {
    attrs: {
      "id": "page_264"
    }
  }, [_vm._v("of Mr Jinkins allowed. For Jinkins, to the last the youngest gentleman’s rock a-head in life, stood upon the coachstep talking to the ladies. Upon the other step was Mr Jonas, who maintained that position in right of his cousinship; whereas the youngest gentleman, who had been first upon the ground, was deep in the booking-office among the black and red placards, and the portraits of fast coaches, where he was ignominiously harassed by porters, and had to contend and strive perpetually with heavy baggage. This false position, combined with his nervous excitement, brought about the very consummation and catastrophe of his miseries; for when in the moment of parting he aimed a flower, a hothouse flower that had cost money, at the fair hand of Mercy, it reached, instead, the coachman on the box, who thanked him kindly, and stuck it in his buttonhole.")])]), _c('a', {
    attrs: {
      "id": "page_264"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were off now; and Todgers’s was alone again. The two young ladies, leaning back in their separate corners, resigned themselves to their own regretful thoughts. But Mr Pecksniff, dismissing all ephemeral considerations of social pleasure and enjoyment, concentrated his meditations on the one great virtuous purpose before him, of casting out that ingrate and deceiver, whose presence yet troubled his domestic hearth, and was a sacrilege upon the altars of his household gods.")])])])])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_265"
    }
  }, [_vm._v("Chapter Twelve")])]), _c('a', {
    attrs: {
      "id": "page_265"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Will be Seen in the Long Run, if Not in the Short One, to Concern Mr Pinch and Others, Nearly. Mr Pecksniff Asserts the Dignity of Outraged Virtue. Young Martin Chuzzlewit Forms a Desperate Resolution")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mr Pinch and Martin, little dreaming of the stormy weather that impended, made themselves very comfortable in the Pecksniffian halls, and improved their friendship daily. Martin’s facility, both of invention and execution, being remarkable, the grammar-school proceeded with great vigour; and Tom repeatedly declared, that if there were anything like certainty in human affairs, or impartiality in human judges, a design so new and full of merit could not fail to carry off the first prize when the time of competition arrived. Without being quite so sanguine himself, Martin had his hopeful anticipations too; and they served to make him brisk and eager at his task.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_265"
    }
  }, [_vm._v("‘If I should turn out a great architect, Tom,’ said the new pupil one day, as he stood at a little distance from his drawing, and eyed it with much complacency, ‘I’ll tell you what should ")]), _c('a', {
    attrs: {
      "id": "page_266"
    }
  }, [_vm._v("be one of the things I’d build.’")])]), _c('a', {
    attrs: {
      "id": "page_266"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye!’ cried Tom. ‘What?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, your fortune.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No!’ said Tom Pinch, quite as much delighted as if the thing were done. ‘Would you though? How kind of you to say so.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’d build it up, Tom,’ returned Martin, ‘on such a strong foundation, that it should last your life—aye, and your children’s lives too, and their children’s after them. I’d be your patron, Tom. I’d take you under my protection. Let me see the man who should give the cold shoulder to anybody I chose to protect and patronise, if I were at the top of the tree, Tom!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, I don’t think,’ said Mr Pinch, ‘upon my word, that I was ever more gratified than by this. I really don’t.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! I mean what I say,’ retorted Martin, with a manner as free and easy in its condescension to, not to say in its compassion for, the other, as if he were already First Architect in ordinary to all the Crowned Heads in Europe. ‘I’d do it. I’d provide for you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am afraid,’ said Tom, shaking his head, ‘that I should be a mighty awkward person to provide for.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pooh, pooh!’ rejoined Martin. ‘Never mind that. If I took it in my head to say, “Pinch is a clever fellow; I approve of Pinch;” I should like to know the man who would venture to put himself in opposition to me. Besides, confound it, Tom, you could be useful to me in a hundred ways.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I were not useful in one or two, it shouldn’t be for want of trying,’ said Tom.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_266"
    }
  }, [_vm._v("‘For instance,’ pursued Martin, after a short reflection, ‘you’d be a capital fellow, now, to see that my ideas were properly carried out; and to overlook the works in their progress before they were sufficiently advanced to be very interesting ")]), _c('a', {
    attrs: {
      "id": "page_267"
    }
  }, [_vm._v("to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v("; and to take all that sort of plain sailing. Then you’d be a splendid fellow to show people over my studio, and to talk about Art to ‘em, when I couldn’t be bored myself, and all that kind of thing. For it would be devilish creditable, Tom (I’m quite in earnest, I give you my word), to have a man of your information about one, instead of some ordinary blockhead. Oh, I’d take care of you. You’d be useful, rely upon it!’")])]), _c('a', {
    attrs: {
      "id": "page_267"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("To say that Tom had no idea of playing first fiddle in any social orchestra, but was always quite satisfied to be set down for the hundred and fiftieth violin in the band, or thereabouts, is to express his modesty in very inadequate terms. He was much delighted, therefore, by these observations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should be married to her then, Tom, of course,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What was that which checked Tom Pinch so suddenly, in the high flow of his gladness; bringing the blood into his honest cheeks, and a remorseful feeling to his honest heart, as if he were unworthy of his friend’s regard?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should be married to her then,’ said Martin, looking with a smile towards the light; ‘and we should have, I hope, children about us. They’d be very fond of you, Tom.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But not a word said Mr Pinch. The words he would have uttered died upon his lips, and found a life more spiritual in self-denying thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All the children hereabouts are fond of you, Tom, and mine would be, of course,’ pursued Martin. ‘Perhaps I might name one of ‘em after you. Tom, eh? Well, I don’t know. Tom’s not a bad name. Thomas Pinch Chuzzlewit. T. P. C. on his pinafores—no objection to that, I should say?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom cleared his throat, and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("She")]), _vm._v(" would like you, Tom, I know,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye!’ cried Tom Pinch, faintly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_267"
    }
  }), _c('a', {
    attrs: {
      "id": "page_268"
    }
  }, [_vm._v("‘I can tell exactly what she would think of you,’ said Martin leaning his chin upon his hand, and looking through the window-glass as if he read there what he said; ‘I know her so well. She would smile, Tom, often at first when you spoke to her, or when she looked at you—merrily too—but you wouldn’t mind that. A brighter smile you never saw.’")])]), _c('a', {
    attrs: {
      "id": "page_268"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ said Tom. ‘I wouldn’t mind that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She would be as tender with you, Tom,’ said Martin, ‘as if you were a child yourself. So you are almost, in some things, an’t you, Tom?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch nodded his entire assent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She would always be kind and good-humoured, and glad to see you,’ said Martin; ‘and when she found out exactly what sort of fellow you were (which she’d do very soon), she would pretend to give you little commissions to execute, and to ask little services of you, which she knew you were burning to render; so that when she really pleased you most, she would try to make you think you most pleased her. She would take to you uncommonly, Tom; and would understand you far more delicately than I ever shall; and would often say, I know, that you were a harmless, gentle, well-intentioned, good fellow.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How silent Tom Pinch was!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In honour of old time,’ said Martin, ‘and of her having heard you play the organ in this damp little church down here—for nothing too—we will have one in the house. I shall build an architectural music-room on a plan of my own, and it’ll look rather knowing in a recess at one end. There you shall play away, Tom, till you tire yourself; and, as you like to do so in the dark, it shall "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("be")]), _vm._v(" dark; and many’s the summer evening she and I will sit and listen to you, Tom; be sure of that!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_268"
    }
  }, [_vm._v("It may have required a stronger effort on Tom Pinch’s part ")]), _c('a', {
    attrs: {
      "id": "page_269"
    }
  }, [_vm._v("to leave the seat on which he sat, and shake his friend by both hands, with nothing but serenity and grateful feeling painted on his face; it may have required a stronger effort to perform this simple act with a pure heart, than to achieve many and many a deed to which the doubtful trumpet blown by Fame has lustily resounded. Doubtful, because from its long hovering over scenes of violence, the smoke and steam of death have clogged the keys of that brave instrument; and it is not always that its notes are either true or tuneful.")])]), _c('a', {
    attrs: {
      "id": "page_269"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’s a proof of the kindness of human nature,’ said Tom, characteristically putting himself quite out of sight in the matter, ‘that everybody who comes here, as you have done, is more considerate and affectionate to me than I should have any right to hope, if I were the most sanguine creature in the world; or should have any power to express, if I were the most eloquent. It really overpowers me. But trust me,’ said Tom, ‘that I am not ungrateful—that I never forget—and that if I can ever prove the truth of my words to you, I will.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s all right,’ observed Martin, leaning back in his chair with a hand in each pocket, and yawning drearily. ‘Very fine talking, Tom; but I’m at Pecksniff’s, I remember, and perhaps a mile or so out of the high-road to fortune just at this minute. So you’ve heard again this morning from what’s his name, eh?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Who may that be?’ asked Tom, seeming to enter a mild protest on behalf of the dignity of an absent person.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" know. What is it? Northkey.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Westlock,’ rejoined Tom, in rather a louder tone than usual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah! to be sure,’ said Martin, ‘Westlock. I knew it was something connected with a point of the compass and a door. Well! and what says Westlock?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_269"
    }
  }, [_vm._v("‘Oh! he has come into his property,’ answered Tom, nodding ")]), _c('a', {
    attrs: {
      "id": "page_270"
    }
  }, [_vm._v("his head, and smiling.")])]), _c('a', {
    attrs: {
      "id": "page_270"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s a lucky dog,’ said Martin. ‘I wish it were mine instead. Is that all the mystery you were to tell me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No,’ said Tom; ‘not all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What’s the rest?’ asked Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For the matter of that,’ said Tom, ‘it’s no mystery, and you won’t think much of it; but it’s very pleasant to me. John always used to say when he was here, “Mark my words, Pinch. When my father’s executors cash up”—he used strange expressions now and then, but that was his way.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Cash-up’s a very good expression,’ observed Martin, ‘when other people don’t apply it to you. Well!—What a slow fellow you are, Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, I am I know,’ said Tom; ‘but you’ll make me nervous if you tell me so. I’m afraid you have put me out a little now, for I forget what I was going to say.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘When John’s father’s executors cashed up,’ said Martin impatiently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh yes, to be sure,’ cried Tom; ‘yes. “Then,” says John, “I’ll give you a dinner, Pinch, and come down to Salisbury on purpose.” Now, when John wrote the other day—the morning Pecksniff left, you know—he said his business was on the point of being immediately settled, and as he was to receive his money directly, when could I meet him at Salisbury? I wrote and said, any day this week; and I told him besides, that there was a new pupil here, and what a fine fellow you were, and what friends we had become. Upon which John writes back this letter’—Tom produced it—‘fixes to-morrow; sends his compliments to you; and begs that we three may have the pleasure of dining together; not at the house where you and I were, either; but at the very first hotel in the town. Read what he says.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_270"
    }
  }), _c('a', {
    attrs: {
      "id": "page_271"
    }
  }, [_vm._v("‘Very well,’ said Martin, glancing over it with his customary coolness; ‘much obliged to him. I’m agreeable.’")])]), _c('a', {
    attrs: {
      "id": "page_271"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom could have wished him to be a little more astonished, a little more pleased, or in some form or other a little more interested in such a great event. But he was perfectly self-possessed; and falling into his favourite solace of whistling, took another turn at the grammar-school, as if nothing at all had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff’s horse being regarded in the light of a sacred animal, only to be driven by him, the chief priest of that temple, or by some person distinctly nominated for the time being to that high office by himself, the two young men agreed to walk to Salisbury; and so, when the time came, they set off on foot; which was, after all, a better mode of travelling than in the gig, as the weather was very cold and very dry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Better! A rare strong, hearty, healthy walk—four statute miles an hour—preferable to that rumbling, tumbling, jolting, shaking, scraping, creaking, villanous old gig? Why, the two things will not admit of comparison. It is an insult to the walk, to set them side by side. Where is an instance of a gig having ever circulated a man’s blood, unless when, putting him in danger of his neck, it awakened in his veins and in his ears, and all along his spine, a tingling heat, much more peculiar than agreeable? When did a gig ever sharpen anybody’s wits and energies, unless it was when the horse bolted, and, crashing madly down a steep hill with a stone wall at the bottom, his desperate circumstances suggested to the only gentleman left inside, some novel and unheard-of mode of dropping out behind? Better than the gig!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_271"
    }
  }, [_vm._v("The air was cold, Tom; so it was, there was no denying it; but would it have been more genial in the gig? The blacksmith’s fire burned very bright, and leaped up high, as though ")]), _c('a', {
    attrs: {
      "id": "page_272"
    }
  }, [_vm._v("it wanted men to warm; but would it have been less tempting, looked at from the clammy cushions of a gig? The wind blew keenly, nipping the features of the hardy wight who fought his way along; blinding him with his own hair if he had enough to it, and wintry dust if he hadn’t; stopping his breath as though he had been soused in a cold bath; tearing aside his wrappings-up, and whistling in the very marrow of his bones; but it would have done all this a hundred times more fiercely to a man in a gig, wouldn’t it? A fig for gigs!")])]), _c('a', {
    attrs: {
      "id": "page_272"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Better than the gig! When were travellers by wheels and hoofs seen with such red-hot cheeks as those? when were they so good-humouredly and merrily bloused? when did their laughter ring upon the air, as they turned them round, what time the stronger gusts came sweeping up; and, facing round again as they passed by, dashed on, in such a glow of ruddy health as nothing could keep pace with, but the high spirits it engendered? Better than the gig! Why, here is a man in a gig coming the same way now. Look at him as he passes his whip into his left hand, chafes his numbed right fingers on his granite leg, and beats those marble toes of his upon the foot-board. Ha, ha, ha! Who would exchange this rapid hurry of the blood for yonder stagnant misery, though its pace were twenty miles for one?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_272"
    }
  }, [_vm._v("Better than the gig! No man in a gig could have such interest in the milestones. No man in a gig could see, or feel, or think, like merry users of their legs. How, as the wind sweeps on, upon these breezy downs, it tracks its flight in darkening ripples on the grass, and smoothest shadows on the hills! Look round and round upon this bare bleak plain, and see even here, upon a winter’s day, how beautiful the shadows are! Alas! it is the nature of their kind to be so. The loveliest things in life, Tom, are but shadows; and they come and go, ")]), _c('a', {
    attrs: {
      "id": "page_273"
    }
  }, [_vm._v("and change and fade away, as rapidly as these!")])]), _c('a', {
    attrs: {
      "id": "page_273"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Another mile, and then begins a fall of snow, making the crow, who skims away so close above the ground to shirk the wind, a blot of ink upon the landscape. But though it drives and drifts against them as they walk, stiffening on their skirts, and freezing in the lashes of their eyes, they wouldn’t have it fall more sparingly, no, not so much as by a single flake, although they had to go a score of miles. And, lo! the towers of the Old Cathedral rise before them, even now! and by-and-bye they come into the sheltered streets, made strangely silent by their white carpet; and so to the Inn for which they are bound; where they present such flushed and burning faces to the cold waiter, and are so brimful of vigour, that he almost feels assaulted by their presence; and, having nothing to oppose to the attack (being fresh, or rather stale, from the blazing fire in the coffee-room), is quite put out of his pale countenance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A famous Inn! the hall a very grove of dead game, and dangling joints of mutton; and in one corner an illustrious larder, with glass doors, developing cold fowls and noble joints, and tarts wherein the raspberry jam coyly withdrew itself, as such a precious creature should, behind a lattice work of pastry. And behold, on the first floor, at the court-end of the house, in a room with all the window-curtains drawn, a fire piled half-way up the chimney, plates warming before it, wax candles gleaming everywhere, and a table spread for three, with silver and glass enough for thirty—John Westlock; not the old John of Pecksniff’s, but a proper gentleman; looking another and a grander person, with the consciousness of being his own master and having money in the bank; and yet in some respects the old John too, for he seized Tom Pinch by both his hands the instant he appeared, and fairly hugged him, in his cordial welcome.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_273"
    }
  }), _c('a', {
    attrs: {
      "id": "page_274"
    }
  }, [_vm._v("‘And this,’ said John, ‘is Mr Chuzzlewit. I am very glad to see him!’—John had an off-hand manner of his own; so they shook hands warmly, and were friends in no time.")])]), _c('a', {
    attrs: {
      "id": "page_274"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stand off a moment, Tom,’ cried the old pupil, laying one hand on each of Mr Pinch’s shoulders, and holding him out at arm’s length. ‘Let me look at you! Just the same! Not a bit changed!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, it’s not so very long ago, you know,’ said Tom Pinch, ‘after all.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It seems an age to me,’ cried John, ‘and so it ought to seem to you, you dog.’ And then he pushed Tom down into the easiest chair, and clapped him on the back so heartily, and so like his old self in their old bedroom at old Pecksniff’s that it was a toss-up with Tom Pinch whether he should laugh or cry. Laughter won it; and they all three laughed together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have ordered everything for dinner, that we used to say we’d have, Tom,’ observed John Westlock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No!’ said Tom Pinch. ‘Have you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Everything. Don’t laugh, if you can help it, before the waiters. I couldn’t when I was ordering it. It’s like a dream.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John was wrong there, because nobody ever dreamed such soup as was put upon the table directly afterwards; or such fish; or such side-dishes; or such a top and bottom; or such a course of birds and sweets; or in short anything approaching the reality of that entertainment at ten-and-sixpence a head, exclusive of wines. As to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("them")]), _vm._v(", the man who can dream such iced champagne, such claret, port, or sherry, had better go to bed and stop there.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_274"
    }
  }, [_vm._v("But perhaps the finest feature of the banquet was, that nobody was half so much amazed by everything as John himself, who in his high delight was constantly bursting into fits of laughter, and then endeavouring to appear preternaturally ")]), _c('a', {
    attrs: {
      "id": "page_275"
    }
  }, [_vm._v("solemn, lest the waiters should conceive he wasn’t used to it. Some of the things they brought him to carve, were such outrageous practical jokes, though, that it was impossible to stand it; and when Tom Pinch insisted, in spite of the deferential advice of an attendant, not only on breaking down the outer wall of a raised pie with a tablespoon, but on trying to eat it afterwards, John lost all dignity, and sat behind the gorgeous dish-cover at the head of the table, roaring to that extent that he was audible in the kitchen. Nor had he the least objection to laugh at himself, as he demonstrated when they had all three gathered round the fire and the dessert was on the table; at which period the head waiter inquired with respectful solicitude whether that port, being a light and tawny wine, was suited to his taste, or whether he would wish to try a fruity port with greater body. To this John gravely answered that he was well satisfied with what he had, which he esteemed, as one might say, a pretty tidy vintage; for which the waiter thanked him and withdrew. And then John told his friends, with a broad grin, that he supposed it was all right, but he didn’t know; and went off into a perfect shout.")])]), _c('a', {
    attrs: {
      "id": "page_275"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were very merry and full of enjoyment the whole time, but not the least pleasant part of the festival was when they all three sat about the fire, cracking nuts, drinking wine and talking cheerfully. It happened that Tom Pinch had a word to say to his friend the organist’s assistant, and so deserted his warm corner for a few minutes at this season, lest it should grow too late; leaving the other two young men together.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_275"
    }
  }, [_vm._v("They drank his health in his absence, of course; and John Westlock took that opportunity of saying, that he had never had even a peevish word with Tom during the whole term of their residence in Mr Pecksniff’s house. This naturally led him to dwell upon Tom’s character, and to hint that Mr Pecksniff ")]), _c('a', {
    attrs: {
      "id": "page_276"
    }
  }, [_vm._v("understood it pretty well. He only hinted this, and very distantly; knowing that it pained Tom Pinch to have that gentleman disparaged, and thinking it would be as well to leave the new pupil to his own discoveries.")])]), _c('a', {
    attrs: {
      "id": "page_276"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Martin. ‘It’s impossible to like Pinch better than I do, or to do greater justice to his good qualities. He is the most willing fellow I ever saw.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s rather too willing,’ observed John, who was quick in observation. ‘It’s quite a fault in him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘So it is,’ said Martin. ‘Very true. There was a fellow only a week or so ago—a Mr Tigg—who borrowed all the money he had, on a promise to repay it in a few days. It was but half a sovereign, to be sure; but it’s well it was no more, for he’ll never see it again.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Poor fellow!’ said John, who had been very attentive to these few words. ‘Perhaps you have not had an opportunity of observing that, in his own pecuniary transactions, Tom’s proud.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t say so! No, I haven’t. What do you mean? Won’t he borrow?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Westlock shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s very odd,’ said Martin, setting down his empty glass. ‘He’s a strange compound, to be sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As to receiving money as a gift,’ resumed John Westlock; ‘I think he’d die first.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s made up of simplicity,’ said Martin. ‘Help yourself.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You, however,’ pursued John, filling his own glass, and looking at his companion with some curiosity, ‘who are older than the majority of Mr Pecksniff’s assistants, and have evidently had much more experience, understand him, I have no doubt, and see how liable he is to be imposed upon.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_276"
    }
  }, [_vm._v("‘Certainly,’ said Martin, stretching out his legs, and holding ")]), _c('a', {
    attrs: {
      "id": "page_277"
    }
  }, [_vm._v("his wine between his eye and the light. ‘Mr Pecksniff knows that too. So do his daughters. Eh?’")])]), _c('a', {
    attrs: {
      "id": "page_277"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("John Westlock smiled, but made no answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘By the bye,’ said Martin, ‘that reminds me. What’s your opinion of Pecksniff? How did he use you? What do you think of him now?—Coolly, you know, when it’s all over?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ask Pinch,’ returned the old pupil. ‘He knows what my sentiments used to be upon the subject. They are not changed, I assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ said Martin, ‘I’d rather have them from you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But Pinch says they are unjust,’ urged John with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh! well! Then I know what course they take beforehand,’ said Martin; ‘and, therefore, you can have no delicacy in speaking plainly. Don’t mind me, I beg. I don’t like him I tell you frankly. I am with him because it happens from particular circumstances to suit my convenience. I have some ability, I believe, in that way; and the obligation, if any, will most likely be on his side and not mine. At the lowest mark, the balance will be even, and there’ll be no obligation at all. So you may talk to me, as if I had no connection with him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you press me to give my opinion—’ returned John Westlock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, I do,’ said Martin. ‘You’ll oblige me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘—I should say,’ resumed the other, ‘that he is the most consummate scoundrel on the face of the earth.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ said Martin, as coolly as ever. ‘That’s rather strong.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_277"
    }
  }, [_vm._v("‘Not stronger than he deserves,’ said John; ‘and if he called upon me to express my opinion of him to his face, I would do so in the very same terms, without the least qualification. His treatment of Pinch is in itself enough to justify them; but when I look back upon the five years I passed in that house, and remember the hyprocrisy, the knavery, the meannesses, the ")]), _c('a', {
    attrs: {
      "id": "page_278"
    }
  }, [_vm._v("false pretences, the lip service of that fellow, and his trading in saintly semblances for the very worst realities; when I remember how often I was the witness of all this and how often I was made a kind of party to it, by the fact of being there, with him for my teacher; I swear to you that I almost despise myself.’")])]), _c('a', {
    attrs: {
      "id": "page_278"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin drained his glass, and looked at the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t mean to say that is a right feeling,’ pursued John Westlock ‘because it was no fault of mine; and I can quite understand—you for instance, fully appreciating him, and yet being forced by circumstances to remain there. I tell you simply what my feeling is; and even now, when, as you say, it’s all over; and when I have the satisfaction of knowing that he always hated me, and we always quarrelled, and I always told him my mind; even now, I feel sorry that I didn’t yield to an impulse I often had, as a boy, of running away from him and going abroad.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why abroad?’ asked Martin, turning his eyes upon the speaker.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In search,’ replied John Westlock, shrugging his shoulders, ‘of the livelihood I couldn’t have earned at home. There would have been something spirited in that. But, come! Fill your glass, and let us forget him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As soon as you please,’ said Martin. ‘In reference to myself and my connection with him, I have only to repeat what I said before. I have taken my own way with him so far, and shall continue to do so, even more than ever; for the fact is, to tell you the truth, that I believe he looks to me to supply his defects, and couldn’t afford to lose me. I had a notion of that in first going there. Your health!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ returned young Westlock. ‘Yours. And may the new pupil turn out as well as you can desire!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_278"
    }
  }), _c('a', {
    attrs: {
      "id": "page_279"
    }
  }, [_vm._v("‘What new pupil?’")])]), _c('a', {
    attrs: {
      "id": "page_279"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The fortunate youth, born under an auspicious star,’ returned John Westlock, laughing; ‘whose parents, or guardians, are destined to be hooked by the advertisement. What! Don’t you know that he has advertised again?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes. I read it just before dinner in the old newspaper. I know it to be his; having some reason to remember the style. Hush! Here’s Pinch. Strange, is it not, that the more he likes Pecksniff (if he can like him better than he does), the greater reason one has to like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him?")]), _vm._v(" Not a word more, or we shall spoil his whole enjoyment.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom entered as the words were spoken, with a radiant smile upon his face; and rubbing his hands, more from a sense of delight than because he was cold (for he had been running fast), sat down in his warm corner again, and was as happy as only Tom Pinch could be. There is no other simile that will express his state of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And so,’ he said, when he had gazed at his friend for some time in silent pleasure, ‘so you really are a gentleman at last, John. Well, to be sure!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Trying to be, Tom; trying to be,’ he rejoined good-humouredly. ‘There is no saying what I may turn out, in time.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I suppose you wouldn’t carry your own box to the mail now?’ said Tom Pinch, smiling; ‘although you lost it altogether by not taking it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wouldn’t I?’ retorted John. ‘That’s all you know about it, Pinch. It must be a very heavy box that I wouldn’t carry to get away from Pecksniff’s, Tom.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_279"
    }
  }, [_vm._v("‘There!’ cried Pinch, turning to Martin, ‘I told you so. The great fault in his character is his injustice to Pecksniff. You mustn’t mind a word he says on that subject. His prejudice is ")]), _c('a', {
    attrs: {
      "id": "page_280"
    }
  }, [_vm._v("most extraordinary.’")])]), _c('a', {
    attrs: {
      "id": "page_280"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The absence of anything like prejudice on Tom’s part, you know,’ said John Westlock, laughing heartily, as he laid his hand on Mr Pinch’s shoulder, ‘is perfectly wonderful. If one man ever had a profound knowledge of another, and saw him in a true light, and in his own proper colours, Tom has that knowledge of Mr Pecksniff.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, of course I have,’ cried Tom. ‘That’s exactly what I have so often said to you. If you knew him as well as I do—John, I’d give almost any money to bring that about—you’d admire, respect, and reverence him. You couldn’t help it. Oh, how you wounded his feelings when you went away!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I had known whereabout his feelings lay,’ retorted young Westlock, ‘I’d have done my best, Tom, with that end in view, you may depend upon it. But as I couldn’t wound him in what he has not, and in what he knows nothing of, except in his ability to probe them to the quick in other people, I am afraid I can lay no claim to your compliment.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch, being unwilling to protract a discussion which might possibly corrupt Martin, forbore to say anything in reply to this speech; but John Westlock, whom nothing short of an iron gag would have silenced when Mr Pecksniff’s merits were once in question, continued notwithstanding.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("His")]), _vm._v(" feelings! Oh, he’s a tender-hearted man. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("His")]), _vm._v(" feelings! Oh, he’s a considerate, conscientious, self-examining, moral vagabond, he is! "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("His")]), _vm._v(" feelings! Oh!—what’s the matter, Tom?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch was by this time erect upon the hearth-rug, buttoning his coat with great energy.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_280"
    }
  }, [_vm._v("‘I can’t bear it,’ said Tom, shaking his head. ‘No. I really cannot. You must excuse me, John. I have a great esteem and friendship for you; I love you very much; and have been perfectly charmed and overjoyed to-day, to find you just the same ")]), _c('a', {
    attrs: {
      "id": "page_281"
    }
  }, [_vm._v("as ever; but I cannot listen to this.’")])]), _c('a', {
    attrs: {
      "id": "page_281"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, it’s my old way, Tom; and you say yourself that you are glad to find me unchanged.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not in this respect,’ said Tom Pinch. ‘You must excuse me, John. I cannot, really; I will not. It’s very wrong; you should be more guarded in your expressions. It was bad enough when you and I used to be alone together, but under existing circumstances, I can’t endure it, really. No. I cannot, indeed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are quite right!’ exclaimed the other, exchanging looks with Martin. ‘and I am quite wrong, Tom, I don’t know how the deuce we fell on this unlucky theme. I beg your pardon with all my heart.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have a free and manly temper, I know,’ said Pinch; ‘and therefore, your being so ungenerous in this one solitary instance, only grieves me the more. It’s not my pardon you have to ask, John. You have done "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" nothing but kindnesses.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well! Pecksniff’s pardon then,’ said young Westlock. ‘Anything Tom, or anybody. Pecksniff’s pardon—will that do? Here! let us drink Pecksniff’s health!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thank you,’ cried Tom, shaking hands with him eagerly, and filling a bumper. ‘Thank you; I’ll drink it with all my heart, John. Mr Pecksniff’s health, and prosperity to him!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Westlock echoed the sentiment, or nearly so; for he drank Mr Pecksniff’s health, and Something to him—but what, was not quite audible. The general unanimity being then completely restored, they drew their chairs closer round the fire, and conversed in perfect harmony and enjoyment until bed-time.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_281"
    }
  }, [_vm._v("No slight circumstance, perhaps, could have better illustrated the difference of character between John Westlock and Martin Chuzzlewit, than the manner in which each of the young men contemplated Tom Pinch, after the little rupture ")]), _c('a', {
    attrs: {
      "id": "page_282"
    }
  }, [_vm._v("just described. There was a certain amount of jocularity in the looks of both, no doubt, but there all resemblance ceased. The old pupil could not do enough to show Tom how cordially he felt towards him, and his friendly regard seemed of a graver and more thoughtful kind than before. The new one, on the other hand, had no impulse but to laugh at the recollection of Tom’s extreme absurdity; and mingled with his amusement there was something slighting and contemptuous, indicative, as it appeared, of his opinion that Mr Pinch was much too far gone in simplicity to be admitted as the friend, on serious and equal terms, of any rational man.")])]), _c('a', {
    attrs: {
      "id": "page_282"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("John Westlock, who did nothing by halves, if he could help it, had provided beds for his two guests in the hotel; and after a very happy evening, they retired. Mr Pinch was sitting on the side of his bed with his cravat and shoes off, ruminating on the manifold good qualities of his old friend, when he was interrupted by a knock at his chamber door, and the voice of John himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re not asleep yet, are you, Tom?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Bless you, no! not I. I was thinking of you,’ replied Tom, opening the door. ‘Come in.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am not going to detail you,’ said John; ‘but I have forgotten all the evening a little commission I took upon myself; and I am afraid I may forget it again, if I fail to discharge it at once. You know a Mr Tigg, Tom, I believe?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tigg!’ cried Tom. ‘Tigg! The gentleman who borrowed some money of me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Exactly,’ said John Westlock. ‘He begged me to present his compliments, and to return it with many thanks. Here it is. I suppose it’s a good one, but he is rather a doubtful kind of customer, Tom.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_282"
    }
  }, [_vm._v("Mr Pinch received the little piece of gold with a face whose ")]), _c('a', {
    attrs: {
      "id": "page_283"
    }
  }, [_vm._v("brightness might have shamed the metal; and said he had no fear about that. He was glad, he added, to find Mr Tigg so prompt and honourable in his dealings; very glad.")])]), _c('a', {
    attrs: {
      "id": "page_283"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, to tell you the truth, Tom,’ replied his friend, ‘he is not always so. If you’ll take my advice, you’ll avoid him as much as you can, in the event of your encountering him again. And by no means, Tom—pray bear this in mind, for I am very serious—by no means lend him money any more.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye, aye!’ said Tom, with his eyes wide open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He is very far from being a reputable acquaintance,’ returned young Westlock; ‘and the more you let him know you think so, the better for you, Tom.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I say, John,’ quoth Mr Pinch, as his countenance fell, and he shook his head in a dejected manner. ‘I hope you are not getting into bad company.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ he replied laughing. ‘Don’t be uneasy on that score.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, but I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("am")]), _vm._v(" uneasy,’ said Tom Pinch; ‘I can’t help it, when I hear you talking in that way. If Mr Tigg is what you describe him to be, you have no business to know him, John. You may laugh, but I don’t consider it by any means a laughing matter, I assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ returned his friend, composing his features. ‘Quite right. It is not, certainly.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You know, John,’ said Mr Pinch, ‘your very good nature and kindness of heart make you thoughtless, and you can’t be too careful on such a point as this. Upon my word, if I thought you were falling among bad companions, I should be quite wretched, for I know how difficult you would find it to shake them off. I would much rather have lost this money, John, than I would have had it back again on such terms.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_283"
    }
  }, [_vm._v("‘I tell you, my dear good old fellow,’ cried his friend, shaking ")]), _c('a', {
    attrs: {
      "id": "page_284"
    }
  }, [_vm._v("him to and fro with both hands, and smiling at him with a cheerful, open countenance, that would have carried conviction to a mind much more suspicious than Tom’s; ‘I tell you there is no danger.’")])]), _c('a', {
    attrs: {
      "id": "page_284"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well!’ cried Tom, ‘I am glad to hear it; I am overjoyed to hear it. I am sure there is not, when you say so in that manner. You won’t take it ill, John, that I said what I did just now!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ill!’ said the other, giving his hand a hearty squeeze; ‘why what do you think I am made of? Mr Tigg and I are not on such an intimate footing that you need be at all uneasy, I give you my solemn assurance of that, Tom. You are quite comfortable now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Quite,’ said Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then once more, good night!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good night!’ cried Tom; ‘and such pleasant dreams to you as should attend the sleep of the best fellow in the world!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘—Except Pecksniff,’ said his friend, stopping at the door for a moment, and looking gayly back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Except Pecksniff,’ answered Tom, with great gravity; ‘of course.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And thus they parted for the night; John Westlock full of light-heartedness and good humour, and poor Tom Pinch quite satisfied; though still, as he turned over on his side in bed, he muttered to himself, ‘I really do wish, for all that, though, that he wasn’t acquainted with Mr Tigg.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_284"
    }
  }, [_vm._v("They breakfasted together very early next morning, for the two young men desired to get back again in good season; and John Westlock was to return to London by the coach that day. As he had some hours to spare, he bore them company for three or four miles on their walk, and only parted from them at last in sheer necessity. The parting was an unusually hearty one, not only as between him and Tom Pinch, but on the side ")]), _c('a', {
    attrs: {
      "id": "page_285"
    }
  }, [_vm._v("of Martin also, who had found in the old pupil a very different sort of person from the milksop he had prepared himself to expect.")])]), _c('a', {
    attrs: {
      "id": "page_285"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Young Westlock stopped upon a rising ground, when he had gone a little distance, and looked back. They were walking at a brisk pace, and Tom appeared to be talking earnestly. Martin had taken off his greatcoat, the wind being now behind them, and carried it upon his arm. As he looked, he saw Tom relieve him of it, after a faint resistance, and, throwing it upon his own, encumber himself with the weight of both. This trivial incident impressed the old pupil mightily, for he stood there, gazing after them, until they were hidden from his view; when he shook his head, as if he were troubled by some uneasy reflection, and thoughtfully retraced his steps to Salisbury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the meantime, Martin and Tom pursued their way, until they halted, safe and sound, at Mr Pecksniff’s house, where a brief epistle from that good gentleman to Mr Pinch announced the family’s return by that night’s coach. As it would pass the corner of the lane at about six o’clock in the morning, Mr Pecksniff requested that the gig might be in waiting at the finger-post about that time, together with a cart for the luggage. And to the end that he might be received with the greater honour, the young men agreed to rise early, and be upon the spot themselves.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_285"
    }
  }, [_vm._v("It was the least cheerful day they had yet passed together. Martin was out of spirits and out of humour, and took every opportunity of comparing his condition and prospects with those of young Westlock; much to his own disadvantage always. This mood of his depressed Tom; and neither that morning’s parting, nor yesterday’s dinner, helped to mend the matter. So the hours dragged on heavily enough; and they ")]), _c('a', {
    attrs: {
      "id": "page_286"
    }
  }, [_vm._v("were glad to go to bed early.")])]), _c('a', {
    attrs: {
      "id": "page_286"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They were not quite so glad to get up again at half-past four o’clock, in all the shivering discomfort of a dark winter’s morning; but they turned out punctually, and were at the finger-post full half-an-hour before the appointed time. It was not by any means a lively morning, for the sky was black and cloudy, and it rained hard; but Martin said there was some satisfaction in seeing that brute of a horse (by this, he meant Mr Pecksniff’s Arab steed) getting very wet; and that he rejoiced, on his account, that it rained so fast. From this it may be inferred that Martin’s spirits had not improved, as indeed they had not; for while he and Mr Pinch stood waiting under a hedge, looking at the rain, the gig, the cart, and its reeking driver, he did nothing but grumble; and, but that it is indispensable to any dispute that there should be two parties to it, he would certainly have picked a quarrel with Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At length the noise of wheels was faintly audible in the distance and presently the coach came splashing through the mud and mire with one miserable outside passenger crouching down among wet straw, under a saturated umbrella; and the coachman, guard, and horses, in a fellowship of dripping wretchedness. Immediately on its stopping, Mr Pecksniff let down the window-glass and hailed Tom Pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear me, Mr Pinch! Is it possible that you are out upon this very inclement morning?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, sir,’ cried Tom, advancing eagerly, ‘Mr Chuzzlewit and I, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ said Mr Pecksniff, looking not so much at Martin as at the spot on which he stood. ‘Oh! Indeed. Do me the favour to see to the trunks, if you please, Mr Pinch.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_286"
    }
  }, [_vm._v("Then Mr Pecksniff descended, and helped his daughters to alight; but neither he nor the young ladies took the slightest ")]), _c('a', {
    attrs: {
      "id": "page_287"
    }
  }, [_vm._v("notice of Martin, who had advanced to offer his assistance, but was repulsed by Mr Pecksniff’s standing immediately before his person, with his back towards him. In the same manner, and in profound silence, Mr Pecksniff handed his daughters into the gig; and following himself and taking the reins, drove off home.")])]), _c('a', {
    attrs: {
      "id": "page_287"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lost in astonishment, Martin stood staring at the coach, and when the coach had driven away, at Mr Pinch, and the luggage, until the cart moved off too; when he said to Tom:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now will you have the goodness to tell me what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" portends?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What?’ asked Tom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This fellow’s behaviour. Mr Pecksniff’s, I mean. You saw it?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No. Indeed I did not,’ cried Tom. ‘I was busy with the trunks.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It is no matter,’ said Martin. ‘Come! Let us make haste back!’ And without another word started off at such a pace, that Tom had some difficulty in keeping up with him.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_287"
    }
  }, [_vm._v("He had no care where he went, but walked through little heaps of mud and little pools of water with the utmost indifference; looking straight before him, and sometimes laughing in a strange manner within himself. Tom felt that anything he could say would only render him the more obstinate, and therefore trusted to Mr Pecksniff’s manner when they reached the house, to remove the mistaken impression under which he felt convinced so great a favourite as the new pupil must unquestionably be labouring. But he was not a little amazed himself, when they did reach it, and entered the parlour where Mr Pecksniff was sitting alone before the fire, drinking some hot tea, to find that instead of taking favourable notice of his relative and keeping him, Mr Pinch, in the background, ")]), _c('a', {
    attrs: {
      "id": "page_288"
    }
  }, [_vm._v("he did exactly the reverse, and was so lavish in his attentions to Tom, that Tom was thoroughly confounded.")])]), _c('a', {
    attrs: {
      "id": "page_288"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Take some tea, Mr Pinch—take some tea,’ said Pecksniff, stirring the fire. ‘You must be very cold and damp. Pray take some tea, and come into a warm place, Mr Pinch.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom saw that Martin looked at Mr Pecksniff as though he could have easily found it in his heart to give "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(" an invitation to a very warm place; but he was quite silent, and standing opposite that gentleman at the table, regarded him attentively.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Take a chair, Pinch,’ said Pecksniff. ‘Take a chair, if you please. How have things gone on in our absence, Mr Pinch?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You—you will be very much pleased with the grammar-school, sir,’ said Tom. ‘It’s nearly finished.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you will have the goodness, Mr Pinch,’ said Pecksniff, waving his hand and smiling, ‘we will not discuss anything connected with that question at present. What have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" been doing, Thomas, humph?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch looked from master to pupil, and from pupil to master, and was so perplexed and dismayed that he wanted presence of mind to answer the question. In this awkward interval, Mr Pecksniff (who was perfectly conscious of Martin’s gaze, though he had never once glanced towards him) poked the fire very much, and when he couldn’t do that any more, drank tea assiduously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, Mr Pecksniff,’ said Martin at last, in a very quiet voice, ‘if you have sufficiently refreshed and recovered yourself, I shall be glad to hear what you mean by this treatment of me.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And what,’ said Mr Pecksniff, turning his eyes on Tom Pinch, even more placidly and gently than before, ‘what have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" been doing, Thomas, humph?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_288"
    }
  }, [_vm._v("When he had repeated this inquiry, he looked round the ")]), _c('a', {
    attrs: {
      "id": "page_289"
    }
  }, [_vm._v("walls of the room as if he were curious to see whether any nails had been left there by accident in former times.")])]), _c('a', {
    attrs: {
      "id": "page_289"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom was almost at his wit’s end what to say between the two, and had already made a gesture as if he would call Mr Pecksniff’s attention to the gentleman who had last addressed him, when Martin saved him further trouble, by doing so himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Pecksniff,’ he said, softly rapping the table twice or thrice, and moving a step or two nearer, so that he could have touched him with his hand; ‘you heard what I said just now. Do me the favour to reply, if you please. I ask you’—he raised his voice a little here—‘what you mean by this?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I will talk to you, sir,’ said Mr Pecksniff in a severe voice, as he looked at him for the first time, ‘presently.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You are very obliging,’ returned Martin; ‘presently will not do. I must trouble you to talk to me at once.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pecksniff made a feint of being deeply interested in his pocketbook, but it shook in his hands; he trembled so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now,’ retorted Martin, rapping the table again. ‘Now. Presently will not do. Now!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you threaten me, sir?’ cried Mr Pecksniff.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin looked at him, and made no answer; but a curious observer might have detected an ominous twitching at his mouth, and perhaps an involuntary attraction of his right hand in the direction of Mr Pecksniff’s cravat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I lament to be obliged to say, sir,’ resumed Mr Pecksniff, ‘that it would be quite in keeping with your character if you did threaten me. You have deceived me. You have imposed upon a nature which you knew to be confiding and unsuspicious. You have obtained admission, sir,’ said Mr Pecksniff, rising, ‘to this house, on perverted statements and on false pretences.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_289"
    }
  }), _c('a', {
    attrs: {
      "id": "page_290"
    }
  }, [_vm._v("‘Go on,’ said Martin, with a scornful smile. ‘I understand you now. What more?’")])]), _c('a', {
    attrs: {
      "id": "page_290"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thus much more, sir,’ cried Mr Pecksniff, trembling from head to foot, and trying to rub his hands, as though he were only cold. ‘Thus much more, if you force me to publish your shame before a third party, which I was unwilling and indisposed to do. This lowly roof, sir, must not be contaminated by the presence of one who has deceived, and cruelly deceived, an honourable, beloved, venerated, and venerable gentleman; and who wisely suppressed that deceit from me when he sought my protection and favour, knowing that, humble as I am, I am an honest man, seeking to do my duty in this carnal universe, and setting my face against all vice and treachery. I weep for your depravity, sir,’ said Mr Pecksniff; ‘I mourn over your corruption, I pity your voluntary withdrawal of yourself from the flowery paths of purity and peace;’ here he struck himself upon his breast, or moral garden; ‘but I cannot have a leper and a serpent for an inmate. Go forth,’ said Mr Pecksniff, stretching out his hand: ‘go forth, young man! Like all who know you, I renounce you!’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20246m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With what intention Martin made a stride forward at these words, it is impossible to say. It is enough to know that Tom Pinch caught him in his arms, and that, at the same moment, Mr Pecksniff stepped back so hastily, that he missed his footing, tumbled over a chair, and fell in a sitting posture on the ground; where he remained without an effort to get up again, with his head in a corner, perhaps considering it the safest place.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_290"
    }
  }, [_vm._v("‘Let me go, Pinch!’ cried Martin, shaking him away. ‘Why do you hold me? Do you think a blow could make him a more abject creature than he is? Do you think that if I spat upon him, I could degrade him to a lower level than his own? Look ")]), _c('a', {
    attrs: {
      "id": "page_291"
    }
  }, [_vm._v("at him. Look at him, Pinch!’")])]), _c('a', {
    attrs: {
      "id": "page_291"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Pinch involuntarily did so. Mr Pecksniff sitting, as has been already mentioned, on the carpet, with his head in an acute angle of the wainscot, and all the damage and detriment of an uncomfortable journey about him, was not exactly a model of all that is prepossessing and dignified in man, certainly. Still he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" Pecksniff; it was impossible to deprive him of that unique and paramount appeal to Tom. And he returned Tom’s glance, as if he would have said, ‘Aye, Mr Pinch, look at me! Here I am! You know what the Poet says about an honest man; and an honest man is one of the few great works that can be seen for nothing! Look at me!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I tell you,’ said Martin, ‘that as he lies there, disgraced, bought, used; a cloth for dirty hands, a mat for dirty feet, a lying, fawning, servile hound, he is the very last and worst among the vermin of the world. And mark me, Pinch! The day will come—he knows it; see it written on his face, while I speak!—when even you will find him out, and will know him as I do, and as he knows I do. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" renounce "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v("! Cast your eyes on the Renouncer, Pinch, and be the wiser for the recollection!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He pointed at him as he spoke, with unutterable contempt, and flinging his hat upon his head, walked from the room and from the house. He went so rapidly that he was already clear of the village, when he heard Tom Pinch calling breathlessly after him in the distance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well! what now?’ he said, when Tom came up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dear, dear!’ cried Tom, ‘are you going?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Going!’ he echoed. ‘Going!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t so much mean that, as were you going now at once—in this bad weather—on foot—without your clothes—with no money?’ cried Tom.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_291"
    }
  }), _c('a', {
    attrs: {
      "id": "page_292"
    }
  }, [_vm._v("‘Yes,’ he answered sternly, ‘I am.’")])]), _c('a', {
    attrs: {
      "id": "page_292"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And where?’ cried Tom. ‘Oh where will you go?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know,’ he said. ‘Yes, I do. I’ll go to America!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, no,’ cried Tom, in a kind of agony. ‘Don’t go there. Pray don’t. Think better of it. Don’t be so dreadfully regardless of yourself. Don’t go to America!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My mind is made up,’ he said. ‘Your friend was right. I’ll go to America. God bless you, Pinch!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Take this!’ cried Tom, pressing a book upon him in great agitation. ‘I must make haste back, and can’t say anything I would. Heaven be with you. Look at the leaf I have turned down. Good-bye, good-bye!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The simple fellow wrung him by the hand, with tears stealing down his cheeks; and they parted hurriedly upon their separate ways.")])])])])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_293"
    }
  }, [_vm._v("Chapter Thirteen")])]), _c('a', {
    attrs: {
      "id": "page_293"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("Showing what became of Martin and His Desparate Resolve, after He Left Mr Pecksniff’s house; What Persons He Encountered; What Anxieties He Suffered; And What News He Heard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Carrying Tom Pinch’s book quite unconsciously under his arm, and not even buttoning his coat as a protection against the heavy rain, Martin went doggedly forward at the same quick pace, until he had passed the finger-post, and was on the high road to London. He slackened very little in his speed even then, but he began to think, and look about him, and to disengage his senses from the coil of angry passions which hitherto had held them prisoner.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_293"
    }
  }, [_vm._v("It must be confessed that, at that moment, he had no very agreeable employment either for his moral or his physical perceptions. The day was dawning from a patch of watery light in the east, and sullen clouds came driving up before it, from which the rain descended in a thick, wet mist. It streamed from every twig and bramble in the hedge; made little gullies in the path; ran down a hundred channels in the road; and punched innumerable holes into the face of every pond ")]), _c('a', {
    attrs: {
      "id": "page_294"
    }
  }, [_vm._v("and gutter. It fell with an oozy, slushy sound among the grass; and made a muddy kennel of every furrow in the ploughed fields. No living creature was anywhere to be seen. The prospect could hardly have been more desolate if animated nature had been dissolved in water, and poured down upon the earth again in that form.")])]), _c('a', {
    attrs: {
      "id": "page_294"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The range of view within the solitary traveller was quite as cheerless as the scene without. Friendless and penniless; incensed to the last degree; deeply wounded in his pride and self-love; full of independent schemes, and perfectly destitute of any means of realizing them; his most vindictive enemy might have been satisfied with the extent of his troubles. To add to his other miseries, he was by this time sensible of being wet to the skin, and cold at his very heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this deplorable condition he remembered Mr Pinch’s book; more because it was rather troublesome to carry, than from any hope of being comforted by that parting gift. He looked at the dingy lettering on the back, and finding it to be an odd volume of the ‘Bachelor of Salamanca,’ in the French tongue, cursed Tom Pinch’s folly twenty times. He was on the point of throwing it away, in his ill-humour and vexation, when he bethought himself that Tom had referred him to a leaf, turned down; and opening it at that place, that he might have additional cause of complaint against him for supposing that any cold scrap of the Bachelor’s wisdom could cheer him in such circumstances, found!—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well, well! not much, but Tom’s all. The half-sovereign. He had wrapped it hastily in a piece of paper, and pinned it to the leaf. These words were scrawled in pencil on the inside: ‘I don’t want it indeed. I should not know what to do with it if I had it.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_294"
    }
  }, [_vm._v("There are some falsehoods, Tom, on which men mount, as ")]), _c('a', {
    attrs: {
      "id": "page_295"
    }
  }, [_vm._v("on bright wings, towards Heaven. There are some truths, cold bitter taunting truths, wherein your worldly scholars are very apt and punctual, which bind men down to earth with leaden chains. Who would not rather have to fan him, in his dying hour, the lightest feather of a falsehood such as thine, than all the quills that have been plucked from the sharp porcupine, reproachful truth, since time began!")])]), _c('a', {
    attrs: {
      "id": "page_295"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin felt keenly for himself, and he felt this good deed of Tom’s keenly. After a few minutes it had the effect of raising his spirits, and reminding him that he was not altogether destitute, as he had left a fair stock of clothes behind him, and wore a gold hunting-watch in his pocket. He found a curious gratification, too, in thinking what a winning fellow he must be to have made such an impression on Tom; and in reflecting how superior he was to Tom; and how much more likely to make his way in the world. Animated by these thoughts, and strengthened in his design of endeavouring to push his fortune in another country, he resolved to get to London as a rallying-point, in the best way he could; and to lose no time about it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_295"
    }
  }, [_vm._v("He was ten good miles from the village made illustrious by being the abiding-place of Mr Pecksniff, when he stopped to breakfast at a little roadside alehouse; and resting upon a high-backed settle before the fire, pulled off his coat, and hung it before the cheerful blaze to dry. It was a very different place from the last tavern in which he had regaled; boasting no greater extent of accommodation than the brick-floored kitchen yielded; but the mind so soon accommodates itself to the necessities of the body, that this poor waggoner’s house-of-call, which he would have despised yesterday, became now quite a choice hotel; while his dish of eggs and bacon, and his mug of beer, were not by any means the coarse fare he had ")]), _c('a', {
    attrs: {
      "id": "page_296"
    }
  }, [_vm._v("supposed, but fully bore out the inscription on the window-shutter, which proclaimed those viands to be ‘Good entertainment for Travellers.’")])]), _c('a', {
    attrs: {
      "id": "page_296"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He pushed away his empty plate; and with a second mug upon the hearth before him, looked thoughtfully at the fire until his eyes ached. Then he looked at the highly-coloured scripture pieces on the walls, in little black frames like common shaving-glasses, and saw how the Wise Men (with a strong family likeness among them) worshipped in a pink manger; and how the Prodigal Son came home in red rags to a purple father, and already feasted his imagination on a sea-green calf. Then he glanced through the window at the falling rain, coming down aslant upon the sign-post over against the house, and overflowing the horse-trough; and then he looked at the fire again, and seemed to descry a double distant London, retreating among the fragments of the burning wood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had repeated this process in just the same order, many times, as if it were a matter of necessity, when the sound of wheels called his attention to the window out of its regular turn; and there he beheld a kind of light van drawn by four horses, and laden, as well as he could see (for it was covered in), with corn and straw. The driver, who was alone, stopped at the door to water his team, and presently came stamping and shaking the wet off his hat and coat, into the room where Martin sat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a red-faced burly young fellow; smart in his way, and with a good-humoured countenance. As he advanced towards the fire he touched his shining forehead with the forefinger of his stiff leather glove, by way of salutation; and said (rather unnecessarily) that it was an uncommon wet day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very wet,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t know as ever I see a wetter.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_296"
    }
  }), _c('a', {
    attrs: {
      "id": "page_297"
    }
  }, [_vm._v("‘I never felt one,’ said Martin.")])]), _c('a', {
    attrs: {
      "id": "page_297"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver glanced at Martin’s soiled dress, and his damp shirt-sleeves, and his coat hung up to dry; and said, after a pause, as he warmed his hands:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You have been caught in it, sir?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ was the short reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Out riding, maybe?’ said the driver")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should have been, if I owned a horse; but I don’t,’ returned Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s bad,’ said the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And may be worse,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now the driver said ‘That’s bad,’ not so much because Martin didn’t own a horse, as because he said he didn’t with all the reckless desperation of his mood and circumstances, and so left a great deal to be inferred. Martin put his hands in his pockets and whistled when he had retorted on the driver; thus giving him to understand that he didn’t care a pin for Fortune; that he was above pretending to be her favourite when he was not; and that he snapped his fingers at her, the driver, and everybody else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver looked at him stealthily for a minute or so; and in the pauses of his warming whistled too. At length he asked, as he pointed his thumb towards the road.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Up or down?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Which "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" up?’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘London, of course,’ said the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Up then,’ said Martin. He tossed his head in a careless manner afterwards, as if he would have added, ‘Now you know all about it.’ put his hands deeper into his pockets; changed his tune, and whistled a little louder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m going up,’ observed the driver; ‘Hounslow, ten miles this side London.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_297"
    }
  }), _c('a', {
    attrs: {
      "id": "page_298"
    }
  }, [_vm._v("‘Are you?’ cried Martin, stopping short and looking at him.")])]), _c('a', {
    attrs: {
      "id": "page_298"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The driver sprinkled the fire with his wet hat until it hissed again and answered, ‘Aye, to be sure he was.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, then,’ said Martin, ‘I’ll be plain with you. You may suppose from my dress that I have money to spare. I have not. All I can afford for coach-hire is a crown, for I have but two. If you can take me for that, and my waistcoat, or this silk handkerchief, do. If you can’t, leave it alone.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Short and sweet,’ remarked the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You want more?’ said Martin. ‘Then I haven’t got more, and I can’t get it, so there’s an end of that.’ Whereupon he began to whistle again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I didn’t say I wanted more, did I?’ asked the driver, with something like indignation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You didn’t say my offer was enough,’ rejoined Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, how could I, when you wouldn’t let me? In regard to the waistcoat, I wouldn’t have a man’s waistcoat, much less a gentleman’s waistcoat, on my mind, for no consideration; but the silk handkerchief’s another thing; and if you was satisfied when we got to Hounslow, I shouldn’t object to that as a gift.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is it a bargain, then?’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, it is,’ returned the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then finish this beer,’ said Martin, handing him the mug, and pulling on his coat with great alacrity; ‘and let us be off as soon as you like.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In two minutes more he had paid his bill, which amounted to a shilling; was lying at full length on a truss of straw, high and dry at the top of the van, with the tilt a little open in front for the convenience of talking to his new friend; and was moving along in the right direction with a most satisfactory and encouraging briskness.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_298"
    }
  }, [_vm._v("The driver’s name, as he soon informed Martin, was William ")]), _c('a', {
    attrs: {
      "id": "page_299"
    }
  }, [_vm._v("Simmons, better known as Bill; and his spruce appearance was sufficiently explained by his connection with a large stage-coaching establishment at Hounslow, whither he was conveying his load from a farm belonging to the concern in Wiltshire. He was frequently up and down the road on such errands, he said, and to look after the sick and rest horses, of which animals he had much to relate that occupied a long time in the telling. He aspired to the dignity of the regular box, and expected an appointment on the first vacancy. He was musical besides, and had a little key-bugle in his pocket, on which, whenever the conversation flagged, he played the first part of a great many tunes, and regularly broke down in the second.")])]), _c('a', {
    attrs: {
      "id": "page_299"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah!’ said Bill, with a sigh, as he drew the back of his hand across his lips, and put this instrument in his pocket, after screwing off the mouth-piece to drain it; ‘Lummy Ned of the Light Salisbury, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" was the one for musical talents. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" a guard. What you may call a Guard’an Angel, was Ned.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Is he dead?’ asked Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Dead!’ replied the other, with a contemptuous emphasis. ‘Not he. You won’t catch Ned a-dying easy. No, no. He knows better than that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You spoke of him in the past tense,’ observed Martin, ‘so I supposed he was no more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He’s no more in England,’ said Bill, ‘if that’s what you mean. He went to the U-nited States.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Did he?’ asked Martin, with sudden interest. ‘When?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Five year ago, or then about,’ said Bill. ‘He had set up in the public line here, and couldn’t meet his engagements, so he cut off to Liverpool one day, without saying anything about it, and went and shipped himself for the U-nited States.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well?’ said Martin.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_299"
    }
  }, [_vm._v("‘Well! as he landed there without a penny to bless himself ")]), _c('a', {
    attrs: {
      "id": "page_300"
    }
  }, [_vm._v("with, of course they wos very glad to see him in the U-nited States.’")])]), _c('a', {
    attrs: {
      "id": "page_300"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do you mean?’ asked Martin, with some scorn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What do I mean?’ said Bill. ‘Why, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(". All men are alike in the U-nited States, an’t they? It makes no odds whether a man has a thousand pound, or nothing, there. Particular in New York, I’m told, where Ned landed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘New York, was it?’ asked Martin, thoughtfully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes,’ said Bill. ‘New York. I know that, because he sent word home that it brought Old York to his mind, quite vivid, in consequence of being so exactly unlike it in every respect. I don’t understand what particular business Ned turned his mind to, when he got there; but he wrote home that him and his friends was always a-singing, Ale Columbia, and blowing up the President, so I suppose it was something in the public line; or free-and-easy way again. Anyhow, he made his fortune.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No!’ cried Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, he did,’ said Bill. ‘I know that, because he lost it all the day after, in six-and-twenty banks as broke. He settled a lot of the notes on his father, when it was ascertained that they was really stopped and sent ‘em over with a dutiful letter. I know that, because they was shown down our yard for the old gentleman’s benefit, that he might treat himself with tobacco in the workus.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘He was a foolish fellow not to take care of his money when he had it,’ said Martin, indignantly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘There you’re right,’ said Bill, ‘especially as it was all in paper, and he might have took care of it so very easy, by folding it up in a small parcel.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_300"
    }
  }, [_vm._v("Martin said nothing in reply, but soon afterwards fell asleep, and remained so for an hour or more. When he awoke, ")]), _c('a', {
    attrs: {
      "id": "page_301"
    }
  }, [_vm._v("finding it had ceased to rain, he took his seat beside the driver, and asked him several questions; as how long had the fortunate guard of the Light Salisbury been in crossing the Atlantic; at what time of the year had he sailed; what was the name of the ship in which he made the voyage; how much had he paid for passage-money; did he suffer greatly from sea-sickness? and so forth. But on these points of detail his friend was possessed of little or no information; either answering obviously at random or acknowledging that he had never heard, or had forgotten; nor, although he returned to the charge very often, could he obtain any useful intelligence on these essential particulars.")])]), _c('a', {
    attrs: {
      "id": "page_301"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They jogged on all day, and stopped so often—now to refresh, now to change their team of horses, now to exchange or bring away a set of harness, now on one point of business, and now upon another, connected with the coaching on that line of road—that it was midnight when they reached Hounslow. A little short of the stables for which the van was bound, Martin got down, paid his crown, and forced his silk handkerchief upon his honest friend, notwithstanding the many protestations that he didn’t wish to deprive him of it, with which he tried to give the lie to his longing looks. That done, they parted company; and when the van had driven into its own yard and the gates were closed, Martin stood in the dark street, with a pretty strong sense of being shut out, alone, upon the dreary world, without the key of it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_301"
    }
  }, [_vm._v("But in this moment of despondency, and often afterwards, the recollection of Mr Pecksniff operated as a cordial to him; awakening in his breast an indignation that was very wholesome in nerving him to obstinate endurance. Under the influence of this fiery dram he started off for London without more ado. Arriving there in the middle of the night, and not knowing ")]), _c('a', {
    attrs: {
      "id": "page_302"
    }
  }, [_vm._v("where to find a tavern open, he was fain to stroll about the streets and market-places until morning.")])]), _c('a', {
    attrs: {
      "id": "page_302"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He found himself, about an hour before dawn, in the humbler regions of the Adelphi; and addressing himself to a man in a fur-cap, who was taking down the shutters of an obscure public-house, informed him that he was a stranger, and inquired if he could have a bed there. It happened by good luck that he could. Though none of the gaudiest, it was tolerably clean, and Martin felt very glad and grateful when he crept into it, for warmth, rest, and forgetfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was quite late in the afternoon when he awoke; and by the time he had washed and dressed, and broken his fast, it was growing dusk again. This was all the better, for it was now a matter of absolute necessity that he should part with his watch to some obliging pawn-broker. He would have waited until after dark for this purpose, though it had been the longest day in the year, and he had begun it without a breakfast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He passed more Golden Balls than all the jugglers in Europe have juggled with, in the course of their united performances, before he could determine in favour of any particular shop where those symbols were displayed. In the end he came back to one of the first he had seen, and entering by a side-door in a court, where the three balls, with the legend ‘Money Lent,’ were repeated in a ghastly transparency, passed into one of a series of little closets, or private boxes, erected for the accommodation of the more bashful and uninitiated customers. He bolted himself in; pulled out his watch; and laid it on the counter.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_302"
    }
  }, [_vm._v("‘Upon my life and soul!’ said a low voice in the next box to the shopman who was in treaty with him, ‘you must make it more; you must make it a trifle more, you must indeed! You ")]), _c('a', {
    attrs: {
      "id": "page_303"
    }
  }, [_vm._v("must dispense with one half-quarter of an ounce in weighing out your pound of flesh, my best of friends, and make it two-and-six.’")])]), _c('a', {
    attrs: {
      "id": "page_303"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin drew back involuntarily, for he knew the voice at once.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You’re always full of your chaff,’ said the shopman, rolling up the article (which looked like a shirt) quite as a matter of course, and nibbing his pen upon the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I shall never be full of my wheat,’ said Mr Tigg, ‘as long as I come here. Ha, ha! Not bad! Make it two-and-six, my dear friend, positively for this occasion only. Half-a-crown is a delightful coin. Two-and-six. Going at two-and-six! For the last time at two-and-six!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It’ll never be the last time till it’s quite worn out,’ rejoined the shopman. ‘It’s grown yellow in the service as it is.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Its master has grown yellow in the service, if you mean that, my friend,’ said Mr Tigg; ‘in the patriotic service of an ungrateful country. You are making it two-and-six, I think?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m making it,’ returned the shopman, ‘what it always has been—two shillings. Same name as usual, I suppose?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Still the same name,’ said Mr Tigg; ‘my claim to the dormant peerage not being yet established by the House of Lords.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The old address?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Not at all,’ said Mr Tigg; ‘I have removed my town establishment from thirty-eight, Mayfair, to number fifteen-hundred-and-forty-two, Park Lane.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Come, I’m not going to put down that, you know,’ said the shopman with a grin.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_303"
    }
  }, [_vm._v("‘You may put down what you please, my friend,’ quoth Mr Tigg. ‘The fact is still the same. The apartments for the under-butler and the fifth footman being of a most confounded low ")]), _c('a', {
    attrs: {
      "id": "page_304"
    }
  }, [_vm._v("and vulgar kind at thirty-eight, Mayfair, I have been compelled, in my regard for the feelings which do them so much honour, to take on lease for seven, fourteen, or twenty-one years, renewable at the option of the tenant, the elegant and commodious family mansion, number fifteen-hundred-and-forty-two Park Lane. Make it two-and-six, and come and see me!’")])]), _c('a', {
    attrs: {
      "id": "page_304"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The shopman was so highly entertained by this piece of humour that Mr Tigg himself could not repress some little show of exultation. It vented itself, in part, in a desire to see how the occupant of the next box received his pleasantry; to ascertain which he glanced round the partition, and immediately, by the gaslight, recognized Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I wish I may die,’ said Mr Tigg, stretching out his body so far that his head was as much in Martin’s little cell as Martin’s own head was, ‘but this is one of the most tremendous meetings in Ancient or Modern History! How are you? What is the news from the agricultural districts? How are our friends the P.’s? Ha, ha! David, pay particular attention to this gentleman immediately, as a friend of mine, I beg.’")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20255m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Here! Please to give me the most you can for this,’ said Martin, handing the watch to the shopman. ‘I want money sorely.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_304"
    }
  }, [_vm._v("‘He wants money, sorely!’ cried Mr Tigg with excessive sympathy. ‘David, will you have the goodness to do your very utmost for my friend, who wants money sorely. You will deal with my friend as if he were myself. A gold hunting-watch, David, engine-turned, capped and jewelled in four holes, escape movement, horizontal lever, and warranted to perform correctly, upon my personal reputation, who have observed it narrowly for many years, under the most trying circumstances’—here he winked at Martin, that he might understand this ")]), _c('a', {
    attrs: {
      "id": "page_305"
    }
  }, [_vm._v("recommendation would have an immense effect upon the shopman; ‘what do you say, David, to my friend? Be very particular to deserve my custom and recommendation, David.’")])]), _c('a', {
    attrs: {
      "id": "page_305"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I can lend you three pounds on this, if you like’ said the shopman to Martin, confidentially. ‘It is very old-fashioned. I couldn’t say more.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And devilish handsome, too,’ cried Mr Tigg. ‘Two-twelve-six for the watch, and seven-and-six for personal regard. I am gratified; it may be weakness, but I am. Three pounds will do. We take it. The name of my friend is Smivey: Chicken Smivey, of Holborn, twenty-six-and-a-half B: lodger.’ Here he winked at Martin again, to apprise him that all the forms and ceremonies prescribed by law were now complied with, and nothing remained but the receipt for the money.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In point of fact, this proved to be the case, for Martin, who had no resource but to take what was offered him, signified his acquiescence by a nod of his head, and presently came out with the cash in his pocket. He was joined in the entry by Mr Tigg, who warmly congratulated him, as he took his arm and accompanied him into the street, on the successful issue of the negotiation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘As for my part in the same,’ said Mr Tigg, ‘don’t mention it. Don’t compliment me, for I can’t bear it!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have no such intention, I assure you,’ retorted Martin, releasing his arm and stopping.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You oblige me very much’ said Mr Tigg. ‘Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now, sir,’ observed Martin, biting his lip, ‘this is a large town, and we can easily find different ways in it. If you will show me which is your way, I will take another.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr Tigg was about to speak, but Martin interposed:")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_305"
    }
  }, [_vm._v("‘I need scarcely tell you, after what you have just seen, that I have nothing to bestow upon your friend Mr Slyme. And it is ")]), _c('a', {
    attrs: {
      "id": "page_306"
    }
  }, [_vm._v("quite as unnecessary for me to tell you that I don’t desire the honour of your company.’")])]), _c('a', {
    attrs: {
      "id": "page_306"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Stop’ cried Mr Tigg, holding out his hand. ‘Hold! There is a most remarkably long-headed, flowing-bearded, and patriarchal proverb, which observes that it is the duty of a man to be just before he is generous. Be just now, and you can be generous presently. Do not confuse me with the man Slyme. Do not distinguish the man Slyme as a friend of mine, for he is no such thing. I have been compelled, sir, to abandon the party whom you call Slyme. I have no knowledge of the party whom you call Slyme. I am, sir,’ said Mr Tigg, striking himself upon the breast, ‘a premium tulip, of a very different growth and cultivation from the cabbage Slyme, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It matters very little to me,’ said Martin coolly, ‘whether you have set up as a vagabond on your own account, or are still trading on behalf of Mr Slyme. I wish to hold no correspondence with you. In the devil’s name, man’ said Martin, scarcely able, despite his vexation, to repress a smile as Mr Tigg stood leaning his back against the shutters of a shop window, adjusting his hair with great composure, ‘will you go one way or other?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You will allow me to remind you, sir,’ said Mr Tigg, with sudden dignity, ‘that you—not I—that you—I say emphatically, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v("—have reduced the proceedings of this evening to a cold and distant matter of business, when I was disposed to place them on a friendly footing. It being made a matter of business, sir, I beg to say that I expect a trifle (which I shall bestow in charity) as commission upon the pecuniary advance, in which I have rendered you my humble services. After the terms in which you have addressed me, sir,’ concluded Mr Tigg, ‘you will not insult me, if you please, by offering more than half-a-crown.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_306"
    }
  }), _c('a', {
    attrs: {
      "id": "page_307"
    }
  }, [_vm._v("Martin drew that piece of money from his pocket, and tossed it towards him. Mr Tigg caught it, looked at it to assure himself of its goodness, spun it in the air after the manner of a pieman, and buttoned it up. Finally, he raised his hat an inch or two from his head with a military air, and, after pausing a moment with deep gravity, as to decide in which direction he should go, and to what Earl or Marquis among his friends he should give the preference in his next call, stuck his hands in his skirt-pockets and swaggered round the corner. Martin took the directly opposite course; and so, to his great content, they parted company.")])]), _c('a', {
    attrs: {
      "id": "page_307"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It was with a bitter sense of humiliation that he cursed, again and again, the mischance of having encountered this man in the pawnbroker’s shop. The only comfort he had in the recollection was, Mr Tigg’s voluntary avowal of a separation between himself and Slyme, that would at least prevent his circumstances (so Martin argued) from being known to any member of his family, the bare possibility of which filled him with shame and wounded pride. Abstractedly there was greater reason, perhaps, for supposing any declaration of Mr Tigg’s to be false, than for attaching the least credence to it; but remembering the terms on which the intimacy between that gentleman and his bosom friend had subsisted, and the strong probability of Mr Tigg’s having established an independent business of his own on Mr Slyme’s connection, it had a reasonable appearance of probability; at all events, Martin hoped so; and that went a long way.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_307"
    }
  }, [_vm._v("His first step, now that he had a supply of ready money for his present necessities, was, to retain his bed at the public-house until further notice, and to write a formal note to Tom Pinch (for he knew Pecksniff would see it) requesting to have his clothes forwarded to London by coach, with a direction to ")]), _c('a', {
    attrs: {
      "id": "page_308"
    }
  }, [_vm._v("be left at the office until called for. These measures taken, he passed the interval before the box arrived—three days—in making inquiries relative to American vessels, at the offices of various shipping-agents in the city; and in lingering about the docks and wharves, with the faint hope of stumbling upon some engagement for the voyage, as clerk or supercargo, or custodian of something or somebody, which would enable him to procure a free passage. But finding, soon, that no such means of employment were likely to present themselves, and dreading the consequences of delay, he drew up a short advertisement, stating what he wanted, and inserted it in the leading newspapers. Pending the receipt of the twenty or thirty answers which he vaguely expected, he reduced his wardrobe to the narrowest limits consistent with decent respectability, and carried the overplus at different times to the pawnbroker’s shop, for conversion into money.")])]), _c('a', {
    attrs: {
      "id": "page_308"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_308"
    }
  }, [_vm._v("And it was strange, very strange, even to himself, to find how, by quick though almost imperceptible degrees, he lost his delicacy and self-respect, and gradually came to do that as a matter of course, without the least compunction, which but a few short days before had galled him to the quick. The first time he visited the pawnbroker’s, he felt on his way there as if every person whom he passed suspected whither he was going; and on his way back again, as if the whole human tide he stemmed, knew well where he had come from. When did he care to think of their discernment now! In his first wanderings up and down the weary streets, he counterfeited the walk of one who had an object in his view; but soon there came upon him the sauntering, slipshod gait of listless idleness, and the lounging at street-corners, and plucking and biting of stray bits of straw, and strolling up and down the same place, and looking into the same shop-windows, with a miserable indifference, ")]), _c('a', {
    attrs: {
      "id": "page_309"
    }
  }, [_vm._v("fifty times a day. At first, he came out from his lodging with an uneasy sense of being observed—even by those chance passers-by, on whom he had never looked before, and hundreds to one would never see again—issuing in the morning from a public-house; but now, in his comings-out and goings-in he did not mind to lounge about the door, or to stand sunning himself in careless thought beside the wooden stem, studded from head to heel with pegs, on which the beer-pots dangled like so many boughs upon a pewter-tree. And yet it took but five weeks to reach the lowest round of this tall ladder!")])]), _c('a', {
    attrs: {
      "id": "page_309"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, moralists, who treat of happiness and self-respect, innate in every sphere of life, and shedding light on every grain of dust in God’s highway, so smooth below your carriage-wheels, so rough beneath the tread of naked feet, bethink yourselves in looking on the swift descent of men who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("have")]), _vm._v(" lived in their own esteem, that there are scores of thousands breathing now, and breathing thick with painful toil, who in that high respect have never lived at all, nor had a chance of life! Go ye, who rest so placidly upon the sacred Bard who had been young, and when he strung his harp was old, and had never seen the righteous forsaken, or his seed begging their bread; go, Teachers of content and honest pride, into the mine, the mill, the forge, the squalid depths of deepest ignorance, and uttermost abyss of man’s neglect, and say can any hopeful plant spring up in air so foul that it extinguishes the soul’s bright torch as fast as it is kindled! And, oh! ye Pharisees of the nineteen hundredth year of Christian Knowledge, who soundingly appeal to human nature, see that it be human first. Take heed it has not been transformed, during your slumber and the sleep of generations, into the nature of the Beasts!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_309"
    }
  }), _c('a', {
    attrs: {
      "id": "page_310"
    }
  }, [_vm._v("Five weeks! Of all the twenty or thirty answers, not one had come. His money—even the additional stock he had raised from the disposal of his spare clothes (and that was not much, for clothes, though dear to buy, are cheap to pawn)—was fast diminishing. Yet what could he do? At times an agony came over him in which he darted forth again, though he was but newly home, and, returning to some place where he had been already twenty times, made some new attempt to gain his end, but always unsuccessfully. He was years and years too old for a cabin-boy, and years upon years too inexperienced to be accepted as a common seaman. His dress and manner, too, militated fatally against any such proposal as the latter; and yet he was reduced to making it; for even if he could have contemplated the being set down in America totally without money, he had not enough left now for a steerage passage and the poorest provisions upon the voyage.")])]), _c('a', {
    attrs: {
      "id": "page_310"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_310"
    }
  }, [_vm._v("It is an illustration of a very common tendency in the mind of man, that all this time he never once doubted, one may almost say the certainty of doing great things in the New World, if he could only get there. In proportion as he became more and more dejected by his present circumstances, and the means of gaining America receded from his grasp, the more he fretted himself with the conviction that that was the only place in which he could hope to achieve any high end, and worried his brain with the thought that men going there in the meanwhile might anticipate him in the attainment of those objects which were dearest to his heart. He often thought of John Westlock, and besides looking out for him on all occasions, actually walked about London for three days together for the express purpose of meeting with him. But although he failed in this; and although he would not have scrupled to borrow money of him; and although he believed that John would ")]), _c('a', {
    attrs: {
      "id": "page_311"
    }
  }, [_vm._v("have lent it; yet still he could not bring his mind to write to Pinch and inquire where he was to be found. For although, as we have seen, he was fond of Tom after his own fashion, he could not endure the thought (feeling so superior to Tom) of making him the stepping-stone to his fortune, or being anything to him but a patron; and his pride so revolted from the idea that it restrained him even now.")])]), _c('a', {
    attrs: {
      "id": "page_311"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It might have yielded, however; and no doubt must have yielded soon, but for a very strange and unlooked-for occurrence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The five weeks had quite run out, and he was in a truly desperate plight, when one evening, having just returned to his lodging, and being in the act of lighting his candle at the gas jet in the bar before stalking moodily upstairs to his own room, his landlord called him by his name. Now as he had never told it to the man, but had scrupulously kept it to himself, he was not a little startled by this; and so plainly showed his agitation that the landlord, to reassure him, said ‘it was only a letter.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A letter!’ cried Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘For Mr Martin Chuzzlewit,’ said the landlord, reading the superscription of one he held in his hand. ‘Noon. Chief office. Paid.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin took it from him, thanked him, and walked upstairs. It was not sealed, but pasted close; the handwriting was quite unknown to him. He opened it and found enclosed, without any name, address, or other inscription or explanation of any kind whatever, a Bank of England note for Twenty Pounds.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_311"
    }
  }, [_vm._v("To say that he was perfectly stunned with astonishment and delight; that he looked again and again at the note and the wrapper; that he hurried below stairs to make quite certain that the note was a good note; and then hurried up again to ")]), _c('a', {
    attrs: {
      "id": "page_312"
    }
  }, [_vm._v("satisfy himself for the fiftieth time that he had not overlooked some scrap of writing on the wrapper; that he exhausted and bewildered himself with conjectures; and could make nothing of it but that there the note was, and he was suddenly enriched; would be only to relate so many matters of course to no purpose. The final upshot of the business at that time was, that he resolved to treat himself to a comfortable but frugal meal in his own chamber; and having ordered a fire to be kindled, went out to purchase it forthwith.")])]), _c('a', {
    attrs: {
      "id": "page_312"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He bought some cold beef, and ham, and French bread, and butter, and came back with his pockets pretty heavily laden. It was somewhat of a damping circumstance to find the room full of smoke, which was attributable to two causes; firstly, to the flue being naturally vicious and a smoker; and secondly, to their having forgotten, in lighting the fire, an odd sack or two and some trifles, which had been put up the chimney to keep the rain out. They had already remedied this oversight, however; and propped up the window-sash with a bundle of firewood to keep it open; so that except in being rather inflammatory to the eyes and choking to the lungs, the apartment was quite comfortable.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_312"
    }
  }, [_vm._v("Martin was in no vein to quarrel with it, if it had been in less tolerable order, especially when a gleaming pint of porter was set upon the table, and the servant-girl withdrew, bearing with her particular instructions relative to the production of something hot when he should ring the bell. The cold meat being wrapped in a playbill, Martin laid the cloth by spreading that document on the little round table with the print downwards, and arranging the collation upon it. The foot of the bed, which was very close to the fire, answered for a sideboard; and when he had completed these preparations, he squeezed an old arm-chair into the warmest corner, and sat down to ")]), _c('a', {
    attrs: {
      "id": "page_313"
    }
  }, [_vm._v("enjoy himself.")])]), _c('a', {
    attrs: {
      "id": "page_313"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He had begun to eat with great appetite, glancing round the room meanwhile with a triumphant anticipation of quitting it for ever on the morrow, when his attention was arrested by a stealthy footstep on the stairs, and presently by a knock at his chamber door, which, although it was a gentle knock enough, communicated such a start to the bundle of firewood, that it instantly leaped out of window, and plunged into the street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘More coals, I suppose,’ said Martin. ‘Come in!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘It an’t a liberty, sir, though it seems so,’ rejoined a man’s voice. ‘Your servant, sir. Hope you’re pretty well, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin stared at the face that was bowing in the doorway, perfectly remembering the features and expression, but quite forgetting to whom they belonged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tapley, sir,’ said his visitor. ‘Him as formerly lived at the Dragon, sir, and was forced to leave in consequence of a want of jollity, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘To be sure!’ cried Martin. ‘Why, how did you come here?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Right through the passage, and up the stairs, sir,’ said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How did you find me out, I mean?’ asked Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, sir,’ said Mark, ‘I’ve passed you once or twice in the street, if I’m not mistaken; and when I was a-looking in at the beef-and-ham shop just now, along with a hungry sweep, as was very much calculated to make a man jolly, sir—I see you a-buying that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin reddened as he pointed to the table, and said, somewhat hastily:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well! What then?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, then, sir,’ said Mark, ‘I made bold to foller; and as I told ‘em downstairs that you expected me, I was let up.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_313"
    }
  }), _c('a', {
    attrs: {
      "id": "page_314"
    }
  }, [_vm._v("‘Are you charged with any message, that you told them you were expected?’ inquired Martin.")])]), _c('a', {
    attrs: {
      "id": "page_314"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, sir, I an’t,’ said Mark. ‘That was what you may call a pious fraud, sir, that was.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin cast an angry look at him; but there was something in the fellow’s merry face, and in his manner—which with all its cheerfulness was far from being obtrusive or familiar—that quite disarmed him. He had lived a solitary life too, for many weeks, and the voice was pleasant in his ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tapley,’ he said, ‘I’ll deal openly with you. From all I can judge and from all I have heard of you through Pinch, you are not a likely kind of fellow to have been brought here by impertinent curiosity or any other offensive motive. Sit down. I’m glad to see you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thankee, sir,’ said Mark. ‘I’d as lieve stand.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you don’t sit down,’ retorted Martin, ‘I’ll not talk to you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good, sir,’ observed Mark. ‘Your will’s a law, sir. Down it is;’ and he sat down accordingly upon the bedstead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Help yourself,’ said Martin, handing him the only knife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Thankee, sir,’ rejoined Mark. ‘After you’ve done.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you don’t take it now, you’ll not have any,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good, sir,’ rejoined Mark. ‘That being your desire—now it is.’ With which reply he gravely helped himself and went on eating. Martin having done the like for a short time in silence, said abruptly:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What are you doing in London?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing at all, sir,’ rejoined Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How’s that?’ asked Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I want a place,’ said Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m sorry for you,’ said Martin.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_314"
    }
  }, [_vm._v("‘—To attend upon a single gentleman,’ resumed Mark. ‘If from the country the more desirable. Makeshifts would be ")]), _c('a', {
    attrs: {
      "id": "page_315"
    }
  }, [_vm._v("preferred. Wages no object.’")])]), _c('a', {
    attrs: {
      "id": "page_315"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He said this so pointedly, that Martin stopped in his eating, and said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you mean me—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, I do, sir,’ interposed Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then you may judge from my style of living here, of my means of keeping a man-servant. Besides, I am going to America immediately.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, sir,’ returned Mark, quite unmoved by this intelligence ‘from all that ever I heard about it, I should say America is a very likely sort of place for me to be jolly in!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again Martin looked at him angrily; and again his anger melted away in spite of himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Lord bless you, sir,’ said Mark, ‘what is the use of us a-going round and round, and hiding behind the corner, and dodging up and down, when we can come straight to the point in six words? I’ve had my eye upon you any time this fortnight. I see well enough there’s a screw loose in your affairs. I know’d well enough the first time I see you down at the Dragon that it must be so, sooner or later. Now, sir here am I, without a sitiwation; without any want of wages for a year to come; for I saved up (I didn’t mean to do it, but I couldn’t help it) at the Dragon—here am I with a liking for what’s wentersome, and a liking for you, and a wish to come out strong under circumstances as would keep other men down; and will you take me, or will you leave me?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘How can I take you?’ cried Martin.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_315"
    }
  }, [_vm._v("‘When I say take,’ rejoined Mark, ‘I mean will you let me go? and when I say will you let me go, I mean will you let me go along with you? for go I will, somehow or another. Now that you’ve said America, I see clear at once, that that’s the place for me to be jolly in. Therefore, if I don’t pay my own ")]), _c('a', {
    attrs: {
      "id": "page_316"
    }
  }, [_vm._v("passage in the ship you go in, sir, I’ll pay my own passage in another. And mark my words, if I go alone it shall be, to carry out the principle, in the rottenest, craziest, leakingest tub of a wessel that a place can be got in for love or money. So if I’m lost upon the way, sir, there’ll be a drowned man at your door—and always a-knocking double knocks at it, too, or never trust me!’")])]), _c('a', {
    attrs: {
      "id": "page_316"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘This is mere folly,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good, sir,’ returned Mark. ‘I’m glad to hear it, because if you don’t mean to let me go, you’ll be more comfortable, perhaps, on account of thinking so. Therefore I contradict no gentleman. But all I say is, that if I don’t emigrate to America in that case, in the beastliest old cockle-shell as goes out of port, I’m—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You don’t mean what you say, I’m sure,’ said Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes I do,’ cried Mark.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I tell you I know better,’ rejoined Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very good, sir,’ said Mark, with the same air of perfect satisfaction. ‘Let it stand that way at present, sir, and wait and see how it turns out. Why, love my heart alive! the only doubt I have is, whether there’s any credit in going with a gentleman like you, that’s as certain to make his way there as a gimlet is to go through soft deal.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was touching Martin on his weak point, and having him at a great advantage. He could not help thinking, either, what a brisk fellow this Mark was, and how great a change he had wrought in the atmosphere of the dismal little room already.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, certainly, Mark,’ he said, ‘I have hopes of doing well there, or I shouldn’t go. I may have the qualifications for doing well, perhaps.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_316"
    }
  }, [_vm._v("‘Of course you have, sir,’ returned Mark Tapley. ‘Everybody ")]), _c('a', {
    attrs: {
      "id": "page_317"
    }
  }, [_vm._v("knows that.’")])]), _c('a', {
    attrs: {
      "id": "page_317"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You see,’ said Martin, leaning his chin upon his hand, and looking at the fire, ‘ornamental architecture applied to domestic purposes, can hardly fail to be in great request in that country; for men are constantly changing their residences there, and moving further off; and it’s clear they must have houses to live in.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I should say, sir,’ observed Mark, ‘that that’s a state of things as opens one of the jolliest look-outs for domestic architecture that ever I heerd tell on.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin glanced at him hastily, not feeling quite free from a suspicion that this remark implied a doubt of the successful issue of his plans. But Mr Tapley was eating the boiled beef and bread with such entire good faith and singleness of purpose expressed in his visage that he could not but be satisfied. Another doubt arose in his mind however, as this one disappeared. He produced the blank cover in which the note had been enclosed, and fixing his eyes on Mark as he put it in his hands, said:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now tell me the truth. Do you know anything about that?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mark turned it over and over; held it near his eyes; held it away from him at arm’s length; held it with the superscription upwards and with the superscription downwards; and shook his head with such a genuine expression of astonishment at being asked the question, that Martin said, as he took it from him again:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, I see you don’t. How should you! Though, indeed, your knowing about it would not be more extraordinary than its being here. Come, Tapley,’ he added, after a moment’s thought, ‘I’ll trust you with my history, such as it is, and then you’ll see more clearly what sort of fortunes you would link yourself to, if you followed me.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_317"
    }
  }), _c('a', {
    attrs: {
      "id": "page_318"
    }
  }, [_vm._v("‘I beg your pardon, sir,’ said Mark; ‘but afore you enter upon it will you take me if I choose to go? Will you turn off me—Mark Tapley—formerly of the Blue Dragon, as can be well recommended by Mr Pinch, and as wants a gentleman of your strength of mind to look up to; or will you, in climbing the ladder as you’re certain to get to the top of, take me along with you at a respectful distance? Now, sir,’ said Mark, ‘it’s of very little importance to you, I know, there’s the difficulty; but it’s of very great importance to me, and will you be so good as to consider of it?’")])]), _c('a', {
    attrs: {
      "id": "page_318"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("If this were meant as a second appeal to Martin’s weak side, founded on his observation of the effect of the first, Mr Tapley was a skillful and shrewd observer. Whether an intentional or an accidental shot, it hit the mark fully for Martin, relenting more and more, said with a condescension which was inexpressibly delicious to him, after his recent humiliation:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘We’ll see about it, Tapley. You shall tell me in what disposition you find yourself to-morrow.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Then, sir,’ said Mark, rubbing his hands, ‘the job’s done. Go on, sir, if you please. I’m all attention.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_318"
    }
  }, [_vm._v("Throwing himself back in his arm-chair, and looking at the fire, with now and then a glance at Mark, who at such times nodded his head sagely, to express his profound interest and attention. Martin ran over the chief points in his history, to the same effect as he had related them, weeks before, to Mr Pinch. But he adapted them, according to the best of his judgment, to Mr Tapley’s comprehension; and with that view made as light of his love affair as he could, and referred to it in very few words. But here he reckoned without his host; for Mark’s interest was keenest in this part of the business, and prompted him to ask sundry questions in relation to it; for which he ")]), _c('a', {
    attrs: {
      "id": "page_319"
    }
  }, [_vm._v("apologised as one in some measure privileged to do so, from having seen (as Martin explained to him) the young lady at the Blue Dragon.")])]), _c('a', {
    attrs: {
      "id": "page_319"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And a young lady as any gentleman ought to feel more proud of being in love with,’ said Mark, energetically, ‘don’t draw breath.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Aye! You saw her when she was not happy,’ said Martin, gazing at the fire again. ‘If you had seen her in the old times, indeed—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, she certainly was a little down-hearted, sir, and something paler in her colour than I could have wished,’ said Mark, ‘but none the worse in her looks for that. I think she seemed better, sir, after she come to London.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin withdrew his eyes from the fire; stared at Mark as if he thought he had suddenly gone mad; and asked him what he meant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No offence intended, sir,’ urged Mark. ‘I don’t mean to say she was any the happier without you; but I thought she was a-looking better, sir.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you mean to tell me she has been in London?’ asked Martin, rising hurriedly, and pushing back his chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course I do,’ said Mark, rising too, in great amazement from the bedstead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do you mean to tell me she is in London now?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Most likely, sir. I mean to say she was a week ago.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And you know where?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes!’ cried Mark. ‘What! Don’t you?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My good fellow!’ exclaimed Martin, clutching him by both arms, ‘I have never seen her since I left my grandfather’s house.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_319"
    }
  }, [_vm._v("‘Why, then!’ cried Mark, giving the little table such a blow with his clenched fist that the slices of beef and ham danced ")]), _c('a', {
    attrs: {
      "id": "page_320"
    }
  }, [_vm._v("upon it, while all his features seemed, with delight, to be going up into his forehead, and never coming back again any more, ‘if I an’t your nat’ral born servant, hired by Fate, there an’t such a thing in natur’ as a Blue Dragon. What! when I was a-rambling up and down a old churchyard in the City, getting myself into a jolly state, didn’t I see your grandfather a-toddling to and fro for pretty nigh a mortal hour! Didn’t I watch him into Todgers’s commercial boarding-house, and watch him out, and watch him home to his hotel, and go and tell him as his was the service for my money, and I had said so, afore I left the Dragon! Wasn’t the young lady a-sitting with him then, and didn’t she fall a-laughing in a manner as was beautiful to see! Didn’t your grandfather say, “Come back again next week,” and didn’t I go next week; and didn’t he say that he couldn’t make up his mind to trust nobody no more; and therefore wouldn’t engage me, but at the same time stood something to drink as was handsome! Why,’ cried Mr Tapley, with a comical mixture of delight and chagrin, ‘where’s the credit of a man’s being jolly under such circumstances! Who could help it, when things come about like this!’")])]), _c('a', {
    attrs: {
      "id": "page_320"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For some moments Martin stood gazing at him, as if he really doubted the evidence of his senses, and could not believe that Mark stood there, in the body, before him. At length he asked him whether, if the young lady were still in London, he thought he could contrive to deliver a letter to her secretly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Do I think I can?’ cried Mark. ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Think")]), _vm._v(" I can? Here, sit down, sir. Write it out, sir!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With that he cleared the table by the summary process of tilting everything upon it into the fireplace; snatched some writing materials from the mantel-shelf; set Martin’s chair before them; forced him down into it; dipped a pen into the ink; and put it in his hand.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_320"
    }
  }), _c('a', {
    attrs: {
      "id": "page_321"
    }
  }, [_vm._v("‘Cut away, sir!’ cried Mark. ‘Make it strong, sir. Let it be wery pinted, sir. Do I think so? I should think so. Go to work, sir!’")])]), _c('a', {
    attrs: {
      "id": "page_321"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Martin required no further adjuration, but went to work at a great rate; while Mr Tapley, installing himself without any more formalities into the functions of his valet and general attendant, divested himself of his coat, and went on to clear the fireplace and arrange the room; talking to himself in a low voice the whole time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jolly sort of lodgings,’ said Mark, rubbing his nose with the knob at the end of the fire-shovel, and looking round the poor chamber; ‘that’s a comfort. The rain’s come through the roof too. That an’t bad. A lively old bedstead, I’ll be bound; popilated by lots of wampires, no doubt. Come! my spirits is a-getting up again. An uncommon ragged nightcap this. A very good sign. We shall do yet! Here, Jane, my dear,’ calling down the stairs, ‘bring up that there hot tumbler for my master as was a-mixing when I come in. That’s right, sir,’ to Martin. ‘Go at it as if you meant it, sir. Be very tender, sir, if you please. You can’t make it too strong, sir!’")])])])])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_c('a', {
    attrs: {
      "id": "page_322"
    }
  }, [_vm._v("Chapter Fourteen")])]), _c('a', {
    attrs: {
      "id": "page_322"
    }
  }, [_c('p', {
    staticClass: "ch-sub"
  }, [_vm._v("In which Martin Bids Adieu to the Lady of His Love; And Honours an Obscure Individual whose Fortune He Intends to make by Commending Her to His Protection")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The letter being duly signed, sealed, and delivered, was handed to Mark Tapley, for immediate conveyance if possible. And he succeeded so well in his embassy as to be enabled to return that same night, just as the house was closing, with the welcome intelligence that he had sent it upstairs to the young lady, enclosed in a small manuscript of his own, purporting to contain his further petition to be engaged in Mr Chuzzlewit’s service; and that she had herself come down and told him, in great haste and agitation, that she would meet the gentleman at eight o’clock to-morrow morning in St. James’s Park. It was then agreed between the new master and the new man, that Mark should be in waiting near the hotel in good time, to escort the young lady to the place of appointment; and when they had parted for the night with this understanding, Martin took up his pen again; and before he went to bed wrote another letter, whereof more will be seen presently.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_322"
    }
  }), _c('a', {
    attrs: {
      "id": "page_323"
    }
  }, [_vm._v("He was up before daybreak, and came upon the Park with the morning, which was clad in the least engaging of the three hundred and sixty-five dresses in the wardrobe of the year. It was raw, damp, dark, and dismal; the clouds were as muddy as the ground; and the short perspective of every street and avenue was closed up by the mist as by a filthy curtain.")])]), _c('a', {
    attrs: {
      "id": "page_323"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fine weather indeed,’ Martin bitterly soliloquised, ‘to be wandering up and down here in, like a thief! Fine weather indeed, for a meeting of lovers in the open air, and in a public walk! I need be departing, with all speed, for another country; for I have come to a pretty pass in this!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He might perhaps have gone on to reflect that of all mornings in the year, it was not the best calculated for a young lady’s coming forth on such an errand, either. But he was stopped on the road to this reflection, if his thoughts tended that way, by her appearance at a short distance, on which he hurried forward to meet her. Her squire, Mr Tapley, at the same time fell discreetly back, and surveyed the fog above him with an appearance of attentive interest.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "Book1/images/20270m.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear Martin,’ said Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘My dear Mary,’ said Martin; and lovers are such a singular kind of people that this is all they did say just then, though Martin took her arm, and her hand too, and they paced up and down a short walk that was least exposed to observation, half-a-dozen times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If you have changed at all, my love, since we parted,’ said Martin at length, as he looked upon her with a proud delight, ‘it is only to be more beautiful than ever!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_323"
    }
  }, [_vm._v("Had she been of the common metal of love-worn young ladies, she would have denied this in her most interesting manner; and would have told him that she knew she had become a perfect fright; or that she had wasted away with weeping and ")]), _c('a', {
    attrs: {
      "id": "page_324"
    }
  }, [_vm._v("anxiety; or that she was dwindling gently into an early grave; or that her mental sufferings were unspeakable; or would, either by tears or words, or a mixture of both, have furnished him with some other information to that effect, and made him as miserable as possible. But she had been reared up in a sterner school than the minds of most young girls are formed in; she had had her nature strengthened by the hands of hard endurance and necessity; had come out from her young trials constant, self-denying, earnest, and devoted; had acquired in her maidenhood—whether happily in the end, for herself or him, is foreign to our present purpose to inquire—something of that nobler quality of gentle hearts which is developed often by the sorrows and struggles of matronly years, but often by their lessons only. Unspoiled, unpampered in her joys or griefs; with frank and full, and deep affection for the object of her early love; she saw in him one who for her sake was an outcast from his home and fortune, and she had no more idea of bestowing that love upon him in other than cheerful and sustaining words, full of high hope and grateful trustfulness, than she had of being unworthy of it, in her lightest thought or deed, for any base temptation that the world could offer.")])]), _c('a', {
    attrs: {
      "id": "page_324"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘What change is there in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(", Martin,’ she replied; ‘for that concerns me nearest? You look more anxious and more thoughtful than you used.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Why, as to that, my love,’ said Martin as he drew her waist within his arm, first looking round to see that there were no observers near, and beholding Mr Tapley more intent than ever on the fog; ‘it would be strange if I did not; for my life—especially of late—has been a hard one.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I know it must have been,’ she answered. ‘When have I forgotten to think of it and you?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_324"
    }
  }, [_vm._v("‘Not often, I hope,’ said Martin. ‘Not often, I am sure. Not often, ")]), _c('a', {
    attrs: {
      "id": "page_325"
    }
  }, [_vm._v("I have some right to expect, Mary; for I have undergone a great deal of vexation and privation, and I naturally look for that return, you know.’")])]), _c('a', {
    attrs: {
      "id": "page_325"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A very, very poor return,’ she answered with a fainter smile. ‘But you have it, and will have it always. You have paid a dear price for a poor heart, Martin; but it is at least your own, and a true one.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Of course I feel quite certain of that,’ said Martin, ‘or I shouldn’t have put myself in my present position. And don’t say a poor heart, Mary, for I say a rich one. Now, I am about to break a design to you, dearest, which will startle you at first, but which is undertaken for your sake. I am going,’ he added slowly, looking far into the deep wonder of her bright dark eyes, ‘abroad.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Abroad, Martin!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Only to America. See now. How you droop directly!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I do, or, I hope I may say, if I did,’ she answered, raising her head after a short silence, and looking once more into his face, ‘it was for grief to think of what you are resolved to undergo for me. I would not venture to dissuade you, Martin; but it is a long, long distance; there is a wide ocean to be crossed; illness and want are sad calamities in any place, but in a foreign country dreadful to endure. Have you thought of all this?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_325"
    }
  }, [_vm._v("‘Thought of it!’ cried Martin, abating, in his fondness—and he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" very fond of her—hardly an iota of his usual impetuosity. ‘What am I to do? It’s very well to say, “Have I thought of it?” my love; but you should ask me in the same breath, have I thought of starving at home; have I thought of doing porter’s work for a living; have I thought of holding horses in the streets to earn my roll of bread from day to day? Come, come,’ he added, in a gentler tone, ‘do not hang down your head, my dear, for I need the encouragement that your sweet face alone ")]), _c('a', {
    attrs: {
      "id": "page_326"
    }
  }, [_vm._v("can give me. Why, that’s well! Now you are brave again.’")])]), _c('a', {
    attrs: {
      "id": "page_326"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am endeavouring to be,’ she answered, smiling through her tears.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Endeavouring to be anything that’s good, and being it, is, with you, all one. Don’t I know that of old?’ cried Martin, gayly. ‘So! That’s famous! Now I can tell you all my plans as cheerfully as if you were my little wife already, Mary.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hung more closely on his arm, and looking upwards in his face, bade him speak on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘You see,’ said Martin, playing with the little hand upon his wrist, ‘that my attempts to advance myself at home have been baffled and rendered abortive. I will not say by whom, Mary, for that would give pain to us both. But so it is. Have you heard him speak of late of any relative of mine or his, called Pecksniff? Only tell me what I ask you, no more.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I have heard, to my surprise, that he is a better man than was supposed.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thought so,’ interrupted Martin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘And that it is likely we may come to know him, if not to visit and reside with him and—I think—his daughters. He "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("has")]), _vm._v(" daughters, has he, love?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘A pair of them,’ Martin answered. ‘A precious pair! Gems of the first water!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Ah! You are jesting!’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_326"
    }
  }, [_vm._v("‘There is a sort of jesting which is very much in earnest, and includes some pretty serious disgust,’ said Martin. ‘I jest in reference to Mr Pecksniff (at whose house I have been living as his assistant, and at whose hands I have received insult and injury), in that vein. Whatever betides, or however closely you may be brought into communication with this family, never forget that, Mary; and never for an instant, whatever appearances may seem to contradict me, lose sight of this ")]), _c('a', {
    attrs: {
      "id": "page_327"
    }
  }, [_vm._v("assurance—Pecksniff is a scoundrel.’")])]), _c('a', {
    attrs: {
      "id": "page_327"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Indeed!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In thought, and in deed, and in everything else. A scoundrel from the topmost hair of his head, to the nethermost atom of his heel. Of his daughters I will only say that, to the best of my knowledge and belief, they are dutiful young ladies, and take after their father closely. This is a digression from the main point, and yet it brings me to what I was going to say.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stopped to look into her eyes again, and seeing, in a hasty glance over his shoulder, that there was no one near, and that Mark was still intent upon the fog, not only looked at her lips, too, but kissed them into the bargain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Now I am going to America, with great prospects of doing well, and of returning home myself very soon; it may be to take you there for a few years, but, at all events, to claim you for my wife; which, after such trials, I should do with no fear of your still thinking it a duty to cleave to him who will not suffer me to live (for this is true), if he can help it, in my own land. How long I may be absent is, of course, uncertain; but it shall not be very long. Trust me for that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In the meantime, dear Martin—’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That’s the very thing I am coming to. In the meantime you shall hear, constantly, of all my goings-on. Thus.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused to take from his pocket the letter he had written overnight, and then resumed:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘In this fellow’s employment, and living in this fellow’s house (by fellow, I mean Mr Pecksniff, of course), there is a certain person of the name of Pinch. Don’t forget; a poor, strange, simple oddity, Mary; but thoroughly honest and sincere; full of zeal; and with a cordial regard for me. Which I mean to return one of these days, by setting him up in life in some way or other.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_327"
    }
  }), _c('a', {
    attrs: {
      "id": "page_328"
    }
  }, [_vm._v("‘Your old kind nature, Martin!’")])]), _c('a', {
    attrs: {
      "id": "page_328"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh!’ said Martin, ‘that’s not worth speaking of, my love. He’s very grateful and desirous to serve me; and I am more than repaid. Now one night I told this Pinch my history, and all about myself and you; in which he was not a little interested, I can tell you, for he knows you! Aye, you may look surprised—and the longer the better for it becomes you—but you have heard him play the organ in the church of that village before now; and he has seen you listening to his music; and has caught his inspiration from you, too!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" the organist?’ cried Mary. ‘I thank him from my heart!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, he was,’ said Martin, ‘and is, and gets nothing for it either. There never was such a simple fellow! Quite an infant! But a very good sort of creature, I assure you.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I am sure of that,’ she said with great earnestness. ‘He must be!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes, no doubt at all about it,’ rejoined Martin, in his usual careless way. ‘He is. Well! It has occurred to me—but stay. If I read you what I have written and intend sending to him by post to-night it will explain itself. “My dear Tom Pinch.” That’s rather familiar perhaps,’ said Martin, suddenly remembering that he was proud when they had last met, ‘but I call him my dear Tom Pinch because he likes it, and it pleases him.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Very right, and very kind,’ said Mary.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_328"
    }
  }, [_vm._v("‘Exactly so!’ cried Martin. ‘It’s as well to be kind whenever one can; and, as I said before, he really is an excellent fellow. “My dear Tom Pinch—I address this under cover to Mrs Lupin, at the Blue Dragon, and have begged her in a short note to deliver it to you without saying anything about it elsewhere; and to do the same with all future letters she may receive ")]), _c('a', {
    attrs: {
      "id": "page_329"
    }
  }, [_vm._v("from me. My reason for so doing will be at once apparent to you”—I don’t know that it will be, by the bye,’ said Martin, breaking off, ‘for he’s slow of comprehension, poor fellow; but he’ll find it out in time. My reason simply is, that I don’t want my letters to be read by other people; and particularly by the scoundrel whom he thinks an angel.’")])]), _c('a', {
    attrs: {
      "id": "page_329"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Mr Pecksniff again?’ asked Mary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The same,’ said Martin ‘—will be at once apparent to you. I have completed my arrangements for going to America; and you will be surprised to hear that I am to be accompanied by Mark Tapley, upon whom I have stumbled strangely in London, and who insists on putting himself under my protection’—meaning, my love,’ said Martin, breaking off again, ‘our friend in the rear, of course.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was delighted to hear this, and bestowed a kind glance upon Mark, which he brought his eyes down from the fog to encounter and received with immense satisfaction. She said in his hearing, too, that he was a good soul and a merry creature, and would be faithful, she was certain; commendations which Mr Tapley inwardly resolved to deserve, from such lips, if he died for it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘“Now, my dear Pinch,”’ resumed Martin, proceeding with his letter; ‘“I am going to repose great trust in you, knowing that I may do so with perfect reliance on your honour and secrecy, and having nobody else just now to trust in.”’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t think I would say that, Martin.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Wouldn’t you? Well! I’ll take that out. It’s perfectly true, though.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘But it might seem ungracious, perhaps.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_329"
    }
  }, [_vm._v("‘Oh, I don’t mind Pinch,’ said Martin. ‘There’s no occasion to stand on any ceremony with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("him")]), _vm._v(". However, I’ll take it out, as you wish it, and make the full stop at “secrecy.” Very well! “I ")]), _c('a', {
    attrs: {
      "id": "page_330"
    }
  }, [_vm._v("shall not only”—this is the letter again, you know.’")])]), _c('a', {
    attrs: {
      "id": "page_330"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I understand.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘“I shall not only enclose my letters to the young lady of whom I have told you, to your charge, to be forwarded as she may request; but I most earnestly commit her, the young lady herself, to your care and regard, in the event of your meeting in my absence. I have reason to think that the probabilities of your encountering each other—perhaps very frequently—are now neither remote nor few; and although in our position you can do very little to lessen the uneasiness of hers, I trust to you implicitly to do that much, and so deserve the confidence I have reposed in you.” You see, my dear Mary,’ said Martin, ‘it will be a great consolation to you to have anybody, no matter how simple, with whom you can speak about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v("; and the very first time you talk to Pinch, you’ll feel at once that there is no more occasion for any embarrassment or hesitation in talking to him, than if he were an old woman.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘However that may be,’ she returned, smiling, ‘he is your friend, and that is enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, yes, he’s my friend,’ said Martin, ‘certainly. In fact, I have told him in so many words that we’ll always take notice of him, and protect him; and it’s a good trait in his character that he’s grateful—very grateful indeed. You’ll like him of all things, my love, I know. You’ll observe very much that’s comical and old-fashioned about Pinch, but you needn’t mind laughing at him; for he’ll not care about it. He’ll rather like it indeed!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I don’t think I shall put that to the test, Martin.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_330"
    }
  }, [_vm._v("‘You won’t if you can help it, of course,’ he said, ‘but I think you’ll find him a little too much for your gravity. However, that’s neither here nor there, and it certainly is not the letter; which ends thus: “Knowing that I need not impress the nature ")]), _c('a', {
    attrs: {
      "id": "page_331"
    }
  }, [_vm._v("and extent of that confidence upon you at any greater length, as it is already sufficiently established in your mind, I will only say, in bidding you farewell and looking forward to our next meeting, that I shall charge myself from this time, through all changes for the better, with your advancement and happiness, as if they were my own. You may rely upon that. And always believe me, my dear Tom Pinch, faithfully your friend, Martin Chuzzlewit. P.S.—I enclose the amount which you so kindly”—Oh,’ said Martin, checking himself, and folding up the letter, ‘that’s nothing!’")])]), _c('a', {
    attrs: {
      "id": "page_331"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At this crisis Mark Tapley interposed, with an apology for remarking that the clock at the Horse Guards was striking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Which I shouldn’t have said nothing about, sir,’ added Mark, ‘if the young lady hadn’t begged me to be particular in mentioning it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I did,’ said Mary. ‘Thank you. You are quite right. In another minute I shall be ready to return. We have time for a very few words more, dear Martin, and although I had much to say, it must remain unsaid until the happy time of our next meeting. Heaven send it may come speedily and prosperously! But I have no fear of that.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fear!’ cried Martin. ‘Why, who has? What are a few months? What is a whole year? When I come gayly back, with a road through life hewn out before me, then indeed, looking back upon this parting, it may seem a dismal one. But now! I swear I wouldn’t have it happen under more favourable auspices, if I could; for then I should be less inclined to go, and less impressed with the necessity.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Yes, yes. I feel that too. When do you go?’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_331"
    }
  }, [_vm._v("‘To-night. We leave for Liverpool to-night. A vessel sails from that port, as I hear, in three days. In a month, or less, we shall be there. Why, what’s a month! How many months have ")]), _c('a', {
    attrs: {
      "id": "page_332"
    }
  }, [_vm._v("flown by, since our last parting!’")])]), _c('a', {
    attrs: {
      "id": "page_332"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Long to look back upon,’ said Mary, echoing his cheerful tone, ‘but nothing in their course!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Nothing at all!’ cried Martin. ‘I shall have change of scene and change of place; change of people, change of manners, change of cares and hopes! Time will wear wings indeed! I can bear anything, so that I have swift action, Mary.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was he thinking solely of her care for him, when he took so little heed of her share in the separation; of her quiet monotonous endurance, and her slow anxiety from day to day? Was there nothing jarring and discordant even in his tone of courage, with this one note ‘self’ for ever audible, however high the strain? Not in her ears. It had been better otherwise, perhaps, but so it was. She heard the same bold spirit which had flung away as dross all gain and profit for her sake, making light of peril and privation that she might be calm and happy; and she heard no more. That heart where self has found no place and raised no throne, is slow to recognize its ugly presence when it looks upon it. As one possessed of an evil spirit was held in old time to be alone conscious of the lurking demon in the breasts of other men, so kindred vices know each other in their hiding-places every day, when Virtue is incredulous and blind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The quarter’s gone!’ cried Mr Tapley, in a voice of admonition.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_332"
    }
  }, [_vm._v("‘I shall be ready to return immediately,’ she said. ‘One thing, dear Martin, I am bound to tell you. You entreated me a few minutes since only to answer what you asked me in reference to one theme, but you should and must know (otherwise I could not be at ease) that since that separation of which I was the unhappy occasion, he has never once uttered your name; has never coupled it, or any faint allusion to it, with ")]), _c('a', {
    attrs: {
      "id": "page_333"
    }
  }, [_vm._v("passion or reproach; and has never abated in his kindness to me.’")])]), _c('a', {
    attrs: {
      "id": "page_333"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I thank him for that last act,’ said Martin, ‘and for nothing else. Though on consideration I may thank him for his other forbearance also, inasmuch as I neither expect nor desire that he will mention my name again. He may once, perhaps—to couple it with reproach—in his will. Let him, if he please! By the time it reaches me, he will be in his grave; a satire on his own anger, God help him!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Martin! If you would but sometimes, in some quiet hour; beside the winter fire; in the summer air; when you hear gentle music, or think of Death, or Home, or Childhood; if you would at such a season resolve to think, but once a month, or even once a year, of him, or any one who ever wronged you, you would forgive him in your heart, I know!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘If I believed that to be true, Mary,’ he replied, ‘I would resolve at no such time to bear him in my mind; wishing to spare myself the shame of such a weakness. I was not born to be the toy and puppet of any man, far less his; to whose pleasure and caprice, in return for any good he did me, my whole youth was sacrificed. It became between us two a fair exchange—a barter—and no more; and there is no such balance against me that I need throw in a mawkish forgiveness to poise the scale. He has forbidden all mention of me to you, I know,’ he added hastily. ‘Come! Has he not?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘That was long ago,’ she returned; ‘immediately after your parting; before you had left the house. He has never done so since.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_333"
    }
  }, [_vm._v("‘He has never done so since because he has seen no occasion,’ said Martin; ‘but that is of little consequence, one way or other. Let all allusion to him between you and me be interdicted from this time forth. And therefore, love’—he drew her ")]), _c('a', {
    attrs: {
      "id": "page_334"
    }
  }, [_vm._v("quickly to him, for the time of parting had now come—‘in the first letter that you write to me through the Post Office, addressed to New York; and in all the others that you send through Pinch; remember he has no existence, but has become to us as one who is dead. Now, God bless you! This is a strange place for such a meeting and such a parting; but our next meeting shall be in a better, and our next and last parting in a worse.’")])]), _c('a', {
    attrs: {
      "id": "page_334"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘One other question, Martin, I must ask. Have you provided money for this journey?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Have I?’ cried Martin; it might have been in his pride; it might have been in his desire to set her mind at ease: ‘Have I provided money? Why, there’s a question for an emigrant’s wife! How could I move on land or sea without it, love?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I mean, enough.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Enough! More than enough. Twenty times more than enough. A pocket-full. Mark and I, for all essential ends, are quite as rich as if we had the purse of Fortunatus in our baggage.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘The half-hour’s a-going!’ cried Mr Tapley.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Good-bye a hundred times!’ cried Mary, in a trembling voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But how cold the comfort in Good-bye! Mark Tapley knew it perfectly. Perhaps he knew it from his reading, perhaps from his experience, perhaps from intuition. It is impossible to say; but however he knew it, his knowledge instinctively suggested to him the wisest course of proceeding that any man could have adopted under the circumstances. He was taken with a violent fit of sneezing, and was obliged to turn his head another way. In doing which, he, in a manner fenced and screened the lovers into a corner by themselves.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_334"
    }
  }, [_vm._v("There was a short pause, but Mark had an undefined sensation ")]), _c('a', {
    attrs: {
      "id": "page_335"
    }
  }, [_vm._v("that it was a satisfactory one in its way. Then Mary, with her veil lowered, passed him with a quick step, and beckoned him to follow. She stopped once more before they lost that corner; looked back; and waved her hand to Martin. He made a start towards them at the moment as if he had some other farewell words to say; but she only hurried off the faster, and Mr Tapley followed as in duty bound.")])]), _c('a', {
    attrs: {
      "id": "page_335"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When he rejoined Martin again in his own chamber, he found that gentleman seated moodily before the dusty grate, with his two feet on the fender, his two elbows on his knees, and his chin supported, in a not very ornamental manner, on the palms of his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, Mark!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Well, sir,’ said Mark, taking a long breath, ‘I see the young lady safe home, and I feel pretty comfortable after it. She sent a lot of kind words, sir, and this,’ handing him a ring, ‘for a parting keepsake.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Diamonds!’ said Martin, kissing it—let us do him justice, it was for her sake; not for theirs—and putting it on his little finger. ‘Splendid diamonds! My grandfather is a singular character, Mark. He must have given her this now.’")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_335"
    }
  }, [_vm._v("Mark Tapley knew as well that she had bought it, to the end that that unconscious speaker might carry some article of sterling value with him in his necessity; as he knew that it was day, and not night. Though he had no more acquaintance of his own knowledge with the history of the glittering trinket on Martin’s outspread finger, than Martin himself had, he was as certain that in its purchase she had expended her whole stock of hoarded money, as if he had seen it paid down coin by coin. Her lover’s strange obtuseness in relation to this little incident, promptly suggested to Mark’s mind its real cause and root; and from that moment he had a clear and perfect insight ")]), _c('a', {
    attrs: {
      "id": "page_336"
    }
  }, [_vm._v("into the one absorbing principle of Martin’s character.")])]), _c('a', {
    attrs: {
      "id": "page_336"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘She is worthy of the sacrifices I have made,’ said Martin, folding his arms, and looking at the ashes in the stove, as if in resumption of some former thoughts. ‘Well worthy of them. No riches’—here he stroked his chin and mused—‘could have compensated for the loss of such a nature. Not to mention that in gaining her affection I have followed the bent of my own wishes, and baulked the selfish schemes of others who had no right to form them. She is quite worthy—more than worthy—of the sacrifices I have made. Yes, she is. No doubt of it.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These ruminations might or might not have reached Mark Tapley; for though they were by no means addressed to him, yet they were softly uttered. In any case, he stood there, watching Martin with an indescribable and most involved expression on his visage, until that young man roused himself and looked towards him; when he turned away, as being suddenly intent upon certain preparations for the journey, and, without giving vent to any articulate sound, smiled with surpassing ghastliness, and seemed by a twist of his features and a motion of his lips, to release himself of this word:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Jolly!’")])])])])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(186),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(189),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(195),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(198),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(204),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(206),
  /* template */
  __webpack_require__(207),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(210),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(213),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(216),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(237),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(240),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(243),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(246),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(252),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(258),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(260),
  /* template */
  __webpack_require__(261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(264),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(267),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(270),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(311),
  /* template */
  __webpack_require__(312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(314),
  /* template */
  __webpack_require__(315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(375),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(390),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(399),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(402),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(405),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(408),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(411),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(414),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(417),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(420),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(423),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(426),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(429),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(432),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(435),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(438),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(441),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(447),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(453),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(459),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(462),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(468),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(474),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(477),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(480),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(483),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(489),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(492),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(495),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(498),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(501),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(504),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(507),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(510),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(513),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(516),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(519),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(522),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(525),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(528),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(531),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(534),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(537),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(543),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(546),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(549),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(552),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(555),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(558),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(561),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(564),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(567),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(570),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(573),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(576),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(579),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(582),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(590),
  /* template */
  __webpack_require__(591),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(593),
  /* template */
  __webpack_require__(594),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(596),
  /* template */
  __webpack_require__(597),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(599),
  /* template */
  __webpack_require__(600),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(602),
  /* template */
  __webpack_require__(603),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(605),
  /* template */
  __webpack_require__(606),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(608),
  /* template */
  __webpack_require__(609),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(611),
  /* template */
  __webpack_require__(612),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(614),
  /* template */
  __webpack_require__(615),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(617),
  /* template */
  __webpack_require__(618),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(620),
  /* template */
  __webpack_require__(621),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(623),
  /* template */
  __webpack_require__(624),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(626),
  /* template */
  __webpack_require__(627),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(629),
  /* template */
  __webpack_require__(630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(632),
  /* template */
  __webpack_require__(633),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(635),
  /* template */
  __webpack_require__(636),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(638),
  /* template */
  __webpack_require__(639),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(641),
  /* template */
  __webpack_require__(642),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(644),
  /* template */
  __webpack_require__(645),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(647),
  /* template */
  __webpack_require__(648),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(650),
  /* template */
  __webpack_require__(651),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(653),
  /* template */
  __webpack_require__(654),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(656),
  /* template */
  __webpack_require__(657),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(659),
  /* template */
  __webpack_require__(660),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(662),
  /* template */
  __webpack_require__(663),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(665),
  /* template */
  __webpack_require__(666),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(668),
  /* template */
  __webpack_require__(669),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 669 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(671),
  /* template */
  __webpack_require__(672),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(674),
  /* template */
  __webpack_require__(675),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 675 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(677),
  /* template */
  __webpack_require__(678),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(680),
  /* template */
  __webpack_require__(681),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504065146',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(685)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(687);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 687 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.8b8f0182fe54bdd28e15.js